export const JSONData = [
  {
    Timestamp: "",
    "Name of the student": "Rutuja Kawade",
    "Institute Name(College)": "Pune Institute of Computer Technology",
    "Field of study": "B.E. in Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Python, C++ programming, Web development, technical content writing, data analysis",
    "Period of Internship": "1-3 Months Can start immediately",
    "Current Location(With Country)": "Pune, Maharashtra, India",
    "Does Remote Internship work for you?": "Yes, open to remote internships",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FevKlhosCaPHQ9Bo2Ia7J1t3_e7FDxfH/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rutuja-kawade-6b7a8a171/",
    "Contact Details (Email)": "rutujakawade24@gmail.com",
    "Anything else you'd like to share?":
      "Like to explore science and computer technology related topics. My field of interest are machine learning, data science, NLP, Python, Java, C++,R, MATLAB. I want to work in these fields for betterment society and its improvisation in field of technology.",
  },
  {
    Timestamp: "03/31/2020 10:41:08",
    "Name of the student": "Namrata Wadhwa",
    "Institute Name(College)": "VES College of Arts, Science & Commerce",
    "Field of study": "BMS (Marketing)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing, Social media, Branding",
    "Period of Internship": "2 months ( By start of April)",
    "Current Location(With Country)":
      "Mumbai (India) - Available to work remotely if location is out of Mumbai.",
    "Does Remote Internship work for you?": "Yes open to remote internship.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14IiTbrIVGBTt2MG51682p-mBYSSwyFd0/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/namrata-wadhwa-107a88160/",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?":
      "Possess traits of Dedication, Team work and Passion which will help me to excel in the work I do. A person with a Curious nature who has a desire to learn new skills and apply them as an asset to the organisation.\n\n My experience involves Conducting a Research project which improved my Critical thinking skills, Time managing skills, etc. By managing cultural events and taking part in competitions I strengthened my communication and interpersonal skills.\n \n I also know a lot about Branding and Social Media and have worked in various projects and made them a success.",
  },
  {
    Timestamp: "03/31/2020 16:33:34",
    "Name of the student": "Riya Bhatia",
    "Institute Name(College)":
      "jaypee Institute of information technology noida",
    "Field of study": "electronics and communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "technical",
    "Period of Internship": "one month",
    "Current Location(With Country)": "meerut",
    "Does Remote Internship work for you?": "delhi, noida",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "riyabhatia823@gmail.com",
    "Anything else you'd like to share?":
      "i m okay with everything, looking forward",
  },
  {
    Timestamp: "03/31/2020 16:39:10",
    "Name of the student": "Manisha Joshi",
    "Institute Name(College)": "CET-IILM-AHL",
    "Field of study": "Biotechnology",
    Education: "M.Tech Biotechnology result awaited",
    "Preferred domain of internship": "Biotechnology",
    "Period of Internship": "1st April, 2020-30th April, 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes. Noida, Delhi, Greater Noida, Gurugram, Dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cQbTFSoiqNtktbgGDiGLHWpuT0yjo4yj/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/manisha-joshi-94677b117",
    "Contact Details (Email)": "manishajoshi005@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:39:11",
    "Name of the student": "Mansi Agarwal",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Cse",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Muzaffarnagar (India)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mansiagg21@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:39:13",
    "Name of the student": "Samyak Jain",
    "Institute Name(College)": "Galgotias University",
    "Field of study": "Btech CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Information Technology",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "New Delhi (India)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1--tU2lAGU47EM7n96JCJG5I-A0J9RJ0C/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/samyak-jain-a940a9158",
    "Contact Details (Email)": "Samyakjain018@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "03/31/2020 16:39:55",
    "Name of the student": "Akash Singh",
    "Institute Name(College)":
      "Jaypee Institute of Information Technology Noida",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning, Data Science, Data Analytics, Deep Learning",
    "Period of Internship": "2 months ( Can start Immediately)",
    "Current Location(With Country)": "Noida ( India)",
    "Does Remote Internship work for you?":
      "Yes, Preferred city is Delhi, Noida or Gurgaon.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZO9J0BjfyoVnJDI4gj9sVvwoNNYHspAC/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/akash-singh-0705",
    "Contact Details (Email)": "Akkacms11@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:40:38",
    "Name of the student": "Akash Sharma",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development Engineer",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ltth43Rjtrq9XnjTXpJw5PCMboWoqkJB/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/akash-sharma-cpp/",
    "Contact Details (Email)": "aakashsharmajc100@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:43:29",
    "Name of the student": "Naman Narula",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Sales and Marketing",
    "Period of Internship":
      "I am looking for a 2-3 months of internship starting from 1st June,2020",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, PAN India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=16Moog-kMbVuqz-7-nLcaiA8jl7ykfIjw",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/naman-narula-b16677123",
    "Contact Details (Email)": "narula.naman5@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:45:19",
    "Name of the student": "Sonu kumar Gupta",
    "Institute Name(College)": "Jaypee Institute of information technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Android development",
    "Period of Internship": "2",
    "Current Location(With Country)": "Noida-India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/12n7Yrx4vtF6m1csH9JUSOrlL_iyeQluv/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/sonu-gupta-07837b158",
    "Contact Details (Email)": "Sonug3189@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:47:49",
    "Name of the student": "Prerit Sharma",
    "Institute Name(College)":
      "Narsee Monjee Institutes of Management Sciences",
    "Field of study": "MBA Marketing management, Btech Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:52:03",
    "Name of the student": "SANDEEP KUMAR SHARMA",
    "Institute Name(College)": "Galgotias University",
    "Field of study": "Btech computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software/ML/ web",
    "Period of Internship": "2 (may-june)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes preferred city is banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1QTdJ6-zAXBk294jLWuM_wWqhCdd_juwL/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/sandeeps097/",
    "Contact Details (Email)": "sandeepsharma097@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:52:58",
    "Name of the student": "Pratyay Prakhar",
    "Institute Name(College)": "Manipal Institute of Technology",
    "Field of study": "Computer and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Covid-19 Helpline",
    "Period of Internship": "As long as it is required, can start immediately",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Maybe",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1x-23V-eTNUdSV1PQ7AhcggtxgVcGMPoJ/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pratyay-prakhar-152498142/",
    "Contact Details (Email)": "ppratyay179@gmail.com",
    "Anything else you'd like to share?":
      "Have a lot of volunteering experience and recently got certified by WHO on Covid-19 Country preparedness and response",
  },
  {
    Timestamp: "03/31/2020 16:55:05",
    "Name of the student": "Ritik Gupta",
    "Institute Name(College)": "Jaypee institute of information technology",
    "Field of study": "Computer science engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software and web development, content writing",
    "Period of Internship": "3-4 months",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/0B8jw0zK1nwr0VkhzZVVPelQ0a3ZaLVl3anU0RzVqR3huUTlJ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritik-gupta-95b21b149",
    "Contact Details (Email)": "hrgpt13@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 16:59:06",
    "Name of the student": "shlok patel",
    "Institute Name(College)": "jiit noida",
    "Field of study": "computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "finance",
    "Period of Internship": "6months",
    "Current Location(With Country)": "noida, India",
    "Does Remote Internship work for you?": "yes, mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1V0LNCbfvzXA1m08Fe-3hkagUQf2lPmUd/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/shlok-patel-95230773",
    "Contact Details (Email)": "mailtosspatel@gmail.com",
    "Anything else you'd like to share?":
      "I am a self taught trader and have a interest in financial markets, so please have a look at my profile and reach me if there's an opportunity for me to add value to your work.",
  },
  {
    Timestamp: "03/31/2020 17:07:54",
    "Name of the student": "Himanshu Arora",
    "Institute Name(College)": "Carnegie Mellon Univeristy",
    "Field of study": "Information systems management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Science, Software Development",
    "Period of Internship": "2.5-3 months",
    "Current Location(With Country)": "Adelaide, Australia",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SjpZK37XP7x1RBkGY8KrKOY3qXsmHmR7/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/himanshua97",
    "Contact Details (Email)": "harora2@andrew.cmu.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 17:18:50",
    "Name of the student": "Riya Gupta",
    "Institute Name(College)": "Srcasw",
    "Field of study": "Statistics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data scientist",
    "Period of Internship": "For 2 months",
    "Current Location(With Country)": "Delhi India",
    "Does Remote Internship work for you?":
      "Yea I am fine with remote internship. I will prefer any state.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1eLg_Y-9uG6uqdx8fYwsCAf3hJwAZtM9v/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/riya-gupta-8b306124",
    "Contact Details (Email)": "gupta99riya@gmail.com",
    "Anything else you'd like to share?":
      "https://drive.google.com/file/d/1Y48EUbDJyCghoSv-Wm5LXR-r6504ijZl/view?usp=drivesdk",
  },
  {
    Timestamp: "03/31/2020 17:22:23",
    "Name of the student": "Tushar agarwal",
    "Institute Name(College)": "Jaypee university of information technology",
    "Field of study": "BTECH ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "IOT",
    "Period of Internship": "Two months lf internship (31may)",
    "Current Location(With Country)": "Muzaffarnagar (INDIA)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "Tushar5719789@gmail.com",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tushar-agarwal-5b79b6150",
    "Contact Details (Email)": "Tushar5719789@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "03/31/2020 17:31:50",
    "Name of the student": "Arpit Pathak",
    "Institute Name(College)": "JIIT",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "3-4",
    "Current Location(With Country)": "Bangalore,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SrcXkVvpDHmaCjnVgzuxHT2c8Yl7Y7bp/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/comm/in/arpit-pathak-511092188?midToken=AQEIltY2fNy8Gg&trk=eml-jobs_jymbii_digest-header-41-profile&trkEmail=eml-jobs_jymbii_digest-header-41-profile-null-c9038d~k8euj5jj~w7-null-neptune%2Fprofile~vanity%2Eview&lipi=urn%3Ali%3Apage%3Aemail_jobs_jymbii_digest%3Bc9XhWjZcTWutRisFnUMONA%3D%3D",
    "Contact Details (Email)": "arpitpathak26@gmail.com",
    "Anything else you'd like to share?": "https://github\ncom/pathak2705",
  },
  {
    Timestamp: "03/31/2020 18:18:09",
    "Name of the student": "Kshitij Nath",
    "Institute Name(College)": "Jaypee Institute Of Information Technology",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Web Development (Django) and Python Development",
    "Period of Internship": "2-3 months (from 2nd April)",
    "Current Location(With Country)": "Greater Noida West (India)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1ovRey0OQPT_F1-2CgExwXT-n9Iy4EEmP",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kshitij-nath-97a05a1a0/",
    "Contact Details (Email)": "kshitijnath@gmail.com",
    "Anything else you'd like to share?":
      "I have been in the web development domain for over 4-5 months and I have also created some medium size projects during this time.",
  },
  {
    Timestamp: "03/31/2020 18:18:19",
    "Name of the student": "Soumya Agarwal",
    "Institute Name(College)":
      "Jaypee Institute of Information Technology, Noida",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning,SDE",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Bareilly, U.P. ,India",
    "Does Remote Internship work for you?": "Yes. Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1gKBig7LwhPyktSc1lr9y0233gljHr9A4",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "soumyaagarwal307@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 18:25:09",
    "Name of the student": "Avinash Jain",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Electronics, Embedded Systems, Internet of Things",
    "Period of Internship": "3 Months (Starting 1/04/2020)",
    "Current Location(With Country)": "New Delhi",
    "Does Remote Internship work for you?":
      "Yes. I am open to relocation across all cities.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1XDH7gWzqZ6s8fRxuGD6_UZPokLm5pFKO",
    "LinkedIn profile link": "https://www.linkedin.com/in/avinash-jain-2099/",
    "Contact Details (Email)": "jain.avinash2099@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 18:27:48",
    "Name of the student": "Akash Marwah",
    "Institute Name(College)": "Jaypee University of Information Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 months 20 May- 20July",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1_4s_etvQakqz2POPyghGwHxRgZXAb2NM",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akash-marwah-011b0114a/",
    "Contact Details (Email)": "akashmarwah07@gmail.com",
    "Anything else you'd like to share?": "Hoping for the best :)",
  },
  {
    Timestamp: "03/31/2020 18:52:44",
    "Name of the student": "Siddhartha Goel",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "IT",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development (MEAN/MERN) + Python",
    "Period of Internship": "2 months, starting in mid may",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Noida/Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14uS_xzUliFaMz-aP5VzO69T6zGYKExpf/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/siddhartha-goel-b2098117a",
    "Contact Details (Email)": "siddharthagoel1998@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "03/31/2020 19:01:05",
    "Name of the student": "Tushali sonkusare",
    "Institute Name(College)":
      "Dr D Y patil biotechnology and bioinformatics institute pune",
    "Field of study": "Virus",
    Education: "Post-Graduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Nagpur India",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 19:08:35",
    "Name of the student": "Akshat Jain",
    "Institute Name(College)": "Harcourt Butler Technical University",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "I.T",
    "Period of Internship": "June to early August",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Pan India",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "akshatj355@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 19:11:09",
    "Name of the student": "swapnil solanki",
    "Institute Name(College)":
      "KJ Somaiya institute of management studies and research",
    "Field of study": "Retail management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "swapnilsolanki272@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 19:20:06",
    "Name of the student": "Priyanshi",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Electronics and Communications Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Developer",
    "Period of Internship": "2-6 months starting from june 2020",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Delhi, Gurgaon, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wz6HDxiofYFCZEKGf-JAS8u09a72NM2P/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/priyanshitaneja",
    "Contact Details (Email)": "tanejapriyanshi1997@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 19:32:18",
    "Name of the student": "Saksham Prakash",
    "Institute Name(College)":
      "Jaypee Institute of Information Technology, Sector - 62, Noida",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science/ ML or IoT",
    "Period of Internship": "6 weeks preferably starting 23rd May",
    "Current Location(With Country)": "Lucknow (Home Town) / Noida (College)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1yurROrWp3Ojooi9Osq5iC_7zStCfGzwJ/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/sakshamprakash/",
    "Contact Details (Email)": "sakshamprakash01@gmail.com",
    "Anything else you'd like to share?":
      "Pursuing Deep learning specialization right now meanwhile working on a project - 'Realtime sign language recognition using Google's mediapipe and modified LSTM model'.\nRegarding IoT- I've been building electronics project since childhood (blog- http://exlectronix.blogspot.com/?m=1) and have built several IoT automation projects.",
  },
  {
    Timestamp: "03/31/2020 20:13:30",
    "Name of the student": "Kumar Aditya",
    "Institute Name(College)": "IMI, New Delhi",
    "Field of study": "Banking and Financial Services",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months. Starting anytime after Lockdown ends.",
    "Current Location(With Country)": "Jamshedpur, India",
    "Does Remote Internship work for you?": "Yes, New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/imi.edu/file/d/0B2hhrUBHMZmULVRVSFVpQVg4T3ZVTWh5NXIyUnFMQzF5aklB/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kumar-aditya-332759119",
    "Contact Details (Email)": "kumar.b19@imi.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 20:34:55",
    "Name of the student": "Laupyam Pattnaik",
    "Institute Name(College)": "Management Development Institute Murshidabad",
    "Field of study": "Marketing and operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months starting from April 1st week",
    "Current Location(With Country)": "Baripada, Odisha",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/mdim.ac.in/file/d/1FOpUur6UV6sE2_DQmazLNZnrjyicUFJ2/view?usp=drivesdk",
    "LinkedIn profile link": "LinkedIn.com/laupyampattnaik",
    "Contact Details (Email)": "laupyampattnaik@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 23:04:43",
    "Name of the student": "Parth Goyal",
    "Institute Name(College)": "Jaypee Institute of information technology",
    "Field of study": "B. Tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Management",
    "Period of Internship": "1-2 months summer internship",
    "Current Location(With Country)": "NCR",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "parthgoyal1767@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 01:22:27",
    "Name of the student": "Manoj Kumar",
    "Institute Name(College)": "FMS, New Delhi",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months starting from 1st April 2020",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/fms.edu/file/d/11P1tw-KtBTngM_QzV2-K1klbqSmNIBSa/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/manoj-kumar-0162b318b",
    "Contact Details (Email)": "manoj.k21@fms.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 03:08:31",
    "Name of the student": "Trinendra Mehria",
    "Institute Name(College)": "Jaypee Institute Of Information Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development Internship",
    "Period of Internship": "2 months, 25 May",
    "Current Location(With Country)": "Agra, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1mxnp-HVPfo7MKegxIhW3QORQPz3O3Khe/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/trinendra-mehria/",
    "Contact Details (Email)": "trinendra.mehria@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 03:20:52",
    "Name of the student": "Amrut Makdani",
    "Institute Name(College)": "Jaypee Institute of Information technology",
    "Field of study": "Electronics and communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Android Application development",
    "Period of Internship": "4 months and start of May",
    "Current Location(With Country)": "Noida",
    "Does Remote Internship work for you?": "Bangalore, Hyderabad, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1HxFgKcu05i75wgB3q9nOeYtT61FdKaDi/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/amrut-makdani-71a952147",
    "Contact Details (Email)": "amrutmakdani@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 08:55:23",
    "Name of the student": "Sangeetha MT",
    "Institute Name(College)":
      "Sri shakthi institute of engineering and technology",
    "Field of study": "B Tech Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "10 days to one month",
    "Current Location(With Country)": "Trichy",
    "Does Remote Internship work for you?": "Coimbatore",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "Sangeetha Mahalingam",
    "Contact Details (Email)": "sangeethamaha25@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 11:30:47",
    "Name of the student": "Yagavi. R",
    "Institute Name(College)":
      "Sri shakthi institute of engineering and technology",
    "Field of study": "Bio technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Genetic and molecular biotechnology",
    "Period of Internship": "1st of July. 3 months",
    "Current Location(With Country)": "Coimbatore (India)",
    "Does Remote Internship work for you?": "Yes. Anywhere with in Tamil nadu",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SMoAfAXB3fPpxDYu_TeWyHfR8tQkB5N9/view?usp=sharing_eil&ts=5e841c17",
    "LinkedIn profile link": "Yagavi yadhav",
    "Contact Details (Email)": "yagaviyadhav@gmail.com",
    "Anything else you'd like to share?":
      "I would do my best to uplift the area of my involvement.",
  },
  {
    Timestamp: "04/01/2020 11:53:37",
    "Name of the student": "Jenovin donald. J",
    "Institute Name(College)":
      "Sri shakthi institute of engineering and technology",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Molecular and Nano biotechnology",
    "Period of Internship": "July 1st. 3months",
    "Current Location(With Country)": "Coimbatore (India)",
    "Does Remote Internship work for you?": "Yes. Anywhere within Tamil nadu",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1sKOykGC4_EXfzhx08rkzlmZzQGMaqeYR/view?usp=sharing_eil&ts=5e841c00",
    "LinkedIn profile link": "Jenovin Donald",
    "Contact Details (Email)": "jenojmj@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 11:58:24",
    "Name of the student": "Pooja. A",
    "Institute Name(College)":
      "Sri shakthi institute of engineering and technology",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Molecular biology",
    "Period of Internship": "",
    "Current Location(With Country)": "Coimbatore",
    "Does Remote Internship work for you?": "Yes. Anywhere with in Tamil nadu",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "Pooja Anbu",
    "Contact Details (Email)": "Poojaanbu08@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 12:00:16",
    "Name of the student": "Nivetha .s",
    "Institute Name(College)":
      "Sri shakthi institute of engineering and technology",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Molecular biology",
    "Period of Internship": "",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 12:01:51",
    "Name of the student": "Dhanusha. C",
    "Institute Name(College)":
      "Sri shakthi institute of engineering and technology",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "Coimbatore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "dhanushachinnaswamy@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 12:03:03",
    "Name of the student": "Kiruthika. N",
    "Institute Name(College)":
      "Sri shakthi institute of engineering and technology",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "Coimbatore India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 13:01:49",
    "Name of the student": "Sanyam Singla",
    "Institute Name(College)":
      "Jaypee university of Information and technology",
    "Field of study": "Btech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Front-end",
    "Period of Internship": "Two months (31may)",
    "Current Location(With Country)": "Karnal, Haryana (India)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1wObEOyAYhlmp71o-E01aYoZ4_Z2Yh7peP-ftjE9zUaw/edit?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sanyam-singla-236874176",
    "Contact Details (Email)": "singlasanyam98@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/01/2020 13:11:28",
    "Name of the student": "Kartikey bindal",
    "Institute Name(College)": "Jaypee University of Information Technology",
    "Field of study": "Btech",
    Education: "Undergraduate",
    "Preferred domain of internship": "IOT",
    "Period of Internship": "Two(31st May)",
    "Current Location(With Country)": "Delhi",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kartikey-bindal-4a6560154",
    "Contact Details (Email)": "kart18bindal@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 14:09:31",
    "Name of the student": "astha dwivedi",
    "Institute Name(College)": "jaypee institute of information technology",
    "Field of study": "B.Tech in computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "data science/machine learning",
    "Period of Internship": "2 months (june 7)",
    "Current Location(With Country)": "uttar pradesh,India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/search?q=astha%20dwivedi%20resume",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/astha-dwivedi-795679191/",
    "Contact Details (Email)": "asthad16@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 14:28:34",
    "Name of the student": "Aishwarya S.Y",
    "Institute Name(College)":
      "Sri Shakthi Institute of Engineering and Technology",
    "Field of study": "B.Tech Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Biotechnology",
    "Period of Internship": "1 month ( 05/04/2020)",
    "Current Location(With Country)": "Coimbatore (India)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "Aishwarya Suresh",
    "Contact Details (Email)": "aishusy20@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 15:51:07",
    "Name of the student": "Mriganka Saikia",
    "Institute Name(College)": "North Carolina State University",
    "Field of study": "Industrial Engineering",
    Education: "Masters",
    "Preferred domain of internship":
      "Supply chain logistics, Data Analytics, Continuous Improvement",
    "Period of Internship": "3 - 9 months",
    "Current Location(With Country)": "North Carolina, USA",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Cd-quqSoL2BD0Zd-WcAru3DQcDbFRhLg",
    "LinkedIn profile link": "www.linkedin.com/in/mriganka-saikia-91a71b15b",
    "Contact Details (Email)": "msaikia2@ncsu.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 20:26:28",
    "Name of the student": "Kritika sharma",
    "Institute Name(College)":
      "Jaypee university of information technology, himachal pradesh",
    "Field of study": "bioinformatics",
    Education: "Undergraduate",
    "Preferred domain of internship": "bioinformatics",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Himachal pradesh, India",
    "Does Remote Internship work for you?": "no",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-Ua7UUKiXgbiuBj0CrfROG-JhWM0QKW-",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kritika-sharma-9b87421a2",
    "Contact Details (Email)": "sharmakritu617@gmail.com",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/01/2020 20:34:45",
    "Name of the student": "Akalya J",
    "Institute Name(College)":
      "Sri shakthi institute of engineering and technology",
    "Field of study": "Biotechonolgy",
    Education: "Undergraduate",
    "Preferred domain of internship": "Molecular biology",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "Tiruppur District. Tamil Nadu",
    "Does Remote Internship work for you?": "Coimbatore",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "akaljayakumar29@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 21:28:09",
    "Name of the student": "Vikraman sathiyanarayanan",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Computer Science",
    Education: "Graduate",
    "Preferred domain of internship":
      "Software Engineering, Machine learning, Data Science",
    "Period of Internship": "3(may 18 to Aug 21)",
    "Current Location(With Country)": "Los Angeles, US",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1OiI7LW-yRJ2jF3MwzjOn3Zo5auK8Srut",
    "LinkedIn profile link": "https://www.linkedin.com/in/vikikkdi/",
    "Contact Details (Email)": "sathiyan@usc.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 21:59:04",
    "Name of the student": "Dhruvinsinh Rathod",
    "Institute Name(College)": "A.D.Patel Institute of Technology",
    "Field of study": "Computer engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development",
    "Period of Internship": "1 or 2 months",
    "Current Location(With Country)": "Navsari,Gujarat -India",
    "Does Remote Internship work for you?": "Yes, Anand",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/ieee.org/file/d/1VOLvz02HIvto_sg7cghSfErYzcCFXP2v/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dhruvinsinh-rathod-558261151/",
    "Contact Details (Email)": "170010107050@adit.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 22:03:27",
    "Name of the student": "Bin Navinchandra Patel",
    "Institute Name(College)": "North Carolina State University",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Engineering and Data Science",
    "Period of Internship": "3 months from 9-May-2020",
    "Current Location(With Country)": "Raleigh, North Carolina, USA",
    "Does Remote Internship work for you?":
      "Yes I Remote internship works for me. Also I am open to relocate anywhere within USA.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17BwEETkqkxJ60886AGwdgNJUnPWC4y-x",
    "LinkedIn profile link": "linkedin.com/in/binpatel",
    "Contact Details (Email)": "bpatel24@ncsu.edu",
    "Anything else you'd like to share?":
      "I am more focused in Software Engineering and cloud technologies. Also have done open source and side projects which give me experience of practically use my skill-set. As this is my first internship in US so very much excited to work and use my knowledge and apply in real world industry application and expect to delivery my best and at end maintain good relations with peers with whom I will work.",
  },
  {
    Timestamp: "04/01/2020 22:25:08",
    "Name of the student": "Bibek Mishra",
    "Institute Name(College)": "Lovely Professional University",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Full Stack Development",
    "Period of Internship": "3-6-9-12month",
    "Current Location(With Country)": "Punjab,  India",
    "Does Remote Internship work for you?": "Pune, Chennai, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bibek-mishra-6bb79314a",
    "Contact Details (Email)":
      "bibek.11714774@lpu.in or bm.bibekmishra@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 23:19:02",
    "Name of the student": "Abhilash Pandurangan",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Data Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Science / Software Engineering",
    "Period of Internship": "3 Months Starting from 15th May 2020",
    "Current Location(With Country)": "Los Angeles, United States",
    "Does Remote Internship work for you?":
      "Yes, I'm open to relocation or remote internships",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1H0zlcN1PaAcgNduin1AriLhD-CyvMQgZ/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhilash-pandurangan/",
    "Contact Details (Email)": "abhilashpandurangan@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 23:50:18",
    "Name of the student": "Mehar Shahani",
    "Institute Name(College)": "Illinois Institute of Technology",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software/Web/Android Development",
    "Period of Internship": "05/10/2020 - 08/15/2020",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes, Anywhere in the US",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1SusW_GGwQwaVJ8taVUbnd5PiRD61F2By",
    "LinkedIn profile link": "https://www.linkedin.com/in/meharshahani/",
    "Contact Details (Email)": "mshahani@hawk.iit.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/02/2020 00:21:51",
    "Name of the student": "Himanshu Ken",
    "Institute Name(College)": "IIM Indore",
    "Field of study": "Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Management",
    "Period of Internship": "2 months, 1st week of April",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EPOtuNZ3vyHhd0pRaLPxpPcu8iY5Fy_4/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/himanshu-ken-709111135/",
    "Contact Details (Email)": "i16himanshuk@iimidr.ac.in",
    "Anything else you'd like to share?": "-",
  },
  {
    Timestamp: "04/02/2020 03:42:34",
    "Name of the student": "Mohit Bagri",
    "Institute Name(College)": "University of Pennsylvania",
    "Field of study": "Data Science (Computer Science)",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Science/ Machine Learning/ Software Development",
    "Period of Internship": "3 months (Start Date: May 18th 2020)",
    "Current Location(With Country)": "Philadelphia (United States)",
    "Does Remote Internship work for you?":
      "Yes. Preferred location: Any location within US",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1k1t9-Pxb-rYBMC1GL3Z9WAg2-iz1-p9G",
    "LinkedIn profile link": "https://www.linkedin.com/in/mohit-bagri970/",
    "Contact Details (Email)": "mohitbagri96@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/02/2020 06:19:17",
    "Name of the student": "Ayushi Purohit",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Masters in Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/127fkOUo1pj1kOiIHe7Ea18oBBcxUODqo/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ayushi.rkl@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/02/2020 07:36:58",
    "Name of the student": "Mounicka D",
    "Institute Name(College)":
      "Sri Shakthi Institute of engineering and technology college",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Research",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Coimbatore",
    "Does Remote Internship work for you?": "Devakottai",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mounickad11@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/02/2020 20:02:22",
    "Name of the student": "Rishabh Gupta",
    "Institute Name(College)": "Manipal Institute of Technology",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science",
    "Period of Internship": "3",
    "Current Location(With Country)": "Agra, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1FmeNgDzGGX4p3h2T742MEEd9RGiON2TJ",
    "LinkedIn profile link": "rishabh-gupta-725461139",
    "Contact Details (Email)": "rishabhgupta2580@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 04:20:30",
    "Name of the student": "Vignesh Viswanathan",
    "Institute Name(College)": "University of Texas at Dallas",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Science/Software Development",
    "Period of Internship": "3 Months. 05/20/2020",
    "Current Location(With Country)": "Dallas, TX, USA",
    "Does Remote Internship work for you?": "Yes. Any city is not a problem",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1P1pB0cMR9NHQBO81AQZaikTxm75YfqOB",
    "LinkedIn profile link": "https://www.linkedin.com/in/vigviswa/",
    "Contact Details (Email)": "vig.viswa@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 06:51:24",
    "Name of the student": "Shivam Rai",
    "Institute Name(College)": "San Francisco State University",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Software Engineering, Frontend, back end roles.",
    "Period of Internship": "May 26 Aug 28 2020 3 months, 16 weeks",
    "Current Location(With Country)": "San Francisco",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1btY5hCRN7pkZvzNiuSS9Hgw32yG9I2tB/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/shivam-rai111/",
    "Contact Details (Email)": "srai3@mail.sfsu.edu",
    "Anything else you'd like to share?":
      "Please reach out to me if you have any questions.",
  },
  {
    Timestamp: "04/03/2020 09:42:21",
    "Name of the student": "Kapil Kumar Israni",
    "Institute Name(College)": "Jaypee Institute of information technology",
    "Field of study": "Information technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Noida,india",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11yeY28GIBjMjvsl6znwBEkm3obiNqOl4/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kapil-israni-7a227317b",
    "Contact Details (Email)": "8209714523",
    "Anything else you'd like to share?":
      "Portfolio : https://090max.github.io/",
  },
  {
    Timestamp: "04/03/2020 09:44:52",
    "Name of the student": "Shashwat Agarwal",
    "Institute Name(College)": "IIT BHU",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product Management",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vh619FJyIKkNIOEd1PfDB2sSP4dD8yeC/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/a-shashwat",
    "Contact Details (Email)": "ashashwat.sharad.mec16@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 10:28:29",
    "Name of the student": "Milind Kumar",
    "Institute Name(College)":
      "Jaypee Institute of Information Technology, Noida",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning",
    "Period of Internship": "3 months starting from 5th of April.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, remote internship will work for me. I am also open to relocate to Gurugram.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Z90k1-Nnc33MW20NZ_Y_XAu3xaa82UwU/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/milind-kumar-574427176",
    "Contact Details (Email)": "milindkumar798@gmail.com",
    "Anything else you'd like to share?":
      "I am eager to further enhance my understanding of machine learning and data science by taking part in remote internships.",
  },
  {
    Timestamp: "04/03/2020 10:57:30",
    "Name of the student": "Abhinav Tyagi",
    "Institute Name(College)": "Jaypee Institute of Information technology",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development",
    "Period of Internship": "Any time will do",
    "Current Location(With Country)": "Saharanpur, UP, India till the lockdown",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1hQqauHJxZujU7Z0H4qUSIM5y1GUOiS5Z/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhinav-tyagi-497073183",
    "Contact Details (Email)": "anna.tyagi4@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 11:16:41",
    "Name of the student": "Suganth K S",
    "Institute Name(College)": "Shri Ram College of Commerce",
    "Field of study": "Commerce",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business strategy/consulting/marketing/Product development",
    "Period of Internship": "2-3 Months (From last week of May)",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes - Delhi,Chennai,Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Y3t4OChkPrlwwywUjBi_xpxGOMpekyjr/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/suganth-srinivasan-0110",
    "Contact Details (Email)": "suganthlbc@gmail.com",
    "Anything else you'd like to share?":
      "I'm currently in my penultimate of graduation and getting an internship is essential in my placements. Please do help to find opportunities",
  },
  {
    Timestamp: "04/03/2020 11:17:02",
    "Name of the student": "Abhimanyu Chandak",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Integrated CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "6 weeks from 1 June 2020",
    "Current Location(With Country)": "Delhi",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1IMfBJ4NuC4FwELqdW3hXMLPaze6fiZBi/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhimanyu-chandak-206a63186",
    "Contact Details (Email)": "abhimanyuchandak@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 11:24:58",
    "Name of the student": "Abhishek Chandak",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "Minimum 6 weeks",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TmTDft0zzJ0_kx7FLCYj-x3b_xFMlX22/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-chandak-548b31194",
    "Contact Details (Email)": "abhishekchandak99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 11:32:13",
    "Name of the student": "Arzoo Kalra",
    "Institute Name(College)": "Jamia Millia Islamia",
    "Field of study": "Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Analytics, Business Analytics, Research and Analytics, consultancy.",
    "Period of Internship": "2 months starting from June.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/ucxysyne121xqsq/Arzook.pdf?dl=0",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arzoo-kalra-b12113157",
    "Contact Details (Email)": "arzookalra98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 11:36:20",
    "Name of the student": "Alexander No",
    "Institute Name(College)": "Florida State University",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineer Internship",
    "Period of Internship": "3 months Start: May 18th",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?":
      "Yes, I am willing to travel anywhere",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1OUuFyHPV3H6Zpgqy3INdygDvKySlukh_/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/alexno123/",
    "Contact Details (Email)": "alexsno31@gmail.com",
    "Anything else you'd like to share?":
      "I have been currently struggling to find an internship opportunity amidst this situation. I do not want to entirely blame that the outbreak has affected my chances at an internship but am also looking on feedback for how I can improve myself as developer/candidate.",
  },
  {
    Timestamp: "04/03/2020 11:43:10",
    "Name of the student": "Shiv Gupta",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Chemical engineering (Data Science)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science /Business Analysis",
    "Period of Internship": "3 month",
    "Current Location(With Country)": "Chennai India",
    "Does Remote Internship work for you?":
      "I am looking for remote internship",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/smail.iitm.ac.in/file/d/12-vKN3wRAEOfEZTcpy3gJ6xEYNuiBC2u/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/shiv-gupta-849732138",
    "Contact Details (Email)": "shivgupta112211@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 11:43:49",
    "Name of the student": "Pratham Khurana",
    "Institute Name(College)":
      "Netaji Subhas Institute of Technology ( Delhi University)",
    "Field of study": "Manufacturing processes and automation engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Robotics and Automation",
    "Period of Internship": "Two ( 1st June - 31st July)",
    "Current Location(With Country)": "Gurgaon,Haryana, India",
    "Does Remote Internship work for you?": "Yes, Delhi NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18xZqEoOugLiSMAj20EnLxf9ZRW8R9ERV/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/pratham-khurana-a9812a159",
    "Contact Details (Email)": "prathamk.mp.17@nsit.net.in",
    "Anything else you'd like to share?":
      "I can start immediately if the internship is work from home. If it is office internship, I am available during work above mentioned period only.",
  },
  {
    Timestamp: "04/03/2020 11:54:08",
    "Name of the student": "Deepankar Sharma",
    "Institute Name(College)": "Manipal institute of technology, Karnataka",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Civil engineering, Management, Aeronautical.",
    "Period of Internship": "Any duration",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ID9HcTdUNTth6yiorpi4LvS3I-R7pwz-/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/deepankar-sharma-900548160",
    "Contact Details (Email)": "deepankar.sssharma@gmail.com",
    "Anything else you'd like to share?": "Thanks a lot.",
  },
  {
    Timestamp: "04/03/2020 11:59:14",
    "Name of the student": "Aniket Shah",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Analytics, Machine Learning, Consultancy or Market Research",
    "Period of Internship": "4 months beginning at the earliest possible",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16-G0vMpqh2AL9C3Wjd0VrcORAi_HuTSj/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/aniket308",
    "Contact Details (Email)": "aniketshah.iitkgp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:03:23",
    "Name of the student": "Abhimanyu Agarwal",
    "Institute Name(College)": "UPES",
    "Field of study": "Int. B.Tech (CSE) + L.LB (Hons.)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Cyber Security and ISO 27001 Imlimentation and Auditing",
    "Period of Internship": "2- 4 monts starting immidiately",
    "Current Location(With Country)": "MP, India",
    "Does Remote Internship work for you?":
      "Remote Internshp accepted. Also, ready to relocate anywhere in India after Lock down is over",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ynwriK8QzJ6bWyhFntaltYP325CMbsBY/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhimanyu-agarwal-64b13112b/",
    "Contact Details (Email)": "abhi96dhruva98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:04:15",
    "Name of the student": "Kshitij Kalla",
    "Institute Name(College)": "Indian institute of technology, Delhi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship":
      "2 Months Internship not sure of starting/end dates.",
    "Current Location(With Country)": "Jodhpur, Rajasthan, India.",
    "Does Remote Internship work for you?":
      "Amidst the Covid-19 situation, Work from home is the only option right now but yeah will surely relocate myself anywhere in India if the situation improve.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=178vbmYGNmhaz0eRzhOMY1lfU8rSq6CFS",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kshitij-kalla-31789a148",
    "Contact Details (Email)": "kshitijkalla28@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:07:39",
    "Name of the student": "Divyam Sharma",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance, Data Analytics, Software Development",
    "Period of Internship": "2 months, start date:- Earliest",
    "Current Location(With Country)": "India(New Delhi)",
    "Does Remote Internship work for you?": "Yes, i can relocate to any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AqfMqJhhcZErxfqEXiBJ73_k2FdNl9fW/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/divyam-sharma-86434414b/",
    "Contact Details (Email)": "divyamsharmaiitkgp@gmail.com",
    "Anything else you'd like to share?":
      "Link to letter of Recommendation:-https://drive.google.com/file/d/1L1TZikQYfdZ0-EPNPXXtcOJH7TDLOGkQ/view?usp=sharing",
  },
  {
    Timestamp: "04/03/2020 12:11:09",
    "Name of the student": "Somesh Grover",
    "Institute Name(College)":
      "School of Business, Public Policy and Social Entrepreneurship, Ambedkar University",
    "Field of study": "MBA (Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "FINANCE",
    "Period of Internship": "2 Months (1st May 2020 to 30th June 2020)",
    "Current Location(With Country)": "Delhi India",
    "Does Remote Internship work for you?":
      "No. Preferably only Delhi and NCR Region",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/somesh-grover-76a669190",
    "Contact Details (Email)": "someshgrover97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:20:57",
    "Name of the student": "Aditi Singh",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Digital Electronics, PCB Design, SOC",
    "Period of Internship": "2 months, Can start immediately",
    "Current Location(With Country)": "Navi Mumbai (India)",
    "Does Remote Internship work for you?":
      "Yes. I am open to relocation to Bangalore or Noida.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Gu32PCzItK4AckWjtJKMCAtZxqOnErDW",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aditi-singh-649ab9159/",
    "Contact Details (Email)": "aditirsingh9@gmail.com",
    "Anything else you'd like to share?":
      "I am a final year student and would like to utilize my summer fruitfully.",
  },
  {
    Timestamp: "04/03/2020 12:24:57",
    "Name of the student": "Xinran Zhou",
    "Institute Name(College)": "Rutgers University",
    "Field of study": "Economics / Finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Investment analysis, Equity research",
    "Period of Internship": "3",
    "Current Location(With Country)": "New York, New York ,US",
    "Does Remote Internship work for you?":
      "I am available for remote and relocate anywhere in the US",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1YPJFlIRyrTNVegvWM_ZXAxxQwWFO7lTK/view?ts=5d86dc5f",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Cherry.xr.zhou@outlook.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:32:23",
    "Name of the student": "Apoorva Singh",
    "Institute Name(College)": "IIT Kanpur",
    "Field of study": "Mathematics and Scientific Computing",
    Education: "Dual Degree",
    "Preferred domain of internship":
      "Data Science/Analytics/ML/Software Engineering",
    "Period of Internship": "2 months, starting immediately",
    "Current Location(With Country)": "Lucknow, India",
    "Does Remote Internship work for you?":
      "Yes. I would also be willing to relocate pan India once the situation improves",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ocYtGLGo_npVyw_8w--HAh64DtdubxPH/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/apoorvasingh0803",
    "Contact Details (Email)": "singh.apoorva.0803@gmail.com",
    "Anything else you'd like to share?":
      "I was offered an internship on day 1 at IIT Kanpur by a reputed global research and advisory firm, and I was given a pre-placement offer by the last firm I interned at. I hope this can vouch for my abilities and work ethics.",
  },
  {
    Timestamp: "04/03/2020 12:33:18",
    "Name of the student": "Setu Dambhare",
    "Institute Name(College)":
      "Dr. D.Y. Patil Biotechnology &Bioinformatics Institute.",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Molecular biology",
    "Period of Internship": "2 months. Start Date- 11 May, 2020.",
    "Current Location(With Country)": "Pune, India.",
    "Does Remote Internship work for you?":
      "Yes, I can relocate if the situation allows. Preferred cities- Bangalore.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Xi3TQwUFf_7B5ZRXkeSw8vN2wdzil2oT/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/setu-dambhare-a52226144",
    "Contact Details (Email)": "setu.dambhare8991@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:41:30",
    "Name of the student": "Gaurav Insha",
    "Institute Name(College)": "IIT kharagpur",
    "Field of study": "Matellurgical and Materials engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "Month of May",
    "Current Location(With Country)": "Roorkee(Uttarakhand)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VkB0K-8twWjFdmAceL1CmNe0sW2UHxBk/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gaurav-insha-55899717a/",
    "Contact Details (Email)": "gauravinsha.dakshana17@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:49:36",
    "Name of the student": "Mayur zalwar",
    "Institute Name(College)":
      "Mgm Institute of Management and research Aurangabad Maharashtra",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Digital marketing,social media marketing, and marketing",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Aurangabad",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1NzXnlX-sjmOc53ceb45uPCmSbJG-06JB/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/mayur-zalwar-544633169",
    "Contact Details (Email)": "mayurzalwar123@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/03/2020 12:52:13",
    "Name of the student": "Ashutosh Bhatt",
    "Institute Name(College)": "BITS Pilani",
    "Field of study": "B.E. (Hons.) Manufacturing with a Minor in Finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Strategy/Product Management/Growth",
    "Period of Internship": "1.5 months, starting from 5th April",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Wont be able to relocate if university resumes, if not then sure. Willing to relocate to mumbai, hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/bits-pilani.ac.in/file/d/154RBCzoRc-H99OXFwpjTjAzPwkJUrwxZ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ashutosh-bhatt-28787a175/",
    "Contact Details (Email)": "f20170957@pilani.bits-pilani.ac.in",
    "Anything else you'd like to share?":
      "I was offered an internship at a Venture Capital firm as an Investment Analyst that was cancelled due to the outbreak. \n\nVice President and case lead at BITS Pilani Consulting Club. Lead and delivered live cases for ngos and startups. ",
  },
  {
    Timestamp: "04/03/2020 12:55:35",
    "Name of the student": "Shubham Agrawal",
    "Institute Name(College)": "IIM Kashipur",
    "Field of study": "MBA in analytics & marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Product management, Consulting, Marketing, Analytics",
    "Period of Internship": "2 months from Today",
    "Current Location(With Country)": "Patna",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "http://bit.ly/shubhamnovo",
    "LinkedIn profile link": "www.linkedin.com/in/Shubham879",
    "Contact Details (Email)": "shubham.pgp18237@iimkashipur.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:55:44",
    "Name of the student": "Deepak Nechlani",
    "Institute Name(College)": "B.K School of Business Management",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "Ahmedabad",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/deepak-nechlani-b4022316a",
    "Contact Details (Email)": "deepak.ft21@bkschool.org.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:59:34",
    "Name of the student": "Deepanjan Biswas",
    "Institute Name(College)": "Goa Institute Of Management",
    "Field of study": "MBA",
    Education: "Undergraduate",
    "Preferred domain of internship": "Supply Chain and Operations",
    "Period of Internship": "2 months - Available to join at the earliest",
    "Current Location(With Country)": "Jamnagar, Gujarat, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZMmUi6Jhm2dhOLW2rAgn7REFeS43YJ7Z/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/deepanjan-biswas-939380124",
    "Contact Details (Email)": "deepanjanbiswas0902@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 13:00:31",
    "Name of the student": "Param Goswami",
    "Institute Name(College)": "Indian Institute of Technology Kharagpur",
    "Field of study": "Mathematics and Computing",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2, Available now",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "Yes, Any city is preferable",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rcZXTc0m5TTg3o4H7CmHVx_PyB_0wyu2/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/param-goswami-77bb31151",
    "Contact Details (Email)": "paramgoswami2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 13:05:19",
    "Name of the student": "Bhumika Bhandari",
    "Institute Name(College)": "FMS, MSU, Vadodara",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "Yes, Ahmedabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/177v6_XYtnVxFNjT_d7OVjcYMw3tNmzF5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bhumika- bhandari-6045b7142",
    "Contact Details (Email)": "bhumika.bhandari.fms19@gmail.com",
    "Anything else you'd like to share?": "Thank you for this initiative",
  },
  {
    Timestamp: "04/03/2020 13:05:45",
    "Name of the student": "Mukur Gupta",
    "Institute Name(College)": "Indian Institute of Technology Kharagpur",
    "Field of study": "B.Tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science/Machine Learning",
    "Period of Internship": "Minimum 8 weeks between 1/4/20 to 27/7/20",
    "Current Location(With Country)": "Jaipur, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1CnSISPQmBPrUCyxMXYOIK_vRAIId7qwO?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/mukurgupta/",
    "Contact Details (Email)": "mukur.gupta1@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 13:10:57",
    "Name of the student": "Sukriti Sood",
    "Institute Name(College)": "Shri Ram College of Commerce",
    "Field of study": "B com (Hons)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance, HR",
    "Period of Internship":
      "Immediately available for WFH, 1 June -31 July  for full time",
    "Current Location(With Country)": "Gurugram, NCR, India",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocate to Bangalore or Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Jm1TMuRIlc9PGY8jURNxdwrpvUzWfPmz/view?usp=drivesdk",
    "LinkedIn profile link": "Sukriti Sood",
    "Contact Details (Email)": "soodsukriti17@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 13:17:43",
    "Name of the student": "Divesh Singhal",
    "Institute Name(College)": "IIT Madras",
    "Field of study":
      "Chemical engineering ( Minor in System engineering, Operation Research)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Supply chain, Bussiness analytics, Datascience , Data analytics",
    "Period of Internship": "May to july",
    "Current Location(With Country)": "India- Anywhere",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1PM63hjDy-fFYalYaEx0sbhWDpMTD-OzB",
    "LinkedIn profile link": "https://www.linkedin.com/in/divesh-singhal/",
    "Contact Details (Email)": "divesh39@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 13:59:44",
    "Name of the student": "Unez Kazi",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "MSc. Maths and Computing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Machine Learning, Deep Learning",
    "Period of Internship": "3 months (April, May, July)",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes. Yes. Any in PAN India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1N42ogElJ3NFzDYTVWvTkKFp3_FxzDsKV/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/unez-kazi-a61a27150/",
    "Contact Details (Email)": "unez@iitkgp.ac.in",
    "Anything else you'd like to share?": "My Contact Number- +918169341326",
  },
  {
    Timestamp: "04/03/2020 14:05:24",
    "Name of the student": "Sameer Prabhakar Narkhede",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Manufacturing science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2 months (3rd April 2020 to 31st May 2020)",
    "Current Location(With Country)": "Kharagpur (India)",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1eOxSumw1o8hsL77bEQZbaGscNE3zaQyF/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/sameer-narkhede-a0b273151",
    "Contact Details (Email)": "sameernarkhede.iitkgp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 14:05:32",
    "Name of the student": "P.V.S.L. Hari Chandana",
    "Institute Name(College)": "Indian Institute of Technology - Kharagpur",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science, Software Development",
    "Period of Internship": "2-3 months start data: 3-04-20",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?":
      "YES. Also I am open to relocating. Any place is fine.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aZ841P9wiWBfmfmhIPzo_Lb5IQfgE_OT/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/chandana-pvsl-999a83148",
    "Contact Details (Email)": "chandupvsl29@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 14:07:45",
    "Name of the student": "Smiral Rashinkar",
    "Institute Name(College)": "SRM Institute of Science and Technology",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Cloud computing, Machine learning or Software Development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Pune India",
    "Does Remote Internship work for you?":
      "Yes preferably at Bangalore or Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Kx3mYvBL4-S2zR_PihEh9Wn7fpC6UIQc/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/smiral-rashinkar",
    "Contact Details (Email)": "smiraldr@gmail.com",
    "Anything else you'd like to share?":
      "I am open for work from home as well. Although tentatively our college has been planned to finish with exams mid june, we'll be needing internship offer letter to get permission for the same. Although it is still being discussed upon I urge you to Connect me with appropriate opportunities. Thanks.",
  },
  {
    Timestamp: "04/03/2020 14:39:57",
    "Name of the student": "Alok Kumar",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Industrial and Systems Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Development, Product Development, Finance, Consulting, Research",
    "Period of Internship": "April-May",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Bangalore, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rwtubY5FVfAzx6uXgVVOW9-iIF0IQPWg/view?usp=drivesdk",
    "LinkedIn profile link": "http://www.linkedin.com/in/alok-kumar-u",
    "Contact Details (Email)": "alokashokkumar10022001@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 15:24:33",
    "Name of the student": "Amritash Bharadwaj",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Engineering Entrepreneurship",
    Education: "Dual Degree",
    "Preferred domain of internship": "Product Management",
    "Period of Internship": "1 Month/ 2 Month (Available in April and July)",
    "Current Location(With Country)": "Jaipur, Rajasthan, India",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aKTajGvpiccuzaECW1YPs312NmoM9Kwx/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/amritashbharadwaj",
    "Contact Details (Email)": "amritashbharadwaj@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 15:38:36",
    "Name of the student": "Supratim Dhar",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance, Analytics",
    "Period of Internship": "2 Months, Preferred Start Date: 13th April, 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocate. Mumbai/Pune/Bangalore is preferred.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1kk76gTAqkui3LIuRxNiyjzYpV58Y5BzK",
    "LinkedIn profile link": "www.linkedin.com/in/supratim-dhar-13a387182/",
    "Contact Details (Email)": "supratimdhar21@yahoo.in",
    "Anything else you'd like to share?":
      "I had an offer from Goethe University, Frankfurt, Germany. Tentative work was on High Frequency Trading. I am looking for internships related to the domain of Finance.",
  },
  {
    Timestamp: "04/03/2020 15:45:22",
    "Name of the student": "Saurabh Gupta",
    "Institute Name(College)": "Indian Institute of Technology Kharagpur",
    "Field of study": "Chemistry",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 Months Immediate joining (WHF)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No not now maybe after lockdown",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=15F08C_7Oq5GDGfaozVAFEwzmvmCzJ2L5",
    "LinkedIn profile link": "www.linkedin.com/in/saurabh-gupta2104",
    "Contact Details (Email)": "saurabhgupta2104@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 16:36:10",
    "Name of the student": "Ankit Kumar Panda",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?":
      "Yes, Preferred City - Bangalore, Hyderabad, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dQ-5_UWAKRlszAIgcczIN99pdaLjbeX3/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/ankit-kumar-panda-7a992013a",
    "Contact Details (Email)": "ankit.panda357@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/03/2020 17:23:31",
    "Name of the student": "Jonathan Ve Vance",
    "Institute Name(College)": "Indian Institute of Technology, Madras",
    "Field of study": "Data Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science",
    "Period of Internship": "2 months starting mid May.",
    "Current Location(With Country)": "Kerala, India",
    "Does Remote Internship work for you?":
      "No, I can not relocate in this situation.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/12zLbIrsWiPyZXLhBofvwQCT9i0f_vyw8/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/jonathanvevance",
    "Contact Details (Email)": "jonathanvevance@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 17:36:38",
    "Name of the student": "Amulya Aggarwal",
    "Institute Name(College)":
      "Deen Dayal Upadhyaya College (DDUC), Delhi University",
    "Field of study": "BMS-Bachelors Of Management Studies",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Including but not limited to Marketing, Analytics, research , brand management, PR and advertising, Consulting, Financial Management",
    "Period of Internship": "2 months (June and July)",
    "Current Location(With Country)": "New Delhi (India)",
    "Does Remote Internship work for you?": "Yes, Gurgaon , Noida.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1U_wVDChDHM2gxNd0QRoR_dWuyk08_mdt/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/amulya-aggarwal-40299a173",
    "Contact Details (Email)": "aggarwalamulya23@gmail.com",
    "Anything else you'd like to share?": "No, Thanks",
  },
  {
    Timestamp: "04/03/2020 17:44:34",
    "Name of the student": "Vivek Sheoran",
    "Institute Name(College)": "NITIE Mumbai",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Product Management, Supply Chain Management",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, any metro city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1hqAFVVpnMJKtiGHIqQJsVVEHXyEBekEn/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vivek-sheoran-3742a097/",
    "Contact Details (Email)": "vivek.sheoran.2021@nitie.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 18:03:24",
    "Name of the student": "ANANYA SHARMA",
    "Institute Name(College)": "IIT KHARAGPUR",
    "Field of study": "MECHANICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine learning, Deep learning and Data science",
    "Period of Internship": "2",
    "Current Location(With Country)": "Jaipur, Rajasthan",
    "Does Remote Internship work for you?":
      "Yes, remote internship works for me. Yes I am willing to relocate to any city in India if situation improves.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1f8J6EU5zpoAV_xWIykKcZKE2UOg3ua0M/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ananya-sharma-830480152/",
    "Contact Details (Email)": "ananyasharma.iitkgp@gmail.com",
    "Anything else you'd like to share?":
      "Please let me know the details as soon as possible.",
  },
  {
    Timestamp: "04/03/2020 18:43:01",
    "Name of the student": "Ayush Mishra",
    "Institute Name(College)": "Manipal University Jaipur",
    "Field of study": "Bachelor of Computer Applications",
    Education: "Undergraduate",
    "Preferred domain of internship": "Project management",
    "Period of Internship": "3 months, available immediately",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dIEUlFrROZtxjFgEcpo3c7w5YP497wOK/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ayushmishra206@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 18:48:52",
    "Name of the student": "Priyam Patel",
    "Institute Name(College)": "Amity University Jharkhand",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Developement",
    "Period of Internship": "2-3 months, July-August",
    "Current Location(With Country)": "Jamshedpur,India",
    "Does Remote Internship work for you?":
      "Yes, remote is probably the best option for me.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1aJrD5eujIzFG-kHc5da1KsDuZx97LP0Q",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyam-patel-0b3b2817b/",
    "Contact Details (Email)": "patelpriyam090@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 18:51:42",
    "Name of the student": "Gayathri Jayaraman",
    "Institute Name(College)": "Gargi College, Delhi University",
    "Field of study": "Political Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Policy Research",
    "Period of Internship": "4 to 6 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes; Bangalore, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1boBjfUvsxsPFXOmcD2l1hZx6WpsXzyl_/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "gayathrijayaraman2@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 18:54:57",
    "Name of the student": "Saurabh Agarwal",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance (Investment Analysis)",
    "Period of Internship": "6/04/2020-31/04/2020",
    "Current Location(With Country)": "Jamshedpur",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://in.linkedin.com/in/saurabh-agarwal-b09a48168",
    "Contact Details (Email)": "saurabhagarwal0601@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 19:01:22",
    "Name of the student": "Shahrukh Alam",
    "Institute Name(College)": "Purdue University",
    "Field of study": "Data Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "AI, Machine learning,Deep learning,Data Science,Data Analytics",
    "Period of Internship": "6 months(start date:  5/11/2020)",
    "Current Location(With Country)": "Hammond,IN,United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/10KAZRO9nlTdYYoZ8hrQ-ueZ1UvdLbC63/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shahrukh-alam-2086b5157",
    "Contact Details (Email)": "shahrukhalamkhan201@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/03/2020 19:06:02",
    "Name of the student": "Shahrukh Alam",
    "Institute Name(College)": "Purdue University",
    "Field of study": "Data Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "AI, machine learning, deep learning,big Data ,data science,data analytics",
    "Period of Internship": "6 months (start date: 05/11/2020)",
    "Current Location(With Country)": "Hammond,IN, US",
    "Does Remote Internship work for you?":
      "Yes, preferred city: new York,new Jersey, California, Washington,Chicago,Texas",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/10KAZRO9nlTdYYoZ8hrQ-ueZ1UvdLbC63/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shahrukh-alam-2086b5157",
    "Contact Details (Email)": "shahrukhalamkhan201@gmail.com",
    "Anything else you'd like to share?": "Cell:.   +1(219)315-4056",
  },
  {
    Timestamp: "04/03/2020 19:07:50",
    "Name of the student": "Mridupon Kutum",
    "Institute Name(College)": "Indian Institute of Technology Kharagpur",
    "Field of study": "Industrial and Systems Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Analyst, Consultant, Operations, Web Development.",
    "Period of Internship": "1 Month(Most probably During May Month)",
    "Current Location(With Country)": "Assam,India",
    "Does Remote Internship work for you?":
      "yes. I preferred in Guwahati,Assam",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1HUjKXE0R_E20idMl4HbTrBK-9jZhTA-5/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mriduponkutum83@gmail.com",
    "Anything else you'd like to share?":
      "Respected Sir\nI am eagerly Looking for an Internship Opportunity even though it is unpaid. I have been looking out for an Internship from last few days . Even though it is crucial for a company to offer an internship during this pendemic Covid 19 period, I would be very appreciate even if I can gain an experience with unpaid on the above mentioned topics.",
  },
  {
    Timestamp: "04/03/2020 19:16:16",
    "Name of the student": "Prabhu Agrawal",
    "Institute Name(College)": "School of Petroleum Management, PDPU",
    "Field of study": "Energy & Infrastructure",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Energy (Oil and Gas)",
    "Period of Internship": "05-04-20 onwards (2 months)",
    "Current Location(With Country)": "Gandhinagar (India)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Nq0qU-OYrtIx-WgwXM5AuYTWT_DC7fo6/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/prabhu-agrawal-1730bb163",
    "Contact Details (Email)": "7017378747",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 19:16:26",
    "Name of the student": "Aniket Vinchurkar",
    "Institute Name(College)": "IIT Guwahati",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Analytics, Business Analytics, FInance, Operations, Product Management",
    "Period of Internship": "2-3 Months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/128aPuTAyg4kUn3C7TGwA0YdlVVifUvvx/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/ahvinchurkar/",
    "Contact Details (Email)": "vinchurk@iitg.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 19:28:32",
    "Name of the student": "Raj Golhani",
    "Institute Name(College)": "Indian Institute of Technology,Delhi",
    "Field of study": "B.Tech - Biotechnology and Biochemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting/ Finance/ Business Development and Market Research/ Strategy Planning/Operations",
    "Period of Internship":
      "2 months starting from May 15( it might change due to lockdown)",
    "Current Location(With Country)": "Jabalpur(India)",
    "Does Remote Internship work for you?":
      "Yes, I am open for it. My preferred cities are Delhi ,Noida, Gurgaon, Bengaluru and any other tier1 city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1kFEtUHcJKjbVp_82vjJgOLJnVm4ENpzx",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/raj-golhani-778a7416a/",
    "Contact Details (Email)": "rajgolhani03@gmail.com",
    "Anything else you'd like to share?":
      "I am enthusiastic hard working student with a good management and leader ship skill.I also believe in thinking creative and out of the box .I have entrepreneurial mindset and also pursuing minor degree in Entrepreneurship along with my degree.",
  },
  {
    Timestamp: "04/03/2020 20:06:34",
    "Name of the student": "Sanchit Jain",
    "Institute Name(College)": "Vellore Institute of Technology",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Development / Business Analytics",
    "Period of Internship": "3 months starting from 10/4/2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Can relocate anywhere around the globe",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1njE55flBZGjCl9TN1q46DvMaC8jiHQEP",
    "LinkedIn profile link": "https://www.linkedin.com/mwlite/in/sanchitjain1",
    "Contact Details (Email)": "sanchit@venture-spring.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 20:34:11",
    "Name of the student": "Bhoomika Agarwal",
    "Institute Name(College)": "Institute of Management Technology",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months, starting immediately",
    "Current Location(With Country)": "Surat, India",
    "Does Remote Internship work for you?": "Yes. Kolkata/Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xpk2KojF7BqIIpft4ACjuQtpTyxCdOVN/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bhoomika-agarwal-040a89149",
    "Contact Details (Email)": "agarwalbhoomi97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 21:18:33",
    "Name of the student": "Prateek Mohanani",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Material Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance/Investment Banking",
    "Period of Internship": "1.5-2 months",
    "Current Location(With Country)": "Jodhpur, Rajasthan, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1WOBDGmBWBp47KzXVKxe5_4z6N5Lk-7eb",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prateek-mohanani-b74b20165/",
    "Contact Details (Email)": "prateek.mohanani4321@gmail.com",
    "Anything else you'd like to share?": "--",
  },
  {
    Timestamp: "04/03/2020 21:41:46",
    "Name of the student": "JALAJ DORAIBURU",
    "Institute Name(College)": "Indian Institute of Technology,Kharagpur",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software development and Machine Learning",
    "Period of Internship": "2 months  6 April to 31 May",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1ToI943xbm5qlMHMIEn56oxNDpq2PYrYt",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jalaj-dorai-132009113/",
    "Contact Details (Email)": "jalajdorai@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 21:42:22",
    "Name of the student": "Connor Denning",
    "Institute Name(College)": "Gonzaga University",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Transportation Engineering",
    "Period of Internship": "May-August",
    "Current Location(With Country)": "Portland, Oregon, USA",
    "Does Remote Internship work for you?":
      "Yes, willing to move to Spokane, Washington or Seattle, Washington",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/16Q_fRWtepl2M04BvuHJfDvJ-5655xnrPj8zc4KgSPkg/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/connor-denning-95bb88193/",
    "Contact Details (Email)": "denningconnor@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 22:01:47",
    "Name of the student": "Abhinav Jaiswal",
    "Institute Name(College)": "IIIT Gwalior",
    "Field of study": "Information Technology",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "May-July",
    "Current Location(With Country)": "Gwalior,Madhya Pradesh,India",
    "Does Remote Internship work for you?":
      "Yes,Open to relocate to Bangalore,Pune,Gurgaon,Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/12UruI4O4oz94vs-RcC5MW-RZY62lKCfj/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhinav-jaiswal-638045141/",
    "Contact Details (Email)": "abhinavjaiswal0144@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 23:07:57",
    "Name of the student": "Pranjal Jani",
    "Institute Name(College)": "Som-Lalit Institute of Business Managment",
    "Field of study": "MBA Y1 (Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship":
      "for 8 weeks (any date. work from home preferable due to current  condition)",
    "Current Location(With Country)": "Nadiad",
    "Does Remote Internship work for you?": "YES. Ahmedabad, Rajkot , Vadodara",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1JdCpVzFajADDQ1aPQQ28GicuBMag0pB6/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/pranjal-jani",
    "Contact Details (Email)": "pranjaljani323@gmail.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/03/2020 23:25:18",
    "Name of the student": "Niraj J.",
    "Institute Name(College)": "TISS, Mumbai",
    "Field of study":
      "MA Social Work (Community organization and development practice)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Development sector",
    "Period of Internship": "2",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CKyJbsX8d41KGy5Ag8OC8S6T9Z0AgRIj/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/niraj-jawale-9810776b",
    "Contact Details (Email)": "niraj.jawale1995@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 00:14:10",
    "Name of the student": "Pankaj Armo",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Metallurgical and Materials Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Business Analysis, Data Analysis",
    "Period of Internship": "8 Weeks, Start Immediately",
    "Current Location(With Country)": "Bhopal, Madhya Pradesh, India",
    "Does Remote Internship work for you?":
      "Yes, Preferred relocation: Bangalore,Pune,Hyderabad,Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Tsb9fKchmhjM6wLpsBqXi_14kISo1kQS/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pankaj-armo-27993b15b/",
    "Contact Details (Email)": "pankajarmo.iitkgp@gmail.com",
    "Anything else you'd like to share?":
      "My Intership with Gartner was called off, actively looking for opportunities",
  },
  {
    Timestamp: "04/04/2020 00:26:48",
    "Name of the student": "Japman Kharbanda",
    "Institute Name(College)": "University of British Columbia",
    "Field of study": "Economics/Business",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance/Marketing/Investment Banking",
    "Period of Internship": "4-8",
    "Current Location(With Country)": "Canada",
    "Does Remote Internship work for you?": "Yes, anywhere in Canada/US",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Fe8jd1GnW3XepqviNBUTuVsgVoJrJvWC",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/japman-kharbanda-181965138/",
    "Contact Details (Email)": "japman97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 00:58:15",
    "Name of the student": "Raghav Sharma",
    "Institute Name(College)": "Indian Institute of Technology, Delhi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Consulting, Fin-tech, Data Analytics",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "Chandigarh",
    "Does Remote Internship work for you?": "New Delhi, Gurgaon, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1nZHtgELZ4oyehfk9chG_PLGLiaEWUI1P/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/raghav-sharma-a966b215b",
    "Contact Details (Email)": "raghav010599@gmail.com",
    "Anything else you'd like to share?":
      "I'm Raghav Sharma, a junior undergraduate in Chemical Engineering at IIT Delhi. I did my schooling in Chandigarh which is also my home town and after cracking JEE, I moved to Delhi. Here I have strived to maintain a consistent academic record along with co-curricular and extra-curricular activities. I enjoy quizzing and participating in literary activities. I have also been part of the organising teams of various fests at IITD. Apart from that my academic experiences in South Korea and France have helped me develop my technical and leadership skills. In South Korea, I worked for 2 months as a research fellow in a Computational Lab. I really enjoyed the experience of research which I got however I've decided not to pursue research as it tends to be a bit slow and the output to input ratio lags a lot. I've also spent an entire semester in France as part of IIT Delhi's student exchange program. That was a unique experience which taught me various things about life, living in a different culture, meeting new people. I'm always on the lookout for exciting avenues to work and learn especially in fields such as consulting and data analytics.",
  },
  {
    Timestamp: "04/04/2020 00:59:41",
    "Name of the student": "Divyanshu Sheth",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study":
      "Industrial Electronics: Engineering Design and Manufacturing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning / Deep Learning / Data Science",
    "Period of Internship": "1-4 months, starting immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, a remote internship works. My hometown is Mumbai, and I can relocate to almost any major city in the country for the internship, if the situation improves.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1wMIsE12ed6t4ii9v33JtZl2eVblaMI3i",
    "LinkedIn profile link": "https://www.linkedin.com/in/divyanshusheth/",
    "Contact Details (Email)": "shethdivyanshu2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 01:26:21",
    "Name of the student": "Ravali Sambu",
    "Institute Name(College)": "Stony Brook University",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1e_ETmHCf1jkPT_soeug9SDyxzYbgJ6aK/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/ravali-sambu",
    "Contact Details (Email)": "ravali.sambu5@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 01:30:31",
    "Name of the student": "Chinmay Singh",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Chemical Engineering with minor in Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning, Natural Language Processing, Computer Vision",
    "Period of Internship": "2",
    "Current Location(With Country)": "Delhi",
    "Does Remote Internship work for you?":
      "Yes, Can relocate to Anywhere ( Delhi NCR preferred)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=114tN5PII0AJg-TMiIgw2oo2SCA65JjOW",
    "LinkedIn profile link": "https://www.linkedin.com/in/chinmaysingh1/",
    "Contact Details (Email)": "chinmaysingh.iitkgp@gmail.com",
    "Anything else you'd like to share?":
      "Had Previous Intern Offers from Apple California and Gartner India for Machine Learning Role which got rescinded",
  },
  {
    Timestamp: "04/04/2020 01:33:14",
    "Name of the student": "Aman asawa",
    "Institute Name(College)": "IMT Nagpur",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Bhilwara ( India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/aman-asawa-a6610b12b",
    "Contact Details (Email)": "9429010421",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 01:46:56",
    "Name of the student": "Amrit Chugani",
    "Institute Name(College)": "Oklahoma State University",
    "Field of study": "Industrial Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Supply Chain, Business Analytics",
    "Period of Internship": "Summer (May  2020 - August 2020)",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ermA4cbVxdbBKfH216-sPt2e-Vdmk9dE/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/amritchugani/",
    "Contact Details (Email)": "achugan@okstate.edu",
    "Anything else you'd like to share?":
      "I had received Supply Chain internship opportunities from Pepsico and Baker Hughes which got canceled due to COVID-19",
  },
  {
    Timestamp: "04/04/2020 02:53:12",
    "Name of the student": "Shaurya Sharma",
    "Institute Name(College)": "Purdue University",
    "Field of study": "Engineering Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Strategy, Operations, Product Management, Marketing",
    "Period of Internship": "12 month starting 15th May 2020",
    "Current Location(With Country)": "Indiana, United States",
    "Does Remote Internship work for you?":
      "Yes. Willing to relocate anywhere.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1yFy6P63-TkWT56FSnHjmFfB59hHg8UA-/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/shaurya19",
    "Contact Details (Email)": "sharm416@purdue.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 03:05:20",
    "Name of the student": "Akshat Agarwal",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Development, Analytics, Product Management, Machine Learning, Data Science",
    "Period of Internship": "1-2 months. I can start right away!",
    "Current Location(With Country)": "Noida, Uttar Pradesh",
    "Does Remote Internship work for you?":
      "I would like to Work from home. Not willing to relocate if the lockdown is over",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1TBZOF1-viTQyFEvNeGXA2KCfw9sKOeTg",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshat-agarwal-004208143/",
    "Contact Details (Email)": "akshatagl1@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 03:09:10",
    "Name of the student": "Trevor Diuco",
    "Institute Name(College)": "Gonzaga University",
    "Field of study": "Business Administration: Accounting",
    Education: "Undergraduate",
    "Preferred domain of internship": "Accounting",
    "Period of Internship": "3 months starting Monday, May 11",
    "Current Location(With Country)": "Orange County, California, USA",
    "Does Remote Internship work for you?":
      "A remote internship is doable for me. If an in person internship is available, I would be able to relocate to the Spokane, WA area.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/vkw12c3v8hx06rc/Resume_Trevor_Diuco.docx?dl=0",
    "LinkedIn profile link": "https://www.linkedin.com/in/trevor-diuco/",
    "Contact Details (Email)": "tsdiuco@gmail.com || (949) 887-1067",
    "Anything else you'd like to share?":
      "I am a motivated person who is always willing to learn and wants to help as best I possibly can.",
  },
  {
    Timestamp: "04/04/2020 03:51:40",
    "Name of the student": "Abhirup mandal",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2 months, Immediately",
    "Current Location(With Country)": "Kharagpur, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1vicfKCa5St8Cce3IqtDrGk-VJYBCS-eJ",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhirup-mandal-97811016a/",
    "Contact Details (Email)": "abhirupmandal860@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 04:10:26",
    "Name of the student": "Karun Manikoth",
    "Institute Name(College)":
      "Purdue University - Krannert School of Management",
    "Field of study": "MS in Global Supply Chain Management (STEM)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Supply Chain/Operations",
    "Period of Internship": "3 months. Starting May 11th 2020.",
    "Current Location(With Country)": "Indiana, United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rRJLIyfxp44wBm6Ndm2Fh51vcBFPX_g_/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/karunnambiar",
    "Contact Details (Email)": "nambiar.karun@gmail.com",
    "Anything else you'd like to share?":
      "Lean Six Sigma Green Belt Certification",
  },
  {
    Timestamp: "04/04/2020 05:05:30",
    "Name of the student": "Swapnil Tripathi",
    "Institute Name(College)": "IIT Kanpur",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning and Deep Learning",
    "Period of Internship": "2 months (Immediately)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Yes, anywhere",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZwMtGo05CSGSb9iXOLsYpIN2zmuqYF0d/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/swapnil-tripathi-4997b0174/",
    "Contact Details (Email)": "swapnilt@iitk.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 05:17:22",
    "Name of the student": "Dhanshree Tejwani",
    "Institute Name(College)": "JIIT Noida",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Web Developer/Software Engineer/ Software Developer",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Kanpur, UP , India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "https://bit.ly/2wgpcN0",
    "LinkedIn profile link": "https://www.linkedin.com/in/dhanshreetejwani/",
    "Contact Details (Email)": "dhanshree.tejwani@gmail.com",
    "Anything else you'd like to share?":
      "I would like you to review my resume and linkedin profiles so that i can make them more refined.",
  },
  {
    Timestamp: "04/04/2020 05:31:26",
    "Name of the student": "Grace Trippiedi",
    "Institute Name(College)": "Miami University",
    "Field of study": "Mechanical Engineering/Engineering Management",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Construction Management, Project Management, Engineering",
    "Period of Internship": "2-3 months starting in May/June",
    "Current Location(With Country)": "Chicago, IL, USA",
    "Does Remote Internship work for you?":
      "Yes. Chicagoland area. Cincinatti, OH or Colombus, OH",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/ygtwkvmojq0hxh6/New%20Resume%20Spring%202020.docx?dl=0",
    "LinkedIn profile link": "https://www.linkedin.com/in/gracetrippiedi/",
    "Contact Details (Email)": "trippigd@miamioh.edu",
    "Anything else you'd like to share?":
      "I am an extremely driven individual and would love to gain hands on work experience. Thank you so much for your time and consideration.",
  },
  {
    Timestamp: "04/04/2020 06:04:25",
    "Name of the student": "Tanpong  Tanthien",
    "Institute Name(College)": "Georgia Tech",
    "Field of study":
      "Industrial and Systems Engineering in Machine Learning and Operations Research with a minor in management information systems",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science/ Machine Learning/ Operations Research/ Supply chain engineering / financial engineering/ consultant /analytics",
    "Period of Internship": "Start May or June 2020. End late August 202@",
    "Current Location(With Country)": "Atlanta, Georgia , usa",
    "Does Remote Internship work for you?": "Yes to remote. Yes to relocate",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "tanpong.tanthien@gmail.com",
    "Anything else you'd like to share?":
      "Please Contact me for more information or resume",
  },
  {
    Timestamp: "04/04/2020 08:15:15",
    "Name of the student": "Basil Mohamed-Sulieman",
    "Institute Name(College)": "Rutgers University",
    "Field of study":
      "Cognitive Science, Information Technology and Informatics Double Major",
    Education: "Undergraduate",
    "Preferred domain of internship": "User Experience Design",
    "Period of Internship": "Any period of time over 1 month.",
    "Current Location(With Country)": "New Brunswick, New Jersey, USA",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FOqaAYd6TqW7V3g9r9HcwjqrlIYoxrAW/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/basil-mohamed-sulieman-74690bbb/",
    "Contact Details (Email)": "basilmohsulieman@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:33:12",
    "Name of the student": "Avi Sankritya",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science,Machine Learning",
    "Period of Internship": "2 months.",
    "Current Location(With Country)": "Dhanbad(India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Z-fmXfvv-YuTC3Y9az36amE-xNTPMLsz/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/avisankritya",
    "Contact Details (Email)": "avisankritya1@gmail.com",
    "Anything else you'd like to share?":
      "I am really in a dire need of Internship.  I would like to mention that I am a highly motivated and hardworking individual. I am a very quick learner so would be able to learn any pre-requisites.",
  },
  {
    Timestamp: "04/04/2020 09:45:26",
    "Name of the student": "RISHABH RASTOGI",
    "Institute Name(College)": "jiit sec62 noida",
    "Field of study": "cse",
    Education: "Undergraduate",
    "Preferred domain of internship": "cse/it",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "delhi ncr india",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1WzFMQ2XCZAXyZbrOoNLU4q31zctyVyvM",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rishabh.rastogi.31@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 10:50:44",
    "Name of the student": "Avish Jain",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning and Deep learning",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "Indore, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XvsBDLWidM9Rjt31wJFV_0Ma8j-Yt6i7/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/avish-jain-a27141156",
    "Contact Details (Email)": "Avishj21@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 10:54:14",
    "Name of the student": "Vineet Swami",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Railways and Construction",
    "Period of Internship": "2 months (20/05/2020)",
    "Current Location(With Country)": "Golaghat Assam, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ppdVpUzk0ITBsg9qJpIuftH-h_-Qdh3N/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/vineet782",
    "Contact Details (Email)": "vineetswami.nits@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 10:59:03",
    "Name of the student": "Shambhav Tyagi",
    "Institute Name(College)": "IIT (B.H.U.), Varanasi, India",
    "Field of study": "Ceramic Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Android App development, Software Development",
    "Period of Internship": "2/3 months",
    "Current Location(With Country)": "Lucknow, India",
    "Does Remote Internship work for you?":
      "Yes, Remote work goes well. I�ll be able to relocate anywhere PAN India after my semester exams will be over",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/1xLwHzVLS6F77xXUG_l-1kaEfojZo7Iid/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/shambhav-tyagi/",
    "Contact Details (Email)": "Shambhav.tyagi.cer17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 11:25:28",
    "Name of the student": "Tarang Nigam",
    "Institute Name(College)": "MNIT",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business strategy, consultancy, Marketing and Finance",
    "Period of Internship": "1",
    "Current Location(With Country)": "Kanpur, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1bqFE8XEeUoJQIGVwmizmlqxJo3N_gjOS/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "tarangnigamx@gmail.com",
    "Anything else you'd like to share?":
      "I had been going for a research internship in Canada this summers but due to Corona outbreak it stands cancelled.",
  },
  {
    Timestamp: "04/04/2020 11:26:35",
    "Name of the student": "Anabelle Harden",
    "Institute Name(College)": "Colorado College",
    "Field of study": "Psychology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "HR / marketing / anything where I can put my psych skills to good use!",
    "Period of Internship": "May 2020 - August 2020",
    "Current Location(With Country)": "Telluride, CO, USA",
    "Does Remote Internship work for you?":
      "I am open to remote and definitely open to relocate anywhere.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1OxGgXZadvwc9f7zTKLlxDhPVU7TgQEqsy7g10vjaCBI/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anabelle-harden-a7a1a517b/",
    "Contact Details (Email)": "a_harden@coloradocollege.edu",
    "Anything else you'd like to share?":
      "Please feel free to reach out to me if you have any more questions!",
  },
  {
    Timestamp: "04/04/2020 11:56:50",
    "Name of the student": "RICHA SRIVASTAVA",
    "Institute Name(College)": "IIT KHARAGPUR",
    "Field of study": "HUMAN RESOURCE MANAGEMENT",
    Education: "Post-Graduate",
    "Preferred domain of internship": "HUMAN RESOURCE",
    "Period of Internship": "2(16th April,2020)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "BANGALORE",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17IC6ZTQKiQstTl8GsAAdTiC7pMOojkc4",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/richa-srivastava-55542771/",
    "Contact Details (Email)": "richask22@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:11:35",
    "Name of the student": "Divya Kelkar",
    "Institute Name(College)": "SIESCOMS",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "Any time",
    "Current Location(With Country)": "Mumbai, india",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "I have pdf",
    "LinkedIn profile link": "leodivya.dk@gmail.com",
    "Contact Details (Email)": "leodivya.dk@gmail.com",
    "Anything else you'd like to share?":
      "Yes I am looking for a job wfh more than a internship",
  },
  {
    Timestamp: "04/04/2020 12:15:04",
    "Name of the student": "Sriramoju Avinash Sai",
    "Institute Name(College)": "Indian Institute of Technology",
    "Field of study": "Metallurgical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1tFJ4JZqImaqrD5mls0oAVeDyfTlSGcwS/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/avinash-sai99",
    "Contact Details (Email)": "sas10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:15:28",
    "Name of the student": "Amit Ashu",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study":
      "Major in Electrical Engineering, Minor in Computer Science & Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Development, Business & Data Analytics",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Banglore/Gurgaon",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1zaQOfjf5wx68E2nMdQiB6dg6MLxx4p_t/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/amitashu07",
    "Contact Details (Email)": "am49@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I am a third-year undergraduate student of School Of Electrical Sciences, enrolled in its Four Year Bachelor Of Technology Course at IIT Bhubaneswar, interested in the field of Business & Data Analytics and Consulting.\n \nI am aspiring to gain more of both theoretical and practical knowledge in these domains.\n\nI also have a strong skill set in Business Development, Operations and Field Sales Domain.\nI am an experienced specialist with a demonstrated history of working in the management, administrative, e-learning, and people-oriented organizations.",
  },
  {
    Timestamp: "04/04/2020 12:15:33",
    "Name of the student": "Amit Ashu",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study":
      "Major in Electrical Engineering, Minor in Computer Science & Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Development, Business & Data Analytics",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Banglore/Gurgaon",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1zaQOfjf5wx68E2nMdQiB6dg6MLxx4p_t/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/amitashu07",
    "Contact Details (Email)": "am49@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I am a third-year undergraduate student of School Of Electrical Sciences, enrolled in its Four Year Bachelor Of Technology Course at IIT Bhubaneswar, interested in the field of Business & Data Analytics and Consulting.\n \nI am aspiring to gain more of both theoretical and practical knowledge in these domains.\n\nI also have a strong skill set in Business Development, Operations and Field Sales Domain.\nI am an experienced specialist with a demonstrated history of working in the management, administrative, e-learning, and people-oriented organizations.",
  },
  {
    Timestamp: "04/04/2020 12:26:51",
    "Name of the student": "Anuj Parmar",
    "Institute Name(College)": "VGSoM, IIT Kharagpur",
    "Field of study": "Business Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Open to any opportunity",
    "Period of Internship": "2 Months with immediate availability",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Delhi/NCR, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1VWNr5TzUS0JgDGSYmgw3Fga47SiXwMfd",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anuj-parmar-154a8672/",
    "Contact Details (Email)": "anuj.parmar.iitkgp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:29:53",
    "Name of the student": "Alan Sankar B",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Digital Signal Processing, Electronics",
    "Period of Internship": "2 months starting from 5th May",
    "Current Location(With Country)": "Bhubaneswar, Odisha , India",
    "Does Remote Internship work for you?":
      "yes, open to relocating if situation improves , Preferred city : Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15JDAUuKk05vd946QsojJgGr524fcO7RL/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/alan-s-a8491916b/",
    "Contact Details (Email)": "asb15@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:35:57",
    "Name of the student": "M Vamshi Krishna",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software development and Machine learning",
    "Period of Internship": "2 months, 10th may",
    "Current Location(With Country)": "Karimnagar, Telangana",
    "Does Remote Internship work for you?": "Yes. Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1JNz7S9bsy0crlQANDBKOhSXm7zAFwrCt/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vamshi-krishna-maddi-0505/",
    "Contact Details (Email)": "mvk15@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:36:01",
    "Name of the student": "Sri Krishna R",
    "Institute Name(College)": "Indian Institute of Management Raipur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Operations, Supply Chain, Finance, Marketing",
    "Period of Internship": "2 months, Starting from 06th April 2020",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?": "Yes - Any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1NMujzHVOLDtnXG-TELipzoxZDkrwUFBW?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sri-krishna-r-3b7667ba/",
    "Contact Details (Email)": "krishsrir@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:45:13",
    "Name of the student": "NIKHIL TAILOR",
    "Institute Name(College)": "IIT KHARAGPUR",
    "Field of study": "Physics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data, software",
    "Period of Internship": "1/4/20-31/5/20 and 25/6/20-29/7/20",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nikhil-tailor-142466150",
    "Contact Details (Email)": "nktnikhil@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:54:05",
    "Name of the student": "Kumari Vijeta",
    "Institute Name(College)": "Bakhtiyarpur College of Engineering, Patna",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "2 months (starting from 5th April 2020)",
    "Current Location(With Country)": "Patna, Bihar, India",
    "Does Remote Internship work for you?": "Yes,(Bangalore, Delhi, Kolkata)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-nEKCRAXWK2U-BDiLU5Opp6I-s43yn4i/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kumari-vijeta-6590921a5",
    "Contact Details (Email)": "vijeta.kumari.btech@gmail.com",
    "Anything else you'd like to share?":
      "python for everybody specialization on coursera. \nfamiliar with django. Created a blog website using it. ",
  },
  {
    Timestamp: "04/04/2020 13:21:18",
    "Name of the student": "Anurag Porte",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Development, Marketing, Management",
    "Period of Internship": "2 months, starting from 18 April",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Pume",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PG6mN3Q5nGzHncivhd6gcNg8PKnXPVD3/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anurag-porte-12a61316b",
    "Contact Details (Email)": "sonalporte@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 14:01:33",
    "Name of the student": "Mohit Kumar Goyal",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Bachelor of Technology-Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting, Business Analysts, Product Management, Logistics, Supply Chain",
    "Period of Internship":
      "Looking for internship of period upto two months and I shall be available for it from starting May to End July",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?":
      "Yes, Remote internships shall also work and preferred location would be south India like Mumbai, Pune, Bangalore, Hyderabad etc",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Yd2jhse-l00fAlr2A9maMHbXWg0Efoue/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://in.linkedin.com/in/mohit-kumar-goyal-30848b155",
    "Contact Details (Email)": "mohitkrgoyal8699@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 14:03:11",
    "Name of the student": "Savez Siddiqui",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "C.S.E.",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development",
    "Period of Internship": "6-8 weeks, first week of June.",
    "Current Location(With Country)": "Prayagraj, India",
    "Does Remote Internship work for you?": "Yes, Noida, India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1mCmVE1jCZ5eP6X11OB4iXyncsHhB5O7I/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/savez-siddiqui-53564617a",
    "Contact Details (Email)": "savezsiddiqui@gmail.com",
    "Anything else you'd like to share?":
      "I would prefer anything related to node.js",
  },
  {
    Timestamp: "04/04/2020 14:17:31",
    "Name of the student": "Ian Mah",
    "Institute Name(College)": "University of British Columbia",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Developer/Engineer",
    "Period of Internship": "May to August",
    "Current Location(With Country)": "Canada",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1f1tr920AEfjMRne3bdR1PemxnK8Ug2bZ/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/ianmah/",
    "Contact Details (Email)": "ianmmah@gmail.com",
    "Anything else you'd like to share?": "Thank you so much",
  },
  {
    Timestamp: "04/04/2020 14:26:21",
    "Name of the student": "Aniket Kumar",
    "Institute Name(College)": "IIT Patna",
    "Field of study": "EE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "2 months, starting from 15th may",
    "Current Location(With Country)": "Patna, India",
    "Does Remote Internship work for you?": "yes, bengaluru, Delhi, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Bo7FpQDhtpWYtrwXCn899-p61PLPBky9",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aniket-kumar-b4564b159/",
    "Contact Details (Email)": "aniketpinjour@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:02:52",
    "Name of the student": "nimish batra",
    "Institute Name(College)": "Shiv Nadar University",
    "Field of study": "International Relations and Governance Studies",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Public Policy and International Economics",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "NOIDA, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ie6r5ZskoFv-UCZh7LhcfAoE9DjxLyIK/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nimish-batra-58b554166",
    "Contact Details (Email)": "nimishbatra204@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:07:29",
    "Name of the student": "Stayed sumaiyyah",
    "Institute Name(College)": "Jain University",
    "Field of study": "Information science and technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software developer",
    "Period of Internship": "5",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/0B-wzmlQtQ63rYW82dFZOaEVWUEJKanVJWHM4NE1sUXVjSVZz/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sumaiya-sayed-53a676183",
    "Contact Details (Email)": "syedsumaiya0@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:23:14",
    "Name of the student": "Savi Modi",
    "Institute Name(College)": "Indian Institute of Technology Delhi",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting, Analytics, Operations, Finance, Civil Core",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Yes, I am ready for a suitable relocation.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18xdAHFCNNGJPsh6QL71ra8mY9O856NCk/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/savi-modi-7237641a2",
    "Contact Details (Email)": "savi.savimodi@gmail.com",
    "Anything else you'd like to share?":
      "I am really looking forward to be in touch with recruiters around the globe in this time of crisis. As the recruitment process of my college had to be stopped midway due to the outbreak,  it would be really helpful if I could reach out to companies through this platform.",
  },
  {
    Timestamp: "04/04/2020 16:25:16",
    "Name of the student": "Sanjeet Chandra",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Metallurgy and Materials Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analysis",
    "Period of Internship": "2.5 Months (10 May)",
    "Current Location(With Country)": "Bhubaneswar (India)",
    "Does Remote Internship work for you?": "Yes. Pune, Nagpur, Bhubaneswar.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1sQRlfuQFVeiJf2BfmoeQAU6JBaqogP8S/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sanjeet-chandra-230666157",
    "Contact Details (Email)": "sc27@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I am really into the field of Data Analysis and Bussiness Analysis, looking forward to see myself as Business Analyst in future.",
  },
  {
    Timestamp: "04/04/2020 16:56:18",
    "Name of the student": "Sumit Kumar",
    "Institute Name(College)": "Indian Institute of Technology (BHU), Varanasi",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software enginnering, Backened developer, Cloud based opportunity.",
    "Period of Internship": "2 months. 6 April to 6-June",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1J-sh_vT0-C3z0ekumekalXyPiUWuz6y6",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sumit-kumar-5546491a5",
    "Contact Details (Email)": "sumit.kumar.eee17@itbhu.ac.in",
    "Anything else you'd like to share?":
      "Looking for work from home based internship as per the current situation.",
  },
  {
    Timestamp: "04/04/2020 17:04:25",
    "Name of the student": "Yash Bhurani",
    "Institute Name(College)":
      "Delhi School of Management, Delhi Technological University",
    "Field of study": "Marketing and IT",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Product Management, Business Analyst, Marketing",
    "Period of Internship": "2-3 months starting from June",
    "Current Location(With Country)": "Delhi (India)",
    "Does Remote Internship work for you?": "Delhi NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1T7NgmQWSfVU4d3CdriO8X_oDwTQPPP91/view",
    "LinkedIn profile link":
      "https://in.linkedin.com/in/yash-bhurani-34174b128",
    "Contact Details (Email)": "yashwayne1@gmail.com",
    "Anything else you'd like to share?":
      "I am currently pursuing my MBA in Marketing and IT from Delhi Technological University. I have worked with Aspiring Minds as a Management Trainee - Product Management team for 14 months where I was responsible for liasoning with various stakeholders for timely development of the product and creating Business Requirement Documents (BRDs) for developers. I did functionality testing  of a product based on Call Chat Simulation. I was also responsible for making the android and iOS app consistent with the web interface by identifying the key gaps. Involved in developing the Test Manuals of the assessments. I did my B.Tech in Computer Science from GGSIPU (Delhi) and I did two internship during B.Tech. One at Aspiring Minds and other at Technical University of Sofia (Bulgaria).",
  },
  {
    Timestamp: "04/04/2020 17:09:07",
    "Name of the student": "Simran",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Biochemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Analytics/ Machine learning/ Business",
    "Period of Internship": "1 to 2 months",
    "Current Location(With Country)": "Work from home or Delhi, India",
    "Does Remote Internship work for you?": "yes, Any metrocity will work",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1s8ROk9hG-QIu68j3huY1fbZdS1WOiBtx/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/simran-dhiman-2a7240157",
    "Contact Details (Email)": "07simrandhiman@gmail.com",
    "Anything else you'd like to share?":
      "I don't have much experience in Analytics and Machine Learning field but I am looking forward to learn and do online courses as per internship requirement.",
  },
  {
    Timestamp: "04/04/2020 17:14:24",
    "Name of the student": "Aditya Ranjan",
    "Institute Name(College)": "Indian Institute of Technology Patna",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "VLSI and Computer Architecture",
    "Period of Internship":
      "Upto 2 month of internship, start date - around 20th May 2020",
    "Current Location(With Country)": "Patna, India",
    "Does Remote Internship work for you?": "Yes, Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1OprYO9ymYF_jVNB7FDsSPeL-_ox-3fzR",
    "LinkedIn profile link": "https://www.linkedin.com/in/aditya-ranjan-04",
    "Contact Details (Email)": "adityaranjan21052000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 17:16:13",
    "Name of the student": "Vasu Chourasia",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "DA, ML, PRODUCT MANAGEMENT",
    "Period of Internship": "2",
    "Current Location(With Country)": "Narsinghpur",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1IoxvMx-WufL4TEwEHye1xYViI7VJnuyK/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/vasuchourasia",
    "Contact Details (Email)": "vasu.chourasia695@gmail.com",
    "Anything else you'd like to share?": "Very keen to get any internship.",
  },
  {
    Timestamp: "04/04/2020 17:29:05",
    "Name of the student": "Amal Mathew James",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "BTech Metallurgical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Reserach: Modelling and Simulations( Preferably in Material Science or Physics)",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "Kerala",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VEihVmt7VCgc78thpunqN-ESGftwIChW/view",
    "LinkedIn profile link": "https://www.linkedin.com/in/amal-mathew-james/",
    "Contact Details (Email)": "amj10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 17:34:29",
    "Name of the student": "Arvind Ghorpade",
    "Institute Name(College)": "SITRC",
    "Field of study": "MBA-1Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Sales and Marketing, Business Development ,",
    "Period of Internship": "5 April - june",
    "Current Location(With Country)": "Nashik, Maharastra , India",
    "Does Remote Internship work for you?": "Nashik, Pune, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PmFsiwTixMgUqWBVeVstDPLWOYjm4Zk_/view?usp=drivesdk",
    "LinkedIn profile link": "ARVIND GHORPADE",
    "Contact Details (Email)": "ghorpadearvind@gmail.com",
    "Anything else you'd like to share?":
      "I will discuss the all details about the Collage/internship/lockdown/exam over the call",
  },
  {
    Timestamp: "04/04/2020 17:56:26",
    "Name of the student": "Surbhi Joshi",
    "Institute Name(College)": "Indian Institute of Foreign Trade",
    "Field of study": "Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data analytics or Finance",
    "Period of Internship": "May-June(2 months)",
    "Current Location(With Country)": "Indore, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1V2alY70E4zMCHKzUYCAwwS8NoEZlyLxL",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/surbhi-joshi-486b27150/",
    "Contact Details (Email)": "joshisurbhi36@gmail.com",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/04/2020 18:10:49",
    "Name of the student": "Vaibhav Khatwani",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study":
      "Agricultural and Food Engineering/Engineering Entrepreneurship (Dual Degree course)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting, Operations, Supply Chain, Analytics",
    "Period of Internship": "Two months April-May",
    "Current Location(With Country)": "Jaipur",
    "Does Remote Internship work for you?": "Delhi-NCR, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1LJ8ScuMkT0drhIvi-RZGtdQrz4ICuzQQ/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/vaibhav-khatwani",
    "Contact Details (Email)": "vaibhavkhatwani.iitkgp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 18:14:42",
    "Name of the student": "Lohar Lalit Jagadish",
    "Institute Name(College)":
      "Sandip institute of technology and research centre nashik",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "Nashik-maharashtra-india",
    "Does Remote Internship work for you?":
      "Nashik,Pune,Dhule,Jalgaon,Aurangabad",
    "Link to Resume(Google Drive/Dropbox)": "Yes",
    "LinkedIn profile link": "https://www.linkedin.com/in/lalit-lhar-318227191",
    "Contact Details (Email)": "lalitlohar907@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 19:01:36",
    "Name of the student": "Akshat Jain",
    "Institute Name(College)": "IIT Patna",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 months. Starting anytime in April or May.",
    "Current Location(With Country)": "Ajmer, Rajasthan, India",
    "Does Remote Internship work for you?":
      "Yes, remote internship works for me.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1fsrBLfzZavoPZ39iotdmpNM8Gjd050qc",
    "LinkedIn profile link": "https://www.linkedin.com/in/akjn99",
    "Contact Details (Email)": "akjn11@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 19:19:54",
    "Name of the student": "Jaiganesh S",
    "Institute Name(College)": "Anna University",
    "Field of study": "Agriculture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Agriculture",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, noida , delhi , banglore, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/12H5VZllr5PjcV5eD2DGPrvtydVlH9wfY/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jaiganesh-suthandiramani-890a58121",
    "Contact Details (Email)": "jaiganesh.s98fire@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/04/2020 19:31:31",
    "Name of the student": "Vaibhav Patil",
    "Institute Name(College)": "Sandip Foundation Nashik",
    "Field of study": "MBA (Marketing)",
    Education: "Under PG",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Nashik, Maharashtra",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "Yes",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vaibhav-patil-979238195",
    "Contact Details (Email)": "Vaibhavpatil1019@gmail.com",
    "Anything else you'd like to share?": "Nothing",
  },
  {
    Timestamp: "04/04/2020 22:53:24",
    "Name of the student": "Tushar Singla",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Instrumentation Engineering (B.Tech)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consultant; Business Analyst ; Strategy Analyst ;",
    "Period of Internship": "Start Date : April 10 ; 3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, Bangalore if needed  to relocate or as per the requirement",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1FOIAJVn1ce4GgIGwCEKK-rfFbHXeI6NW",
    "LinkedIn profile link": "https://www.linkedin.com/in/singla-tushar/",
    "Contact Details (Email)": "singlatushar2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 23:05:36",
    "Name of the student": "Krishnendu Chakraborty",
    "Institute Name(College)": "Institute of Engineering & Management Kolkata",
    "Field of study": "Computer Science & Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning,Data Science,C++,Python",
    "Period of Internship": "6 months,1st week of July",
    "Current Location(With Country)": "Kolkata,India",
    "Does Remote Internship work for you?":
      "Yes,I am open to relocate to any city in India.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1njN1jbVpz7iiNEET3Tel_L0peDtVPESI",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/krishnendu-chakraborty-09547994/",
    "Contact Details (Email)": "ikrish.coder@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/04/2020 23:17:55",
    "Name of the student": "Tuhin Atta",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Manufacturing Science & Systems Management",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science & ML",
    "Period of Internship": "2 months starting from April",
    "Current Location(With Country)": "Jamshedpur, India",
    "Does Remote Internship work for you?": "Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wpNTRSQegO0H8bo16aA0tjpNp0Mg9R0a/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tuhin-atta-b97196154/",
    "Contact Details (Email)": "tuhin9053@gmail.com",
    "Anything else you'd like to share?":
      "I have worked on ML and applied Data Analysis and ML algorithms to problems in our Data Analytics General Championship competitions. I have also worked on time series modelling architecture. I hope to extend my career in data science.",
  },
  {
    Timestamp: "04/05/2020 01:58:43",
    "Name of the student": "Maxwell Yang",
    "Institute Name(College)": "University of British Columbia",
    "Field of study": "Engineering Physics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "4 month, May 1, 2020",
    "Current Location(With Country)": "Richmond, BC, Canada",
    "Does Remote Internship work for you?":
      "Yes I am open to relocate, I do not have a preferred city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1NOls1ChgvCGNESnxZ6TfV3BeH_vVAAcJ/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/maxwellyang84/",
    "Contact Details (Email)": "maxwellyang84@gmail.com",
    "Anything else you'd like to share?":
      "Thank you for taking the time to look through this document!",
  },
  {
    Timestamp: "04/05/2020 02:33:06",
    "Name of the student": "Skylar Hughes",
    "Institute Name(College)": "Gonzaga University",
    "Field of study": "Human Resource Management & Marketing",
    Education: "Undergraduate",
    "Preferred domain of internship": "HR",
    "Period of Internship": "3-4 months",
    "Current Location(With Country)": "San Diego, CA",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/4z6rs86mhwt8qvg/Summer%202020-%20Resume%21.pdf?dl=0",
    "LinkedIn profile link": "https://www.linkedin.com/in/skylar-h-a0b862128/",
    "Contact Details (Email)": "skylarnhughes@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 04:48:42",
    "Name of the student": "Katherine Li",
    "Institute Name(College)": "Columbia University",
    "Field of study": "Data Analytics, Machine Learning",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Business Analytics, Consulting",
    "Period of Internship": "May 20, 2020",
    "Current Location(With Country)": "New York, NY",
    "Does Remote Internship work for you?": "Remote works fine",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Gw6L2vo3loaE4x9l9xJelou2g0km5qSq/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/katherine-li-0831/",
    "Contact Details (Email)": "ml4436@columbia.edu",
    "Anything else you'd like to share?":
      "My name is Katherine. I am master student at Columbia University major in applied analytics and interning at Business Insider as a business analyst. I have a strong background in data analytics, data visualization, and machine learning. But with the people-centric personality and strong sales skills, I'm always enjoying teamwork.  \n\nI am looking for any data and consulting related internship/full-time opportunities. Please contact ml4436@columbia.edu if you have any questions!",
  },
  {
    Timestamp: "04/05/2020 05:03:03",
    "Name of the student": "Soham bhattacharya",
    "Institute Name(College)": "Ndim",
    "Field of study": "Mba",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Consultancy",
    "Period of Internship": "2",
    "Current Location(With Country)": "New Delhi",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 05:25:43",
    "Name of the student": "Naman Gautam",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Textile Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Management Consulting or Analytics",
    "Period of Internship": "2 month's",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Definitely",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wxHaU-xntarBZgwbQqTV8neT_AY4s6u0/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/naman-gautam-8629a8152",
    "Contact Details (Email)": "Tt1170916@iitd.ac.in",
    "Anything else you'd like to share?":
      "\nAs a third-year undergraduate at the Indian Institute of Technology Delhi, I have gained skills and knowledge in Data Science, Machine and Statistical Learning, that I would like to leverage during my internship period.",
  },
  {
    Timestamp: "04/05/2020 06:03:39",
    "Name of the student": "Amrit Goswami",
    "Institute Name(College)": "Indian Institute of Technology Kharagpur",
    "Field of study":
      "Industrial and Systems Engineering with Specialisation in Financial Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning, Reinforcement Learning, Computer Vision",
    "Period of Internship": "2-4 months, starting April first week",
    "Current Location(With Country)": "Jaipur, India",
    "Does Remote Internship work for you?":
      "Yes, Preferred cities - Mumbai, Banglore, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1lrJXYJ8h-q13vaTSF4BWizY6ihxEp7BO/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/amritgos/",
    "Contact Details (Email)": "amrit4.8goswami@gmail.com",
    "Anything else you'd like to share?":
      "Github - https://github.com/amritgos",
  },
  {
    Timestamp: "04/05/2020 06:28:31",
    "Name of the student": "Sarthak Agarwal",
    "Institute Name(College)": "JIIT Noida",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Database, Data Analysis, Marketing and Content Management",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Yes, Bangalore, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1T1Z3KElL4giwNCEsm0a2KJSdT7W5Nr83/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/sarthakagarwaltech",
    "Contact Details (Email)": "sarthakagarwal.work@gmail.com",
    "Anything else you'd like to share?":
      "I am great at SQL, and can also work on Data Analysis and Backend technologies.",
  },
  {
    Timestamp: "04/05/2020 06:36:10",
    "Name of the student": "Shlok garg",
    "Institute Name(College)": "University of Illinois at Chicago",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months, Start date - 11th May 2020",
    "Current Location(With Country)": "Chicago, USA",
    "Does Remote Internship work for you?": "Yes, any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/10MrEMlnLCwfeD_d2sfGSk71BfO5Olvvd/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Sgarg28@uic.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 07:35:07",
    "Name of the student": "",
    "Institute Name(College)": "",
    "Field of study": "",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning",
    "Period of Internship": "April to June(start:any date in April)",
    "Current Location(With Country)": "Nalgonda",
    "Does Remote Internship work for you?": "Yes, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1qE6lrHBuJbSMYcwS1i-JJdzUp2-ySUHW/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sudhamsh.kukkadapu@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 07:44:01",
    "Name of the student": "Vaibhav Sharma",
    "Institute Name(College)": "University of Hyderabad",
    "Field of study": "Business Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Analytics or Audit (Risk)",
    "Period of Internship": "2 months, beginning 1st June 2020",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Yes, New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1nQMl2Mc-rZXtx8XNznq04Tq0_bvDsOx1/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/vaibhavsharma17596",
    "Contact Details (Email)": "vaibhav.17596@gmail.com",
    "Anything else you'd like to share?":
      "This opportunity readily fulfills my motive to not lose touch with my financial risk and IT Audit concepts learnt in my previous job of 14 months as an IT Audit Risk Analyst at Ernst and Young. Since my last job involved being adept to data analysis approaches, risk assessment competencies, preventing data breaches and holding a prowess at MS Excel, this opportunity will provide me hands-on experience in implementing the tools, enhancing my competency and adding another feather to my cap to hone my skills.",
  },
  {
    Timestamp: "04/05/2020 10:38:49",
    "Name of the student": "Rishabh Dev Sharma",
    "Institute Name(College)": "Shri Guru Tegh Bahadur Khalsa",
    "Field of study": "BA (HONS) Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "1-1.5",
    "Current Location(With Country)": "Delhi NCR",
    "Does Remote Internship work for you?": "Delhi and Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16FHCP4Sh-1p74WD9boazCIC-UMjjihqU/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://drive.google.com/file/d/1EYDePy69TlA0vwB_q8uh2FpVy67LR2bC/view?usp=drivesdk",
    "Contact Details (Email)": "Krishdsharma2001@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 11:39:30",
    "Name of the student": "Asutosh Swain",
    "Institute Name(College)": "IIT Patna",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software developer",
    "Period of Internship": "2month",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Bangalore, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ES-rMQicSgLkb_e4jV3xEMM3D5bBV3Gf/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/asutosh-swain-7146a016a",
    "Contact Details (Email)": "asutoshswain.419@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 12:41:20",
    "Name of the student": "Miral patel",
    "Institute Name(College)": "BK SCHOOL OF MANAGEMENT",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Capital market",
    "Period of Internship": "2",
    "Current Location(With Country)": "Ahmedabad",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/bkschool.org.in/file/d/1Dvk5GdOWIL9VrLQ-rD78Zfg79Dwkj0zJ/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "miralp92@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 13:44:28",
    "Name of the student": "MAYANK MANJEARA",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "metallurgical and materials engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Operations/ Product management/ Data Science/ Consult",
    "Period of Internship": "2 months. I can start from April 15.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, I can relocate to Bangalore/ Delhi if situation improves.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ABbHULbABeCIHeS7Xm5UaOxxMrz5IUb8/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mayank-manjeara-bbb504148",
    "Contact Details (Email)": "mayankmanjeara@gmail.com",
    "Anything else you'd like to share?":
      "At IIT Kharagpur, I have been exposed to a myriad of challenging roles that have instilled in me the abilities to lead and effectively work in a team. Being the General Secretary Sports & Games, Technology Students' Gymkhana at IIT Kharagpur I am holding the highest student-level position in campus and have gained a vast experience tackling managing and supervising a host of activities. As a student representative, I determined the key pain points that the student body was facing and devised plausible solutions to solve them in an expeditious manner. From negotiating for funds to liaising with local clubs, sporting associations and interfacing with institute authorities, I have matured to become a persuasive individual who strives to think for creative solutions. Furthermore, as Overall Coordinator at Inter IIT Sports Meet 2019, I have been able to lead a team of 98 students coordinating among publicity, sponsorship, hospitality and events and organise the 13 day Meet introducing Live Streaming, Live score update & Recreational Events. Besides, my experience goes into developing a project that predicts a fault in an industrial asset.",
  },
  {
    Timestamp: "04/05/2020 14:01:14",
    "Name of the student": "Sachin Saw",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Engineering, Machine Learning, Deep Learning",
    "Period of Internship":
      "I am looking for 2 months internship, with the startdate: 7/4/20",
    "Current Location(With Country)": "Kharagpur, India",
    "Does Remote Internship work for you?":
      "Yes, not have any preffered location",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1EhHXjSSy3kcDBJ_C1RP2NRi1hr7nES4mfk8OHQZ3lm8/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sachin-saw-906524164/",
    "Contact Details (Email)": "sachinsaw1998@gmail.com",
    "Anything else you'd like to share?": ".",
  },
  {
    Timestamp: "04/05/2020 14:04:55",
    "Name of the student": "Pratiksha P Prabhu",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "May 15th - August 15th (3 months)",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?":
      "Yes, any where within United States",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1CCdggSDcv05mI1V--HHAozx55XA0vnRY",
    "LinkedIn profile link": "https://www.linkedin.com/in/pratiksha-prabhu",
    "Contact Details (Email)": "pratikshapprabhu@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 15:24:21",
    "Name of the student": "Yogesh Gattani",
    "Institute Name(College)": "Ashoka University",
    "Field of study": "Political Science and International Relations",
    Education: "Undergraduate",
    "Preferred domain of internship": "Research, Analys, Governance etc.",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1BQ-ALfMykn_LZ4onIoHxjTP8B5LYyUw_/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/yogesh-gattani-6a7a9815b/",
    "Contact Details (Email)": "ygattani55@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 16:02:17",
    "Name of the student": "Akash Roy",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "1.Finance   2.Data Analytics",
    "Period of Internship": "1.5 month (10 th April 2020)",
    "Current Location(With Country)": "Kolkata,India",
    "Does Remote Internship work for you?":
      "Remote internship works good for me",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1gXPhPzv1zyKk9XnuLf-_2O4NNOPlEJ9s/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/akash-roy-b3742b166/",
    "Contact Details (Email)": "roy2016akash@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/05/2020 17:00:31",
    "Name of the student": "Saurabh kumar choudhary",
    "Institute Name(College)": "Vidya college of engineering",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development software development",
    "Period of Internship": "June",
    "Current Location(With Country)": "Meerut",
    "Does Remote Internship work for you?": "Yes delhi ;dehi ncr",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "saurabhthebeast2105@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 18:46:35",
    "Name of the student": "Priyanshu Singh",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Economics + Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software/AI/Data",
    "Period of Internship": "2-3 months. Available from April 1 to June 15",
    "Current Location(With Country)": "Kharagpur, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1q3IRDqurgOwGQPb_mUaoUiQfnU4D7l5R/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/priyanshu-singh/",
    "Contact Details (Email)": "priyanshux@iitkgp.ac.in",
    "Anything else you'd like to share?":
      "I was being considered for a reputed MNC in the United Kingdom but it got cancelled due to safety concerns over travelling abroad. A reputed/good company is my priority right now, even without stipend as well as available to work from home.",
  },
  {
    Timestamp: "04/05/2020 19:08:27",
    "Name of the student": "Chirag Sharma",
    "Institute Name(College)": "Madras School of Economics",
    "Field of study": "Economics (Applied Quantitative Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Analytics, finance, risk",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes. Bangalore, Mumbai, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/mse.ac.in/file/d/1-wVvmE0P9ojvBH06k1xhLfdtswOL1Vnl/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/chirag-sharma-370850136/",
    "Contact Details (Email)": "chiragsharma138@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 20:30:01",
    "Name of the student": "Akshi Atreya",
    "Institute Name(College)": "MBM Engineering College",
    "Field of study": "Information technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Python",
    "Period of Internship": "1st June - 31st July",
    "Current Location(With Country)": "Jaipur, India",
    "Does Remote Internship work for you?":
      "Yes, I'm ready to related once the situation stabilize. Jaipur, Mumbai, Bangalore, Chennai.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Z2AylHHIVCE42_SK7GtVFbAxeYoAACdO/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshi-atreya-33351219b",
    "Contact Details (Email)": "akshiatreya.10@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 21:16:16",
    "Name of the student": "Krutantak Patil",
    "Institute Name(College)": "University of Florida",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship":
      "3 months Summer Internship starting May 11, 2020 or 6 months Fall co-op",
    "Current Location(With Country)": "Florida, United States",
    "Does Remote Internship work for you?":
      "Yes, remote internship works for me. I'm also open to relocate if the situation improves. I have a good amount of experience working from home as well.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FtoG1cS-V7WO1pm-GvHm5-NQMkHeCjuk/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/krutantak",
    "Contact Details (Email)": "8.katnaturk@gmail.com",
    "Anything else you'd like to share?":
      "I have 2 years on industry experience working as a Full Stack Application Developer at JP Morgan Chase & Co. I am proficient in Java and Python Programming Languages, SQL as well as NoSQL data stores, RESTFul services and Web Technologies. I have worked on frameworks like Spring, Angular, Flask and FitNesse. Also, I am very well versed with Unix servers, Got version control and continuous integration and continuous delivery pipeline.",
  },
  {
    Timestamp: "04/05/2020 21:35:27",
    "Name of the student": "Ishan Agrawal",
    "Institute Name(College)": "Indian institute of technology kharagpur",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data science, business analysis,  product management",
    "Period of Internship":
      "2 immidiate joining with a break from 1 june to 23rd june",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MDd8zXft1HbLTkB808FE4w8Gj3SFSRad/view?usp=drivesdk",
    "LinkedIn profile link": "Linkedin.com/in/ishan-agrawal-50548216b/",
    "Contact Details (Email)": "ishanagrawal3328@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 21:38:33",
    "Name of the student": "Divyam Jain",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Quantitative Research",
    "Period of Internship": "2 months - In the months of May and July",
    "Current Location(With Country)": "Kharagpur - India",
    "Does Remote Internship work for you?":
      "I am open to remote internship opportunities. Currently, I am within my campus at IIT Kharagpur. As soon as the situation improves, I will be going back to Mumbai where I live. Hence, my preferred location for internship shall be Mumbai, though I am willing to relocate to any place my internship demands.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1lAE3X_ZnuMlTVVlQqwxeEOpuyieuPrW5?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/divyam-jain99/",
    "Contact Details (Email)": "divyamj.iitkgp@gmail.com",
    "Anything else you'd like to share?":
      "Cover letter - uploaded in the Resume folder shared above",
  },
  {
    Timestamp: "04/05/2020 23:29:06",
    "Name of the student": "Saurabh Yadav",
    "Institute Name(College)": "Indian institute of Management Jammu",
    "Field of study": "MBA  Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Gurgaon, India",
    "Does Remote Internship work for you?": "Yes, Mumbai , Pune , Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1nh0E6IkjfdwDCyJRwbfd_HJ7-3CMkqM7/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saurabh-yadav-325519191",
    "Contact Details (Email)": "mba19045@iimj.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 23:41:39",
    "Name of the student": "Patel Rajukhatal",
    "Institute Name(College)":
      "MIT-WORLD PEACE UNIVERSITY, School of Management, Pune",
    "Field of study": "Marketing Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing and Sales",
    "Period of Internship": "2 months, 01/05/2020",
    "Current Location(With Country)": "Latur, India",
    "Does Remote Internship work for you?": "Pune, India",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rajukhatal-patel-06b32093",
    "Contact Details (Email)": "rajukhatalpatel@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 23:59:17",
    "Name of the student": "KARAN MADHUSUDAN SANWAL",
    "Institute Name(College)":
      "B.K. School of Professional and Management Studies",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months starting from mid May",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "no",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1aLm0XvExFpkZadwUHPsfANeaMOXwwulB",
    "LinkedIn profile link": "https://www.linkedin.com/in/karan-sanwal/",
    "Contact Details (Email)": "karan.ft21@bkschool.org.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 02:03:25",
    "Name of the student": "Namrata Wadhwa",
    "Institute Name(College)": "VES College of Arts, Science & Commerce",
    "Field of study": "BMS (Marketing)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing, Social media, Branding",
    "Period of Internship": "2 months ( By start of April)",
    "Current Location(With Country)":
      "Mumbai (India) - Available to work remotely if location is out of Mumbai.",
    "Does Remote Internship work for you?": "Yes open to remote internship.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14IiTbrIVGBTt2MG51682p-mBYSSwyFd0/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/namrata-wadhwa-107a88160/",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?":
      "Possess traits of Dedication, Team work and Passion which will help me to excel in the work I do. A person with a Curious nature who has a desire to learn new skills and apply them as an asset to the organisation.\n\n My experience involves Conducting a Research project which improved my Critical thinking skills, Time managing skills, etc. By managing cultural events and taking part in competitions I strengthened my communication and interpersonal skills.\n \n I also know a lot about Branding and Social Media and have worked in various projects and made them a success.",
  },
  {
    Timestamp: "04/06/2020 03:09:20",
    "Name of the student": "Bihan Jiang",
    "Institute Name(College)": "Stanford University",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering/Consulting",
    "Period of Internship": "3 (start June 15)",
    "Current Location(With Country)": "Boston, USA",
    "Does Remote Internship work for you?":
      "open to remote and relocation (NY, SF, Dallas, Boston)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ToNd0JdPri0N4Hyskc2k4Pd5gDzRnxCy/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/bihanjiang/",
    "Contact Details (Email)": "bihan@stanford.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 07:06:22",
    "Name of the student": "Talha Kiani",
    "Institute Name(College)": "Washington University In Saint Louis",
    "Field of study": "Computer Science and Mathematics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Full Stack Web Development",
    "Period of Internship": "May - August",
    "Current Location(With Country)": "Saint Losis, USA",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-tmlw4dh_lDH8Rtx-b1a0emqHVt929by/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/talha-kiani-37306b135/",
    "Contact Details (Email)": "talhakiani@ymail.com",
    "Anything else you'd like to share?":
      "I am an ambitious young junior, enrolled in the Dual Degree Program at Washington University in Saint Louis. Having completed my Bachelors in Mathematics, with a minor in Physics and Statistics from Arcadia University, I am on track to get my Bachelors in Computer Science from WashU. I am actively looking for internship opportunities for summer 2020, and eagerly waiting to apply my knowledge in Maths and IT, to do something impactful.",
  },
  {
    Timestamp: "04/06/2020 09:21:33",
    "Name of the student": "Pooja Patwari",
    "Institute Name(College)": "IIT(ISM) Dhanbad",
    "Field of study": "Electronics and Instrumentation Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Rishikesh, Uttarakhand",
    "Does Remote Internship work for you?": "-",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1zWdMrOdXsNk9iSnubvOo3nC112wjiLu8/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://in.linkedin.com/in/pooja-patwari-a80672166",
    "Contact Details (Email)": "poojapatwari4@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 09:34:52",
    "Name of the student": "Jorge Albin",
    "Institute Name(College)": "University of British Columbia",
    "Field of study": "Business (HR & Finance)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Human Resources or Finance or Real Estate",
    "Period of Internship": "(1, 2, 3 or, 4 months) (Start date: May)",
    "Current Location(With Country)": "Vancouver, Canada",
    "Does Remote Internship work for you?": "Yes ( Any city)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11JHBaDFclZKwPCjguycPRKeAqcNMkkp7/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/jorge-albin",
    "Contact Details (Email)": "19jalbin@gmail.com",
    "Anything else you'd like to share?":
      "Thank you for the support and opportunity!",
  },
  {
    Timestamp: "04/06/2020 11:01:20",
    "Name of the student": "Jash P Sanghvi",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Industrial Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development/Data Science",
    "Period of Internship": "8-10 weeks from 7 April 2020",
    "Current Location(With Country)": "Rourkela, Odisha, India",
    "Does Remote Internship work for you?": "Bangalore, India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iHxyQnOdL-FwSKb0nYFqOXOyQu2_qPQM/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/jash-sanghvi/",
    "Contact Details (Email)": "jashpsanghvi@gmail.com",
    "Anything else you'd like to share?":
      "I am willing to start the internship right away as my summer vacation has started.",
  },
  {
    Timestamp: "04/06/2020 11:31:30",
    "Name of the student": "Shirin Pajnoo",
    "Institute Name(College)": "Symbiosis Centre for Media and Communication",
    "Field of study": "Mass communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Journalism",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Yes, I can relocate to Pune.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1MA9lzH7ZankQsS_jJ9Aoia3UHMKQM-pN",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shirin-pajnoo-9855481a1",
    "Contact Details (Email)": "pajnooshirin@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 11:39:57",
    "Name of the student": "Patricia Basu",
    "Institute Name(College)": "Symbiosis Centre for Media and Communication",
    "Field of study": "Communication Management",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Advertising (preferably in the planning department)",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Kolkata, India",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PkzZrz7eyhXGbAYNhYOX_OpoXA0Uy46B/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/patricia-basu-634393168",
    "Contact Details (Email)": "patricia.basu@scmc.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 11:42:49",
    "Name of the student": "Yashika",
    "Institute Name(College)": "Symbiosis centre for media and communication",
    "Field of study": "Mass comm",
    Education: "Undergraduate",
    "Preferred domain of internship": "Developemental sector",
    "Period of Internship": "1.5 months",
    "Current Location(With Country)": "Delhi- India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Yashikachhari01@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 11:48:23",
    "Name of the student": "Anantjeet Singh Dutt",
    "Institute Name(College)": "Symbiosis Centre for Media and Communication",
    "Field of study": "Communication Managment",
    Education: "Undergraduate",
    "Preferred domain of internship": "Advertising",
    "Period of Internship": "1 month, preferably starting 15th April",
    "Current Location(With Country)": "Visakhapatnam, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Mumbai, Delhi, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1tAtnqQ3_MUnnR9dKYYko-lOmM07kOj66/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anantjeet-singh-dutt-813381168/",
    "Contact Details (Email)": "anantjeet.dutt@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 12:00:03",
    "Name of the student": "Tina",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "10 April- 31st May",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Yes, I would be willing to relocate to any city in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1epAgATws23ow7DvrxSrCsRiPu8AlkaXq?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tina-chillar-61470416b/",
    "Contact Details (Email)": "tina123dchillar@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 13:50:41",
    "Name of the student": "Manasvi Furia",
    "Institute Name(College)": "Symbiosis Centre for Mass communication",
    "Field of study": "Advertising/PR",
    Education: "Undergraduate",
    "Preferred domain of internship": "Something in the field of advertising",
    "Period of Internship": "1-2 months maybe from April 25th",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "nope",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "manasvi.furia@scmc.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 14:51:45",
    "Name of the student": "Tanushi Bhatnagar",
    "Institute Name(College)": "Symbiosis center for media and communication",
    "Field of study": "Mass communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Writing/ journalism/ creative content creation",
    "Period of Internship": "2 months - Starting anytime in April",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Remote works best",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1qvnZKbTR_F6qv80seG6NrhJAcbArRGop/view?usp=drivesdk",
    "LinkedIn profile link":
      "http://linkedin.com/in/tanushi-bhatnagar-91025b168",
    "Contact Details (Email)": "tanushi.bhatnagar@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 17:54:27",
    "Name of the student": "Yashika",
    "Institute Name(College)": "Symbiosis centre for media and communication",
    "Field of study": "Mass comm",
    Education: "Undergraduate",
    "Preferred domain of internship": "Developemental sector",
    "Period of Internship": "1.5 months",
    "Current Location(With Country)": "Delhi- India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Yashikachhari01@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:09:21",
    "Name of the student": "M.Eswar",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1QqzFFCxEyn38wYPYN9O-TvAj6vFoY5SV/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "eswarmangamuri@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:23:43",
    "Name of the student": "Ritik Roy",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Metallurgical and Materials Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Analysis, Supply Chain, Operations, Business Research, Market Research, Data Analytics, Data Science, Machine Learning",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1ItlQSkpNdMDoNtuLiCvoTlRH4T67RwLu",
    "LinkedIn profile link": "www.linkedin.com/in/ritikroy",
    "Contact Details (Email)": "rr3@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I am currently, looking for both industrial (fields mentioned above)  as well as academic research internships if possible.",
  },
  {
    Timestamp: "04/06/2020 18:23:48",
    "Name of the student": "JAMMA SATHWIK",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "COMPUTER SCIENCE AND ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "DATA SCIENCE",
    "Period of Internship": "2 APRIL19",
    "Current Location(With Country)": "HYDERABAD,TELANGANA,INDIA",
    "Does Remote Internship work for you?": "Yes! for sure.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1-PHDydBx7KkdWtc9eEVziug7QdoHDH88HEKrCycgA_Y/edit?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/jammasathwik5830",
    "Contact Details (Email)": "js25@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I wanna do intern in the analytics and consulting part sub domain under data science domain.",
  },
  {
    Timestamp: "04/06/2020 18:24:15",
    "Name of the student": "Gudipudi Siva Rama Krishna",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electrical engineering domain",
    "Period of Internship": "2 months starting from May 10.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Bhubaneswar.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/10hSL1oxDV49c8axZmD7x2Mfqh-dxA4XP/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "grk11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:24:36",
    "Name of the student": "Akshat Vijaywargiya",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer Science, Core Electrical",
    "Period of Internship": "Max 2 months",
    "Current Location(With Country)": "Indore, India",
    "Does Remote Internship work for you?": "Indore",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshat-vijaywargiya-716396195",
    "Contact Details (Email)": "av25@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:25:36",
    "Name of the student": "Eknoor Malhotra",
    "Institute Name(College)": "Indian Institue of Technology, Kharagpur",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance/Consulting/Business Development/Data Analytics",
    "Period of Internship": "6th April to 31st May 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "I will be open to relocate if the situation improves. Following cities will be preferred: Bangalore, New Delhi, Mumbai, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1bKZXcsIqw30xHBb1WT5ziEyYwklW7aRG",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/eknoor-malhotra-b9820b16a/",
    "Contact Details (Email)": "eknoormalhotra.iitkgp@gmail.com",
    "Anything else you'd like to share?": "-",
  },
  {
    Timestamp: "04/06/2020 18:42:18",
    "Name of the student": "sneha gupta",
    "Institute Name(College)": "indian institute of technology bhubaneswar",
    "Field of study": "electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "digital signal processing, wireless communication technology,marketing,game development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "banda,Uttarpradesh",
    "Does Remote Internship work for you?":
      "yes, any city would be fine ,preferred City are delhi,allahabad,kanpur,bhubanesar,Jhansi.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Lx2hJulnRdvr8_FR6Ku7IuZnR-WC-_b7/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sneha-gupta-172b85179?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B9whXr081S5uu9uBXULlGBw%3D%3D",
    "Contact Details (Email)": "sg51@iitbb.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:44:52",
    "Name of the student": "Prabhas Naidu",
    "Institute Name(College)": "IIT BHUBANESHWAR",
    "Field of study": "Civil",
    Education: "Undergraduate",
    "Preferred domain of internship": "Work with startups",
    "Period of Internship": "2 months  from may 1",
    "Current Location(With Country)": "Bobbili, Andhra pradesh, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "apn10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:53:50",
    "Name of the student": "Krishna Dutta Tripathi",
    "Institute Name(College)": "Indian institute of technology Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Online teaching,app development,business development,business analyst, operation analysts",
    "Period of Internship": "Two months .",
    "Current Location(With Country)": "Kanpur,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "kdt13@iitbbs.ac.in",
    "Anything else you'd like to share?": "Nothing",
  },
  {
    Timestamp: "04/06/2020 18:57:18",
    "Name of the student": "Anish Rajuri",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "2 months, April 15 to August 1",
    "Current Location(With Country)": "Hyderabad",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11oKi8LNj05k7h1-s86U22l6pNW7BkJkR/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anish-rajuri-887720170",
    "Contact Details (Email)": "ra18@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I did like to work at any place in India.",
  },
  {
    Timestamp: "04/06/2020 18:59:35",
    "Name of the student": "Cholleti Murali Venkata Sai Sreejith",
    "Institute Name(College)": "Indian Institute of Technology, Bombay",
    "Field of study": "Aerospace Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software (coding)",
    "Period of Internship": "1.5 months",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Hh6WOk4-87HUgrSOG1CKjmilN18aKh-J/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mvs-sreejith-cholleti-012973157",
    "Contact Details (Email)": "cmvssreejith@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 19:02:43",
    "Name of the student": "Lahari Avvaru",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer programming",
    "Period of Internship": "1.5-2months,may 15",
    "Current Location(With Country)": "Hyderabad",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1WUU94D_fSCxQp_FOi6U29cX_XiVBxWHY/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/profile/view",
    "Contact Details (Email)": "avvarulahari2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 19:10:53",
    "Name of the student": "NITHYA SRI ANUMULA",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "COMPUTER SCIENCE",
    Education: "Undergraduate",
    "Preferred domain of internship": "SOFTWARE DEVELOPMENT",
    "Period of Internship": "2-3 MONTHS",
    "Current Location(With Country)": "HYDERABAD, INDIA",
    "Does Remote Internship work for you?": "HYDERABAD/ BANGALORE",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1UwoS5FKLmranmRZ_TCOdLEiKbk79XV8z/view?usp=sharing",
    "LinkedIn profile link": "-",
    "Contact Details (Email)": "ravindra.nithyasri@gmail.com",
    "Anything else you'd like to share?": "-",
  },
  {
    Timestamp: "04/06/2020 19:20:46",
    "Name of the student": "Suraj Bhika Lahase",
    "Institute Name(College)": "Indian institute of technology Bhubaneswar",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Engineering",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Malkapur, Maharashtra, India",
    "Does Remote Internship work for you?": "Yes, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1vGJnTpCNSCVDXM5wco3afmv8tdSXlKmC/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out Suraj Lahase�s profile on LinkedIn https://www.linkedin.com/in/suraj-lahase-917913157",
    "Contact Details (Email)": "sbl10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 19:30:46",
    "Name of the student": "Rishikesh Vepura",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software development and Machine Learning Engineer",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Hyderabad (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1Q44HT8Jds721foLiBF_0Fnu6Y9MAA5hj/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rishikesh-vepura-73b829185",
    "Contact Details (Email)": "rv13@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "Sorry didn't update cgpa in resume \nConsider cgpa as 7.49",
  },
  {
    Timestamp: "04/06/2020 19:39:44",
    "Name of the student": "KARTEEK SIRISETTI",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electronics and communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "SOftware Developement(SDE), Machine Learning",
    "Period of Internship": "2 months(Open from May1st)",
    "Current Location(With Country)":
      "IIT Bhubaneswar, Bhubaneswar, Odisha, India",
    "Does Remote Internship work for you?": "Hyderabad, Bangalore, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1y8au_vH-EhhokqMaU7Dm5O5snV-XT6Ti/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/karteek-sirisetti-a385a0153/",
    "Contact Details (Email)": "sk67@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 19:45:28",
    "Name of the student": "Ravi Teja Pedapudi",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Hyderabad, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1yGcNjuE9F-YK73N4uFFCxthE1ZX-rZs3",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ravi-teja-pedapudi-a546a5152/",
    "Contact Details (Email)": "prt15@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "https://github.com/RAVIROCK916\nMy github projects",
  },
  {
    Timestamp: "04/06/2020 19:57:10",
    "Name of the student": "Hemanth",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Srikakulam, Andhra Pradesh",
    "Does Remote Internship work for you?": "Yes, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1D1Y3Kc7KJWpQD59yFuxQjK0lzM7OKByf/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/hemanth-kumar-87a827148",
    "Contact Details (Email)": "kh10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 20:00:59",
    "Name of the student": "Kriti Maloo",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing or Business development",
    "Period of Internship":
      "2 months, anytime immediately if it's a remote internship.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Preferred city- Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1gciq3Wczt2x7TwTElOpnwzdqEfeIm9cb",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kriti-maloo-097851190",
    "Contact Details (Email)": "km22@iitbbs.ac.in",
    "Anything else you'd like to share?": "I prefer a remote internship.",
  },
  {
    Timestamp: "04/06/2020 20:19:41",
    "Name of the student": "Mohit Kumar Soni",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine learning, Product Management, Business Analyst,IT",
    "Period of Internship": "2 Month",
    "Current Location(With Country)": "Jhunjhunu, Rajasthan (India)",
    "Does Remote Internship work for you?":
      "Yes Bhubaneswar,  Jaipur, Delhi, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18tr3RskN9OL4alhvSB0nh2iYf42HKNnl/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mohit-kumar-soni-63a15a171",
    "Contact Details (Email)": "mohitkumarsoni02@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 20:27:29",
    "Name of the student": "Aayushmita Bhattacharjee",
    "Institute Name(College)": "Symbiosis Centre for Media and Communication",
    "Field of study": "Mass Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Feature Journalism",
    "Period of Internship": "7 weeks (20th April to 1st June)",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/folders/1--H1xekQcDL2wo1mTbXXx3-wXgfdcrAz",
    "LinkedIn profile link":
      "linkedin.com/in/aayushmita-bhattacharjee-87653a168",
    "Contact Details (Email)": "aayushmita.bhattacharjee@scmc.edu.in",
    "Anything else you'd like to share?":
      "I have a keen interest in Feature Writing in the field of Journalism. I am open to working in both Print or Digital Medium although I prefer Print more.",
  },
  {
    Timestamp: "04/06/2020 20:33:52",
    "Name of the student": "Spriha Prerna Barla",
    "Institute Name(College)": "Symbiosis Centre of media and communications",
    "Field of study": "BA( mass communication)",
    Education: "Undergraduate",
    "Preferred domain of internship": "strategy ( Advertising )",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "visakhapatnam, Andhra Pradesh, India",
    "Does Remote Internship work for you?":
      "yes, I would prefer working in Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=13YHmru2xwQTdRJOwPAQ_pptbkkyITb98",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/spriha-barla-55037816a/",
    "Contact Details (Email)": "spriha.barla@scmc.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 20:47:34",
    "Name of the student": "Dhruv Ajay Ray",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "IoT solutions, web development, machine learning, teaching assistant",
    "Period of Internship": "2 months, starting: May 2020",
    "Current Location(With Country)":
      "Home: Hyderabad, India; College: Bhubaneswar, India",
    "Does Remote Internship work for you?":
      "Yes, remote internship works for me",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1bUG_F6FTG5e7wnXKGDCoH6VTHT3ZMyQ7/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dhruv-ajay-ray-847a93195",
    "Contact Details (Email)": "dhruv.ray2001@gmail.com",
    "Anything else you'd like to share?":
      "This internship would provide me with an opportunity to apply the many skills I have learnt and trained myself in. Therefore, I can assure you that I am capable of working extremely hard and fulfilling my responsibilities to achieve the combined goal of the team.",
  },
  {
    Timestamp: "04/06/2020 20:51:16",
    "Name of the student": "ARTH SOJITRA",
    "Institute Name(College)": "Indian Institute of Technology Bhubaneswar",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Computational mathematics,Finite Element Analysis, Simulations, Partial Differential Equations, Numerical Analysis",
    "Period of Internship": "2 Months, Starting from 10th May",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Kz_e-WfCzd1Pt0AlwAMMvvp-jNFPh_3F",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arth-sojitra-2a4033157/",
    "Contact Details (Email)": "as76@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I am a third-year undergraduate student. Having completed the second year of my undergraduate studies, I began to explore my interests in several ?elds, ?nding that my keen interest lies in Finite Element Analysis, Partial Di?erential Equations, and Numerical Methods. \n\nThe ?uid ?ows have always fascinated me in one way or another ranging from the ?ow of the rivers to the ?ow of the air on the top of the wing to the formation of tornados. Most of the ?ows are turbulent. The random and chaotic nature of the ?uid ?ows has aroused my curiosity and the motivation to research in this ?eld.",
  },
  {
    Timestamp: "04/06/2020 21:15:46",
    "Name of the student": "KOPPULA NITISHA",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electrical and electronics",
    "Period of Internship": "8 weeks(2months)",
    "Current Location(With Country)": "Hyderabad (India)",
    "Does Remote Internship work for you?":
      "If the lockdown is down. Then yes and preferably Hyderabad.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1NXNrlpP7p3dLaYwU076OsyiChWGYEeKP/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out KOPPULA NITISHA�S profile on LinkedIn https://www.linkedin.com/in/koppula-nitisha-974193158",
    "Contact Details (Email)": "kn23@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "It would really help the students if internships can be provided as work from home considering the current situation.",
  },
  {
    Timestamp: "04/06/2020 21:38:15",
    "Name of the student": "KOPPULA NITISHA",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electrical and electronics",
    "Period of Internship":
      "8weeks (2months). As given the situation start date cannot be specified unless it's a remote internship.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes. Hyderabad would be preferable",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1NXNrlpP7p3dLaYwU076OsyiChWGYEeKP/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out KOPPULA NITISHA�S profile on LinkedIn https://www.linkedin.com/in/koppula-nitisha-974193158",
    "Contact Details (Email)": "KN23@IITBBS.AC.IN",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 21:47:21",
    "Name of the student": "rajam ashish",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Signal processing, Hardware architecture, Image and Vedio processing",
    "Period of Internship": "2 months at max.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes, Vishakapatnam",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1UJQhzFVtwEZIa2zfvtGJM2ZXXCAmaXk3/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rajam-ashish-500a00191/",
    "Contact Details (Email)": "ra20@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I can't mention the starting date because our institute hasn't yet declared any Vaccination dates.",
  },
  {
    Timestamp: "04/06/2020 21:49:02",
    "Name of the student": "Gorantla Ravi Teja",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core",
    "Period of Internship": "One month, May 1st",
    "Current Location(With Country)": "Vijayawada, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "grt11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 22:07:47",
    "Name of the student": "Saharsh J",
    "Institute Name(College)": "Indian Institute of Technology Bhubaneswar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Technical Development, Solid modelling, System design",
    "Period of Internship": "1-2 months starting by mid may",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Au8hvyVZLbS2QOjDrevGIaNt4-qLJ4m_/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saharsh-jaisankar-618109184/",
    "Contact Details (Email)": "sj20@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 22:18:01",
    "Name of the student": "Satya Brata Routray",
    "Institute Name(College)": "Symbiosis international university",
    "Field of study": "MBA (Digital & Telecom Management)",
    Education: "Currently pursuing MBA",
    "Preferred domain of internship":
      "Consulting or Auditing Firms,Analytics Firm",
    "Period of Internship": "2 months, From April 15",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes,Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ssyd06Vi7DaVORbhy5B-vEWhy0320KN8/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/satya-brata-routray-98707699/",
    "Contact Details (Email)": "satya.routray1921@sitm.ac.in",
    "Anything else you'd like to share?":
      "I was selected for internship in one of the big 4's (Deloitte) but due to the current  situation,it has been postponed .",
  },
  {
    Timestamp: "04/06/2020 22:21:28",
    "Name of the student": "Tanvi Atulbhai Ajmera",
    "Institute Name(College)":
      "B K School of Professional and Management Studies.",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital marketing",
    "Period of Internship": "2 months (Mid May)",
    "Current Location(With Country)": "Bhavnagar, Gujarat, India",
    "Does Remote Internship work for you?":
      "No I won't be able to relocate if lockdown is over.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PhaD51S5-cAa4T2RxzgUJevrm2ul7BcS/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tanvi-ajmera-5a4345167",
    "Contact Details (Email)": "tanviajmera1997@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 22:42:24",
    "Name of the student": "K.RAHUL SIDDARTHA SAKYA",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "Electronics &. Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "VLSI, IoT, Embedded Systems",
    "Period of Internship": "2months(8 weeks)",
    "Current Location(With Country)": "Kakinada,Andhra Pradesh (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uScwTI5AGy7YroWzfpVDgd_QvF1mzazV/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rahul-sakya-92487b175",
    "Contact Details (Email)": "krs12@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "Please note that I am searching for an intern in multiple domains mentioned above, as I am comfortable with in any of the above areas.\nalternative E-mail Id - rahulsakya357@gmail.com",
  },
  {
    Timestamp: "04/06/2020 22:51:43",
    "Name of the student": "Divesh Digamber Shet",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Teaching",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Goa India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "dds12@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 23:05:33",
    "Name of the student": "Drishya Dahal",
    "Institute Name(College)": "University of Texas at San Antonio",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Engineering, Product Design, Robotics, Mechanical Engineering, Mechatronics",
    "Period of Internship": "Open",
    "Current Location(With Country)": "San Antonio, TX",
    "Does Remote Internship work for you?": "Yes. Open to relocation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1QnpSyRjDx1FBsewMMmkVgbviLW-1ykdd",
    "LinkedIn profile link": "https://www.linkedin.com/in/drishyadahal/",
    "Contact Details (Email)": "drishyadahal@yahoo.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 23:22:14",
    "Name of the student": "Priya",
    "Institute Name(College)": "Indian institute of technology Bhubaneswar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "ML, software, power system, power electronics, communication system, web development",
    "Period of Internship": "2 months, immediate",
    "Current Location(With Country)": "Raebareli ( Uttar Pradesh)India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1NgXQZFNjHptjkj_lN0IkOfmEuiXA41iX/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/priya-43804b190",
    "Contact Details (Email)": "pr35@iitbbs.ac.in, priya99569@gmail.com",
    "Anything else you'd like to share?":
      "I would like to have mentor for job. Generally my internet connectivity is not good but I will try hard to get out of it.",
  },
  {
    Timestamp: "04/06/2020 23:24:08",
    "Name of the student": "Vishesh",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Manufacturing science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes, chandigarh, Delhi, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=151-OFewafSeVUu5fDItjAs-aA0zEf2LA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vishesh-kumar-178807161/",
    "Contact Details (Email)": "visheshkumariitkgp506@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 23:49:58",
    "Name of the student": "Abhishek Shah",
    "Institute Name(College)":
      "B.K. School of Professional and Management Studies",
    "Field of study": "MBA - Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 - immidiately",
    "Current Location(With Country)": "Ahmedabad, Gujarat, India",
    "Does Remote Internship work for you?":
      "Yes. Remote internship work for me.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/bkschool.org.in/file/d/1yAOd83350NeTMz798dDv-C_BtdC0JQwy/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-shah-48472a154",
    "Contact Details (Email)": "abhishek.ft21@bkschool.org.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 00:10:10",
    "Name of the student": "Abhilasha Kharpate",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research, Mumbai",
    "Field of study": "Masyers in Management Studies",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 (01/05/2020)",
    "Current Location(With Country)": "Mumbai/Pune India",
    "Does Remote Internship work for you?": "Yes (Any)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Mfeltz-B9UnUJs_Hpdwp9gsdImzEE7sg/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhil asha-kharpate-897942101",
    "Contact Details (Email)": "abhilasha.kharpate.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 00:24:05",
    "Name of the student": "Rayyan Khan",
    "Institute Name(College)": "Symbiosis Institute of Media and Communication",
    "Field of study": "Media",
    Education: "Undergraduate",
    "Preferred domain of internship": "Content writing, Social media handling",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rayyan.khan1011@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 00:39:08",
    "Name of the student": "Yash Wagh",
    "Institute Name(College)": "Indian Institute of Technology Bhubaneswar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Engineering",
    "Period of Internship": "2 months. May 10 to July 10",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/105HVJdadSioaN-esRIlCAtwnOqGxspKo/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out Yash Wagh�s profile on LinkedIn https://www.linkedin.com/in/yash-wagh-68650b1a6",
    "Contact Details (Email)": "yashblackhart@gmail.com",
    "Anything else you'd like to share?":
      "Haven't been selected for any internship yet, still applying",
  },
  {
    Timestamp: "04/07/2020 01:20:05",
    "Name of the student": "Saharsh J",
    "Institute Name(College)": "Indian Institute of Technology Bhubaneswar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Technical development, solid modelling, system design",
    "Period of Internship": "1 to 2 months, from mid may",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1gy0A96B0SIf4q_7eFEEv-Z_UNLmZWOca/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saharsh-jaisankar-618109184/",
    "Contact Details (Email)": "sj20@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 01:41:57",
    "Name of the student": "Shubham Deshpande",
    "Institute Name(College)": "Indian Institute of Technology, Bhubaneswar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Mechanical engineering design/ simulations",
    "Period of Internship": "2 Months 15 May to 15 July",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.slideshare.net/slideshow/embed_code/key/7vWvXp5Fch17g0",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "smd10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 01:54:00",
    "Name of the student": "Bharat Girdhar",
    "Institute Name(College)":
      "National Institute of Industrial Engineering, Mumbai",
    "Field of study": "Supply chain, Operations, Project Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Supply Chain Management, Operations",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/0B4YNI0HwGkPPcEtPQnp1TlNaV0JCa3g3RW94WVVISC1uTk9B/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/bharatgirdhar",
    "Contact Details (Email)": "bharat.girdhar.2021@nitie.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 02:06:46",
    "Name of the student": "Amanpreet Singh",
    "Institute Name(College)": "Stony Brook University",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Software Development, Machine Learning, NLP",
    "Period of Internship": "3 months starting June",
    "Current Location(With Country)": "Stony Brook, NY, USA",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/stonybrook.edu/file/d/1KYhJQfN77iaS3_tCv51a1XB5D3Jqx3pH/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/amanpreet-singh-k",
    "Contact Details (Email)": "amanpreet.singh@stonybrook.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 03:05:30",
    "Name of the student": "Priyansh Kumar Nigam",
    "Institute Name(College)": "Indian Institute of Technology Bhubaneswar",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core and non core both",
    "Period of Internship": "2 months, from 1-05-2020",
    "Current Location(With Country)": "Bhopal, India",
    "Does Remote Internship work for you?":
      "yes, preferred locations are- Bhopal, Bhubaneswar, Indore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17c1FdN3N3b-33mzQioKMr5IZO4s04Fsp/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyansh-kumar-nigam-74a54a186",
    "Contact Details (Email)": "pkn11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 04:33:59",
    "Name of the student": "Katherine",
    "Institute Name(College)": "Columbia University",
    "Field of study": "Data Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data analytics, consulting, technilogy",
    "Period of Internship": "3-6 months",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Gw6L2vo3loaE4x9l9xJelou2g0km5qSq/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/katherine-li-0831/",
    "Contact Details (Email)": "ml4436@columbia.edu",
    "Anything else you'd like to share?":
      "I am a master student at Columbia University major in Applied Analytic and currently interning at Business Insider as a business analyst. I am passionate and specialized in data analytics and visualization, data warehousing, and machine learning techniques to provide IT and business solutions. Detailed oriented, I�m a team player and look into working in fast-paced environment. \n\nI'm interested in data analytics/ consulting related opportunities. Please contact ml4436@columbia.edu if you have any question!",
  },
  {
    Timestamp: "04/07/2020 07:24:19",
    "Name of the student": "Kristina Mikhailova",
    "Institute Name(College)": "DePauw University",
    "Field of study": "Mathematics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business, Data Analysis, Business Engineering, consulting, marketing, education",
    "Period of Internship": "May 1 - August 20",
    "Current Location(With Country)": "Greencastle, IN",
    "Does Remote Internship work for you?":
      "Yes, I can relocate anywhere within States. Los Angeles is preferable",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16tqdHTCf6wQBz1bLqgF0yo_MxV5eHved/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/kristinamikhailova/",
    "Contact Details (Email)": "kmikhailova_2022@depauw.edu",
    "Anything else you'd like to share?":
      "I would love to be considered for any internship opening, even outside of my area of interest",
  },
  {
    Timestamp: "04/07/2020 07:40:09",
    "Name of the student": "Heuiyeon Seo",
    "Institute Name(College)": "DePauw University/EWHA Womans University",
    "Field of study": "Neuroscience",
    Education: "Undergraduate",
    "Preferred domain of internship": "Research",
    "Period of Internship": "From a month to two months / Around May or June",
    "Current Location(With Country)": "The U.S",
    "Does Remote Internship work for you?": "Yes/Seoul",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "heuiyeon.seo@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 07:55:09",
    "Name of the student": "Hamza Cherqaoui",
    "Institute Name(College)": "DePauw University",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Information Technology/Computer Science",
    "Period of Internship": "Start date - Late May/Early June  (2 months)",
    "Current Location(With Country)": "Greencastle, Indiana, united States",
    "Does Remote Internship work for you?": "Chicago,Illinois",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1xeVO0yFWn-6YCpHZmB8tZVNF246gFSovBtaCfHA41u8/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/hamza-cherqaoui-a859b31a6/",
    "Contact Details (Email)": "hamzacherqaoui_2023@depauw.edu",
    "Anything else you'd like to share?": "n/a",
  },
  {
    Timestamp: "04/07/2020 07:56:17",
    "Name of the student": "Karavadi RaviChandra",
    "Institute Name(College)": "Indian institute of Technology, Bhubaneswar",
    "Field of study": "Computer science & engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development, ML",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ongole, Andhrapradesh, India",
    "Does Remote Internship work for you?": "Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1xe-IGwo4XZ-8s28eB-BRYtcvUK9vmlNm/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ravi-chandra-23a97a7b",
    "Contact Details (Email)": "Krc10@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "https://github.com/ravic375/Image-detection-and-collage-formation",
  },
  {
    Timestamp: "04/07/2020 08:02:46",
    "Name of the student": "M Sai Praneeth",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electronics and communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Research, software development, machine learning",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Bangalore",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "msp10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 08:06:04",
    "Name of the student": "Ayush Jha",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Civil",
    Education: "Undergraduate",
    "Preferred domain of internship": "Technical ( Backend Development)",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ranchi,Jharkhand,India",
    "Does Remote Internship work for you?": "YES (any city is suitable)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1_pLv6nfo1WWIVdXUuRqVV2OjzYEYdU7F/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/ayush-jha-57231398/",
    "Contact Details (Email)": "ayushjha121@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 08:50:37",
    "Name of the student": "Jintu Goyary",
    "Institute Name(College)": "Indian Institute of Technology, Bhubaneswar",
    "Field of study": "Metallurgical and Materials Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "project management, business development, marketing, startup",
    "Period of Internship": "2 months",
    "Current Location(With Country)":
      "Bodofa Nwgwr, p.o- Tinali, Kokrajhar, Assam, India",
    "Does Remote Internship work for you?": "Yes. Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1omS4oo-Zn12WDYJyw7DU4LtvVexRY-Zx",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jintu-goyary-9a9473150/",
    "Contact Details (Email)": "jg11@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I took 1 year leave from the institute because I was sick and I had undergone hip operation.",
  },
  {
    Timestamp: "04/07/2020 08:54:45",
    "Name of the student": "Kancherla Kishorereddy",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Webdevelopment or software development",
    "Period of Internship": "1-3 months starting from rightawy",
    "Current Location(With Country)": "Guntur, AndhraPradesh, India",
    "Does Remote Internship work for you?": "Yes. Hyderabad, Bhubaneswar",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dVs-AESm6UQxZgWpQO9s2fwXwEPpigKS/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kishorereddy-kancherla-588294170/",
    "Contact Details (Email)": "kk23@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 09:33:01",
    "Name of the student": "Bhoomika R S",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "ML, Power electronics",
    "Period of Internship": "2-3 months, starting ASAP",
    "Current Location(With Country)": "Bengaluru, Karnataka, India",
    "Does Remote Internship work for you?": "Relocation only to Bhubaneswar",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "brs14@iitbbs.ac.in         8277392246",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 09:36:18",
    "Name of the student": "Shubhayu Das",
    "Institute Name(College)": "Indian Institute of Technology, Bhubaneswar",
    "Field of study": "Electronics and Communications",
    Education: "Undergraduate",
    "Preferred domain of internship": "Hardware and Robotics related domain",
    "Period of Internship": "2",
    "Current Location(With Country)": "Bhubaneswar, India",
    "Does Remote Internship work for you?":
      "Yes. Kolkata, Bangalore , Pune , Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1C57dV2Z-zpH5Drhhub0h4fbxenK-Jmiw/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shubhayu-das-a718a0179/",
    "Contact Details (Email)": "sd42@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 10:19:36",
    "Name of the student": "Akshat Agrawal",
    "Institute Name(College)": "Amity Business School",
    "Field of study": "General",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshat-agrawal-95b772149",
    "Contact Details (Email)": "aagrawal1198@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 10:23:29",
    "Name of the student": "SATHVIK CHILAKA",
    "Institute Name(College)": "INDIAN INSTITUTE OF TECHNOLOGY BHUBANESWAR",
    "Field of study": "COMPUTER SCIENCE ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "SOCIAL MEDIA MARKETING",
    "Period of Internship": "2 MONTHS ( Can begin from 08-04-2020)",
    "Current Location(With Country)": "VIJAYAWADA, ANDHRA PRADESH, INDIA",
    "Does Remote Internship work for you?": "YES, BHUBANESWAR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1C1ZLNWqLUGYrOaELgQAetzIldny9-ccf/view?usp=sharing",
    "LinkedIn profile link": "SATHVIK CHILAKA",
    "Contact Details (Email)": "cs34@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I can only do work from home, but i can't come to the work place.",
  },
  {
    Timestamp: "04/07/2020 10:28:57",
    "Name of the student": "Anwesha Samaddar",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Manufacturing Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning/ Data Analytics",
    "Period of Internship": "Present-May 31,July 1-August 15",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1v7Vrj7xJyPWvyY3pFUIrt1E_dp7XKweN/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anwesha-samaddar-389464147/",
    "Contact Details (Email)": "1998anwesha.samaddar@gmail.com",
    "Anything else you'd like to share?":
      "I hope you are safe and healthy. I am a third year undergraduate of Mechanical Engineering Department and I am a Data Science enthusiast. I managed to secure internship in the same field in two different firms which however got cancelled due to the deadly pandemic. So I would like to utilize my time in some remote internship from home which would be the best possible way to gain experience and knowledge in this field.",
  },
  {
    Timestamp: "04/07/2020 10:53:26",
    "Name of the student": "Tejas Yadav",
    "Institute Name(College)": "NITIE Mumbai",
    "Field of study": "MBA in operations & supply chain",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Operations and supply chain, strategy, marketing",
    "Period of Internship": "2",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14rzw0S3zTiBFIeIvIrtiUJ2uUvS8hTyK/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tejas-yadav-075841100/",
    "Contact Details (Email)": "tejas.yadav.2021@nitie.ac.in",
    "Anything else you'd like to share?": "looking forward for the replies",
  },
  {
    Timestamp: "04/07/2020 12:44:48",
    "Name of the student": "Venkata Saicharan Gurramkonda",
    "Institute Name(College)": "Great Lakes Institute Of Managment",
    "Field of study": "Data Science Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data science, Analytics",
    "Period of Internship": "As per companies norms",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes(Anywhere in India)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AajJU4yU0C9801BtwM3BefymItyu7mHb/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/charan-gurramkonda117/",
    "Contact Details (Email)": "Saicharangurramkonda@gmail.com",
    "Anything else you'd like to share?":
      "To be a part of progressive organisation where I can contribute in decision making through analytics. To work contribute and gain experience where Data science, Analytics, Machine learning and statistical methods are used.",
  },
  {
    Timestamp: "04/07/2020 12:46:11",
    "Name of the student": "SAGAR RAHINJ",
    "Institute Name(College)":
      "BALAJI INSTITUTE OF MANAGEMENT &HUMAN RESOURCE DEVELOPMENT",
    "Field of study": "MARKETING",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months  01st may 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sagar-rahinj-5a1187184",
    "Contact Details (Email)": "rahinjsagar3012@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 12:58:58",
    "Name of the student": "Sipho Muzikayise Lushozi",
    "Institute Name(College)": "Johannesburg Central College",
    "Field of study": "Graphic design",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "https://www.linkedin.com/in/sipho-lushozi-0874ba162",
    "Period of Internship": "12 months, available all Times",
    "Current Location(With Country)": "South Africa",
    "Does Remote Internship work for you?": "JOHANNESBURG",
    "Link to Resume(Google Drive/Dropbox)": "craftlife4me@gmail.com",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sipho-lushozi-0874ba162",
    "Contact Details (Email)": "shozimuzikayise@gmail.com",
    "Anything else you'd like to share?":
      "I am a Graphic designer and I hope this works because I'm always online",
  },
  {
    Timestamp: "04/07/2020 13:07:45",
    "Name of the student": "Hemanth Reddy",
    "Institute Name(College)": "Lovely Professional University",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 months( from May 1st)",
    "Current Location(With Country)": "Mumbai, Bangalore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1fgbxtM9rLiSIsklhGxwxWD1llUxM1g_B/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "vankayalahemanth@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/07/2020 13:26:27",
    "Name of the student": "Esha Mondal",
    "Institute Name(College)": "Symbiosis Institute of Design",
    "Field of study": "Inderior Space Design",
    Education: "Undergraduate",
    "Preferred domain of internship": "Interior Space design",
    "Period of Internship": "4 months, starting from September.",
    "Current Location(With Country)": "Kolkata, India",
    "Does Remote Internship work for you?": "Bangalore, Mumbai, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1YEmuS34kipvJkoxzyuR3uvi9CdqJObQh/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/esha-mondal",
    "Contact Details (Email)": "emondal.id@gmail.com",
    "Anything else you'd like to share?":
      "https://drive.google.com/file/d/1Xz1Bsy87ZBXGVUk4TGQwpv-7fw3_iXGv/view?usp=sharing",
  },
  {
    Timestamp: "04/07/2020 13:47:05",
    "Name of the student": "Ravi Teja Pedapudi",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development, UI/UX Designer",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Hyderabad, Bangalore.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Vf3jzjBo4-nu0mte8X8GSkGtUfet8bp3",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ravi-teja-pedapudi-a546a5152/",
    "Contact Details (Email)": "prt15@iitbbs.ac.in",
    "Anything else you'd like to share?": "Much more interested in designing.",
  },
  {
    Timestamp: "04/07/2020 14:01:31",
    "Name of the student": "Aishwarya Ramanathan",
    "Institute Name(College)": "IIM Indore",
    "Field of study": "Foundations in management and pursuing MBA",
    Education: "",
    "Preferred domain of internship": "Marketing, product management",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iimidr.ac.in/file/d/1yJ-ccyIY_om7Q61-yVzT33iG0XfCgv6q/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "i16aishwaryar@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 14:07:24",
    "Name of the student": "Abhishek Kumar",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Data Science/Deep Learning/Machine Learning",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science/Deep Learning/Machine Learning",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "Aurangabad, Bihar, India",
    "Does Remote Internship work for you?":
      "yes, I can work from or can come in office for full time.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DyW25Q5oFWlG-2ar_SQqhHXJkZX59Kf3/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-kumar-003739169/",
    "Contact Details (Email)": "singhabhi.iitkgp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 14:14:22",
    "Name of the student": "Satyakshi Sharma",
    "Institute Name(College)": "Indian Institute Of Management, Calcutta",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Product Management, Operations, Open for all.",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Kolkata, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1W8TfSt6TvFOB8v8kL5-Gl-4ZipZeDnZb",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/satyakshi-sharma-626a53ba/",
    "Contact Details (Email)": "satyakshis2021@email.iimcal.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 14:33:47",
    "Name of the student": "AVANISH SINGHAL",
    "Institute Name(College)": "Manipal University Jaipur",
    "Field of study": "Information Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science/ML/AI/CV",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1e9CX48dLttZN_ffD9pIyGrl44sDSgVKo/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/avanish-singhal-b7695b14b",
    "Contact Details (Email)": "avanishsinghal149@gmail.com",
    "Anything else you'd like to share?":
      "I am a passionate developer and a quick learner.",
  },
  {
    Timestamp: "04/07/2020 14:41:58",
    "Name of the student": "Somesh Grover",
    "Institute Name(College)": "Ambedkar University Delhi",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance and Marketing",
    "Period of Internship": "2 Months from 1st May 2020 to 30th June 2020",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Delhi or NCR Region",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/somesh-grover-76a669190",
    "Contact Details (Email)": "sgrover.19@stu.aud.ac.in",
    "Anything else you'd like to share?":
      "If any of the documents are required by you, please contact me from any of the mode of communication you are comfortable with, I will be happy to send you any of the documents you require.",
  },
  {
    Timestamp: "04/07/2020 14:56:04",
    "Name of the student": "Mayank Doi",
    "Institute Name(College)": "Panjab University",
    "Field of study": "Petroleum and GIS",
    Education: "Post-Graduate",
    "Preferred domain of internship": "GIS / PETROLEUM",
    "Period of Internship": "3-6",
    "Current Location(With Country)": "Kota Rajasthan",
    "Does Remote Internship work for you?":
      "Yes I have option of Bangalore and Jaipur",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/mayank-doi-9305a9b8",
    "Contact Details (Email)": "doi.mayank@gmail.com",
    "Anything else you'd like to share?": "Stay safe stay healthy",
  },
  {
    Timestamp: "04/07/2020 14:57:03",
    "Name of the student": "Sharon Carl",
    "Institute Name(College)": "IES Management College and Research Centre",
    "Field of study": "MBA in Business Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "8th April, 2020 : 2-3 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/sharoncarl",
    "Contact Details (Email)": "sharoncc11@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 15:02:45",
    "Name of the student": "Krunal Patil",
    "Institute Name(College)":
      "Pimpri Chinchwad College of Engineering and Research, Ravet , Pune",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning, Data Science",
    "Period of Internship": "1 to 3 months",
    "Current Location(With Country)": "Pune",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cOzq_4yFKvVWbMPrS5agMIO2OjYyD0RS/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/k001/",
    "Contact Details (Email)": "pkrunalb888@gmail.com",
    "Anything else you'd like to share?":
      "I will mostly prefer a remote internship, or part time internship. And THANKS a lot for creating this platform",
  },
  {
    Timestamp: "04/07/2020 15:17:24",
    "Name of the student": "Abheet jain",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Biochemical and Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product, operation, market research, business strategy, consulting",
    "Period of Internship": "2-3 months, immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XpaxoliXcnDTFHbDU7cndrhi1gXQaaQ6/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abheet-jain-839702148",
    "Contact Details (Email)": "jainabheet@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 15:48:46",
    "Name of the student": "Yukta Butala",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core electrical",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/yukta-butala-157103187",
    "Contact Details (Email)": "ypb11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 15:52:23",
    "Name of the student": "Reya Sadhu",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Electric machines, High speed drives, Power system protection, Transformers, Power converters, Electric vehicles, Microcontrollers, PCB design",
    "Period of Internship": "2 months, starting from 3rd or 4th may",
    "Current Location(With Country)": "Kolkata, West Bengal, India",
    "Does Remote Internship work for you?":
      "Yes. Bangalore, Chennai, Pune, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Q35PBKjxgh7AlTod1NNsIz7H102KeKwu/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/reya-sadhu-12364517a",
    "Contact Details (Email)": "rs49@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 16:10:25",
    "Name of the student": "Lalit Chamat",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research Mumbai",
    "Field of study": "Marketing- PGDM",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "May-June",
    "Current Location(With Country)": "Nagpur, India",
    "Does Remote Internship work for you?": "Yes, Nagpur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vbPjkS5SmO-VucjEvJNAgETSFcqWLImh/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/lalitchamat",
    "Contact Details (Email)": "lalitchamat27.04@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 16:33:21",
    "Name of the student": "Attada Mrudhula",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "attadamrudhula@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 16:44:20",
    "Name of the student": "Tanish Kalra",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Upstream Sector",
    "Period of Internship": "1 May- 15 June",
    "Current Location(With Country)": "Hisar, Haryana (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1tvMfGnnG9IETj34Ir744TNsASQr5U96e/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tanish-kalra-a4369016a/",
    "Contact Details (Email)": "tanishkalra2@gmail.com",
    "Anything else you'd like to share?":
      "Would prefer work from home projects of core companies if available under current scenario.",
  },
  {
    Timestamp: "04/07/2020 16:44:47",
    "Name of the student": "Md Ashad",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies Dehradun",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Upstream",
    "Period of Internship": "1 May to 15 June",
    "Current Location(With Country)": "Ranchi, Jharkhand",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PscF5DqAiwswSoekstUERYOdTCQiO3gl/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "md.ashad98@gmail.com",
    "Anything else you'd like to share?": "Nope",
  },
  {
    Timestamp: "04/07/2020 18:02:46",
    "Name of the student": "Yogendra Sharma",
    "Institute Name(College)": "Army Institute of Technology Pune",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mechanical Engineering, Consulting",
    "Period of Internship": "Upto 6 months",
    "Current Location(With Country)": "Pune (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aZCGBlygTejSKHCY2OV8wnRpkP-bnmBp/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/yogendra-sharma-92367a131",
    "Contact Details (Email)": "yogendra1999sharma@gmail.com",
    "Anything else you'd like to share?":
      "I am an early career professional who is actively looking for job opportunities.",
  },
  {
    Timestamp: "04/07/2020 18:25:05",
    "Name of the student": "CHARY SAITEJA",
    "Institute Name(College)": "Indian institute of technology Bhubaneswar",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Research, marketing and engineering",
    "Period of Internship": "45 days",
    "Current Location(With Country)": "Bhubaneswar",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GC6z5sp78r5O6y9vWViseqgQa0S6x0sh/view?usp=drivesdk",
    "LinkedIn profile link": "Chary Saiteja",
    "Contact Details (Email)": "cst10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 18:30:14",
    "Name of the student": "Manoj Kumar",
    "Institute Name(College)": "Bakhtiyarpur College of Engineering",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Python, Android,Web",
    "Period of Internship": "3 Months",
    "Current Location(With Country)": "Patna, India",
    "Does Remote Internship work for you?": "Banglore, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aa5y3qbdtF8bfsHUIv4GuSvTOpvq8tx2/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/manoj-kumar-2241b317a",
    "Contact Details (Email)": "gcssm1999@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 18:37:36",
    "Name of the student": "Amit Priyankar",
    "Institute Name(College)": "IIT Patna",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aMiKQmX0mt3rLHv4tCQnG9cdx7lypcU5/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/amitpriyankar/",
    "Contact Details (Email)": "amitpriyankar22@gmail.com",
    "Anything else you'd like to share?":
      "I am a Third Year Undergraduate student in the Computer Science and Engineering department at IIT Patna, and I am currently looking for a summer internship. I was offered a software development internship role by a US-based computer networking company through intern recuitment drive in our campus, but the offer was rescinded because of this unfortunate pandemic COVID-19.",
  },
  {
    Timestamp: "04/07/2020 19:04:21",
    "Name of the student": "KADUKUNTLA POORNIMA",
    "Institute Name(College)": "Indian Institute of Technology, Bhubaneswar",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning/Artificial Intelligence",
    "Period of Internship": "2-3 months, starting May 15th",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Remote",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17J6pl_EW5ytkQyrh4AClOpwjzKklQ0ny",
    "LinkedIn profile link": "linkedin.com/in/poornima-kadukuntla-19005b193",
    "Contact Details (Email)": "kadupoornima@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 19:05:17",
    "Name of the student": "Avinash Karumanchi",
    "Institute Name(College)": "IIM Kashipur",
    "Field of study": "General Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance and Operations",
    "Period of Internship":
      "2 Months.  Start Date can be as soon as the lock down ends ( given from office location) and immediate if WFH",
    "Current Location(With Country)": "Guntur, Andhra Pradesh, India",
    "Does Remote Internship work for you?":
      "Yes. Hyderabad can be a preferred city once the lockdown is completed.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1HI0U-qs6aWBZNw7yurVoEBD_G-pgFA3b?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/avinashkarumachi",
    "Contact Details (Email)": "karumanchi.mba19262@iimkashipur.ac.in",
    "Anything else you'd like to share?":
      "Open to work in any domain but finance and operations are my strengths",
  },
  {
    Timestamp: "04/07/2020 19:27:48",
    "Name of the student": "Harmehar Singh chhabra",
    "Institute Name(College)": "Amity University",
    "Field of study": "Marketing",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "9911094933",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 19:28:38",
    "Name of the student": "Eswar Chand Thokala",
    "Institute Name(College)": "Sree nidhi Institute of science and technology",
    "Field of study": "Data Science,Machine Learning",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science, Machine Learning",
    "Period of Internship": "2 to 6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VgFbEEL-Uka-zXgYsce5oL-4y5uH7Ll6/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/eswar-chand-b8280a190/",
    "Contact Details (Email)": "eswarchandt@gmail.com",
    "Anything else you'd like to share?":
      "https://www.kaggle.com/eswarchandt - Iam expert at kaggle  and a certified data Scientist",
  },
  {
    Timestamp: "04/07/2020 20:16:12",
    "Name of the student": "Aastha Juneja",
    "Institute Name(College)":
      "Jaypee Institute of Information Technology Noida",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning and Data Science",
    "Period of Internship":
      "3 months.Yes, I will start immediately the  internship. I really wants to explore more in this field and I know I will do my work with focus and enthusiasm. I need a platform to nourish my skills and I know that your platform has brought a big opportunity for me. I want to extract every bit of knowledge from this internship and wants to do best out of it. I am really looking forward to this. It is my dream and I have always been so motivated to work on machine learning. It is just that I wanted to learn and explore more in this field. It would be great if you would consider my request.",
    "Current Location(With Country)": "Bharatpur, Rajasthan",
    "Does Remote Internship work for you?": "Noida.",
    "Link to Resume(Google Drive/Dropbox)":
      "linkedin.com/in/aasthajuneja27/( I have my resume attached in my LinkedIn profile)",
    "LinkedIn profile link": "linkedin.com/in/aasthajuneja27/",
    "Contact Details (Email)": "aasthajuneja27@gmail.com",
    "Anything else you'd like to share?":
      "I am an undergraduate who is optimistic and self-motivated and a learner who is energetic and focused with a zeal to explore new things. Beginner in the field of Data Science and dedicated to learning more of its Fundamentals. Always try to be mentally prepared and fearless to all new opportunities or new projects in my college. As an undergraduate, I am consistent with my academics and able to manage my time in other activities. Known to people for my sincerity, determination and socializing nature. I am really looking forward to this opportunity and I think this is the perfect platform for me to develop and nourish my skills. I have made certain projects on machine learning and I am really interested in that and really wants to go in that field. Always wants to learn more and build something new all by my self. I am always Confident and sincere with my work. It will be an honour if you will hire me as an intern. I will try my all level best to complete my work on time with focus and sincerity.",
  },
  {
    Timestamp: "04/07/2020 20:24:18",
    "Name of the student": "ABHISHEK NEGI",
    "Institute Name(College)": "Indian institute of technology Bhubaneswar",
    "Field of study": "Minerals metallurgical and materials engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Management",
    "Period of Internship": "2 months after 10th may",
    "Current Location(With Country)": "Uttarakhand India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AvA9_w8SOKkiooJqtseXwwYRE9gRA6-k/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-negi-1a701218b",
    "Contact Details (Email)": "an25@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 20:24:37",
    "Name of the student": "Medanki Nishanth",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Computer science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning, SDE",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Vijayawada, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Hyderabad, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1mkJWlySC1x8GPRrAKdr6nPtgFgnBNJYW/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nishanth-medanki-75706515a",
    "Contact Details (Email)": "mn21@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 20:25:19",
    "Name of the student": "Madeline Olden",
    "Institute Name(College)": "American University",
    "Field of study": "Global Security",
    Education: "Post-Graduate",
    "Preferred domain of internship": "",
    "Period of Internship": "May-August",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "madeline.olden@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 20:28:36",
    "Name of the student": "Dhruv Kadia",
    "Institute Name(College)":
      "B.K. School of Professional and Management Studies",
    "Field of study": "Master of Business Administration(MBA)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance,  Accounting",
    "Period of Internship": "2 months Starting of June",
    "Current Location(With Country)": "Ahmedabad, Gujarat, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/bkschool.org.in/file/d/1-5bqTnxkSRdxpe5ODQckQlp8c1Z2z0z-/view?usp=drivesdk",
    "LinkedIn profile link": "Dhruv Kadia",
    "Contact Details (Email)": "dhruv.ft21@bkschool.org.in",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/07/2020 20:40:30",
    "Name of the student": "Parag Wagh",
    "Institute Name(College)": "MET Institue of Management",
    "Field of study": "Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Business Analytics or Operations",
    "Period of Internship": "2 months (From 1/5/2020)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1POko_p9S7p55prtnLUoHVFEsaUfbbkAZ/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/paragwagh/",
    "Contact Details (Email)": "paragwagh54@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 20:43:28",
    "Name of the student": "Sumit Adwani",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study":
      "Department:Mechanical Engineering; Branch:Manufacturing Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Core internship in R&D or operations. Preferably in the automotive industry.",
    "Period of Internship":
      "At least 8 weeks. Any time between 10/04 - 15/07 (excluding 01/06 - 24/06)",
    "Current Location(With Country)": "Gondia, Maharashtra, India",
    "Does Remote Internship work for you?":
      "Yes. Preferred cities: Pune and Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-cufn1u3VECpjiZhXl_0ucofqSx8sXyd/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/sumit46656",
    "Contact Details (Email)": "adwani6sumit@gmail.com",
    "Anything else you'd like to share?":
      'I have institute summer vacations till 31st may and from 24th june to 15th july. That\'s why I have written "excluding 01/06 - 24/06" in paranthesis in the option "period of internship".',
  },
  {
    Timestamp: "04/07/2020 20:54:35",
    "Name of the student": "Dawson",
    "Institute Name(College)": "University of Cincinnati",
    "Field of study": "IT/cybersecurity",
    Education: "Undergraduate",
    "Preferred domain of internship": "IT",
    "Period of Internship": "Anywhere from the middle of May until December.",
    "Current Location(With Country)":
      "Cincinnati, OH, United States. Open to relocation",
    "Does Remote Internship work for you?": "Yes, anywhere",
    "Link to Resume(Google Drive/Dropbox)": "Https://tinyurl.com/ulasyr9",
    "LinkedIn profile link":
      "Https://www.linkedin.com/in/dawson-paul-35826316a",
    "Contact Details (Email)": "Pauldo@mail.uc.edu",
    "Anything else you'd like to share?":
      "I appreciate everyone being flexible in the current situation and look forward to hearing from people!",
  },
  {
    Timestamp: "04/07/2020 21:15:26",
    "Name of the student": "Venkata Ram Tej Kuncham",
    "Institute Name(College)": "IIM Sambalpur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Supply Chain Management and Marketing",
    "Period of Internship": "2 months and 8th April 2020",
    "Current Location(With Country)": "Visakhapatnam",
    "Does Remote Internship work for you?": "Yes, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XGU3k0WPsm4f5ax4ZgG1nf6qrD8OKmbS/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ram-tej-kuncham-5856a918b",
    "Contact Details (Email)": "mba19venkataramkt@iimsambalpur.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 21:36:29",
    "Name of the student": "Shradha Rathod",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Maths and Computing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Software development, Finance",
    "Period of Internship": "2 months starting from 1st May",
    "Current Location(With Country)": "Aurangabad, Maharashtra, India",
    "Does Remote Internship work for you?":
      "Yes I am comfortable with remote internship and if situation improves I can relocate to Mumbai, Delhi, Bangalore, Pune.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cxJrf1n94kZCf9oB8UQg5gFiCt2qbdNm/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/shradha-rathod-25827117b",
    "Contact Details (Email)": "shradharathod17@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 21:39:57",
    "Name of the student": "Himanshu Shende",
    "Institute Name(College)": "IIM Sambalpur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations and Logistics",
    "Period of Internship": "2 months and can start immediately",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PTDCDH7-kPAfTi0YNC-ewBQjbtN8DKXO/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/himanshu-shende-aa2b0a18b/",
    "Contact Details (Email)": "mba19himanshus@iimsambalpur.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 21:40:57",
    "Name of the student": "Saif Ali Khan",
    "Institute Name(College)": "Indian Institute of Technology Bhubaneswar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mechanical Design, CFD",
    "Period of Internship": "April 10 to June 10",
    "Current Location(With Country)": "Aurangabad, Maharashtra, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Bb2fJlPrAA5JsCai7XSncAoRaV-e8Ewr/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saif-ali-khan-b9600315a/",
    "Contact Details (Email)": "sak10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 21:50:54",
    "Name of the student": "Aniket Gupta",
    "Institute Name(College)":
      "Delhi Technological University (Formerly Delhi College of Engineering)",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Research & Analytics",
    "Period of Internship": "2 months, Starting immediately till 31st July",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes, PAN India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1gkIa_Sa1cC1QcKJqzGzYARqROxKji327/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/aniketgupta2211",
    "Contact Details (Email)": "Aniket_bt2k17@dtu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 21:54:12",
    "Name of the student": "PENUMAKA SAI NAVYANTH",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study":
      "Electrical engineering (but interested in Computer science)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Technical (machine learning, software development, web development) and business strategy (if available)",
    "Period of Internship":
      "2 months. Can stretch for 2 more weeks. I can start right away(April 8)",
    "Current Location(With Country)": "Hyderabad, Telangana state, India.",
    "Does Remote Internship work for you?":
      "Yes,remote works for me. Yes, I'm comfortable with relocation. I prefer Hyderabad, Bangalore, Mumbai, Delhi, Chennai.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1yEGe1X4tk7wbOc4r6WVI-0X7wgu_RMHy/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sai-navyanth-penumaka-015569179",
    "Contact Details (Email)": "psn10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 23:15:19",
    "Name of the student": "Shobhit Sahoo",
    "Institute Name(College)": "Indian Institute of Technology, Bhubaneswar",
    "Field of study": "Electronics and communication engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "software development, data analyst",
    "Period of Internship":
      "2 months from 10/05/2020 or any data close to that",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1_bNUNLjELiIdpE6E87WGObuqBmMrUw8x",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shobhit-sahoo-663171160?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BKmi8JLVqQASjzmlY0%2BAN1w%3D%3D",
    "Contact Details (Email)": "ss80@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I am just looking for a good intern and for a good experience and hands on training.",
  },
  {
    Timestamp: "04/07/2020 23:23:05",
    "Name of the student": "Shivani Tawari",
    "Institute Name(College)":
      "Prin.L.N welingkar institute of Management Development and Research",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Marketing, Brand management, Category management, sales in apparel industry",
    "Period of Internship": "2",
    "Current Location(With Country)": "Jalgaon - India",
    "Does Remote Internship work for you?": "Yes - Mumbai, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Yups5Ivgr3nH-PYOMVvdrppjA2T4cV0B/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shiva ni-tawari-21a3b7182/",
    "Contact Details (Email)": "tawarishivani@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 23:29:19",
    "Name of the student": "Harish Pratabh C C",
    "Institute Name(College)": "IIM Sambalpur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations, Marketing & Sales",
    "Period of Internship": "2 months, Starting from April 8th",
    "Current Location(With Country)": "Chennai, Tamilnadu, India",
    "Does Remote Internship work for you?": "Yes, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1G7Kv2VcsdBtoAkf_yBYYfqrj1i5d7T5x",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harish-pratabh-242907b4/",
    "Contact Details (Email)": "mba19harishp@iimsambalpur.ac.in",
    "Anything else you'd like to share?":
      "I have 18 months of work experience in ITeS and ERP industry, and Amazon is the last company I have worked with. I am based out of Chennai and currently actively looking for internship opportunities that can be worked from home(considering current COVID-19 outbreak).",
  },
  {
    Timestamp: "04/07/2020 23:42:16",
    "Name of the student": "Vikash Gupta",
    "Institute Name(College)":
      "Indian Institute of Technology Bhubaneshwar, Odisha",
    "Field of study": "Electronics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning and Digital Electronics",
    "Period of Internship":
      "Not more than 2 months, starting from when situation become better from COVID-19 pandemic",
    "Current Location(With Country)": "Varanasi, Uttar Pradesh, India",
    "Does Remote Internship work for you?":
      "Yea, not ready for relocation, considering the present scenario",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1FUOtVthK4RhDp3rm0UApWmMDRUzDagL9/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "8299062726",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 00:00:29",
    "Name of the student": "Shivakshi Singhal",
    "Institute Name(College)": "IIM Ranchi",
    "Field of study": "MBA-HR",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Human Resources",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Zirakpur,Punjab,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1t2li_xSKHFRWykUoQsKY89nvyvV3ZvEA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivakshi-singhal-60ab44b0/",
    "Contact Details (Email)": "shivakshi.singhal19@iimranchi.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 00:14:33",
    "Name of the student": "Akshatha Dinesh",
    "Institute Name(College)": "SPJIMR, Mumbai",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Product management or Program managment",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "Oestrich Winkel, Germany",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Fq0OdB1_dE3zSqIpn8Yxix6GTYboF_8j/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshatha-dinesh-bb9b0166/",
    "Contact Details (Email)": "akshathadnsh@gmail.com",
    "Anything else you'd like to share?":
      "I am a dual MBA candidate from SPJIMR, Mumbai and EBS, Germany",
  },
  {
    Timestamp: "04/08/2020 00:19:36",
    "Name of the student": "Sudharshan PJ",
    "Institute Name(College)": "The University of Edinburgh",
    "Field of study": "Artificial Intelligence",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Science/AI",
    "Period of Internship": "3-6 months, September onwardd",
    "Current Location(With Country)": "Edinburgh, United Kingdom",
    "Does Remote Internship work for you?": "Yes, any",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iiitdmj.ac.in/file/d/1Vmdyv1RrrjyMvvXZpvwCIODnnEt00iI8/view?usp=drivesdk",
    "LinkedIn profile link": "https://uk.linkedin.com/in/pjsudharshan",
    "Contact Details (Email)": "pjsudharshan",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 00:24:01",
    "Name of the student": "Danielle Larson",
    "Institute Name(College)": "Washington University in St. Louis",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software engineering",
    "Period of Internship": "3 month, starting in May",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes to remote, relocate anyhwere",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1NPYXC15szyKAyPHd1z8fjtMk3NJdxnmA",
    "LinkedIn profile link": "https://www.linkedin.com/feed/",
    "Contact Details (Email)": "danielle.r.larson@gmail.com",
    "Anything else you'd like to share?":
      "I am working on my Master's in Computer Science, looking for a new internship because mine was canceled due to COVID-19.",
  },
  {
    Timestamp: "04/08/2020 01:07:02",
    "Name of the student": "Chenxi Pu",
    "Institute Name(College)": "DePauw University",
    "Field of study": "Economics/ Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Human Resource, Communication",
    "Period of Internship":
      "2-3 months, starting from anytime between May 20- June 1",
    "Current Location(With Country)":
      "408 S. Locust St. UB #6799, Greencastle, IN46135, USA",
    "Does Remote Internship work for you?":
      "Yes, anywhere in the United States",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1rBNj9u1GZd9625gZdIzPaIQZz876hT92/edit#heading=h.gjdgxs",
    "LinkedIn profile link": "https://www.linkedin.com/in/ariel-pu-00347b1a3",
    "Contact Details (Email)": "chenxipu_2023@depauw.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 01:43:38",
    "Name of the student": "Parag Agarwal",
    "Institute Name(College)":
      "Indian Institute of Information Technology, Allahabad",
    "Field of study": "MBA (Finance & Marketing)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "NCR region",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1JgtE6GlzGP5IqodaNCYl0qp18pa7k-W7",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/parag-agarwal-8b831a192/",
    "Contact Details (Email)": "paragagarwal444@gmail.com",
    "Anything else you'd like to share?":
      "First priority is Work from home then in NCR region.",
  },
  {
    Timestamp: "04/08/2020 01:58:35",
    "Name of the student": "Anjali Parakh",
    "Institute Name(College)": "Indian Institute of Management Sambalpur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "two months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1ODbo9kiIX9oc8AA1CPJjwZZ_1kW5k85e",
    "LinkedIn profile link": "www.linkedin.com/in/anjali-parakh-09a3a9191",
    "Contact Details (Email)": "mba19anjalip@iimsambalpur.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 02:15:33",
    "Name of the student": "Anjuli Taneja",
    "Institute Name(College)": "Amity University Noida",
    "Field of study": "Analyst or Market Research",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing or Finance",
    "Period of Internship": "1 month to 6 weeks",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "anjuli017@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 02:40:31",
    "Name of the student": "Maggie Yue",
    "Institute Name(College)": "University Of British Columbia",
    "Field of study": "Accounting",
    Education: "Undergraduate",
    "Preferred domain of internship": "Accounting",
    "Period of Internship": "Four months starting from May",
    "Current Location(With Country)": "Vancouver, BC, Canada",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=12Jyrrn4zpo54u_dpBcrHFMicVHWz_E9m",
    "LinkedIn profile link": "https://www.linkedin.com/in/maggie-yue-7v/",
    "Contact Details (Email)": "maggieyue7v@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 02:57:59",
    "Name of the student": "Jean Feng",
    "Institute Name(College)": "University of California, Los Angles",
    "Field of study": "Psychology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "3 months starting whenever",
    "Current Location(With Country)": "Los Angeles, California",
    "Does Remote Internship work for you?":
      "Remote internships are ideal for now otherwise I�d really appreciate an internship in LA!",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17J9uBqZoquRuqCutM1wOC_Ce0aJkk0cA/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/FengJingJean",
    "Contact Details (Email)": "jean.feng.97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 03:15:42",
    "Name of the student": "Rachel Tabor",
    "Institute Name(College)": "Tulane University",
    "Field of study": "Biomedical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Engineering",
    "Period of Internship": "May 18 - August 9",
    "Current Location(With Country)": "Louisiana",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocation and remote internships",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rtabor@tulane.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 03:22:41",
    "Name of the student": "Jofred Cayabyab",
    "Institute Name(College)": "University of Calgary",
    "Field of study": "Software Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development, data science",
    "Period of Internship": "4-16 months starting May 2020",
    "Current Location(With Country)": "Calgary, Canada",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.jcayabyab.com/resume.pdf",
    "LinkedIn profile link": "https://www.linkedin.com/in/jofred-cayabyab/",
    "Contact Details (Email)": "me@jcayabyab.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 03:53:37",
    "Name of the student": "Utsav Khandelwal",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting, Project Manager, Data Analytics",
    "Period of Internship": "1-2, Anytime starting from 10th April",
    "Current Location(With Country)": "Alwar, Rajasthan (India)",
    "Does Remote Internship work for you?": "Gurugram, Delhi, Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1a-2IcEvqJO2HPkAtG9CgX8ccI7w1zXDZ/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/utsav-khandelwal-2778a4155",
    "Contact Details (Email)":
      "https://www.linkedin.com/in/utsav-khandelwal-2778a4155",
    "Anything else you'd like to share?":
      "I am very keen on exploring the consulting field, but it's not a limitation. I have previously a Data analytics intern with Nokia. I have had a pretty active college life and have been a dedicated member of many societies/clubs.",
  },
  {
    Timestamp: "04/08/2020 03:55:45",
    "Name of the student": "Arianna Ninh",
    "Institute Name(College)": "University of California, Berkeley",
    "Field of study": "",
    Education: "Undergraduate",
    "Preferred domain of internship": "UI/UX Design, User Research",
    "Period of Internship": "Summer or Fall internships, any length of time!",
    "Current Location(With Country)":
      "San Francisco Bay Area, California, United States",
    "Does Remote Internship work for you?":
      "Remote internships or relocation are both perfectly okay. Preferred city would be any urban area such as Seattle, NYC, Berlin, any city in the world.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xOZ_dIYB815OIbb-JMK8Apiy1Shr4NDO/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/arianna-n-08923891/",
    "Contact Details (Email)": "ariannaninh@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 03:56:52",
    "Name of the student": "saksham",
    "Institute Name(College)": "University of Calgary",
    "Field of study": "Electrical and computer engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Computer engineering/software engineering",
    "Period of Internship": "12-16 months",
    "Current Location(With Country)": "Calgary",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1l4CIvkDekVmgvJ1yO4_H4ccUEUXm4zys",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sakyb@yahoo.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 04:35:31",
    "Name of the student": "Raghav jasrotia",
    "Institute Name(College)": "Vivekananda Institute Of Professional Studies",
    "Field of study": "Commerce (BBA)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Sales",
    "Period of Internship": "2",
    "Current Location(With Country)": "Gurgaon, India",
    "Does Remote Internship work for you?":
      "I�d prefer working from Gurgaon but in case if needed i�d consider .",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/file/d/1ygkz7uPCF7CrzBRDdcdBqRBwATInjJMe/edit?usp=docslist_api&filetype=msword",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "jasrotia.raghav13@gmail.com",
    "Anything else you'd like to share?":
      "The reason I�m preferring this internship is because there�s a high chance of getting to know more about sales and working under the esteem enterprise . Would be happy to be a part of",
  },
  {
    Timestamp: "04/08/2020 05:48:55",
    "Name of the student": "Suraksha Jain",
    "Institute Name(College)":
      "Currently on gap months. Will be beginning with bachelors in July from Azim Premji University.",
    "Field of study": "Liberal Arts and Humanities",
    Education: "Currently on gap months",
    "Preferred domain of internship":
      "Development and education sector. Also looking forward to work in CSR department of corporates.",
    "Period of Internship": "2 (April-June)",
    "Current Location(With Country)": "Surat, Gujarat, India",
    "Does Remote Internship work for you?": "Yes. Bangalore or Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17qZqN0qH0vkmeIo9XMHehUr4-RFWwul2/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "suraksha48@gmail.com",
    "Anything else you'd like to share?":
      "I work to learn while I learn to work. Being an experiental Iearner I believe work experience counts more than degree. Hence maybe I'm still yet to begin college but I'd really appreciate if this won't be a factor for my eligibility.",
  },
  {
    Timestamp: "04/08/2020 05:59:40",
    "Name of the student": "Sai Krishna Tadepalli",
    "Institute Name(College)": "IIM Trichy",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Business Development, Strategy, Marketing, Analytics",
    "Period of Internship": "April 10 - June 10",
    "Current Location(With Country)": "Guntur india",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1LCDlCB8XUeFQvkeB4t3et7V_FLOHHQtg/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sai-krishna-tadepalli",
    "Contact Details (Email)": "Sai.p19160@iimtrichy.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 06:19:13",
    "Name of the student": "Sonia Godhwani",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Computer Science (Software Engineering, Data Science)",
    "Period of Internship": "3 months- start from 05/15/2020",
    "Current Location(With Country)": "Los Angeles, United States",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1f3W1PMbeHeRV2c6me73Pt_WvSd00IBBz/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/ sonia-godhwani-7121bb104",
    "Contact Details (Email)": "sgodhwan@usc.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 06:50:05",
    "Name of the student": "Shreya Gupta",
    "Institute Name(College)":
      "Narsee Monjee Institute of Management Studies, Hyderabad",
    "Field of study": "PGDM - finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "6-8 weeks from 20 th April",
    "Current Location(With Country)": "Delhi ( India)",
    "Does Remote Internship work for you?": "Yes I am open to relocate",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/file/d/1DaGa-IdmuEtHVtFmglX3qtVU-zdKVH0x/edit?usp=docslist_api&filetype=msword",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "+919958963007",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 07:43:42",
    "Name of the student": "Deepanshu Meemroth",
    "Institute Name(College)": "Maharaja Agrasen Institute of Technology",
    "Field of study": "Information Technology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development/Software Engineering",
    "Period of Internship": "2-3 months (Immediate)",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1muyYB3QiQLvpLyuxgLKqaI_ULf2ycRst/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/deepanshu-meemroth-7b5441150/",
    "Contact Details (Email)": "deepanshu6479@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 07:51:01",
    "Name of the student": "Sarah DeLena",
    "Institute Name(College)": "Emerson College",
    "Field of study": "Publishing",
    Education: "Graduate Student",
    "Preferred domain of internship": "Editing/Publishing/Communications",
    "Period of Internship": "May 5 - August 7",
    "Current Location(With Country)": "Boston, MA or Washington D.C.",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1eIR19G_Md-gvB0vwui_aTCVYiQTH_ePn/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/sarahmariedelena/",
    "Contact Details (Email)": "smdelena@gmail.com",
    "Anything else you'd like to share?":
      "Writing, Editing & Design Portfolio: https://sarahmariedelena.wixsite.com/home/work",
  },
  {
    Timestamp: "04/08/2020 08:17:53",
    "Name of the student": "RAVI N",
    "Institute Name(College)": "BMS College of Engineering Bengaluru",
    "Field of study": "M.Tech in Electronics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Bangalore",
    "Period of Internship": "6 to 12",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Mysore, Hyderabad,Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1OZaM2XucQXeIV_Es_mVHHW0bKejxpbl4/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/ravi-n-982923183",
    "Contact Details (Email)": "ravin.lel19@bmsce.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 08:27:59",
    "Name of the student": "Shitiz Chaudhary",
    "Institute Name(College)": "Yale University -School of Environment",
    "Field of study": "Environment Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Sustainability, Climate Change, Renewable Energy",
    "Period of Internship": "15- May  to 15- Aug 2020",
    "Current Location(With Country)": "New Haven, USA",
    "Does Remote Internship work for you?":
      "Yes- New Haven or New Delhi depending on air traffic situation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1C1uMCt6b21ZoU1qGJZ4_FSWY8K9jPeql",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shitiz.chaudhary@yale.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 08:34:17",
    "Name of the student": "sachin goyal",
    "Institute Name(College)": "GLA UNIVERSITY",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing, IT",
    "Period of Internship": "2 months from 1 June",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Yes, Delhi, NCR REGION",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Nccn40lBJwMDMBy_inET8GduwnRNquyZ/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/sachin-goyal-/",
    "Contact Details (Email)": "sachin.goyal_cs17@gla.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 08:42:35",
    "Name of the student": "Yogesh Mundhra",
    "Institute Name(College)": "Simon Fraser University",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "8 months, starting May",
    "Current Location(With Country)": "Vancouver, Canada",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1UyVTo6ERoECv1f8XpEag_hnSv0ujtQj8/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/yogesh-mundhra/",
    "Contact Details (Email)": "ymundhra@sfu.ca",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 08:52:44",
    "Name of the student": "Rijul Jain",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Core chemical, Analytics, Web Development, Finance, Cosulting",
    "Period of Internship": "2 months (1 June)",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "I will prefer to provide CV when contacted by someone.",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rijul-jain-197011157/",
    "Contact Details (Email)": "rijul2608jain@gmail.com",
    "Anything else you'd like to share?":
      "I will prefer to provide CV when contacted by someone.",
  },
  {
    Timestamp: "04/08/2020 08:52:58",
    "Name of the student": "Sejal Gupta",
    "Institute Name(College)":
      "University School of Information,Communication and Technology, GGSIPU, Delhi",
    "Field of study": "B.Tech IT",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics",
    "Period of Internship": "Summer Internship for 2 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1H9zYSpY-mnVZa2nOV-BuqJsWbXi3Ua7VinTRvaJeZg8/edit?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sejal-gupta-1040ab172/",
    "Contact Details (Email)": "sejal2609.sg@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:10:16",
    "Name of the student": "Niketan Nath",
    "Institute Name(College)": "NSIT, New Delhi",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "Full Time Role",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Open to relocation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GtLbKSr2HJ7fzZQtmqhi1HfSjXV8_vgR/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/niketan-n-4294b1a2/",
    "Contact Details (Email)": "niketannath@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:13:52",
    "Name of the student": "Ayush Kasera",
    "Institute Name(College)": "Cochin University of science and technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, preferred location :- Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/0B3Gqpbh1QEZcRTRIVzJQdHFvc3RkUDZXcUN5bUR1MzM1ZkJr/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ayush-kasera-a3946a153",
    "Contact Details (Email)": "07ayushkasera@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:20:21",
    "Name of the student": "Palash Gutch",
    "Institute Name(College)": "IMT Ghaziabad",
    "Field of study": "PGDM - Sales & Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Gwalior - India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/palashgutch?originalSubdomain=in",
    "Contact Details (Email)": "palashgutch@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:21:48",
    "Name of the student": "Ankit Dwivedi",
    "Institute Name(College)": "Dr dy patil college of engineering, pune",
    "Field of study": "Computer engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development, Technical",
    "Period of Internship": "3-6 months, starting-1May",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Yes, Mumbai,Bangalore",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://drive.google.com/file/d/1cgHR71SugUIIkCJrnjOYruI7Fcq3jn8H/view?usp=drivesdk",
    "Contact Details (Email)": "ankitvd6@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:23:10",
    "Name of the student": "Sydney Turner",
    "Institute Name(College)": "University College Dublin",
    "Field of study": "Economics/International Relations",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing or Human Resources",
    "Period of Internship": "3",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?":
      "Remote Internship works - Can work in San Francisco, CA or Dublin, Ireland.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1TDW66eLN2n4BHpGypFX7bUBgMEqZcAnGMVCXtrURpio/edit",
    "LinkedIn profile link":
      "https://ie.linkedin.com/in/sydney-turner-97367a139",
    "Contact Details (Email)": "sydney.turner@ucdconnect.ie",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:32:40",
    "Name of the student": "Abhishek Sahu",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analysis, Electric Vehicles",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "Jorhat Assam,India",
    "Does Remote Internship work for you?": "To any city in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1UNdUC26i1xbdLKHmDmMnDOArgQcOheW3/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "asahu4080@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:35:17",
    "Name of the student": "Jiwan",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Financial Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months( April - June)",
    "Current Location(With Country)": "Kharagpur, India",
    "Does Remote Internship work for you?":
      "Yes, only open to remote internships",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TlNHLfPjpq7Mp5efP46JtP9NOfaoSpHQ/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jiwan-sharma-686484137/",
    "Contact Details (Email)": "jiwansharma379@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 10:05:43",
    "Name of the student": "Aniket bodkhe",
    "Institute Name(College)":
      "JBIMS ( Jamnalal Bajaj Institute of Management Studies Mumbai )",
    "Field of study": "Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Open to all roles",
    "Period of Internship": "Immediately till June End",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aniket-bodkhe-0556b364?originalSubdomain=in",
    "Contact Details (Email)": "mhrd.aniketbodkhe21@jbims.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 10:19:00",
    "Name of the student": "ishika saha",
    "Institute Name(College)": "Jadavpur university",
    "Field of study": "Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "2, 20th May to 20th July",
    "Current Location(With Country)": "Kolkata(India)",
    "Does Remote Internship work for you?":
      "Yes, Kolkata, Bangalore, Hyderabad, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1Sg8k4_2Gze15gztVjiQovMZ1Xnuq011_TKn5EMGYqLg/edit?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/ishika-saha/",
    "Contact Details (Email)": "ishika.saha.97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 10:19:41",
    "Name of the student": "Sabhajeet Yadav",
    "Institute Name(College)": "Indian Institute of Technology Ropar",
    "Field of study": "Biomedical Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Biopharmaceutical company",
    "Period of Internship": "Job",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Rupnagar",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitrpr.ac.in/file/d/17JrpQvbI3GD0RRYEI2j3nKwaN4lEjiYn/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sabhajeet-yadav-6523b166",
    "Contact Details (Email)": "sabhajeet.91@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 10:34:25",
    "Name of the student": "Aman tyagi",
    "Institute Name(College)": "Punjabi university patiala",
    "Field of study": "Btech mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Business, management, consultant",
    "Period of Internship": "Atleast 6 months",
    "Current Location(With Country)": "New delhi, india",
    "Does Remote Internship work for you?": "Yes, new delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/7sqy28leyw4yvd5/aman%20kumar%20tyagi%20resume.doc?dl=0",
    "LinkedIn profile link": "https://www.linkedin.com/in/aman-tyagi-7b4345173",
    "Contact Details (Email)": "amantyagi140@gmail.com",
    "Anything else you'd like to share?":
      "Please i need a job, internship urgently even i can work overtime",
  },
  {
    Timestamp: "04/08/2020 10:35:47",
    "Name of the student": "Abheet Rajput",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study":
      "Applied Petroleum Engineering with Specialisation in Gas",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum- Exploration and Production",
    "Period of Internship": "2-3 months.  Start date- 15th April",
    "Current Location(With Country)": "Noida, Uttar Pradesh, India",
    "Does Remote Internship work for you?":
      "Noida, Ghaziabad, Delhi, Gurgaon, Dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1md8k0XIPRbApXjg2H_z2ponCmlagyzzt/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abheet-rajput-3a436815b",
    "Contact Details (Email)": "abheet1998@gmail.com",
    "Anything else you'd like to share?":
      "Would be happy to get a software/field petroleum domain internship.",
  },
  {
    Timestamp: "04/08/2020 10:59:39",
    "Name of the student": "Aman Mahapatra",
    "Institute Name(College)": "MVJ College of Engineering",
    "Field of study": "Computer science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business operations, Marketing, Software development, Consulting",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "No, it's not possible for the moment.",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "LinkedIn.com/amank3009",
    "Contact Details (Email)": "amank3009@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:00:08",
    "Name of the student": "Shivam Laddha",
    "Institute Name(College)": "Institute of Management, Nirma University",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance, Research or Consulting",
    "Period of Internship": "4 months (May to August)",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "Yes, No preference",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17_10H8c27kdgfax1g3ftdTyxwYSEuCIL",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivam-laddha-6b7828100",
    "Contact Details (Email)": "9461727022",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:05:08",
    "Name of the student": "Md Omar Faruk",
    "Institute Name(College)":
      "National Institute of Textile Engineering and Research, University of Dhaka, Bangladesh.",
    "Field of study": "Textile Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Technical Textiles, High Performance Textiles, Textiles for Special Application, Smart Textiles and Threads, Textiles Chemistry, Denim Production, Denim Washing, Nano-Technology, 2D Materials, Data Analytics, Supply Chain Management, Quality Control",
    "Period of Internship": "0-12 months",
    "Current Location(With Country)": "Bangladesh",
    "Does Remote Internship work for you?":
      "Yes, I'm willing to relocate in any city around the globe",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xm734A5lbSD1hmAXdAt-4AH1Vg6ZBaY9/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/faruk-niter",
    "Contact Details (Email)": "mdomarfaruk096@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:15:06",
    "Name of the student": "Yutong Li",
    "Institute Name(College)": "Santa Clara University",
    "Field of study": "Computer Science and Engineering",
    Education: "master student graduating in June 2020",
    "Preferred domain of internship": "software engineering",
    "Period of Internship": "10 weeks - 15 weeks, starting in mid-August",
    "Current Location(With Country)": "Santa Clara, California",
    "Does Remote Internship work for you?": "yes, preferably bay area",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wsS7e45suX9lYD9fBUss7RLJ6Es3qrA-/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/yutong-li-a398b1105/",
    "Contact Details (Email)": "yli@scu.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:17:47",
    "Name of the student": "Sundaram Singh",
    "Institute Name(College)":
      "GL Bajaj Institute of Technology and Management",
    "Field of study": "Sales and Marketing",
    Education: "Undergraduate",
    "Preferred domain of internship": "Sales & Marketing",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Greater Noida, Uttar Pradesh, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1LioKaWMyO0rCIcLl9tjZhZuGzBAUbQjn/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sundramsingh9@gmail.com",
    "Anything else you'd like to share?":
      "I am excited to be applying for the Sales and Marketing position. I have an astute attention to detail that is required by the highest quality engineering professionals and look forward to working alongside some of the best Stem experts in the industry. My ability to grasp information quickly translates into shorter training periods and more productivity.\n\nTalking about my Industrial Experience:\n1).  CNH Industrial: Department Sales & Marketing\nHandling Facebook page and Digital Library of New Holland agriculture India\nWorking on 3 campaigns on Facebook creative and content- #GreatPlaceToWork #newhollandmypride #ArtandArtist.\nAlso have experience in agency handling.\n\n2).  Dana Graziano Transmission India Pvt. LTD:\n( Tier 1 supplier of Sonalika Group, John Deere, CNH Tractors, Mercedes Benz for Differential Assembly and Transmission System )I have a strong work ethic, ability to handle multiple projects at once, and a yearning to never stop learning. Asking the right questions has also been a strong suit of mine so that the final product perfectly mirrors what the client is seeking to receive. Between my schooling at Coral Springs University and internship experience, I feel I am a highly qualified candidate for this position.\n\n3). Spark Minda Pvt. Ltd:\n(Tier 1 supplier of John Deere, CNH Tractors and Maruti Suzuki for Key Locks, Wiring Harness and Plastic Components like AC Vent, Cup holder & Battery Cover)\n\nThank you for your valuable time and consideration. I am sincerely looking forward to learning more details about the Sales and Marketing position and about the great work is conducting. Please do not hesitate to reach out to me in order to inquire further about any of my many qualifications listed on my resume. I look forward to speaking with you and the management team in the near future.\nSincerely,\nSundaram Singh",
  },
  {
    Timestamp: "04/08/2020 11:18:07",
    "Name of the student": "kyatham Deepak",
    "Institute Name(College)": "VNR VJIET",
    "Field of study": "INFORMATION TECHNOLOGY",
    Education: "Undergraduate",
    "Preferred domain of internship": "web development",
    "Period of Internship":
      "I am looking for 3 monthsof internship from april .",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MU-6nyalmoD6PECkxMD9_3foCxIXA5Mg/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kyatham-deepak-022872194",
    "Contact Details (Email)": "deepakkyatham@gmail.com",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/08/2020 11:21:18",
    "Name of the student": "Raunak Basak",
    "Institute Name(College)": "Jadavpur University",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Intermediate coding based (C++) or Oil and Energy Sector based",
    "Period of Internship": "3 months,",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1MD71ejvUWaR_B_o9eLRTZTD3QV_Vjm1d",
    "LinkedIn profile link": "https://www.linkedin.com/in/raunakbasak",
    "Contact Details (Email)": "raunak521@gmail.com",
    "Anything else you'd like to share?":
      "I'm looking for mechanical design based internships or intermediate coding based based roles in organisations. I'm including an ATS friendly CV here.",
  },
  {
    Timestamp: "04/08/2020 11:23:44",
    "Name of the student": "Sanjay Mallasamudram Santhanam",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Computer Science",
    Education: "Masters",
    "Preferred domain of internship": "Machine learning,Software Engineering",
    "Period of Internship": "May 15 2020-August 30 2020",
    "Current Location(With Country)": "Los Angeles,United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1QKRrvoVzjgBjnuCmIiAPi_W5QADfjOZW",
    "LinkedIn profile link": "https://www.linkedin.com/in/mssanjay97/",
    "Contact Details (Email)": "mssanjay97@gmail.com",
    "Anything else you'd like to share?":
      "I am flexible in terms of working hours and I am willing to learn any framework/language/library if needed. Thanks",
  },
  {
    Timestamp: "04/08/2020 11:25:06",
    "Name of the student": "Bhaskar Kishor",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development & Data Science",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Patna, Bihar, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1IXhPakMx6sXKduXc06pkyIw7Pyqiyh15/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/bhaskar-kishor",
    "Contact Details (Email)": "bhaskarkishor23@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:30:21",
    "Name of the student": "vijay kumar jha",
    "Institute Name(College)": "IIT (ISM)",
    "Field of study": "Industrial Engineering and Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Science, Supply Chain Management, Operated",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Dhanbad,India",
    "Does Remote Internship work for you?": "Yes, Kolkata, Delhi, bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1JeDd9nUZFHoz3el6mJpfMe69pJSiVPZC/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vijay-kumar-jha-6238aa16a",
    "Contact Details (Email)": "vijay.gkv.1125@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:33:03",
    "Name of the student": "Mitali Rathod",
    "Institute Name(College)": "IIT Ropar",
    "Field of study": "B.tech in Electrical and Electronics Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "core internships (analog or digital IC design or Embedded systems))",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ratlam, Madhya Pradesh, India",
    "Does Remote Internship work for you?":
      "yes I could relocate if the situation improves, any city works well for me",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17ORaXipZY-KfeZs5I-SghgpgPL7jOvQo",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mitali-rathod-a80036182/",
    "Contact Details (Email)": "2017ceb1014@iitrpr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:34:58",
    "Name of the student": "Yashaswi",
    "Institute Name(College)": "DAV Institute of engineering and technology",
    "Field of study": "B. Tech",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Python developer,  ML / data science intern,  web developer intern",
    "Period of Internship": "2- 6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18qgkK9tlKyV2nqzkVSQdPVWYrAq5Qaso/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/yashaswipupneja",
    "Contact Details (Email)": "pupneja.yashu@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:47:45",
    "Name of the student": "Priyank Chaudhary",
    "Institute Name(College)": "IIT-BHU",
    "Field of study": "Chemical engineering and technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product management and Data Scientist",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "If situation improves, then I can relocate anywhere. But want to start internship immediately, so work from home will be perfect.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/1S_sdR2gYgQpPImjwbIkykjcIqZ770UqF/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyank-chaudhary-83a4a0157",
    "Contact Details (Email)": "priyank.chaudhary.che17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 11:55:46",
    "Name of the student": "Devesh Upadhyay",
    "Institute Name(College)": "IIM Rohtak",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing and Finance",
    "Period of Internship": "2 month",
    "Current Location(With Country)": "Bhadohi, UP,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/devesh-upadhyay-27111195/",
    "Contact Details (Email)": "pgp10deveshu@iimrohtak.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 12:03:13",
    "Name of the student": "Aryan Varma",
    "Institute Name(College)": "MVSR",
    "Field of study": "Information technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development, software development",
    "Period of Internship": "",
    "Current Location(With Country)": "Secunderabad, telangana, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aryan-varma-3b06b9152",
    "Contact Details (Email)": "aryan1999varma@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 12:06:50",
    "Name of the student": "Pranjal Agrahri",
    "Institute Name(College)":
      "G.L. Bajaj Institute of Technology and Management, Greater Noida",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Engineering/ Software Development Engineer/ Backend Developer",
    "Period of Internship": "3",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FeBryy-JnCpIAP8YCFifBleWeZX_ec6w/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/pranjal-g/",
    "Contact Details (Email)": "pranjala147@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 12:11:27",
    "Name of the student": "Adithya Rajeev",
    "Institute Name(College)":
      "SRM Institute of Science and Technology, Kattankalathur",
    "Field of study": "B.Tech in Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Automotivs, Embedded Systems, Model Based Design, Core Electronics",
    "Period of Internship": "4-6 months. Start Date - Start of May",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes. Preferred Cities - Bangalore, Pune, Hyderabad, Chennai, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1nrMXoSVTTM3Dv0vuHDq_3jomNFJCfZh-",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/adithya-rajeev-374b5817b/",
    "Contact Details (Email)": "adithyar262@gmail.com",
    "Anything else you'd like to share?":
      "Link to Project Work - https://1drv.ms/u/s!AtJ0OXVZUxcbggrDr87A8Ku0AJZV?e=8XRDzs\nProject Demonstration - https://drive.google.com/open?id=1WHqJQ_-md-UMIeD51ftoozH46xH8wGT3\nLink to Certificates - https://drive.google.com/open?id=1fRGC56JMmIHQhih3uv3Zb4RKt2UX6Z0t",
  },
  {
    Timestamp: "04/08/2020 12:11:35",
    "Name of the student": "Shruti Singh",
    "Institute Name(College)": "Symbiosis International University Nagpur",
    "Field of study": "MBA  IN FINANCE",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Mumbai - India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/file/d/1-N5RtHrhpxb1r8j2aZi8vZWjzYSamSKU/edit?usp=docslist_api&filetype=msword",
    "LinkedIn profile link": "www.linkedin.com/in/shruti-singh- 0003",
    "Contact Details (Email)": "singhshruti9305@gmail.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/08/2020 12:15:01",
    "Name of the student": "Rishabh Kumar",
    "Institute Name(College)":
      "Sardar Vallabhbhai National Institute of Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Web Developer, Software Engineering, Data Analysis",
    "Period of Internship": "2 months, Available from April - July",
    "Current Location(With Country)": "Surat, India",
    "Does Remote Internship work for you?":
      "Yes, Bangalore, Hyderabad, Pune, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1mgO2Q6blMTn5I72xNkX2KRUjVY9-dnHr/",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rishabh-kumar-211208154/",
    "Contact Details (Email)": "rishabhkumar405@gmail.com",
    "Anything else you'd like to share?":
      "I secured Internship offer from my campus and was now allowed to sit for other companies. Now my offer stands cancelled.",
  },
  {
    Timestamp: "04/08/2020 12:20:11",
    "Name of the student": "Abhishek Pandey",
    "Institute Name(College)": "inderprastha engineering college",
    "Field of study": "Computer science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data science, ML ,java development ,big data",
    "Period of Internship": "1-6months, immediate",
    "Current Location(With Country)": "Noida( india)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1S8g0k-zIzxLZNVaqv-URjGIbxlnqN13e/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/abhishek-pandit12",
    "Contact Details (Email)": "abhi.ipecc@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 12:28:02",
    "Name of the student": "Gursimran singh Ranhotra",
    "Institute Name(College)": "SRM University",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Java,data science,.Net",
    "Period of Internship": "3-4",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes.Delhi,Gurgaon,noida,bangalore,Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1y0Ur5j2dm-3CdhJrx8l4DT0FENhgP9H8/view?usp=sharing",
    "LinkedIn profile link":
      "linkedin.com/in/gursimran-singh-ranhotra-bb5a7915a",
    "Contact Details (Email)": "gursimransingh1298@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/08/2020 12:28:38",
    "Name of the student": "siva ganesh",
    "Institute Name(College)": "Srkr engineering college",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AUY9K7hwg-guQXx3FRiJjW_okBy1w-5h/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "siva.ganesh584@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 12:30:36",
    "Name of the student": "Vishesh Soni",
    "Institute Name(College)": "IIT(BHU), Varanasi",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science, Consulting",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Gwalior, India",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/1yWeaBUVdklhvJRMDrlCR5vZG4Zgp3ESz/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vishesh-soni-2766b8171",
    "Contact Details (Email)": "visheshsoni.mec18@itbhu.ac.in",
    "Anything else you'd like to share?":
      "I am a Business Enthusiast too. That's why I love Data science and would like to work for startups too. I am also an aspiring entrepreneur.",
  },
  {
    Timestamp: "04/08/2020 12:45:37",
    "Name of the student": "Rama Sai Vinay DWARA",
    "Institute Name(College)": "ESSEC Business School, France",
    "Field of study": "Masters in Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Strategy, finance, business development",
    "Period of Internship": "2-3 months, starting from 13th April, 2020",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?":
      "Yes, I'm also ok to relocate if necessary",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vNw0gPqWaj7amrV4DV7WTv8WfyBuvcx1/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/vinay-dwara",
    "Contact Details (Email)": "b00756996@essec.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 12:45:42",
    "Name of the student": "Manav Malhotra",
    "Institute Name(College)": "Bits Pilani Goa Campus",
    "Field of study": "MSc Math + BE ECE",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Science / Machine Learning",
    "Period of Internship": "2-4 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "https://bit.ly/2vtikvm",
    "LinkedIn profile link": "https://www.linkedin.com/in/manavmalhotra29/",
    "Contact Details (Email)": "official.manav29@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 12:47:59",
    "Name of the student": "Shreyam Panda",
    "Institute Name(College)":
      "Ambedkar institute of Advanced Communications Technologies and Research",
    "Field of study": "Computer Science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Technical-Backend,Software Development and Testing, Web Development or any computer Science field etc",
    "Period of Internship": "2 to 4 months from June",
    "Current Location(With Country)": "New Delhi,India",
    "Does Remote Internship work for you?": "Yes, Open to relocate",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1N6i9tOs_5cmbRTrzneqMUn_muwCppzJy/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shreyam-panda-5020bb174",
    "Contact Details (Email)": "shreyamdev1999@gmail.com",
    "Anything else you'd like to share?":
      "Git hub repository link:\nhttps://github.com/Shreyam1999",
  },
  {
    Timestamp: "04/08/2020 12:53:10",
    "Name of the student": "Rajat Budania",
    "Institute Name(College)": "IIT ISM DHANBAD",
    "Field of study": "COMPUTER SCIENCE",
    Education: "Undergraduate",
    "Preferred domain of internship": "SOFTWARE DEVELOPMENT",
    "Period of Internship": "3",
    "Current Location(With Country)": "INDIA /DHANBAD",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/rajat-budania/",
    "Contact Details (Email)": "rbudania99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 12:54:36",
    "Name of the student": "Shailesh Kushwaha",
    "Institute Name(College)": "Army institute of technology",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mechanical consulting",
    "Period of Internship": "1month (10th of April)",
    "Current Location(With Country)": "Madhya pradesh",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1bnQuy2pEYmBWRqQ6muwVxNSeNYHHrfXC/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/shailesh-kushwaha-369b4912b",
    "Contact Details (Email)": "shaileshkushwaha_16575@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 13:14:54",
    "Name of the student": "Nikhil Gupta",
    "Institute Name(College)": "IISER Pune",
    "Field of study": "Mathematics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "6-9. Start date can be as soon as possible.",
    "Current Location(With Country)": "Jodhpur, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1YjZ7BmyxEdV2oCwmM_msuaaiSK7yV2dX/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/nikhil-gupta610/",
    "Contact Details (Email)": "nikstein610@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 13:20:21",
    "Name of the student": "Suraj Kumar",
    "Institute Name(College)": "Birla Institute of Technology, Mesra",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering/Data Science",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1n53x7zZ8UcKfHgLoZqJITRJJyia2FGbt/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/suraj1611",
    "Contact Details (Email)": "surajsk1611@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 13:23:01",
    "Name of the student": "Apoorv garg",
    "Institute Name(College)": "Meerut institute of engineering and technology",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Python Developer, Data Science",
    "Period of Internship": "1 or 2 months",
    "Current Location(With Country)": "Meerut, Uttar Pradesh",
    "Does Remote Internship work for you?":
      "I can do remote internship at Delhi and it's neighbouring locations.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1YZCZJrdusKya1MPgnm3eYUSHFUEz2LnX",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/apoorv-garg-b89a65178/",
    "Contact Details (Email)": "garg.apoorv02@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 13:38:55",
    "Name of the student": "Meet Kirankumar Dave",
    "Institute Name(College)": "University of Massachusetts Amherst",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Science, Machine Learning, Computer Vision",
    "Period of Internship": "3 months. May 14, 2020",
    "Current Location(With Country)": "Amherst, MA ( United States)",
    "Does Remote Internship work for you?":
      "Yes, Open to any location in United States",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XCcI7m84ceItCOL5gs9nKwKAJZBssemV/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/meetdave06/",
    "Contact Details (Email)": "meetkirankum@umass.edu",
    "Anything else you'd like to share?":
      "I am a quick learner who likes to solve challenging problems and can work in fast-paced environments. I am currently pursuing my masters in Computer Science at UMass Amherst with specialization in Data Science. Before joining UMass, I have 4 years of industry experience where I have worked on solving various computer vision and machine learning problems such as Human Detection and Tracking for a retail client, Unsafe behaviour detection on rides for a theme park client. I have also worked on machine learning problems such as building a forecasting framework so that users can directly build forecasting models for hierarchical as well as non-hierarchical time-series data. \n\nI am proficient in languages such as Python and R. Moreover, I have extensively used tools and frameworks such as Pytorch, Tensorflow, Scikit-learn. etc.",
  },
  {
    Timestamp: "04/08/2020 13:39:02",
    "Name of the student": "Abhinash Bharat",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Mechanical with specialization in Automotive",
    Education: "Undergraduate",
    "Preferred domain of internship": "Automation, Robotics and Automotive",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Delhi( India)",
    "Does Remote Internship work for you?": "Yes, BANGALORE, Pune, etc",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uURo38RnKTjLq5O0Kmky1GgKFuTgOsCS/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhinash-bharat-samal-94a859142",
    "Contact Details (Email)": "abhinashbharat@outlook.in",
    "Anything else you'd like to share?":
      "The joining for my placement offer has been delayed for 6 months and I would like to get some work experience during his time and also I am open to new job opportunities as well",
  },
  {
    Timestamp: "04/08/2020 13:44:43",
    "Name of the student": "Rahul Tibrewala",
    "Institute Name(College)": "Chetana institute of management and research",
    "Field of study": "Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations",
    "Period of Internship": "2",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "9167750824",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 13:58:20",
    "Name of the student": "Samiksha Bhopale",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Nanded, India",
    "Does Remote Internship work for you?":
      "Yes, I am open to remote internship once the lockdown is over would continue from work from to to office,mumbai and lune are my preferred cities.",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/samiksha-bhopale-b7852a125/",
    "Contact Details (Email)": "samiksha.bhopale.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:00:42",
    "Name of the student": "Ananya Shrivastava",
    "Institute Name(College)": "Medicaps University",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Technical as well as management",
    "Period of Internship": "2-6 months starting ASAP",
    "Current Location(With Country)": "Indore, India",
    "Does Remote Internship work for you?": "Yes. Bangalore, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1QePKBdDe8EQuw8B0ToP7geVlIu8oLdiQ/view",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ananya.shrivastava.98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:04:21",
    "Name of the student": "Karan Parmar",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "MMS(Marketing)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months ( 1st May - 30th June)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocate. Preferred location - Mumbai, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PWLIAGACxxHmjPAfTa263L1lJk7fPFpL/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/karan-parmar-586b8a147",
    "Contact Details (Email)": "karan.parmar.we@gmail.com",
    "Anything else you'd like to share?": "Nope.",
  },
  {
    Timestamp: "04/08/2020 14:08:06",
    "Name of the student": "Ayushi kesharwani",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Engineering physics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Bilaspur Chhattisgarh India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-S3X6f1JhlSIF3YPUX9J8sGUIA6XE3gn/view?usp=drivesdk",
    "LinkedIn profile link":
      "http://linkedin.com/in/ayushi-kesharwani-583584186",
    "Contact Details (Email)": "yyushi.k.15@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:15:42",
    "Name of the student": "Harshita Kanodia",
    "Institute Name(College)": "Kirori Mal College, University of Delhi",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "International Relations, Foreign Policy",
    "Period of Internship": "6-months starting from June 2020",
    "Current Location(With Country)": "New Delhi (India)",
    "Does Remote Internship work for you?":
      "Remote Internships work for me during the lockdown. If the situation improves, I am open to relocate to the metro cities of the country.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=13zclXWAVtHOyAufWEC-rBWYdLhZwAZC3",
    "LinkedIn profile link": "linkedin.com/in/harshita-kanodia-468939147",
    "Contact Details (Email)": "harshitakanodia24@gmail.com",
    "Anything else you'd like to share?":
      "I would like to have a first-hand experience in research work.",
  },
  {
    Timestamp: "04/08/2020 14:24:45",
    "Name of the student": "Zeel Patel",
    "Institute Name(College)": "Institute of Technology Nirma university",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Mechanical, oil and refinery, chemical processing Plant",
    "Period of Internship": "6-12",
    "Current Location(With Country)": "Ahmedabad (Indian)",
    "Does Remote Internship work for you?": "Yes - pan India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1jSGZvecC4BdSwxWb-pcnKflGUfKDn7LR/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/zeel-patel-261438181",
    "Contact Details (Email)": "16bme027@nirmauni.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:25:07",
    "Name of the student": "Khyati grover",
    "Institute Name(College)": "Delhi technological university",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "6 months start date asap",
    "Current Location(With Country)": "Gurgaon",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1--u9jRGnnAHNpYSNV52d90WqiXSLPfXi",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Khyati.grover@yahoo.com",
    "Anything else you'd like to share?":
      "I am a 4th yr student of cse dtu,due to covid 19 my offer has been revoked. It would be great if I am provided a full time role as sde.",
  },
  {
    Timestamp: "04/08/2020 14:34:32",
    "Name of the student": "Stuti Gupta",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Energy Sciences and Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Solar Industry",
    "Period of Internship": "3 months (May June July)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1omGsnmVT7O1TtTCqku5NUUTWZjSUEHdm",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/stuti-gupta-3b390a14a/",
    "Contact Details (Email)": "stutigupta1729@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:34:37",
    "Name of the student": "Stuti Gupta",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Energy Sciences and Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Solar Industry",
    "Period of Internship": "3 months (May June July)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1omGsnmVT7O1TtTCqku5NUUTWZjSUEHdm",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/stuti-gupta-3b390a14a/",
    "Contact Details (Email)": "stutigupta1729@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:49:52",
    "Name of the student": "Somesh Saraswat",
    "Institute Name(College)":
      "Sant Longowal Institute of Engineering and Technology",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mathura,India 281004",
    "Does Remote Internship work for you?": "Yes,Sangrur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EwEZwi3arUSasio1K58Rqp73PurP09g0/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saraswat-somesh-26939b176",
    "Contact Details (Email)": "somesh.pmv@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:52:51",
    "Name of the student": "E V Abhinav",
    "Institute Name(College)":
      "National Institute of Technology,Tiruchirapalli",
    "Field of study": "Manufacturing Technology",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Design,manufacturing, thermal and analyst",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Ahmednagar, India",
    "Does Remote Internship work for you?": "Yes. ( Banglore,Chennai)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1i8-iIOLzs5uGMeXGGsuWuWNqZ5z6FhPR/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "evabhinav@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:58:08",
    "Name of the student": "Apoorva Chanana",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Business Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Analytics",
    "Period of Internship": "2 months, Starting from 1 May 2020",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Yes, Preferred cities are: Delhi, Gurugram & Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1925F3dDKEfZqIfeTLPQZl9Wlntscx785/view?usp=sharing",
    "LinkedIn profile link": "http://linkedin.com/in/apoorva-chanana-80326a176",
    "Contact Details (Email)": "achanana1809@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:58:49",
    "Name of the student": "Souradeep Ghosh",
    "Institute Name(College)": "Symbiosis Institute of Operations Management",
    "Field of study": "MBA - Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations and Supply chain",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/my-drive",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/souradeep-ghosh-8209a6102",
    "Contact Details (Email)": "souradeep.ghosh@siom.in",
    "Anything else you'd like to share?":
      "During this testing time if given a chance I would ensure to leave no stones unturned.",
  },
  {
    Timestamp: "04/08/2020 15:07:35",
    "Name of the student": "Nishtha Jaiswal",
    "Institute Name(College)": "TISS Mumbai",
    "Field of study": "MA Media and Cultural Studies",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Media/Research/Content Devolopment/Communications",
    "Period of Internship": "1 month starting from mid April to mid May",
    "Current Location(With Country)": "Kathmandu (Nepal)",
    "Does Remote Internship work for you?": "Yes, not open to relocation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1IYDKV8EikIvA9JXKwfDzbvnREIFei8Bk/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "nishthajais@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 15:10:10",
    "Name of the student": "Jahanvi Mangla",
    "Institute Name(College)": "Chitkara University",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software engineer",
    "Period of Internship": "6",
    "Current Location(With Country)": "Kalka",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "Jahanvi Mangla",
    "Contact Details (Email)": "jahanvimangla28@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/08/2020 15:11:04",
    "Name of the student": "Kumar",
    "Institute Name(College)": "",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "IoT and Big Data,ml",
    "Period of Internship": "2",
    "Current Location(With Country)": "Bangalore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Yes",
    "Anything else you'd like to share?": "kraishwary@gmail.com",
  },
  {
    Timestamp: "04/08/2020 15:18:47",
    "Name of the student": "Uttaran Tribedi",
    "Institute Name(College)": "Manipal Institute of Technology",
    "Field of study":
      "Instrumentation and Control Engineering with minors in Data Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1F7cWhuSLTdlc9ewBXSs-zpN0a27_QWDM/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/uttarantribedi",
    "Contact Details (Email)": "utribedi18@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 15:21:23",
    "Name of the student": "Vidit Nagpal",
    "Institute Name(College)": "Chitkara University, Punjab",
    "Field of study": "BE CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "SDE - Backend/Frontend/Fullstack python",
    "Period of Internship": "3 to 6",
    "Current Location(With Country)": "Gurugram, India",
    "Does Remote Internship work for you?": "Yes, Bangalore, Mumbai, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1IzT-hjxLZN7VlI5XGsanicm6z_3gGWyO/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vidit-nagpal-13898314b",
    "Contact Details (Email)": "nagpalvidit1@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 15:22:59",
    "Name of the student": "HANSALPARA NIRAV BABULAL",
    "Institute Name(College)": "Nirma University,Ahemdabad",
    "Field of study": "B.Tech- Instrumentation and Control",
    Education: "Undergraduate",
    "Preferred domain of internship": "Automation Plant, Process control Plant",
    "Period of Internship": "5 Months (December)",
    "Current Location(With Country)":
      "Vaishnodevi Circle,Ahmedabad,Gujarat (India)",
    "Does Remote Internship work for you?": "Ahmdebad, Vadodara, Surat, Rajkot",
    "Link to Resume(Google Drive/Dropbox)": "VISIBLE TO ALL",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nirav-hansalpara-86b57b17b",
    "Contact Details (Email)": "niravhansalpara54@gmail.com",
    "Anything else you'd like to share?":
      "I want a company which gives me explosion of my knowledge towards the field of interest (Automation, Process control, measurement )",
  },
  {
    Timestamp: "04/08/2020 15:32:33",
    "Name of the student": "Ranju Raju",
    "Institute Name(College)": "IIM Indore",
    "Field of study": "Marketing and Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "April 2nd week. 2 months",
    "Current Location(With Country)": "Indore",
    "Does Remote Internship work for you?": "Yes. PAN India.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iimidr.ac.in/file/d/1NwWLBQjUCzjqiW94d4GEbsxLz9dxah9l/view?usp=drivesdk",
    "LinkedIn profile link": "Ranju R Mathew",
    "Contact Details (Email)": "pm18ranjur@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 15:43:38",
    "Name of the student": "Saurabh Singh",
    "Institute Name(College)": "IIT KHARAGPUR",
    "Field of study": "Chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software engineering",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Prayagraj, uttar pradesh, India",
    "Does Remote Internship work for you?": "Yes, Bengaluru",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1cQcv4liARX4IG6mh78mcDaxiytKtBCeN",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saurabh-singh-7a9101151",
    "Contact Details (Email)": "Saurabhsinghchahar192@gmail.com",
    "Anything else you'd like to share?": "Phone No: +91 9079286213",
  },
  {
    Timestamp: "04/08/2020 15:52:20",
    "Name of the student": "Rashika Karki",
    "Institute Name(College)": "Kathmandu University",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Preferred but not limited to Machine Learning,Data Science",
    "Period of Internship":
      "I am open for 3 to 6 month internship and I can start from 15th April.",
    "Current Location(With Country)": "Kathmand University",
    "Does Remote Internship work for you?":
      "For the time being I would prefer working remotely.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1eCXOJUOnPHbmo9TUEYp0EQ41fnDW57km/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rashika-karki-7b1570160/",
    "Contact Details (Email)": "rashikakarki9841@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 15:58:37",
    "Name of the student": "Saurabh kumar choudhary",
    "Institute Name(College)": "Vidya college of engineering",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development software development",
    "Period of Internship": "June",
    "Current Location(With Country)": "Meerut",
    "Does Remote Internship work for you?": "Yes delhi ;dehi ncr",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "saurabhthebeast2105@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 16:16:35",
    "Name of the student": "Atharva Rajhans",
    "Institute Name(College)": "Symbiosis Institute of Operations Management",
    "Field of study": "Mamagement",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations, Supply Chain",
    "Period of Internship": "2 months 15th April 2020",
    "Current Location(With Country)": "Nashik, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/siom.in/file/d/1pbR7ZbolrRSWQJZxmDM2MzYqArObE9dT/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/atharva-rajhans-074a03b6",
    "Contact Details (Email)": "atharva.rajhans@siom.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 16:38:06",
    "Name of the student": "Abhishek Kumar Singh",
    "Institute Name(College)": "Haldia Institute of Technology",
    "Field of study": "Computer Science and Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Programmer, Developer",
    "Period of Internship": "6 month",
    "Current Location(With Country)": "West Bengal",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1u8S8YhnLD41ktYAiMEnASbNlJ1cVQkY7/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "abhishekcsek@gmail.com",
    "Anything else you'd like to share?":
      "I am a undergraduate CSE student and very good programmer and well in java and computer network.I got silver batch from IIT KHARAGPUR in DBMS.",
  },
  {
    Timestamp: "04/08/2020 16:54:15",
    "Name of the student": "Pawas seth",
    "Institute Name(College)":
      "University of petroleum and energy studies, Dehradun",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development, Data analyst",
    "Period of Internship": "3",
    "Current Location(With Country)": "Dehradun, India",
    "Does Remote Internship work for you?":
      "Yes, Preferred Cities are Bangalore, Pune, Hyderabad and Gurugram",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1lECl6-AuDdPHer7SNau7Wr5RPvm0G6GfTBGXejesnl8/edit?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/pawas-seth-847090140",
    "Contact Details (Email)": "sethpawas2950@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 16:54:19",
    "Name of the student": "Kakoli Mukherjee",
    "Institute Name(College)": "IMT Ghaziabad",
    "Field of study": "PGDM Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Sales and Marketing",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocate to any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1hEfIwZoYYJIxX9IIRpDSWBe8-qTuEg2p?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kakoli-mukherjee-877478188/",
    "Contact Details (Email)": "pgp19kakolimukherjee@imt.ac.in",
    "Anything else you'd like to share?":
      "A big thank you for this initiative. #We are obliged",
  },
  {
    Timestamp: "04/08/2020 17:02:28",
    "Name of the student": "Shubham kumar",
    "Institute Name(College)": "NIT Kurukshetra",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Is0FRmbQzIvsibpQHm6W7ntQtnpHhoI6/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/shubham-kumar-671584153",
    "Contact Details (Email)": "shubhamjangir802@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 17:03:43",
    "Name of the student": "Pushpendra Singh Champawat",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Geophysics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Jodhpur",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=13xM5d8eGofYLLbjT0EgqQ-lZWm8_jnSN",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pushpendraschampawat/",
    "Contact Details (Email)": "pushpendrachammpawat@gmail.com",
    "Anything else you'd like to share?": "Fourth Year Student",
  },
  {
    Timestamp: "04/08/2020 17:07:59",
    "Name of the student": "Bhavesh Chandwani",
    "Institute Name(College)": "NIT Durgapur",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Business Analytics,Data Analytics",
    "Period of Internship": "2 month, immediately",
    "Current Location(With Country)": "Jhansi,India",
    "Does Remote Internship work for you?": "Yes, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VLygkfu6YkKfaL1lEwhUl8vWa02OlHXy/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://in.linkedin.com/in/bhavesh-chandwani-5ab890189",
    "Contact Details (Email)": "bhavesh19chandwani@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 17:10:34",
    "Name of the student": "Anurag Shukla",
    "Institute Name(College)":
      "Delhi Techonological University (formerly Delhi College of Engineering)",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Analytics, Consultancy",
    "Period of Internship": "3",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Pan-India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MTJhj2JW5ViHX_mXb9ry-SxL7NfCCYd2/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "www.linkedin.com/in/anuragshukla007",
  },
  {
    Timestamp: "04/08/2020 17:12:07",
    "Name of the student": "Anurag Shukla",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Analytics, Consultancy",
    "Period of Internship": "3",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Pan-India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MTJhj2JW5ViHX_mXb9ry-SxL7NfCCYd2/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/anuragshukla007",
    "Contact Details (Email)": "anuragalkuhs@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 17:40:44",
    "Name of the student": "Shaili Parikh",
    "Institute Name(College)": "Birla Institute of Technology, Goa",
    "Field of study":
      "Electronics and Instrumentation Engineering and Economics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Information Technology/Data Analytics/Content Creation",
    "Period of Internship": "3",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?":
      "Yes. In any case, Mumbai will be the preferred location",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/presentation/d/107FY7wBjoAQHeNtbb6GyF-LtJpNPKr5G-gHVYgV1pog/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shaili-parikh-25aa82184/",
    "Contact Details (Email)": "parikhshaili99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 17:44:35",
    "Name of the student": "Jashan",
    "Institute Name(College)": "IIT Mandi",
    "Field of study": "VLSI(microelectronics)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital and Analog IC Design profile",
    "Period of Internship": "12 months, 30June,2020",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Noida, Bangalore, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-1ju2Q738G8mURl8PtyvqJTBXTYwEAqk/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jashan-jain-182a58128",
    "Contact Details (Email)": "jashanjain09@gmail.com",
    "Anything else you'd like to share?":
      "I have good hand on experience on Cadence virtuoso and xilinx verilog.",
  },
  {
    Timestamp: "04/08/2020 17:48:32",
    "Name of the student": "Abinesh A",
    "Institute Name(College)": "Symbiosis Institute of Operations Management",
    "Field of study": "Operatons Management",
    Education: "Undergraduate",
    "Preferred domain of internship": "Operations",
    "Period of Internship": "2 months - 15-04-2020-30-06-2020",
    "Current Location(With Country)": "chennai india",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DVWs2wQ3rao41qlmdLT8NSTngYr1cAsE/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abinesh-arul-572487192/",
    "Contact Details (Email)": "abinesharul7@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:03:41",
    "Name of the student": "Mohammed Farhan Jameel",
    "Institute Name(College)": "Presidency University",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Engineering",
    "Period of Internship": "6months or more  (Start date:- July 2020)",
    "Current Location(With Country)": "Bengaluru (India)",
    "Does Remote Internship work for you?":
      "Yes, Ready to relocate nationally and internationally to any city.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1yYFvETJLc_J5-eWC0WYCqVcti0XGkNE2/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/farhan-jameel-580287169",
    "Contact Details (Email)": "farhanjameel12345@gmail.com",
    "Anything else you'd like to share?":
      "I'm looking forward to Internships or Graduate Trainee programs in the Petroleum industry.",
  },
  {
    Timestamp: "04/08/2020 18:05:24",
    "Name of the student": "Shivani Bundela",
    "Institute Name(College)": "Amity Institute of Food Technology",
    "Field of study": "B.Tech Food Technology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Quality and Production department of edible oil",
    "Period of Internship":
      "I would like 6 months to 1 year training in edible oil company like adani wilmar, cargil India starting ASAP",
    "Current Location(With Country)": "Delhi (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1EdYAGnNEAs8PD-J6LrOotFQuipBXuuwubbKois-741o/edit?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Shivanibundela11@gmail.com",
    "Anything else you'd like to share?":
      "I am food technologist worked as trainee at GSK, Puratos, Veetee group, Globus spirit in production and quality department.",
  },
  {
    Timestamp: "04/08/2020 18:11:49",
    "Name of the student": "Kanav Gupta",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Engineering Physics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Growth & Strategy",
    "Period of Internship": "2. 13Apr-13June.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Mumbai, Bangalore.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14Ox0EejdqoIHhEib4oqLbGc-7JOrebZ8/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/kanav-gupta-250b77161",
    "Contact Details (Email)": "kanav@moodi.org",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:19:46",
    "Name of the student": "Harshit panchbhai",
    "Institute Name(College)": "Indian institute of technology delhi",
    "Field of study": "Coding",
    Education: "Undergraduate",
    "Preferred domain of internship": "Programming",
    "Period of Internship": "2 months from April",
    "Current Location(With Country)": "Indore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1hLHwg88JBHLVU7YKeutNIdJ3k8H51bVG/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/harshit-p-89a6371a4",
    "Contact Details (Email)": "Harshit12339@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:30:40",
    "Name of the student": "Aaditya Arora",
    "Institute Name(College)": "Indian Institute of Technology, Mandi",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Full Stack Development, Backend Development",
    "Period of Internship": "from June 2020 for 2 months",
    "Current Location(With Country)": "Mandi, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=16-Hl0vnn7DjRKeCiXpDt14QnS5LCgVb4",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aaditya-arora-550716154/",
    "Contact Details (Email)": "er.adi2612@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:30:44",
    "Name of the student": "Gunish Matta",
    "Institute Name(College)": "DAV COLLEGE CHANDIGARH",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development or Software Development",
    "Period of Internship": "3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1aPr1aVdRvM5pSkU13He1FLHt_E3amB9OSRqtUiDCMHA/edit?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/gunishmatta2",
    "Contact Details (Email)": "gunishmatta@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:35:24",
    "Name of the student": "Millend Roy",
    "Institute Name(College)": "IIT ISM Dhanbad",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Research Intern, Data Analyst, Core Electrical",
    "Period of Internship": "3 months, April -25",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1PCorIs1Ge70X6gvnw_Ktj844V1W0A-G4wHw6S7kgcGE/edit?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/millend-roy-240897179",
    "Contact Details (Email)": "millendroy239@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:37:12",
    "Name of the student": "Madhavi Mohan",
    "Institute Name(College)": "Netaji subhas institute of technology",
    "Field of study": "Instrumentation and control engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core companies",
    "Period of Internship": "2 months june and july",
    "Current Location(With Country)": "Newdelhi India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "madhavimohan21@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:47:48",
    "Name of the student": "Disha Chugh",
    "Institute Name(College)":
      "Seth Jai Parkash Mukand Lal Institute Of Engineering And Technology,Kurukshetra University",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learnning",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Poanta Sahib, Himachal Pradesh",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14p1izsA2cnAbsShfytRaRJbjGgMx_DrZ/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/disha-chugh20/",
    "Contact Details (Email)": "chughdisha20@gmail.com",
    "Anything else you'd like to share?": "https://github.com/disha2320",
  },
  {
    Timestamp: "04/08/2020 18:50:01",
    "Name of the student": "Soumya Gupta",
    "Institute Name(College)": "Indian Institute Of Technology, Kanpur, India",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science, Finance, Supply Chain",
    "Period of Internship": "2-3(can start now)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ol-9GEWbDT6yffiqSgUU0ysZibYFm-Pm/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/soumya151299",
    "Contact Details (Email)": "soumya151299@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:50:05",
    "Name of the student": "Sajan Bajaj",
    "Institute Name(College)": "Chandigarh University",
    "Field of study": "Computer Science & Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development, DevOps Engineer, Quality Assurance, Cloud Engineer",
    "Period of Internship": "4 months+",
    "Current Location(With Country)": "Ludhiana, Punjab, India",
    "Does Remote Internship work for you?":
      "Yes, Preferred Locations - Bangalore or Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/v6wfutxqfp62cfl/Resume__Sajan_Bajaj.pdf?dl=0",
    "LinkedIn profile link": "https://www.linkedin.com/in/sajanbajaj",
    "Contact Details (Email)": "sajanbajaj21@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:51:09",
    "Name of the student": "Lalit Chamat",
    "Institute Name(College)":
      "Welingkar Institute of Management development and Research Mumbai",
    "Field of study": "MBA- marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "1-5-2020 to 30-06-2020",
    "Current Location(With Country)": "Nagpur, India",
    "Does Remote Internship work for you?": "Yes, Nagpur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vbPjkS5SmO-VucjEvJNAgETSFcqWLImh/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/lalitchamat",
    "Contact Details (Email)": "lalitchamat27.04@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:52:03",
    "Name of the student": "Mudit Garg",
    "Institute Name(College)": "IIT Delhi",
    "Field of study":
      "Minor in Computer Science with Majors in Textile and Fiber Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Machine Learning or Mobile App Development",
    "Period of Internship":
      "Two Months, 20 May - 20 July. (This is my summer vacation period and may change due to corona/lockdown)",
    "Current Location(With Country)": "India, Home - Jaipur, College - Delhi",
    "Does Remote Internship work for you?": "Gurgaon, New Delhi, Jaipur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/182eC982Ab_5vWyeiaPwc53WGGmhT34Ba/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mudit-garg-30b977145/",
    "Contact Details (Email)": "muditgarg.iitdelhi@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 18:58:55",
    "Name of the student": "Yogesh Bagier",
    "Institute Name(College)": "SIOM",
    "Field of study": "Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Supply chain, Operations and Logistics",
    "Period of Internship": "2 (15-04-2020)",
    "Current Location(With Country)": "Nashik, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/yogesh-bagier-99117652/",
    "Contact Details (Email)": "yogesh.bagier@siom.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 19:08:48",
    "Name of the student": "Kunal Kathuria",
    "Institute Name(College)": "NUS Singapore",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "Flexible",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GZejC75hIQckKCG3MfSVqvBD-PW2ebyp/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kunal-kathuria-74295816/",
    "Contact Details (Email)": "KUNAL140@GMAIL.COM",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 19:33:25",
    "Name of the student": "Baddam Harini",
    "Institute Name(College)": "CVR College of Engineering",
    "Field of study": "ECE, Btech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "I am looking for the full time oppurtunity",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Yes, Banglore/Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XOXXNRI_S_yZLtGbBWpPj7Z2fBAeDG1D/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harini-baddam-b00262168?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BrDn3924yRairHL0RaNP2jg%3D%3D",
    "Contact Details (Email)": "harinibaddam99@gmail.com",
    "Anything else you'd like to share?":
      "i  have strong command on DS & Algo& CS fundamentals.I am doing internship at NCR Corp., hyderabad.Due to the current situation, I lost my full time oppurtunities, I will be glad if i can get any Software development full time oppurtunities. Thank you!",
  },
  {
    Timestamp: "04/08/2020 19:33:40",
    "Name of the student": "Janu Suresh",
    "Institute Name(College)":
      "Sree Chitra Thirunal College of Engineering, Trivandrum",
    "Field of study": "Biotechnology and Biochemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Interns belonging to my stream of Engineering",
    "Period of Internship": "A minimum time period of 5 days",
    "Current Location(With Country)": "Pappanamcode,Trivandrum,Kerala,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/janu-suresh-015671170",
    "Contact Details (Email)": "janusureshs1998@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 19:40:25",
    "Name of the student": "Mehul Parmar",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting, Marketing, Business development, analytics or any other profile similar to these.",
    "Period of Internship": "April and May",
    "Current Location(With Country)": "Yavatmal, Maharashtra, India",
    "Does Remote Internship work for you?": "Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1UWIc64lli_9JM1tvQM0l4wubu-jPYKYh/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mehul-parmar-636b80152/",
    "Contact Details (Email)": "parmarmehul189@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 19:42:20",
    "Name of the student": "Sreenidhi Sharma",
    "Institute Name(College)": "Gokhale Institute of Politics & Economics",
    "Field of study": "Financial Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Financial Analytics, Wealth Management, Risk Management",
    "Period of Internship":
      "2 months, preferably from May, but I'm unsure as exam dates are not known yet",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?":
      "Yes, I can move to Delhi, Mumbai, or Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wAVihyJ5ldChpnpSw01fucaE_D5Pz_BX/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sreenidhi-sharma-102361171/",
    "Contact Details (Email)": "sreenidhi.sharma@gipe.ac.in",
    "Anything else you'd like to share?": "No, thank you",
  },
  {
    Timestamp: "04/08/2020 19:45:24",
    "Name of the student": "Shreya Khemka",
    "Institute Name(College)": "EADA Business School",
    "Field of study": "Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations and Strategy",
    "Period of Internship": "3-6 months, Available immediately",
    "Current Location(With Country)": "Mumbai, Maharashtra, India",
    "Does Remote Internship work for you?": "Mumbai, Bangalore, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1CNW6crZQcflrIS5QuFiD53zDzY1pRNJE",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shreya-khemka-8b063844/",
    "Contact Details (Email)": "shreyakhemka13@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 19:47:28",
    "Name of the student": "RAVI KUMAR",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Mechanical engineering, Analyst, Business development, supply chain management",
    "Period of Internship": "2 months (5-6-20)",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Prayagraj, U.P",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1ShaSMTDhWAX6AF1eYICLCEPiYyR66jIr",
    "LinkedIn profile link": "https://www.linkedin.com/in/ravi-kumar-256839166",
    "Contact Details (Email)": "raviksw7@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 20:18:42",
    "Name of the student": "Shubham Maurya",
    "Institute Name(College)": "Lovely Professional University",
    "Field of study": "Computer science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software developer",
    "Period of Internship": "4-6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Pune, banglore, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16pys72D1hYxkTvMOV3MSD7eYyHqNuIRf/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://in.linkedin.com/in/shubham-maurya-91044614a/%7Bcountry%3Des%2C+language%3Des%7D?trk=people-guest_profile-result-card_result-card_full-click",
    "Contact Details (Email)": "shubh27296@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/08/2020 20:22:06",
    "Name of the student": "Shashwat Khare",
    "Institute Name(College)": "IIT BHU",
    "Field of study": "Ceramic engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analytics, data science",
    "Period of Internship": "2 months. 15th April",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/10fw4BCzAU-S09x3u-bRDKecncyCBVPcr/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shashwat-khare-7ba27317b",
    "Contact Details (Email)": "shashwatkhare.cer18@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 20:28:32",
    "Name of the student": "Prince Tyagi",
    "Institute Name(College)": "DTU(DCE)",
    "Field of study": "Mechanical minor in Machine learning",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning/Data Sciencw",
    "Period of Internship": "1June -31 July",
    "Current Location(With Country)": "New Delhi(India)",
    "Does Remote Internship work for you?": "Yes,to any location",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-ajnyxa2ww-YDr71qJgi08aWc6ssT_s0/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/prince-t-aa744188",
    "Contact Details (Email)": "princetyagi193@gmail.com",
    "Anything else you'd like to share?": "github.com/princetyagitech",
  },
  {
    Timestamp: "04/08/2020 20:33:18",
    "Name of the student": "Sonali Pandey",
    "Institute Name(College)": "Ramaiah Institute Of Technology",
    "Field of study": "Computer Science and Engnieering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning",
    "Period of Internship": "6, any time is fine",
    "Current Location(With Country)": "Bangalore",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=15Y-5GMAQtQnv3fWCGhJa_J7-uW2Yj-DZ",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sonali-pandey-25285517a/",
    "Contact Details (Email)": "sonali.pandey2226@gmail.com",
    "Anything else you'd like to share?":
      "Besides Machine learning, i like writing articles as well, here is my resume for content writing and sample work for reference: \nSample work:https://drive.google.com/open?id=1F2OcFASyxne_yiDJwAB0eNZoeSCBI9cQ\nResume:https://drive.google.com/open?id=18IkJs0Rq-Ip2ZbYVFgPi0rPLek_emXLH",
  },
  {
    Timestamp: "04/08/2020 20:37:27",
    "Name of the student": "Veronica Liu",
    "Institute Name(College)": "University of Texas at Dallas",
    "Field of study": "Animation Production & Computer Science minor",
    Education: "Undergraduate",
    "Preferred domain of internship": "Program Management",
    "Period of Internship": "6, starting in May",
    "Current Location(With Country)": "Michigan, United States",
    "Does Remote Internship work for you?":
      "yes, open to relocation throughout the US",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/veronica-liu/",
    "Contact Details (Email)": "verliu21@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 20:38:26",
    "Name of the student": "Anupam kumar singh",
    "Institute Name(College)":
      "Mahatma gandhi mission's college of engineering and technology noida",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Any type of job or internship",
    "Period of Internship": "As company offering",
    "Current Location(With Country)": "Kanpur",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 20:38:44",
    "Name of the student": "Achraf Tai",
    "Institute Name(College)": "DePauw University",
    "Field of study": "Computer Science/Film Studies/ French",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer Science/Film Studies/ French",
    "Period of Internship": "2 or 3 starting May 17th",
    "Current Location(With Country)": "Greencastle, Indiana",
    "Does Remote Internship work for you?": "Yes- No preferred city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/7vprjikdgqqdyds/Achraf%20Tai%27s%20Resume%20%281%29%20%281%29.pdf?dl=0",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "achraftai_2023@depauw.edu",
    "Anything else you'd like to share?":
      "I lost 2 internship opportunities for this summer already",
  },
  {
    Timestamp: "04/08/2020 20:42:17",
    "Name of the student": "ROHIT KUMAR GUPTA",
    "Institute Name(College)": "Netaji Subhas Institute of Technology",
    "Field of study": "SIGNAL PROCESSING",
    Education: "Post-Graduate",
    "Preferred domain of internship": "ELECTRONICS AND SEMICONDUCTOR",
    "Period of Internship": "6 MONTHS",
    "Current Location(With Country)": "NEW DELHI, INDIA",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rohit-gupta-kiet2013/",
    "Contact Details (Email)": "rohitgupta123946@gmail.com",
    "Anything else you'd like to share?":
      "THANKS FOR TAKING SUCH A GOOD INITIATIVE",
  },
  {
    Timestamp: "04/08/2020 20:43:25",
    "Name of the student": "Francesca Civetta",
    "Institute Name(College)": "Bocconi University",
    "Field of study": "Finance",
    Education: "Master",
    "Preferred domain of internship": "Business related",
    "Period of Internship": "3-6 months, starting as soon as possible",
    "Current Location(With Country)": "Italy",
    "Does Remote Internship work for you?":
      "Yes, I can guarantee complete flexibility both regarding remote work or relocation!",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1zCFQ1Gz4SPQgFe41Pi8DQZPPGZOKsT2D/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "francescacivetta1996@gmail.com",
    "Anything else you'd like to share?":
      "I am a graduate student, with previous work experience in both the private and public sector, studying towards an interdisciplinary degree in Quantitative Finance, with a strong demonstrated passion for technology. My most valuable assets are resilience and flexibility, which I gained by maintaining a student-worker position throughout my studies. Moreover, I am a fast learner and I possess valuable experience in due diligence work, market analysis and client presentations. My motto is: �if opportunity doesn�t knock, build a door� and my biggest passions are traveling and learning new languages. \nNevertheless, the most important aspect to know about myself is not included in the hereby attached CV: I really believe that with the right team there is endless impact to be made in the world. I am ready to dedicate my time, energy and knowledge to working with people that are driven by passion and values of innovation and enthusiasm. Thus, I am looking forward to hearing from you and checking whether my team could be right here with you.",
  },
  {
    Timestamp: "04/08/2020 20:45:39",
    "Name of the student": "Asiwaju Imoleayo Samuel",
    "Institute Name(College)": "Federal university otuoke",
    "Field of study": "",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Computer Science",
    "Period of Internship": "1 year, 8/8/2020",
    "Current Location(With Country)": "Nigeria",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "samuelasiwaju@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 20:49:38",
    "Name of the student": "Sharabesh J",
    "Institute Name(College)":
      "National Institute of Technology Tiruchirappali",
    "Field of study": "",
    Education: "Undergraduate",
    "Preferred domain of internship": "Devops",
    "Period of Internship": "2",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1wukOYcNRbtQI0YXVg4EXaJaK6wquULfK",
    "LinkedIn profile link": "https://www.linkedin.com/in/sharabesh-j/",
    "Contact Details (Email)": "sharabeshjayaraman@outlook.com",
    "Anything else you'd like to share?":
      "I am looking for a short term commitment to improvise my skills in development of application and deployment operations . With my previous experience of working in the industry, I can assure my complete potential in to work",
  },
  {
    Timestamp: "04/08/2020 20:49:56",
    "Name of the student": "vishal singh",
    "Institute Name(College)": "VNRVJIET",
    "Field of study": "CIVIL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "MACHINE LEARNING, DEEP LEARNING, STRUCTURAL ENGINEERING",
    "Period of Internship": "START IMMEDIATELY TILL JUNE 5 2020",
    "Current Location(With Country)": "HYDERABAD,INDIA",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1fFuI7AUoVV6iShIFKuD9iSApWUi6L6C_/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vishal-singh-7b30b3b3/",
    "Contact Details (Email)": "vishalsinghpanwar02@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 20:58:39",
    "Name of the student": "Rashul Chutani",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Computer Science And Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering, Machine Learning",
    "Period of Internship": "Around 2.5 months starting mid may",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?":
      "Remote will be fine. Relocation will be difficult. Looking for opportunities in Delhi-NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Xxoo3gHGFqUDtNV0-G6gNdLP_3y60lUq/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rashul-chutani-14281b74/",
    "Contact Details (Email)": "rashul.chutani@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:04:18",
    "Name of the student": "Shelly Jain",
    "Institute Name(College)": "University College London, UK",
    "Field of study": "MSc Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Management consulting, Market Research, Strategy Consulting",
    "Period of Internship": "2-6 months starting from Apr 13, 20.",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Yes, ready to relocate to cities like Mumbai, Bangalore, Pune in India and Singapore, London, New York, Sydney, Boston, Zurich, Melbourne outside India.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/176pI5Rj87GRSV6tYlqMKtDRp9-0wGlMq/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shelly-jain-30ab1b93/",
    "Contact Details (Email)": "shellyjain22@hotmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:08:11",
    "Name of the student": "Nikita Anil Belure",
    "Institute Name(College)": "",
    "Field of study": "",
    Education: "",
    "Preferred domain of internship": "Machine Learning, Computer Vision",
    "Period of Internship": "6",
    "Current Location(With Country)": "Pune(India)",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "www.linkedin.com/in/nikita-belure-55529b170",
    "Contact Details (Email)": "nikitabelure98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:10:18",
    "Name of the student": "Shritama Saha",
    "Institute Name(College)": "Symbiosis Centre for Media and Communication",
    "Field of study": "B.A.- Mass Communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Work from home(due to lockdown) / Full-time / Part time.",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Kolkata,W.B.,India",
    "Does Remote Internship work for you?":
      "Yes,remote internship works for me.If situation improves, I am open to relocate,preferably Pune,India.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ChJxwpBxOb7bO_RuLt97N_1yqmv-RTMW/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shritamasaha@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:14:23",
    "Name of the student": "Randhir Nayan",
    "Institute Name(College)": "National institute of technology Silchar Assam",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Patna",
    "Period of Internship": "1",
    "Current Location(With Country)": "Silchar Assam",
    "Does Remote Internship work for you?": "Silchar",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "randhiryadav.96@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:16:35",
    "Name of the student": "Sougata Laga",
    "Institute Name(College)": "National Institute of Technology, Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Analytics, Data Science, Management, HR, Content writing, Business operations",
    "Period of Internship": "2, starting from April itself",
    "Current Location(With Country)": "Kolkata(India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ypU_tmXVZgdf0VIyPQGCuy56S_uWhFYi/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sougata-laga-b73143154",
    "Contact Details (Email)": "sougatalaga@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/08/2020 21:18:24",
    "Name of the student": "Pradeepta Dey",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing and management",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Silchar (India)",
    "Does Remote Internship work for you?": "Yes. Preferred city is Noida.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Tys_p5V94mBXUhmI4GRx0AO-7f2xymRz/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pradeepta-dey-7b9792191",
    "Contact Details (Email)": "dpradeepta2601@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:21:28",
    "Name of the student": "Yash Chanchad",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Computer Science",
    Education: "Master's",
    "Preferred domain of internship": "Software development engineer",
    "Period of Internship": "3 months from 18th May",
    "Current Location(With Country)": "Los Angeles",
    "Does Remote Internship work for you?": "Yes, any.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-Efm-_WYU3Xzs-MBR_Wd5agzT_gyYVBE/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/yashchanchad",
    "Contact Details (Email)": "chanchad@usc.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:22:25",
    "Name of the student": "Atul Shukla",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Power electronics, control engineering, power engineering",
    "Period of Internship": "4-6 weeks",
    "Current Location(With Country)": "Rajgangpur, Odisha, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17m3CiFgqD-LgcFZG3Kv-OFV_7D55J61G/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out Atul Shukla�s profile on LinkedIn https://www.linkedin.com/in/atul-shukla-2b7009165",
    "Contact Details (Email)": "shuklaatul.satna@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:23:29",
    "Name of the student": "Veena T.A Kumar",
    "Institute Name(College)":
      "National institute of technology Tiruchirapalli (NITT)",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Chemical Engineering",
    "Period of Internship": "2 months. Dec-Jan (2020-21) or May-June (2021)",
    "Current Location(With Country)":
      "19D, Sri Subha Colony,West kk nagar, Chennai 600078, TN, India",
    "Does Remote Internship work for you?": "Yes . Chennai/Banglore/Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1aBTX_-JamdYwFgqg7yXSD2U9LMJiRyF-",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/veena-kumar-05629613a",
    "Contact Details (Email)": "veenakumar012@gmail.com",
    "Anything else you'd like to share?":
      "I would like to do practical application/ work with Software related to Chemical Engineering",
  },
  {
    Timestamp: "04/08/2020 21:26:31",
    "Name of the student": "Vijay Gupta",
    "Institute Name(College)": "NIT Silchar, Assam",
    "Field of study": "ELECTRICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "IT, Software development",
    "Period of Internship":
      "internship for 2-3 months and can Start immediately.",
    "Current Location(With Country)": "Alwar, Rajasthan, India",
    "Does Remote Internship work for you?": "Delhi, Noida, Gurgaon, Jaipur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1E-dF7AZ05Tlknx2Ni17oJpJVjk1BH-4x/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/vijay-nits21",
    "Contact Details (Email)": "vijaygupta131999@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:27:30",
    "Name of the student": "Pratik Kumar Saha",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning.",
    "Period of Internship": "6 weeks. 1-2 months.  1st June 2020.",
    "Current Location(With Country)":
      "Biswanath Chariali, Assam. Country - India",
    "Does Remote Internship work for you?": "Bangalore, Delhi.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1V4rW_8rzWfegctb8lJbUClOgXbld-tcz/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pratik-kumar-saha-0b5219154",
    "Contact Details (Email)": "saha.pratik589@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:29:26",
    "Name of the student": "",
    "Institute Name(College)": "National Institute Of Technology Silchar",
    "Field of study": "B.Tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electrical core",
    "Period of Internship": "1month",
    "Current Location(With Country)": "Nagaon, assam",
    "Does Remote Internship work for you?": "Yes. I prefer city within Assam",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1BZZC0GX7AA3TBv3mOu2Ra0gx_AgiJVpb/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/rituraj-nath-57463b17a",
    "Contact Details (Email)": "riturajnath1@gmail.com",
    "Anything else you'd like to share?": "No thanks",
  },
  {
    Timestamp: "04/08/2020 21:29:26",
    "Name of the student": "Sanjal Katiyar",
    "Institute Name(College)":
      "Indian Institute of Information Technology Gwalior",
    "Field of study": "Information Technology",
    Education: "Integrated Post Graduation (B.Tech+M.Tech)",
    "Preferred domain of internship": "SDE or similar profiles.",
    "Period of Internship": "2-3 months starting from 10th of May 2020.",
    "Current Location(With Country)": "Lucknow, UP, India",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1n_d0Aen1gDkE7oOEvKU-gYP0NQ7P8ThM",
    "LinkedIn profile link": "https://www.linkedin.com/in/sanjal-katiyar/",
    "Contact Details (Email)": "sanjaldhir@gmail.com",
    "Anything else you'd like to share?":
      "I am a pre-final year student at the Indian Institute of Information Technology, Gwalior, having expertise and experience in Full-Stack (MEAN/MERN) Web Development, OOPs, Core Java, JavaScript, Algorithms, and Data Structures.\nI am also passionate about Machine Learning and Deep Learning and have good knowledge of Computer Vision and Natural Language Processing. I am hardworking and always glad to learn something new related to my domain.",
  },
  {
    Timestamp: "04/08/2020 21:35:47",
    "Name of the student": "Hirak Jyoti Borah",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software developer",
    "Period of Internship": "2 month (may 15(not sure))",
    "Current Location(With Country)": "Assam",
    "Does Remote Internship work for you?":
      "Yes. Bangalore, Hyderabad, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1OmlMQGioTRzAF5E0lq7VOOg-eNGTC5In/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/hirak-borah-68b2bb172",
    "Contact Details (Email)": "hborah862@gmail.com",
    "Anything else you'd like to share?": "Phone no: 9101110534",
  },
  {
    Timestamp: "04/08/2020 21:39:18",
    "Name of the student": "Makarand Patil",
    "Institute Name(College)": "National Institute Of Technology Silchar",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core - Electrical Engineering",
    "Period of Internship": "From 18th May for two or three months",
    "Current Location(With Country)": "Maharashtra, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1zlondJGmUZxVVovxRNJQS9_pwvdpy94q/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/makarand-patil-1a9ab5173",
    "Contact Details (Email)": "makpatil22@gmail.com",
    "Anything else you'd like to share?": "No. Thank you.",
  },
  {
    Timestamp: "04/08/2020 21:49:51",
    "Name of the student": "Aniket Jain",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Data Structure(Software Development), Consultancy, Any core civil engineering project.",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Bikaner, India",
    "Does Remote Internship work for you?": "Yes, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SxJBoMI4d4PeguXn4eyR-VizYtZMDoRt/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/aniket-jain-387247176",
    "Contact Details (Email)": "luckyshyamsukha9@gmail.com",
    "Anything else you'd like to share?":
      "Thank you for this initiative. I would like to mention that my research Intern got cancelled due to coronavirus pandemic at Rowan University, New Jersey, US. In this fast pace world, it is equally important to compete with each other and produce best results. This intern will also place an important role in future also. I would be happy, if any suitable openings are there. I will do best justice to my work.",
  },
  {
    Timestamp: "04/08/2020 21:51:11",
    "Name of the student": "RAUSHAN RAJ",
    "Institute Name(College)": "NIT SILCHAR",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Patna, Bihar (india)",
    "Does Remote Internship work for you?": "Yes.  Banglore, mumbai,",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1E2muXdxNjEJDMtdGFMbyHgYrTslBVxqQ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/raushan-raj-b3595713a",
    "Contact Details (Email)": "raushanraj72925@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:51:11",
    "Name of the student": "Rohit Kumar Lohia",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 months, ASAP",
    "Current Location(With Country)": "Guwahati, Assam, India",
    "Does Remote Internship work for you?":
      "Yes. Hyderabad, Delhi, Guwahati, Jaipur.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/10qyAj1FKstCuxuCwmPplwlbQ3AGHQ9Iv/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rohit-lohia-075104152/",
    "Contact Details (Email)": "2016dib002@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 21:58:26",
    "Name of the student": "VINAY YADAV",
    "Institute Name(College)": "CDAC NOIDA, Sector-62.",
    "Field of study": "VLSI ASIC DESIGN AND VERIFICATION.. AND PYTHON/ML/AI",
    Education: "POST GRADUATION DIPLOMA IN VLSI DESIGN",
    "Preferred domain of internship":
      "VLSI ASIC DESIGN AND VERIFICATION.. AND PYTHON/ML/AI",
    "Period of Internship": "Looking for internship and full time job",
    "Current Location(With Country)":
      "I'm from Gurugram and recently completed PGDiplome from CDAC Noida(current), INDIA",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1NpE8M6dacxhzx_F1AzLSDLc1cKysgmr0",
    "LinkedIn profile link": "https://www.linkedin.com/in/vinay-yadav-20006/",
    "Contact Details (Email)": "vinayyadav20006@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 22:00:11",
    "Name of the student": "Deepanwita Dhar",
    "Institute Name(College)": "National Institute of Technology,Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Development,Marketing,Business Analyst,Finance,Investment Banking",
    "Period of Internship": "2 months.",
    "Current Location(With Country)": "Guwahati,Assam(India)",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1tVEM1AwJVndFlNTixZ0tNu0y9q2cdNHv/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/deepanwita-dhar-7832b8165/",
    "Contact Details (Email)": "ddhar125@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 22:02:09",
    "Name of the student": "Shahnaza Yousuf",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core oriented things",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Srinagar",
    "Does Remote Internship work for you?": "Yes Srinagar",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shahnazyousuf1234@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 22:04:31",
    "Name of the student": "Gagan Harlalka",
    "Institute Name(College)": "National Institute of Technology, Silchar",
    "Field of study": "Electronics and Communication Engineering(B.Tech)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development(SDE)",
    "Period of Internship": "2, from May 2020",
    "Current Location(With Country)": "Guwahati, Assam, India",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1N5PnEyb4o-GY_sJ4gf7aiBnKKiLIxuRL/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/gagan-harlalka",
    "Contact Details (Email)": "gagan.har0207@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 22:05:25",
    "Name of the student": "Harshita Kumari",
    "Institute Name(College)":
      "Delhi School of Management, Delhi Technological University",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "Jabalpur (India)",
    "Does Remote Internship work for you?": "Yes, New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/135XhIPCfumLlHnffoQtROr_7Y_J-K9eD/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harshita-kumari-607145141",
    "Contact Details (Email)": "harshita099k@gmail.com",
    "Anything else you'd like to share?":
      " I was selected for Research Intern for IHS Markit in Corporate Actions but because of Covid-19 and change in company policy rescinded Summer Internship Program 2020. I was informed about it on 7th April. \n",
  },
  {
    Timestamp: "04/08/2020 22:08:45",
    "Name of the student": "Dibyaranjan Mohapatra",
    "Institute Name(College)": "Gandhi Institute for Technologycal Advancement",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "QA",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Bhubaneshwar",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "dibyaranjan658@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 22:10:46",
    "Name of the student": "Rohit Alawadhi",
    "Institute Name(College)": "PCCoE",
    "Field of study": "Computer engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "delhi, india",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rohit-alawadhi-6233ba82/",
    "Contact Details (Email)": "rohitaaarora@gmail.com",
    "Anything else you'd like to share?":
      "looking for a full time role for an experienced position",
  },
  {
    Timestamp: "04/08/2020 22:13:22",
    "Name of the student": "Ritika Alawadhi",
    "Institute Name(College)": "VIT, vellore",
    "Field of study": "MCA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "system engineer, system analyst",
    "Period of Internship": "",
    "Current Location(With Country)": "Etobicoke, Canada",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritika-alawadhi-727b66a1/",
    "Contact Details (Email)": "+918983177204",
    "Anything else you'd like to share?":
      "Looking for full time roles for 1 year experience position",
  },
  {
    Timestamp: "04/08/2020 22:14:51",
    "Name of the student": "Mohan Aditya Sabbineni",
    "Institute Name(College)": "IIT (BHU) Varanasi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Core Engineering (Process engineering/ designing/ optimisation)",
    "Period of Internship": "2 months, April 10 onwards",
    "Current Location(With Country)": "Vijayawada, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1fm-DufFInqO2JP_1VUOOmLo4qHgKG4Qg/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mohan-aditya-sabbineni/",
    "Contact Details (Email)": "sabbineni.maditya.che17@itbhu.ac.in",
    "Anything else you'd like to share?":
      "An internship recently offered me by Indian multinational conglomerate company but, after this pandemic has started, I didn't get any confirmation regarding the location of the internship and other details from them. So, trying for another internship as an option.",
  },
  {
    Timestamp: "04/08/2020 22:23:29",
    "Name of the student": "Nikhila Darisa",
    "Institute Name(College)": "Anna University(Saveetha Engineering College)",
    "Field of study": "Bachelors in Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Programming, Full-Stack Developer",
    "Period of Internship": "3-6 months ; April 10th",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?":
      "yeah, I have experience in working remote and coping up with my responsibilities",
    "Link to Resume(Google Drive/Dropbox)": "bit.ly/resumenikhila",
    "LinkedIn profile link": "https://www.linkedin.com/in/nikhiladarisa/",
    "Contact Details (Email)":
      "rohitdarisa@gmail.com\n\nnikhiladarisa@gmail.com",
    "Anything else you'd like to share?":
      "Hi, I graduated from Anna University(Saveetha Engineering College) with Bachelors in Computer Science and Engineering. I have recently completed the Full-Stack Development MERN stack program at AttainU and going through the recruitment process at AttainU.\n\nHowever, due to the ongoing COVID-19 crisis and the ensuing uncertainty, finding it difficult to be aware of the openings and opportunities. \n\nMy coding experience includes working on Full Stack Development Projects --> \n1)  E-Rent -\n  Live app: https://lnkd.in/fRH92QJ\n  Github: https://lnkd.in/fkJ6UWq\n\n2) Online Bookstore -\n  Live app: https://lnkd.in/f2J35zP\n  Github: https://lnkd.in/f3VC-8f\n\nCurrently, I am seeking full-time/intern opportunities across roles, including but not limited to Full Stack Development(MERN stack), Backend and Frontend. Kindly let me know if you have suitable openings or if you could connect me to potential recruiters. Attaching my resume here for the reference here --> bit.ly/resumenikhila\n\nI hope that all of us are in good health and can overcome this challenging global situation together and emerge stronger than ever.",
  },
  {
    Timestamp: "04/08/2020 22:36:02",
    "Name of the student": "Abhimanyu Pratap Singh",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "CAD design, Simulation and Product Development",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Allahabad, Uttar Pradesh, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XPzbz33W-yu8arZQyNJ_IQwLF9c0Tmi4/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhimanyu-pratap-singh-5a998b145",
    "Contact Details (Email)": "abhimanyu.singh02@outlook.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 22:51:30",
    "Name of the student": "Manoj Kumar",
    "Institute Name(College)": "PSNA COLLEGE OF ENGINEERING AND TECHNOLOGY",
    "Field of study": "COMPUTER SCIENCE ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "3 to 6months",
    "Current Location(With Country)": "Madurai, Taminadu , India",
    "Does Remote Internship work for you?": "Yes, Chennai/Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15Wj2T784xsq_ykLlZqiUh-bE_SGHLf1C/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/manojkumar22",
    "Contact Details (Email)": "Manoj22.be@gmail.com",
    "Anything else you'd like to share?":
      "I used the github to save my programming implementations.  My github link is \nhttps://github.com/manoj228",
  },
  {
    Timestamp: "04/08/2020 23:06:02",
    "Name of the student": "Rasmeet Singh",
    "Institute Name(College)": "Panjab University, India",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Research & Development, Process Engineering, Chemical engineering core, Process design",
    "Period of Internship": "2 months starting from first week if June, 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Any location will be preferred.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/kid2zrb3zr0qyy7/CV..pdf?dl=0",
    "LinkedIn profile link": "http://www.linkedin.com/in/rasmeet-singh-030899",
    "Contact Details (Email)": "sidhurasmeet1999@gmail.com",
    "Anything else you'd like to share?":
      "I've previously interned at University of Technology Sydney, Australia.\nHave specialization in Technical writing and Nanotechnology, Nanosensors- Coursera certifications",
  },
  {
    Timestamp: "04/08/2020 23:13:26",
    "Name of the student": "Akash Prabhakar",
    "Institute Name(College)": "IIM Lucknow",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations, Strategy, Marketing",
    "Period of Internship": "2 months. 10th April to 19th June",
    "Current Location(With Country)": "Samastipur, Bihar, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wiiASP-g5w0bYTbWaLoYrF6qVPZQUTr8/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akash-prabhakar-15213071/",
    "Contact Details (Email)": "pgp35153@iiml.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 23:20:42",
    "Name of the student": "Rituparna Khaund",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning/Deep Learning, Natural Language Processing,Computer Vision",
    "Period of Internship":
      "Duration: 2-3 Months and I can start immediately as our college is closed as of now.",
    "Current Location(With Country)": "NIT Silchar,Assam,India",
    "Does Remote Internship work for you?":
      "Yes, Remote Internship works for me and I'd be happy to relocate to any of the Metros if the lockdown is over.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vBeBqfX8JN8GlYWsuPT7P4Lp6gsAinU9/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/rituparna-khaund",
    "Contact Details (Email)": "rituparna.k98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 23:24:31",
    "Name of the student": "Lidia Islam",
    "Institute Name(College)": "University of Birmingham",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Engineering",
    "Period of Internship":
      "2-3 months. Available immediately remotely until end of August 2020.",
    "Current Location(With Country)": "Birmingham, United Kingdom",
    "Does Remote Internship work for you?":
      "Remote internship works for me. I am not open to relocate if later than July.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MzvdIzgDWuLM8ezH3-vkZTHsjTTdxqpH/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/lidia-islam-b34b07176/",
    "Contact Details (Email)": "lidia.islam13@yahoo.com",
    "Anything else you'd like to share?":
      "I am open to take part in an internship/project in any field.",
  },
  {
    Timestamp: "04/08/2020 23:31:44",
    "Name of the student": "Surbhi Airan",
    "Institute Name(College)": "Chandigarh Engineering college,Landran",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Developer In Testing, Software Development",
    "Period of Internship": "3 to 6 month",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1k5oiUgItopxMNIZ4b5QwiOHqeGZPQM5j",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/surbhi-airan-3658b6171/",
    "Contact Details (Email)": "surbhi03airan@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 23:33:24",
    "Name of the student": "Chirag Shetty",
    "Institute Name(College)": "Vellore institute of Technology",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "6",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-mRHbv7rpP47jpJf5eed0Y94J6hJfFLE/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/chirag-shetty-85250913a",
    "Contact Details (Email)": "chirag4798@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 23:35:19",
    "Name of the student": "Lily Widdup",
    "Institute Name(College)": "Wellesley College",
    "Field of study": "Chemistry and Psychology",
    Education: "Undergraduate",
    "Preferred domain of internship": "science",
    "Period of Internship": "any length -- can start immediately",
    "Current Location(With Country)": "Frederick, Maryland, United States",
    "Does Remote Internship work for you?": "I can do remote internships",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xLGaQM0u5j3Ejecf1CmLr3QIafZpQpOp/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/lily-widdup-19b7a2ba",
    "Contact Details (Email)": "lwiddup@wellesley.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 23:42:10",
    "Name of the student": "Ritu Meena",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Chemical engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data analytics, Data science",
    "Period of Internship": "4-5 months",
    "Current Location(With Country)": "Rajasthan, India",
    "Does Remote Internship work for you?": "Chennai, Pune, Banaglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1q0IlWYBpxqL9dV3zi0EaKR7eshjdz2_H/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritu-meena-66a468111/",
    "Contact Details (Email)": "ritumeena30@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 23:49:55",
    "Name of the student": "Guramritpal Singh Saggu",
    "Institute Name(College)": "IIIT Gwalior",
    "Field of study": "Information Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning/Data Science",
    "Period of Internship": "3 months starting from 8th April, 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes anywhere",
    "Link to Resume(Google Drive/Dropbox)": "shorturl.at/fwM36",
    "LinkedIn profile link": "https://www.linkedin.com/in/guramritpal/",
    "Contact Details (Email)": "guramritpalsaggu@gmail.com",
    "Anything else you'd like to share?":
      "I am a 3rd year student of IIIT Gwalior pursuing B.Tech in Information Technology. I have more than two years experience in Data Science, Python Development, SQL and Machine Learning and am actively working in this field. I am well versed with all the related technologies and worked on various projects and internships in this field and completed top rated courses of Data science and Python. Participated in more than 20 machine learning hackathons and got top ranks. Kaggle Contributor and recently been involved in research work in the field of Computer Vision in projects related to image reconstruction and classification. I am dedicated to my work and this internship will only boost my confidence and help me to learn and gain experience to become better.",
  },
  {
    Timestamp: "04/08/2020 23:58:58",
    "Name of the student": "Aman Kishor Singh",
    "Institute Name(College)": "Indian Institute of Technology,Delhi",
    "Field of study": "Bachelor's Degree",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting,Investment Banking,Business Analyst roles,Private Equity,Venture Capitals",
    "Period of Internship": "10th April to 10th June(2 months)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14s48XClYSldzN4yN1cEYb6Zh323LIqe1/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aman-singh-458a46168/",
    "Contact Details (Email)": "amankishor119@gmail.com",
    "Anything else you'd like to share?":
      "I had been offered an internship in Berlin but it got cancelled due to the COVID-19.So,I urge you to provide me with an internship at any reputed firm within the domains,I mentioned.I do case studies & valuation challenges also which can be used in finance internship.",
  },
  {
    Timestamp: "04/09/2020 00:03:10",
    "Name of the student": "Surya Chandra",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Metallurgical and materials engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Web developer, data scientist, analytics",
    "Period of Internship": "Searching for a job",
    "Current Location(With Country)": "Warangal, India.",
    "Does Remote Internship work for you?": "Yes, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AkyDmec10zoq9ubCRScfoNIqxHHuld_E/view?usp=drivesdk",
    "LinkedIn profile link": "LinkedIn.com/suryaarukonda",
    "Contact Details (Email)": "suryaarukonda@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 00:07:03",
    "Name of the student": "Sabira Farheen",
    "Institute Name(College)": "National Institute of Technology,Silchar",
    "Field of study": "B.Tech, Computer science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning, Deep learning, front end development.",
    "Period of Internship":
      "I am looking for 2-3 months of internship starting from May.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, remote internship is fine. If situation improves, I am ready to relocate to Bengaluru, Hyderabad, Pune, Delhi.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1slceZz0N3_WoUKqoKoVFE02Sc6OFSiuz/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sabira-farheen-60a059162/",
    "Contact Details (Email)": "sabira007x@gmail.com",
    "Anything else you'd like to share?":
      "I am also having hands on in competitive programming, data structure and algorithm.",
  },
  {
    Timestamp: "04/09/2020 00:10:11",
    "Name of the student": "Mozammil Ahmad",
    "Institute Name(College)": "Campus Law Centre, University of Delhi",
    "Field of study": "Law",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Legal, research",
    "Period of Internship": "29-June-2020 till 26-July-2020; (4 week)",
    "Current Location(With Country)": "New Delhi",
    "Does Remote Internship work for you?":
      "Yes, I can come to banglore if offered (internship)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1TDiOEPYyHySd--3Zr6-lWCBrD-vt3wWT",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mozammil-ahmad-495859165/",
    "Contact Details (Email)": "mozammil10032@one.ducic.ac.in",
    "Anything else you'd like to share?":
      "I am looking for an opportunity with in house counsel . If possible please help me getting an internship with them",
  },
  {
    Timestamp: "04/09/2020 00:10:37",
    "Name of the student": "Prannesh S",
    "Institute Name(College)": "",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Developer Trainee",
    "Period of Internship": "6 + FTE",
    "Current Location(With Country)": "Coimbatore, India",
    "Does Remote Internship work for you?": "Yes, Anywhere in South India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1IiIKIAlwaBKq5weDe4aU3FkW461v05ej",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prannesh-sathyamoorthy-a5282a15a/",
    "Contact Details (Email)": "pranneshsathiyamoorthy@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 00:10:50",
    "Name of the student": "Glaston Dsouza",
    "Institute Name(College)": "National College of Ireland",
    "Field of study": "Masters in Data Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Ireland",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1S3XBODZSrhdMd_rPosEHD6wThXNjUM-x/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/glastondsouza",
    "Contact Details (Email)": "mr.glaston@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 00:14:23",
    "Name of the student": "Naveed Ahamed",
    "Institute Name(College)": "Vellore institute of technology",
    "Field of study": "Computer Applications",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Cybersecurity, network engineer ,Machine learning",
    "Period of Internship": "12 months 10 April 2020",
    "Current Location(With Country)": "Vellore india",
    "Does Remote Internship work for you?": "Yes, banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1XPnSNI1GTo8SJVTlChKtmizsRBav3q8G",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "naveedahamed87@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 00:16:22",
    "Name of the student": "Shivam Sinha",
    "Institute Name(College)":
      "Institute of innovation in technology and management",
    "Field of study": "Computer Applications",
    Education: "Undergraduate",
    "Preferred domain of internship": "Technology",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, Delhi, Gurugram, Greater Noida.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1eZtq1wlxjBuzd0n9Otib8drF10g3IvAz/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/shivamsinha363",
    "Contact Details (Email)": "Shivamsinha363@gmail.com",
    "Anything else you'd like to share?":
      "I would prefer to work in software development or web development.",
  },
  {
    Timestamp: "04/09/2020 00:48:25",
    "Name of the student": "Akansha Vidyarthi",
    "Institute Name(College)": "Xavier's College, Mumbai",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing and advertising",
    "Period of Internship": "1-6",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 00:53:37",
    "Name of the student": "Anmolpreet Singh",
    "Institute Name(College)": "INDIAN INSTITUTE OF TECHNOLOGY",
    "Field of study": "Computer Science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web debelopment",
    "Period of Internship": "Summer",
    "Current Location(With Country)": "Kapurthala Punjab India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1KLoB6DdSGsM1KPpt3wSKCaKznIX7-Dyf/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anmol-preet-singh-saini-5ab048199",
    "Contact Details (Email)": "anmol323c@gmail.com",
    "Anything else you'd like to share?": "First year student at IIT",
  },
  {
    Timestamp: "04/09/2020 01:01:23",
    "Name of the student": "Aditya Bansal",
    "Institute Name(College)":
      "Dr B R Ambedkar National Institute of Technology, Jalandhar",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 months starting from June",
    "Current Location(With Country)": "Agra,Uttar Pradesh, India",
    "Does Remote Internship work for you?": "Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1VWffxo93qlK_wnU0qYXoeTHzdPPaUglq",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aditya-bansal-897166176/",
    "Contact Details (Email)": "adbansal99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 01:13:44",
    "Name of the student": "Arnab Das",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "B.Tech (Electronics and Communication Engineering)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development, Data Analytics",
    "Period of Internship":
      "2 Months starting from May 1st week (open to changes)",
    "Current Location(With Country)": "Guwahati, Assam, India",
    "Does Remote Internship work for you?":
      "Yes. Preferred City- Bangalore or Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1d06FSE3axGN5yvKOdjP9s4T_huEFZXD-/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/arnab-das-0206",
    "Contact Details (Email)": "darnab0206@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 01:14:00",
    "Name of the student": "Shreya Das",
    "Institute Name(College)": "National Institute of Technology, Silchar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development, Data Analytics",
    "Period of Internship":
      "Two Months starting from May 1st week (open to change).",
    "Current Location(With Country)": "Guwahati, Assam, India",
    "Does Remote Internship work for you?":
      "Yes. Preferred City: Bangalore or Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rPOWv14LxFrWV9Z2FwK8zD8FICq7SOfe/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/shreya-das-59791616b",
    "Contact Details (Email)": "shreyadasnits@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 01:23:12",
    "Name of the student": "Manish Bothra",
    "Institute Name(College)": "National Institute Of technology Silchar",
    "Field of study": "Computer Science & Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "Two Months",
    "Current Location(With Country)": "Guwahati,Assam,India",
    "Does Remote Internship work for you?": "Bangalore,Hyderabad,Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FlQ-nIA7MWs4ilE0UohAlk6oWiqwIaSo/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/bothramanish/",
    "Contact Details (Email)": "manishbothra48@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 01:24:17",
    "Name of the student": "Sabrina Contaldi",
    "Institute Name(College)": "DePauw University",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "within the computer science field, but I'm open to anything",
    "Period of Internship": "3 months starting May",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?":
      "I will be in Cape Town, South Africa",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1NGG7xYW930P4irnGoesdenyU7DSzA3sFrxKOi36EZ58",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sabrinacontaldi_2023@depauw.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 01:31:14",
    "Name of the student": "Hitanshu Vig",
    "Institute Name(College)": "GGSIPU",
    "Field of study": "B.Tech (CSE)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web/Software Development",
    "Period of Internship": "1-3months",
    "Current Location(With Country)": " Delhi,India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16SUIlrxNZDhPO9SbYi_1Cv1zS0iOj1GI/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/hitanshu-v-8a2a86111",
    "Contact Details (Email)": "hitanshu173@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 01:43:18",
    "Name of the student": "Gurinder Kaur",
    "Institute Name(College)": "Lovely professional university, punjab",
    "Field of study": "Computer science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software engineer, ML/DL, NLP, asp.net",
    "Period of Internship": "June-august",
    "Current Location(With Country)": "Garhshankar, hoshiarpur, puniab",
    "Does Remote Internship work for you?": "Yes,chandigarh",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vklGe-MNHZM0pZNu2GD7eLZcu1RCqDku/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gurinder-kaur-7408b513b",
    "Contact Details (Email)": "gurinder.sehra@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 01:59:07",
    "Name of the student": "Rahul Rao Shinde K",
    "Institute Name(College)": "Jain University",
    "Field of study": "Electronics and communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Python,SQL",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Bangalore,India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "Yes",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/k-rahul-rao-shinde-b8265514b",
    "Contact Details (Email)": "rahulraoshinde26@gmail.com",
    "Anything else you'd like to share?":
      "Looking for internship opportunities",
  },
  {
    Timestamp: "04/09/2020 02:06:29",
    "Name of the student": "Vaishnavi L",
    "Institute Name(College)": "Dayananda Sagar College of Engineering",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Designing, Analysis, Research, Robotics, Mechatronics, Automation, Electric Vehicles, Autonomous Vehicles, IoT, Brain-Computer Interface, Mechanical Engineering, Manufacturing, 3D Printing",
    "Period of Internship": "1 to 3 month(s) (Start date - Immediately)",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "Yes. Preferred city - Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dbFWxixX6PPNkjBxnB6m1SCGM-Hyz_dK/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/Vaishnavi-L",
    "Contact Details (Email)": "vivaishna7@gmail.com",
    "Anything else you'd like to share?":
      "Apart from the above mentioned domains, I would also love to work for projects based on Content Writing, Market Research, etc.",
  },
  {
    Timestamp: "04/09/2020 02:32:31",
    "Name of the student": "Nirmalya",
    "Institute Name(College)": "XIMB",
    "Field of study": "Rural Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Social Development,Marketing,Business Development",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Delhi",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nirmalya-kanungo-21016b62/",
    "Contact Details (Email)": "nirmalya.east@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 02:33:30",
    "Name of the student": "Nimmala Vishnu",
    "Institute Name(College)": "IIIT kalyani",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Full stack developer",
    "Period of Internship": "3 months ( june)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18KN2I1OQvAQB2j-BY4avs-XA8wk0V5zD/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nimmala-vishnu-250959141",
    "Contact Details (Email)": "vishnunimmala786@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 03:06:11",
    "Name of the student": "ASHUTOSH TRIPATHY",
    "Institute Name(College)": "NETTUR TRCHNICAL TRAINING FOUNDATION (NTTF)",
    "Field of study": "DIPLOMA IN MECHATRONICS",
    Education: "Undergraduate",
    "Preferred domain of internship": "In Electronics Field",
    "Period of Internship": "24months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ashu1516008@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 03:26:50",
    "Name of the student": "Kalyani Jagdale",
    "Institute Name(College)": "Georgia Institute of Technology",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Science, Analytics, ML, Software",
    "Period of Internship": "2-3 months from 4th May - 14th August",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "https://lnkd.in/fYqGcQu",
    "LinkedIn profile link": "https://www.linkedin.com/in/kalyanijagdale/",
    "Contact Details (Email)": "kalyanijagdale@gatech.edu",
    "Anything else you'd like to share?":
      "My internship offer got rescinded due to the Covid19 impact.",
  },
  {
    Timestamp: "04/09/2020 03:27:59",
    "Name of the student": "Jaymal Lodha",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance, Consulting, Business Analyst, Business Development, Marketing",
    "Period of Internship": "April 10th to June 10th (2 months )",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "Yes - Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1abNNKJM6vuw2Mo-8UcbJreQayIDN9fNu/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jaymal-lodha-828228168",
    "Contact Details (Email)": "jaymal24lodha@gmail.com",
    "Anything else you'd like to share?":
      "Had previously secured my internship at Aditya Birla Group",
  },
  {
    Timestamp: "04/09/2020 04:08:17",
    "Name of the student": "Raka Ghosh Dastidar",
    "Institute Name(College)": "Symbiosis Institute of aoperations Management",
    "Field of study": "Operations Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Operations, supply chain management, logistics, procurement, consulting",
    "Period of Internship": "2 month",
    "Current Location(With Country)": "Kolkata (West Bengal), Indian",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XMET5zUJvUkBqRamqP6dEgjaNRuLqK3P/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/raka-ghosh-dastidar-5092ba143/",
    "Contact Details (Email)": "raka.ghosh@siom.in",
    "Anything else you'd like to share?":
      "\nI am actively looking for summer internship opportunity as an MBA(Operations Management) trainee.Due to the current COVID-19 crisis my offer from a logistics company got cancelled as it required extensive field work.\n\n\n\nI have 25 months of work experience in a delivery team of an MNC interacting multiple clients from agricultural domain, Telecom domain and familiar with lean Principle and ITServicedelivery and different technologies like JAVA , SWING, RPA. Worked on ChangeManagement, Problem management, IncidentManagement using tools like BMC , ServiceNow and Used Root cause analysis (RCA) to figure out the pain points of agricultural client ensuring corrective actions in place.",
  },
  {
    Timestamp: "04/09/2020 04:14:23",
    "Name of the student": "Jayakiran Guntuku",
    "Institute Name(College)":
      "Indian Institute of Information Technology Nagpur",
    "Field of study": "Electronics and communication engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analysis, Machine learning",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Srikakulam, Andhrapradesh",
    "Does Remote Internship work for you?":
      "I prefer Work from home because of final year exams will start after lockdown",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MCcKx6TB71SXUjo7y6G9gdWJaoffQIpE/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jayakiran-guntuku-3b5a23131/",
    "Contact Details (Email)": "jaikiranjay@gmail.com",
    "Anything else you'd like to share?": "Please get back to me ASAP!",
  },
  {
    Timestamp: "04/09/2020 04:40:53",
    "Name of the student": "Ankit Srivastava",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development",
    "Period of Internship": "2 months, 10 may to 10 July",
    "Current Location(With Country)": "Muzaffarpur, Bihar, India",
    "Does Remote Internship work for you?": "Yes, Bangalore, Hyderabad, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FduTpkKFJRz9ACti6CNTuXTC0998Az55/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ankit-srivastava-oa68oa",
    "Contact Details (Email)": "ankitsrivastava21598@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 04:48:59",
    "Name of the student": "Koulick Sadhu",
    "Institute Name(College)": "Jalpaiguri Government Engineering College",
    "Field of study": "Information Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning",
    "Period of Internship": "2-3 months (10th April,2020)",
    "Current Location(With Country)": "Raniganj, West Bengal, India",
    "Does Remote Internship work for you?": "Yes. City-Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Q_QGRpQAt615sW6RM7WGHoilwxOwTMgW/view?usp=drivesdk",
    "LinkedIn profile link": "https://linkedin.com/in/koulick-sadhu/",
    "Contact Details (Email)": "8900507945",
    "Anything else you'd like to share?":
      "I like to make new projects and interesting things. Along with this, I am good at problem solving as I regularly participate in competitive coding competitions.",
  },
  {
    Timestamp: "04/09/2020 05:06:17",
    "Name of the student": "Yash Gupta",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "SDE, Full Stack Development",
    "Period of Internship": "2-3 Months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1M_v-wWpjm1n6jjytnw_wr3G4e3TreCB8/view",
    "LinkedIn profile link": "https://in.linkedin.com/in/yash04g",
    "Contact Details (Email)": "yash04g@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 06:38:33",
    "Name of the student": "Akshita Chander",
    "Institute Name(College)": "DTU (delhi college of engineering)",
    "Field of study": "Mathematics and Computing Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Non Tech (business analyst, consulting, finance, marketing)",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "http://bit.ly/AkshitaChander_Resume",
    "LinkedIn profile link": "https://www.linkedin.com/in/akshicat/",
    "Contact Details (Email)": "akshitachander1@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 07:10:26",
    "Name of the student": "Abhishek Kumar",
    "Institute Name(College)": "Heritage Institute of Technology",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance or Analytics",
    "Period of Internship": "1 or 2 months",
    "Current Location(With Country)": "Kolkata (India)",
    "Does Remote Internship work for you?": "No I'm not open to relocate.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://s.docworkspace.com/d/AG8nZx3fyuAmoeSekMCdFA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-kumar-a95119152",
    "Contact Details (Email)": "abhishekhajipur1@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/09/2020 07:35:39",
    "Name of the student": "Richmond Marngar",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "B.Tech Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Building and Construction",
    "Period of Internship": "1 month (30/5/2020)",
    "Current Location(With Country)": "Nongstoin, Meghalaya, India",
    "Does Remote Internship work for you?": "Yes, Guwahati",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "lidmarn@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 07:40:23",
    "Name of the student": "Hritik sachan",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Kanpur, India",
    "Does Remote Internship work for you?": "Yes, Banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16hJQal6-S1Iky_8cP33jK01NzygVtaUR/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/hritik-sachan-0ba96014b/",
    "Contact Details (Email)": "hritik.sachan.9199@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 07:49:55",
    "Name of the student": "Emily Li",
    "Institute Name(College)": "University of Massachusetts Amherst",
    "Field of study": "Operations & Information Management",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics",
    "Period of Internship":
      "~2 -3 months (10-12 weeks), Can start mid-May or June",
    "Current Location(With Country)": "Boston, MA USA",
    "Does Remote Internship work for you?":
      "Yes, will prefer to relocate to any city in MA, CT, or RI.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EaWr-xJoTm_jFZidJBd-6NdkwPd_paKd/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/emilyjli",
    "Contact Details (Email)": "emilyli@umass.edu",
    "Anything else you'd like to share?":
      "I am interested in the field of data and look forward to learning anything and everything!",
  },
  {
    Timestamp: "04/09/2020 08:04:30",
    "Name of the student": "Pulkit gupta",
    "Institute Name(College)": "Itm gurgaon",
    "Field of study": "Mba",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Looking for job",
    "Period of Internship": "",
    "Current Location(With Country)": "Hisar india",
    "Does Remote Internship work for you?": "Gurgaon",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "guptapulkit110@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 08:14:43",
    "Name of the student": "David John Bier",
    "Institute Name(College)": "Arizona State University",
    "Field of study": "Public Policy",
    Education: "Undergraduate",
    "Preferred domain of internship": "Facebook; Google; Instagram; Spotify",
    "Period of Internship": "May or June 2020; 6 months to a year",
    "Current Location(With Country)": "Los Angeles, CA",
    "Does Remote Internship work for you?": "Yes, remote.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/3x37xybc6cdp7d2/David%20J%20Bier%20Resume.pdf?dl=0",
    "LinkedIn profile link": "https://www.linkedin.com/in/davidjohnbier/",
    "Contact Details (Email)": "davidjohnbier@gmail.com",
    "Anything else you'd like to share?":
      "I'm a first-generation college student, proudly LGBTQ+, and have the non-traditional experience of working full-time while in school full-time (online undergrad program).",
  },
  {
    Timestamp: "04/09/2020 08:20:48",
    "Name of the student": "Sourabh Laxman Rananaware",
    "Institute Name(College)": "Lovely Professional University",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "6 months(from june)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Pune,Delhi,Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/i9ax44116qndktu/cv1.pdf?dl=0",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sourabh-rananaware-824593162/",
    "Contact Details (Email)": "sr.sourabh98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 08:30:07",
    "Name of the student": "Nikhil Kumar Jain",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "IT",
    "Period of Internship": "2 start date 15/04/2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes . Bangalore, Hyderabad.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1jPdmukyhrJQWsDeve4NEbSmnuFeG-zIp",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nikhil-jain-766723152/",
    "Contact Details (Email)": "jainnikhil1097@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 08:54:10",
    "Name of the student": "Abhishek Kumar",
    "Institute Name(College)": "Heritage Institute of Technology",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance or Analytics",
    "Period of Internship": "1 or 2 months",
    "Current Location(With Country)": "Kolkata (India)",
    "Does Remote Internship work for you?": "No I'm not open to relocate.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://s.docworkspace.com/d/AG8nZx3fyuAmoeSekMCdFA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-kumar-a95119152",
    "Contact Details (Email)": "abhishekhajipur1@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/09/2020 09:04:29",
    "Name of the student": "Surath Kumar Srivastva",
    "Institute Name(College)": "Nit Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Power System,Power Electronics ,Data Structure and Algorithms, Web development",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Gorakhpur,Uttar Pradesh ,India",
    "Does Remote Internship work for you?": "Yes. Gorakhpur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xQ9E3RPS1_fDpwhlnl1j0jVcLmNaQzz5/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "surath.nits@gmail.com",
    "Anything else you'd like to share?":
      "I was selected for Doubtnut's a learning based company.",
  },
  {
    Timestamp: "04/09/2020 09:23:46",
    "Name of the student": "Alankrita Kakati",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software",
    "Period of Internship": "1/2 month(s) Start date: 20April 2020",
    "Current Location(With Country)": "Jorhat, Assam, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/13AuBEWOOr1qxF2gKBUo57VO1cq2Fi8DH/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/alankrita-kakati-826217189",
    "Contact Details (Email)": "alankrita41298@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 09:30:48",
    "Name of the student": "Meeta Griglani",
    "Institute Name(College)": "San Jose State University",
    "Field of study": "Electrical Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital VLSI Design and Verification",
    "Period of Internship": "3-12",
    "Current Location(With Country)": "San Jose, CA, US",
    "Does Remote Internship work for you?": "Yes, anywhere in the US",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1RxMkQW8y-EVAh0e7sJhsdpZr2x3AKTeH",
    "LinkedIn profile link": "https://www.linkedin.com/in/meetagriglani/",
    "Contact Details (Email)": "meetagriglani@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 09:36:32",
    "Name of the student": "Tannya Maurya",
    "Institute Name(College)": "IIT (BHU) Varanasi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/tannya-maurya/",
    "Contact Details (Email)": "tannya.maurya@gmail.com",
    "Anything else you'd like to share?":
      "Looking for job opportuninty in Analyst profile",
  },
  {
    Timestamp: "04/09/2020 09:59:34",
    "Name of the student": "Mayur rajesh Zalwar",
    "Institute Name(College)":
      "MGM Institute of Management Aurangabad Maharashtra, India",
    "Field of study": "Master of Business Administration - MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "marketing",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Maybe",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/my-drive",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mayur-zalwar-544633169/",
    "Contact Details (Email)": "mayurzalwar123@gmail.com",
    "Anything else you'd like to share?":
      "To work in an organization offering high degree of challenge, responsibilities and decisions making power where I can use my skills to achieve the organizational Goals",
  },
  {
    Timestamp: "04/09/2020 10:10:47",
    "Name of the student": "Hanumant Dharmraj Gophane",
    "Institute Name(College)":
      "Maharashtra institute of technology Kothrud Pune",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas industry ( Upstream )",
    "Period of Internship":
      "From 1month to  6 months ( Flexible with anytime period )",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Yes, All India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1S0OVKIH_FqZmeGV5babvL_jCy5PGk1k5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://drive.google.com/file/d/1S0OVKIH_FqZmeGV5babvL_jCy5PGk1k5/view?usp=drivesdk",
    "Contact Details (Email)": "gophaneh21@gmail.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/09/2020 10:16:30",
    "Name of the student": "Saurav Chirania",
    "Institute Name(College)": "Indian Institute of Technology, Dhanbad",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Computer Science / Software Development / Web Development",
    "Period of Internship": "8 - 10 weeks, starting immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GEkIfC2nKfoInasU54reKtapE7Kei2K4/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saurav-chirania-60024616b/",
    "Contact Details (Email)": "chiraniasaurav1@gmail.com",
    "Anything else you'd like to share?":
      "I have worked in Google Summer of Code.",
  },
  {
    Timestamp: "04/09/2020 10:25:07",
    "Name of the student": "Abu Ikhtiar Alom",
    "Institute Name(College)":
      "Dibrugarh University Institute of Engineering and Technology",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and Gas",
    "Period of Internship": "3-6 months",
    "Current Location(With Country)": "Assam (india)",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abu-ikhtiar-alom-a4432a129/",
    "Contact Details (Email)": "ikhtiaralom555@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 10:41:03",
    "Name of the student": "Kunjal Shah",
    "Institute Name(College)": "Veermata Jijabai Technological Institute",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer Science and Machine Learning",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, anywhere in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vVVUYWmglF5YTqbPrcNXXtDB5AQ6D5Tu/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kunjal-shah-365179167/",
    "Contact Details (Email)": "kunjal1999@gmail.com",
    "Anything else you'd like to share?": "https://github.com/Kunjal1999",
  },
  {
    Timestamp: "04/09/2020 11:01:06",
    "Name of the student": "Mehak Vashisth",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Environmental Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Waste management, land contamination, WTP and WWTP plant Design and Engineering, business analyst, HSE",
    "Period of Internship": "2 months starting from 1st June",
    "Current Location(With Country)": "Delhi - India or Dubai - UAE",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/file/d/1dBh32Oh1nxm-e04hmW3iva1l81iW9plX/edit?usp=docslist_api&filetype=msword",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mehakvashisth1999@gmail.com",
    "Anything else you'd like to share?":
      "I have prior internship experience with SUEZ - Water Technologies and Solutions",
  },
  {
    Timestamp: "04/09/2020 11:20:56",
    "Name of the student": "Kartike Bhardwaj",
    "Institute Name(College)": "Indian Institute of Technology Delhi",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Management and strategy consulting",
    "Period of Internship": "2 months starting May",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Pune, India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ahiYtqRx5nVEaVEjZXqL1onDC1biatfX/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/kartike-bhardwaj/",
    "Contact Details (Email)": "kartike.iitd@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 11:36:19",
    "Name of the student": "Vaishnavi Singh Sisodia",
    "Institute Name(College)": "M.B.M Engineering College",
    "Field of study": "Bachelor of Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "2-3 months, starting from may or june",
    "Current Location(With Country)": "Jaipur, India",
    "Does Remote Internship work for you?": "Yes, Jaipur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11iy9gSCgHIawNa9qWYIJa3fCAGk8NDhl/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vaishnavi-singh-sisodia-996551196",
    "Contact Details (Email)": "vaishnavisinghsisodia@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 11:37:14",
    "Name of the student": "Arpita Mary Abraham",
    "Institute Name(College)": "Jesus and Mary College",
    "Field of study": "B.A. (H) Economics, second year",
    Education: "Undergraduate",
    "Preferred domain of internship": "Research, Finance, Data Analysis",
    "Period of Internship":
      "1-2 months, available for WFH internships at present",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, Delhi/Gurgaon/Noida/Faridabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1F0-3ffR8yN8xTZDtsn_VC57WoWS0fI6c/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/arpita-m-796079189/",
    "Contact Details (Email)": "maryarpita2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 11:38:34",
    "Name of the student": "Ram Boob",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business development, Strategic roles,Consulting roles, data science",
    "Period of Internship":
      "I can start immediately. I can work till 10th June",
    "Current Location(With Country)": "Indore",
    "Does Remote Internship work for you?": "Yes, preferred city - Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1H7Zz4CnKYUF5hdOtD6V_XgvH39VMwzLG",
    "LinkedIn profile link": "https://www.linkedin.com/in/ram-bub-589997155/",
    "Contact Details (Email)": "rambub25@gmail.com",
    "Anything else you'd like to share?":
      "I have done an internship as an marketing analyst in a startup called Open Secret. I have good background in python and other data science skills. I am also displayed leadership and team working skills, being the operations head of a alumni cell of IIT Bombay. I am open to business development, strategic roles , consulting & data science profiles.",
  },
  {
    Timestamp: "04/09/2020 11:47:34",
    "Name of the student": "Ritika Agrawal",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting, Strategy, Business Analytics, Finance",
    "Period of Internship": "2 months w.e.f. 9th April",
    "Current Location(With Country)": "Gurugram, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1nBtkfDv4t4IqLE7js-qOuB8nXNzD9spK",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritika-agrawal-86b582160/",
    "Contact Details (Email)": "ritika030820@gmail.com",
    "Anything else you'd like to share?":
      "Profiles I'm looking for are Management/Strategy Consulting, Business Analytics, Finance",
  },
  {
    Timestamp: "04/09/2020 11:53:32",
    "Name of the student": "Sujit Kumar Nath",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software",
    "Period of Internship": "1-2 Months",
    "Current Location(With Country)": "Tezpur, Assam, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1wSXPnjNfOgANLg9wChv8-t5qPVxuXb5u",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sujitnath.ece.nits@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 11:55:31",
    "Name of the student": "Aditya Singh",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "20th May for two months",
    "Current Location(With Country)": "Gaya, Bihar, India",
    "Does Remote Internship work for you?":
      "Yes. I can relocate to Delhi and Bombay.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VKtueuPOlZ4dLUdaxY6CQsDQmW1kCskm/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aditya-singh-31a881191",
    "Contact Details (Email)": "malwaadityasingh@gmail.com",
    "Anything else you'd like to share?":
      "YES. Being in a core branch I did not get much opportunity to apply my knowledge in software world but I would like to mention that during this quarantine as I got some time I utilised it by applying my knowledge to build some basic projects on java which includes reading data from csv files, using APIs and applying the core knowledge of java to build the project. And I surely gained a lot to know.\nI just want to express that I'm very much keen towards applying and gaining software knowledge. \nI surely will prove myself fruitful for your organisation for the time being I would be there.",
  },
  {
    Timestamp: "04/09/2020 12:03:10",
    "Name of the student": "Arun Kumar Bisariya",
    "Institute Name(College)": "IIT BHUBANESHWAR",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Front-end development",
    "Period of Internship": "2-Months, from 1st may",
    "Current Location(With Country)": "Gwalior, India",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1f3vy-IAMF9rr9ENNwtN-f3_QJPg4NTC9/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arun-kumar-bisariya-42599b192",
    "Contact Details (Email)": "akb15@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "Due to COVID'19 starting date may vary.",
  },
  {
    Timestamp: "04/09/2020 12:03:25",
    "Name of the student": "Arun Kumar Bisariya",
    "Institute Name(College)": "IIT BHUBANESHWAR",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Front-end development",
    "Period of Internship": "2-Months, from 1st may",
    "Current Location(With Country)": "Gwalior, India",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1f3vy-IAMF9rr9ENNwtN-f3_QJPg4NTC9/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arun-kumar-bisariya-42599b192",
    "Contact Details (Email)": "akb15@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "Due to COVID'19 starting date may vary.",
  },
  {
    Timestamp: "04/09/2020 12:03:45",
    "Name of the student": "Karhale Vaibhav Patil",
    "Institute Name(College)": "SRMIST Chennai",
    "Field of study": "B.Tech-EEE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Power Electronics,Renewable Energy,Solar Photovolatics",
    "Period of Internship": "6-Months 01/05/20",
    "Current Location(With Country)": "Nanded (India)",
    "Does Remote Internship work for you?": "Yes Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ac2dW4fz1U6y_tnq1Tky5HGPt022GKa4/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/karhale-vaibhav-patil-464606171",
    "Contact Details (Email)": "vp1022752@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/09/2020 12:36:09",
    "Name of the student": "Abdullah Khilji",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Remote/Mumbai/Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1P_LVt7SWiBpYDF19zirHriVqYMWIfmOw/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/abdullah1khilji",
    "Contact Details (Email)": "abdullahkhilji.nits@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 13:07:14",
    "Name of the student": "Aida Raza",
    "Institute Name(College)": "University of California, Berkeley",
    "Field of study": "Cognitive Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "~2 months, start in June",
    "Current Location(With Country)": "Los Gatos, CA",
    "Does Remote Internship work for you?":
      "Yes! I can relocate to Berkeley, CA to access opportunities in the East Bay/San Francisco Area.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FCZIyLkOnfArjIfWliSz_5QsYLIWOqC0/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/aida-raza-221818197/",
    "Contact Details (Email)": "aidaraza@berkeley.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 13:34:20",
    "Name of the student": "BONDA VENKATA SWAMY",
    "Institute Name(College)": "IIT Bhunaneswar",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Mechanical, Business Development,Marketing",
    "Period of Internship": "3 Months( Available from May 20)",
    "Current Location(With Country)": "Bhubaneswar,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1jPYvFQGKbPFdGhrp-pXeaDJx9udQ7gWj/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "bv11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 14:04:35",
    "Name of the student": "Shravan A",
    "Institute Name(College)": "International Management Institute",
    "Field of study": "PGDM(Marketing and Operations)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing & Operations",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Kolkata,West Bengal,India.",
    "Does Remote Internship work for you?": "Anywhere",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Wq1zjo8UwRsyDih2ipIi2_eg-E3WWLAK/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shravan-ashok-64976b98",
    "Contact Details (Email)": "shravan.a@imi-k.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 14:10:20",
    "Name of the student": "Ronica Roopak",
    "Institute Name(College)": "Royal College of Art",
    "Field of study": "Art & Design",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Creative Arts, Design, Marketing, Content Writing",
    "Period of Internship": "2 months, Starting immediately",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?":
      "Yes, preferred city - Mumbai, London",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GwFRzOFyOdurAL0ZLLwpi0w6ei4zBpF4/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/ronica-roopak/",
    "Contact Details (Email)": "ronica.roopak9@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 14:38:05",
    "Name of the student": "Arnav Chand",
    "Institute Name(College)": "IIT Roorkee",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "UI/UX or Graphic Design",
    "Period of Internship": "2 months starting 13 April, 2020",
    "Current Location(With Country)": "Faridabad (Delhi NCR), India",
    "Does Remote Internship work for you?":
      "Yes. Preferred city to relocate will be Delhi, Gurgaon",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitr.ac.in/file/d/16WATBovGTqCMBl9iH6YuRJOhojCUhk2q/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arnav-chand-65a97a175",
    "Contact Details (Email)": "achand@ch.iitr.ac.in",
    "Anything else you'd like to share?":
      "Design Portfolio - www.tiny.cc/arnavchand",
  },
  {
    Timestamp: "04/09/2020 14:38:06",
    "Name of the student": "Varun Gupta",
    "Institute Name(College)": "EDHEC Business School, Nice, France",
    "Field of study": "Financial Markets/Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Financial Analyst/Investment Research/Trader",
    "Period of Internship": "6 months(as soon as possible)",
    "Current Location(With Country)": "Mumbai(INDIA)",
    "Does Remote Internship work for you?": "Yes, any city works for me.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TimrVztBkuA7xP5Wy7pcuWDL0S9u1VB1/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/varun-gupta09",
    "Contact Details (Email)": "varun.gupta@edhec.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 14:41:28",
    "Name of the student": "Jhinuk Santra",
    "Institute Name(College)": "National Institute of Technology, Silchar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Developement, Data Analytics, Coding and Data Structures",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Guwahati (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1eU9ZbJfMaERAr4x46Lw9GOBCcSGF2862",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jhinuk-santra-17b6ba16a",
    "Contact Details (Email)": "jhinuk.santra0602@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 14:42:13",
    "Name of the student": "Shushant Kumar",
    "Institute Name(College)": "IIT Bhubaneshwar",
    "Field of study": "Civil",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "1-2",
    "Current Location(With Country)": "Noida, Uttar Pradesh",
    "Does Remote Internship work for you?": "Yes, Bhubaneshwar",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1J7rd-cI0LWeaGsxithXxVj85hbQHN-4z/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shushant-kumar-b62585192",
    "Contact Details (Email)": "sk85@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 14:49:43",
    "Name of the student": "Addarsh Srivastava",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "1.5 - 2 months (Starting Date - 15/05/2020)",
    "Current Location(With Country)":
      "Gorakhnath, Gorakhpur, Uttar Pradesh, India",
    "Does Remote Internship work for you?": "Gurugram",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=15YnJoL27kNXfp9DelrFmUotYAylDgW99",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/addarsh-srivastava-588b9a161/",
    "Contact Details (Email)": "addarshsri@gmail.com",
    "Anything else you'd like to share?":
      "Another preferred city for remote internship - Bengaluru",
  },
  {
    Timestamp: "04/09/2020 15:11:16",
    "Name of the student": "Nimish Singh Gahlot",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Strategy, Operation, Product Management, Supply Chain and Data Visualization",
    "Period of Internship": "Present to 13th July",
    "Current Location(With Country)": "Jammu, J&K, India",
    "Does Remote Internship work for you?": "Yes, Mumbai or Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-32wmNG5BrPfSiGL57Uk-xYbBBhkCpZz/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nimish-gahlot-73833b153",
    "Contact Details (Email)": "nimishg65@gmail.com",
    "Anything else you'd like to share?":
      "Given the current scenario, I'm just looking for a great learning experience and not really looking for a stipend",
  },
  {
    Timestamp: "04/09/2020 15:12:24",
    "Name of the student": "Rachita",
    "Institute Name(College)": "SVNIT",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software",
    "Period of Internship": "FULL TIME",
    "Current Location(With Country)": "Rajasthan,INDIA",
    "Does Remote Internship work for you?": "Bangalore,Hyderabad,Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1mPLHamOHuGF1Rqghh4T2cB7PZK1axLnk/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rachita-bhagat-150a08150",
    "Contact Details (Email)": "rachitakt21@gmail.com",
    "Anything else you'd like to share?":
      "I was initially offered a Pre Placement Offer by a Bangalore based analytics firm,which they have withdrawn due to the current crisis. I am currently in final year of my graduation at NIT,Surat and actively seeking jobs in software/computer related domain.",
  },
  {
    Timestamp: "04/09/2020 15:16:10",
    "Name of the student": "Archit Nanda",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Management, Financial Analyst, Management Consultant, Business Analyst, or other options",
    "Period of Internship": "10th April '20 - 31st May '20",
    "Current Location(With Country)": "Chandigarh, Punjab, India",
    "Does Remote Internship work for you?":
      "I am ready for a remote internship and relocation if the situation improves",
    "Link to Resume(Google Drive/Dropbox)":
      "https://tinyurl.com/architnandaresume",
    "LinkedIn profile link": "https://www.linkedin.com/in/architnanda22/",
    "Contact Details (Email)": "architnanda22@gmail.com",
    "Anything else you'd like to share?":
      "I was the cultural and events head for Mood Indigo 2019 (Asia�s largest college cultural festival) and through my various experiences in campus activities, have developed an inclination towards problem-solving. \n\nIn the light of the recent events concerning COVID-19, my summer internship program offer was revoked at a reputed top firm where I was placed during the internship season at IIT Bombay. I am seeking internship opportunities across roles, but not limited to Product Management, Financial Analyst, Management Consultant, Business Analyst, or other options, which you might feel constructive. Thus, I am reaching out to you to discuss the possibility of completing a work from home internship in your organization.",
  },
  {
    Timestamp: "04/09/2020 15:38:33",
    "Name of the student": "Dhulipala Sri Venkata Vivek",
    "Institute Name(College)": "IIT(ISM) Dhanbad",
    "Field of study": "Computer Science And Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development or data science",
    "Period of Internship": "6 months internship, june 2k20",
    "Current Location(With Country)": "Kovvur, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Yes, Hyderabad.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1YBKOs15U4wY_zjhw91putjyepMPp_8Dx/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sri-venkata-vivek-dhulipala-a01246172/",
    "Contact Details (Email)": "dsvvivek9@gmail.com",
    "Anything else you'd like to share?":
      "I am a final year undergraduate, openly looking for job opprtunities.",
  },
  {
    Timestamp: "04/09/2020 15:59:32",
    "Name of the student": "Mayank singh",
    "Institute Name(College)": "Delhi technological university",
    "Field of study": "Software engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "SDE",
    "Period of Internship": "2-3 months, comfortable with any start date",
    "Current Location(With Country)": "New  Delhi",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ciywn4T0YWNWWPHAIYD1AoTvdtZDk7El/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mayanksingh202@gmail.com",
    "Anything else you'd like to share?": "No.",
  },
  {
    Timestamp: "04/09/2020 16:16:13",
    "Name of the student": "Ojasvee Chaurasia",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2",
    "Current Location(With Country)": "Varanasi (INDIA)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 16:25:41",
    "Name of the student": "Ankur Dubey",
    "Institute Name(College)": "IIT Patna",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "2 Months. Start date: 15 May",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Preferred city: Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1C1v6ED11wgg26hhtoGOJ5g5bCUITiR1n",
    "LinkedIn profile link": "https://www.linkedin.com/in/ankurd98/",
    "Contact Details (Email)": "theankurdubey@gmail.com",
    "Anything else you'd like to share?":
      "I had a summer internship offer from a US based computer networking company but they rescinded all offers due to COVID-19 lockdown. Also, I am not looking for app/web development roles.",
  },
  {
    Timestamp: "04/09/2020 16:57:45",
    "Name of the student": "Julkarnain Shahid",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Web Development",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Developer",
    "Period of Internship": "2 months. Anytime is fine.",
    "Current Location(With Country)": "Dhubri, Assam, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11b3eD5w5MFV7OmxWTx8iTdVdaOexuf4D/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/julkarnain-shahid",
    "Contact Details (Email)": "jsofficial16@gmail.com",
    "Anything else you'd like to share?":
      "I previously got an internship at Here Technologies, Mumbai. Unfortunately, it got canceled due to the present situation.",
  },
  {
    Timestamp: "04/09/2020 17:18:06",
    "Name of the student": "Harshita Kumari",
    "Institute Name(College)":
      "Delhi School of Management, Delhi Technological University",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "Jabalpur (M. P.)",
    "Does Remote Internship work for you?":
      "New Delhi, when situation improves",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/135XhIPCfumLlHnffoQtROr_7Y_J-K9eD/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harshita-kumari-607145141",
    "Contact Details (Email)": "harshita099k@gmail.com",
    "Anything else you'd like to share?":
      "I was offered Research Intern profile from a reputed data and information services business for financial services. But due to unprecedented scenario and Company's Policy Summer Internship program was revoked. I have a keen interest in Finance, accounts and economics.",
  },
  {
    Timestamp: "04/09/2020 17:30:07",
    "Name of the student": "Salil Shukla",
    "Institute Name(College)": "JIIT - 62",
    "Field of study": "B. Tech. ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 Months, Starting Immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1_WuaYgO5jT7h_6v_tv-7NEJ5rjx6JVmI/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/thesalilshukla/",
    "Contact Details (Email)": "thesalilshukla@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 17:45:16",
    "Name of the student": "Swapnil Agarwal",
    "Institute Name(College)": "NIT Raipur",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development, Data Science",
    "Period of Internship": "2",
    "Current Location(With Country)": "Banglore,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=19ITQ-zf8izVY9BkM3x9C2nsHXe23Dga9",
    "LinkedIn profile link": "www.linkedin.com/in/swapnil-agarwal-60724b172",
    "Contact Details (Email)": "agarwalswapnil793@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 17:50:20",
    "Name of the student": "Arpita Paul",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Electronics and communication engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2 months (June, July)",
    "Current Location(With Country)": "Guwahati",
    "Does Remote Internship work for you?": "No.",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "paularpita1998@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 18:02:02",
    "Name of the student": "Vivek Kumar",
    "Institute Name(College)": "NIT Raipur",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "CP",
    "Period of Internship": "1",
    "Current Location(With Country)": "Raipur India",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "vk48962713@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 18:14:40",
    "Name of the student": "Saurabh agarwal",
    "Institute Name(College)": "National institute of technology Raipur",
    "Field of study": "Computer science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning and data analysis .",
    "Period of Internship": "3 months, immediate",
    "Current Location(With Country)": "RAIPUR, CHATTISGARH,INDIA",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saurabh-agarwal-77aab4185",
    "Contact Details (Email)": "8114497770",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 18:14:49",
    "Name of the student": "kirankumar",
    "Institute Name(College)": "christuniversity",
    "Field of study": "bsc computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "IT",
    "Period of Internship": "2",
    "Current Location(With Country)": "bengaluru india",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.linkedin.com/in/kirankumar-a-b09a2b19a/",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kirankumar-a-b09a2b19a/",
    "Contact Details (Email)": "kirankumar.a@science.christuniversity.in",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/09/2020 18:23:34",
    "Name of the student": "RAHUL RAJ",
    "Institute Name(College)":
      "NATIONAL INSTITUTE OF TECHNOLOGY SILCHAR, ASSAM",
    "Field of study": "E.C.E.",
    Education: "Undergraduate",
    "Preferred domain of internship": "MACHINE LEARNING",
    "Period of Internship": "14/04/2020 to 30/05/2020",
    "Current Location(With Country)":
      "Vill-Sangipur(Purebhawan), Lalganj Ajahara, Dist.-Pratapgarh, Uttar Pradesh, INDIA, PIN: 230132",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1DfCVtfldhLLRrtXP_MxzCweU9A6pwBim",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rahulraj.nits.ece@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 18:23:42",
    "Name of the student": "Milan Patidar",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance, Data science / Analytics",
    "Period of Internship": "2 moths, (10 April - 10 june)",
    "Current Location(With Country)": "kukshi M.P., india",
    "Does Remote Internship work for you?": "Yes, Banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1kGUlCCpfxokwmc_6PuRCZYj-X0p2L5c7",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/milan-patidar-247132174/",
    "Contact Details (Email)": "9770756004",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 18:27:59",
    "Name of the student": "Amish Sharma",
    "Institute Name(College)":
      "Chhotubhai Gopalbhai Patel Institute of Technology",
    "Field of study": "Information Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Vadodara, Gujarat, India",
    "Does Remote Internship work for you?":
      "Yes, I am ready to relocate as per the company needs.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1evIkoNYfgYurT573p33eayvYo9beViVC/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/amish19",
    "Contact Details (Email)": "sharmaamish39@gmail.com",
    "Anything else you'd like to share?":
      "I am a competitive programmer, and machine learning enthusiast. I am ready to work by heart and I assure you that I will give my best. \n\nThis is my profile:\n\nCodechef: https://www.codechef.com/users/amish19\n\nHackerearth: https://www.hackerearth.com/@amish19/\n\nTechgig: https://techgig.com/amishsharma\n\nGithub: https://github.com/07legion\n\nKaggle: https://www.kaggle.com/amishsharma",
  },
  {
    Timestamp: "04/09/2020 18:32:24",
    "Name of the student": "Saptarshi Saikia",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "MBA-Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "Two months",
    "Current Location(With Country)": "North Lakhimpur, Assam, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1avrBVIFFQajk_hRlTdX9gbPuutkyVsyQ/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/saptarshi-saikia-886418192",
    "Contact Details (Email)": "saptarshisaikia@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 18:39:19",
    "Name of the student": "Pritesh Shewale",
    "Institute Name(College)": "JBIMS Mumbai",
    "Field of study": "MBA-Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Sales & Marketing,business development,Customer relation.",
    "Period of Internship": "Two month  ( Apr-May)",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "Yes location not constraint",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 18:49:37",
    "Name of the student": "Nilesh Singhania",
    "Institute Name(College)": "National institute of technology, Raipur",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software developer intern",
    "Period of Internship": "2 months from 21st April 2020",
    "Current Location(With Country)": "Jharsuguda, Odisha, India",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1pYdR-WhXobIw8vGLdCENIgOWy3-ozWR4/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nilesh-singhania-79812a167",
    "Contact Details (Email)": "nileshsinghania0481@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 18:55:57",
    "Name of the student": "Mrinal Kranti Das",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electronics and Instrumentation Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software",
    "Period of Internship": "Two months, starting at May'2020",
    "Current Location(With Country)": "Guwahati, Assam, India",
    "Does Remote Internship work for you?": "Yes. Kolkata, Delhi, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1C-wnxJ3fZ_6E_85D-daur0jdA09SVCzK/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/mrinalkrantidas",
    "Contact Details (Email)": "dasmrinalkranti1998@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 19:10:30",
    "Name of the student": "Ashish Ranjan",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies, Dehradun",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and Gas Domain",
    "Period of Internship": "1� months and can start immediately",
    "Current Location(With Country)": "Koderma (India)",
    "Does Remote Internship work for you?":
      "Yes, Delhi Dehradun Kolkata Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ePrUIiQYKbVjnKxXo6NKFSmcjiBawlvn/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ashish-ranjan-a34247122",
    "Contact Details (Email)": "ashishranjan4617@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/09/2020 19:12:56",
    "Name of the student": "Kimmi Jain",
    "Institute Name(College)": "KMV, DU",
    "Field of study": "Commerce",
    Education: "Undergraduate",
    "Preferred domain of internship": "Digital Marketing, HR, COntent writing",
    "Period of Internship": "1-2 months . Commencement from April or may",
    "Current Location(With Country)": "Rohtak, Haryana, India",
    "Does Remote Internship work for you?":
      "Only if it is part time intern option in Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1r769KTOhKR6KveIG3-0SYLNVt_2E9hLB/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kimmi-jain-826145185/",
    "Contact Details (Email)": "Kimmi2002jain@gmail.com",
    "Anything else you'd like to share?":
      "I am focused and striving hard to improve and do the best use of my cognitive mind.",
  },
  {
    Timestamp: "04/09/2020 20:02:43",
    "Name of the student": "Anand Gupta",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electronic And Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Indore, India",
    "Does Remote Internship work for you?": "Open to relocate in any city.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1yX-U-q3VK6DqpI3QieX6uPsqYj7JfpJw/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/anand-gupta-20/",
    "Contact Details (Email)": "anandguptanits@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 20:06:46",
    "Name of the student": "Umang Agarwal",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Manufacturing Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2 months (09/04/20)",
    "Current Location(With Country)": "Kolkata(India)",
    "Does Remote Internship work for you?": "Yes(Anywhere in India)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1l_o7-eWPiaWX33rR8haM4-P8Td8BhmXo",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/umang-agarwal-06b21016a/",
    "Contact Details (Email)": "uagarwal.17.99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 20:26:47",
    "Name of the student": "Akshay Ranjan Jha",
    "Institute Name(College)": "T A Pai Management Institute",
    "Field of study": "IT Consulting, Sales and Marketing, Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Consulting, Sales and Marketing, Analytics",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Ranchi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11zEJbA3P8aqBM7m2anMia1mojhOmau0b/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "akshayranjan02@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 20:30:15",
    "Name of the student": "Shubhanshu Singh",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development, web development",
    "Period of Internship": "2 months. Anytime",
    "Current Location(With Country)": "Ranikhet,India",
    "Does Remote Internship work for you?": "Yes. Preferred city:Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ivihl75sXJsvRG0wCWbLPowG3z8oEGog/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shubhanshu-singh-9bb601112/",
    "Contact Details (Email)": "iamanshu98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 20:43:14",
    "Name of the student": "Suraj Monga",
    "Institute Name(College)": "Chandigarh group of Colleges",
    "Field of study": "Btech CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Java",
    "Period of Internship": "3 to 6 months, can start immediately",
    "Current Location(With Country)": "Ferozepur, india",
    "Does Remote Internship work for you?": "I can't relocate.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RZ6hxVQeJFQy_vgSi8uoPA0HqtaxCTpE/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/suraj-monga-7a684b172",
    "Contact Details (Email)": "smonga1998@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 20:43:53",
    "Name of the student": "Anuj verma",
    "Institute Name(College)":
      "Indian Institute of Tourism &. Travel Management",
    "Field of study": "Tourism",
    Education: "Undergraduate",
    "Preferred domain of internship": "Junior Web developer",
    "Period of Internship": "3 months  start date- 10 April 2020",
    "Current Location(With Country)": "Prayagaraj",
    "Does Remote Internship work for you?":
      "Yes can relocate to Chandigarh, Noida , Jaipur, Lucknow",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-gJfHR8TqHTkI1eYbB6_Fmon3aEAm6Wd/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/anuj-v-01071998",
    "Contact Details (Email)": "anujv01071998@gmail.com",
    "Anything else you'd like to share?":
      "I am looking for internship in web development I am a fresher in this field with the internship in this field i want to enhance my skillset.",
  },
  {
    Timestamp: "04/09/2020 20:49:37",
    "Name of the student": "Akshit Madhu",
    "Institute Name(College)": "DIT University,Dehradun",
    "Field of study": "B.tech(Computer Science & Engineering)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science/Data Analyst/Machine Learning",
    "Period of Internship": "4 - 6 weeks",
    "Current Location(With Country)": "Hisar(Haryana)",
    "Does Remote Internship work for you?": "Yes,I can relocate to Delhi-NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=102l-9ccrZ_cgHB78tOFAdUJI0NYRcLdI",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshit-madhu-949b66155/",
    "Contact Details (Email)": "akshitmadhu23@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/09/2020 21:15:16",
    "Name of the student": "Sneha K",
    "Institute Name(College)": "Government engineering college Thrissur",
    "Field of study": "Electrical and electronics engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "Kerala, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "snehaeee432@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 21:32:41",
    "Name of the student": "AMIT KUMAR",
    "Institute Name(College)": "NIT RAIPUR",
    "Field of study": "COMPUTER SCIENCE & ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "SOFTWARE DEVELOPER, PROBLEM SETTER",
    "Period of Internship": "For 2 month internship starting after 15 APRIL.",
    "Current Location(With Country)": "Hapur, Uttar Pradesh, 245101,India",
    "Does Remote Internship work for you?":
      "Yes, i am willing to locate. My preferred city are Bangalore, Hyderabad, Delhi, Noida.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xRZTk99vK0rqS_UCovx3KJGOvH-ZMt-s/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/amit-kumar-a85648153/",
    "Contact Details (Email)": "amian.nitan.2000@gmail.com",
    "Anything else you'd like to share?":
      "MY PROJECT LINK : http://samar19.herokuapp.com/",
  },
  {
    Timestamp: "04/09/2020 22:05:25",
    "Name of the student": "Maharshi Dey",
    "Institute Name(College)": "University of North Dakota, USA",
    "Field of study": "Mechanical Engineering (focus in Materials Science)",
    Education: "Currently working on my PhD after MS",
    "Preferred domain of internship": "Materials Science Intern",
    "Period of Internship": "Can start from May 15th 2020 for 3-4months",
    "Current Location(With Country)":
      "Grand Forks, North Dakota, United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15e4dFkNVgem3GdXtg_Hpt6hQ7A-QAZUU/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/maharshidey/",
    "Contact Details (Email)": "dey.maharshi1@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 22:15:22",
    "Name of the student": "Simran Koul",
    "Institute Name(College)": "Chitkara University",
    "Field of study": "BE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics/ SDE",
    "Period of Internship": "6",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/simrankoul",
    "Contact Details (Email)": "simrankoul525@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 22:16:23",
    "Name of the student": "Himanshu Gupta",
    "Institute Name(College)": "National Institute of Technology,Silchar",
    "Field of study": "Electronics and Instrumentation",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development,Coding",
    "Period of Internship": "10th April-30thMay",
    "Current Location(With Country)": "Maharajganj,Azamgarh.UP(INDIA)",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://internshala.com/student/interstitial",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/himanshu-gupta-2b786a145/",
    "Contact Details (Email)": "hg63370@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 22:31:40",
    "Name of the student": "Akashdeep Garg",
    "Institute Name(College)": "IIT BHU",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "3 months starting from now onwards",
    "Current Location(With Country)": "Bathinda, Punjab, India",
    "Does Remote Internship work for you?":
      "Yes, if situation opens i would be willing to relocate anywhere in india",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AlZF5WHptFAVTjU9XOovaLmaxX912Y-f/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akashdeep-garg-752525168",
    "Contact Details (Email)": "adeepgarg4@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 23:01:24",
    "Name of the student": "Sanidhya Sinha",
    "Institute Name(College)": "Manipal Institute Of Technology, Manipal",
    "Field of study": "B.Tech in computers and communication engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software development, Analyst, data scientist",
    "Period of Internship": "Any, June 15th",
    "Current Location(With Country)": "Noida",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "sanidhyasinha17@gmail.com",
    "Contact Details (Email)": "sanidhyasinha17@gmail.com",
    "Anything else you'd like to share?":
      "I did an internship for 2 months as a data analyst in a firm and with my team, we gave a solution which was 20 percent more accurate and the time we took was half of the time that the organisation had previously done and I got a ppo in July 2019 just to be withdrawn yesterday.",
  },
  {
    Timestamp: "04/09/2020 23:09:23",
    "Name of the student": "Ashutosh Kumar",
    "Institute Name(College)":
      "NATIONAL INSTITUTE OF FOUNDRY AND FORGE TECHNOLOGY,RANCHI",
    "Field of study": "B.Tech in Metallurgy and materials engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics, Business Analyst",
    "Period of Internship": "4,soon",
    "Current Location(With Country)": "Bengaluru India",
    "Does Remote Internship work for you?": "Yes,yes, Bengaluru",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://drive.google.com/open?id=1aalwAuHABTaqAVbmMDA9fCB3QrDAZpzY",
    "Contact Details (Email)": "ashutoshkr103@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 23:29:41",
    "Name of the student": "Parth Sharma",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Mathematics and Computing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Analytics, Technology Analytics and Data Analytics",
    "Period of Internship": "01/06/2020- 31/07/2020",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1oZuQwithTMEc9sWtfv0LkoDUO9Wahfl-/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/parth-sharma-849740192/",
    "Contact Details (Email)": "sharma.parth1404@gmail.com",
    "Anything else you'd like to share?":
      "Looking forward for Growth Focussed Opportunities and serving my best .",
  },
  {
    Timestamp: "04/09/2020 23:31:13",
    "Name of the student": "Govind V B",
    "Institute Name(College)": "IIT MADRAS",
    "Field of study": "Chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data science / Machine learning, and I'm to anything thy would involve critical thinking and problem solving using cutting edge technologies",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "Kottayam, Kerala,Indiaa",
    "Does Remote Internship work for you?":
      "Yes. I would be comfortable relocating to Chennai or Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/smail.iitm.ac.in/file/d/1LPMJiJS91XJbKq3VZ7nWSiZmoHgHBXFh/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/govind-vb-114743159",
    "Contact Details (Email)": "govindvbiitm17@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 23:35:04",
    "Name of the student": "Ritu Chouhan",
    "Institute Name(College)": "National institute of technology, silchar",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes (preferred delhi)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GoXLafYSReb89n100ItTF-fPVObr9IV3/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritu-chouhan-b24523172",
    "Contact Details (Email)": "rituchouhan1012@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 00:12:25",
    "Name of the student": "NABWIRE JAYAN",
    "Institute Name(College)": "Kenya technical trainers college",
    "Field of study":
      "Technical education, social work and community development",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Non.govermental organization, technical institution",
    "Period of Internship": "3, starting May to July",
    "Current Location(With Country)": "Busia, kenya",
    "Does Remote Internship work for you?": "Yes, nakuru",
    "Link to Resume(Google Drive/Dropbox)": "Yes",
    "LinkedIn profile link": "Phone contact",
    "Contact Details (Email)": "alicenjayan@gmail.com",
    "Anything else you'd like to share?":
      "Looking forward for a positive response",
  },
  {
    Timestamp: "04/10/2020 00:18:20",
    "Name of the student": "Palak Jindal",
    "Institute Name(College)": "IILM Graduate School of Management",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "3 months & 11/04/2020",
    "Current Location(With Country)": "Varanasi, India",
    "Does Remote Internship work for you?": "Delhi, Noida, Gurugram",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iilmcms.ac.in/file/d/16k4X8VGI7rzJtiLB3nWVuGL27_wg9IVY/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/palak-jindal-746446146",
    "Contact Details (Email)": "palak.jindal.pgdm21@iilmcms.ac.in",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/10/2020 00:24:53",
    "Name of the student": "Kranthi Kumar",
    "Institute Name(College)": "IILM Graduate school of Management",
    "Field of study": "PGDM",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2-3 months Start Date : 11/04/2020",
    "Current Location(With Country)": "Visakhapatnam( India)",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/file/d/1u513G-nhtzX-ZoNsvjnas899lS8Wa8Kt/edit?usp=docslist_api&filetype=msword",
    "LinkedIn profile link": "http://linkedin.com/in/kranthi-kumar-3b2543190",
    "Contact Details (Email)": "kranthikumarpenta123@gmail.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/10/2020 00:35:48",
    "Name of the student": "Divyansh Bhatia",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analysis",
    "Period of Internship": "2, 13th April",
    "Current Location(With Country)": "Gurgaon, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PRZLFtRt5lMdUepdVZxPPi0LkI1K63NQ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/divyansh-bhatia-481460154",
    "Contact Details (Email)": "divyanshbhatia007@gmail.com",
    "Anything else you'd like to share?":
      "CAT - 98.74\nCan also work in Finance domain",
  },
  {
    Timestamp: "04/10/2020 01:18:54",
    "Name of the student": "Swapnil Kusumwal",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web/Software Development",
    "Period of Internship": "2 months . Immediate Joining",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11L0kXEc3Vw2V9_4L-tN81R629-lZ9q8X/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/swapnil-kusumwal-38398b33/",
    "Contact Details (Email)": "swapnilkusumwal@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 01:23:13",
    "Name of the student": "Drew Bies",
    "Institute Name(College)": "Gonzaga",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "may to August",
    "Current Location(With Country)": "Redmond Washington usa",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Dbies3@gmail.com",
    "Anything else you'd like to share?":
      "I am a software engineer with 2 years of experience looking for a summer internship.",
  },
  {
    Timestamp: "04/10/2020 01:47:44",
    "Name of the student": "Bhavesh Jain",
    "Institute Name(College)": "IIT KHARAGPUR",
    "Field of study": "Agriculture and food Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science",
    "Period of Internship": "6-8 weeks",
    "Current Location(With Country)": "Jaipur",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uoiuEO77wdLBCVNNtLrR1bKxBIXLfe-u/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bhavesh-jain-1b8029165?originalSubdomain=in",
    "Contact Details (Email)": "bjuser127@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/10/2020 01:57:15",
    "Name of the student": "Zahid Ahmed",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Metallurgical and Materials Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Quant Trading/Analytics/Business Development",
    "Period of Internship": "3-6 months starting from 10/5/2020",
    "Current Location(With Country)": "Bhubaneswar",
    "Does Remote Internship work for you?":
      "I'd be open to relocation incase there's a need for it. I'd be more than happy to make the move if the city is Hyderabad.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1cMFn04svfGDXR7prJbVvfydfhopN8b3e",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/zahid-ahmed-a48785145",
    "Contact Details (Email)": "mza10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 02:36:26",
    "Name of the student": "Mohit Sharma",
    "Institute Name(College)": "UIET KUK",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Web development, Android App Development",
    "Period of Internship": "2-6 month, June, 2020",
    "Current Location(With Country)": "Haryana India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/0B1cmufA4vSisQ295bk1hcWJBOENrS1JuMTBRWWRROFpTNmlB/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mohit-sharma-863025146/",
    "Contact Details (Email)": "mohit1999sh@gmail.com",
    "Anything else you'd like to share?": "Nope",
  },
  {
    Timestamp: "04/10/2020 03:10:54",
    "Name of the student": "Steffi",
    "Institute Name(College)": "Mahindra Ecole centrale",
    "Field of study": "Electrical and electronics engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer systems and network",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "steffiroy@hotmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 05:40:31",
    "Name of the student": "Gudala Kamesh Abhinav",
    "Institute Name(College)": "Indian Institute of Technology(IIT), Delhi",
    "Field of study": "Textile Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Analytics, Operations",
    "Period of Internship": "40 days, from around mid April to May",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1D8E_-fPuM7T8Id0f-vgCrW20Q9nsXaJ5/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/abhinav-gudala-88ba88175",
    "Contact Details (Email)": "abhinav2342000@gmail.com",
    "Anything else you'd like to share?":
      "Hoping to have a career in Data analytics, I am willing to learn as much as possible from the internship and make myself useful to your firm. I have prior experience in market research and have good analytical and observational skills.",
  },
  {
    Timestamp: "04/10/2020 05:51:50",
    "Name of the student": "Wail Chagar",
    "Institute Name(College)": "DePauw University",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer Science",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1olv1_XhoWRblVBVOSnbPgzTYairu8zoV",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "chagarliaw@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 06:51:49",
    "Name of the student": "Nischal Sharma",
    "Institute Name(College)": "The LNMIIT",
    "Field of study": "CCE",
    Education: "Undergraduate",
    "Preferred domain of internship": "ML, Data Science",
    "Period of Internship": "2months (1st May)",
    "Current Location(With Country)": "Pune (India)",
    "Does Remote Internship work for you?":
      "Yes, any major city (mumbai, B'glore, Delhi)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1r1suS25VW0IpgqLwiBcNBCzlErdCV3LS/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nischal-sharma-2b8295a6/",
    "Contact Details (Email)": "17ucc040@lnmiit.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 07:12:19",
    "Name of the student": "Aishwarya Chakraborty",
    "Institute Name(College)": "IMT Ghaziabad",
    "Field of study": "MBA marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months, can start immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Ready to relocate",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aishwarya-chakraborty-503a74175",
    "Contact Details (Email)": "chakrabortyaishwarya@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 07:30:25",
    "Name of the student": "Vishal Khatri",
    "Institute Name(College)": "Rutgers Business School",
    "Field of study": "Quantitative Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2.5 Months - 15th May 2020",
    "Current Location(With Country)": "Jersey City, NJ, USA",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1niwnAB8B02dBeTvwK-1kqfBk-gMxpD45/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/vishalkhatri15",
    "Contact Details (Email)": "khatrivishal15@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 07:53:49",
    "Name of the student": "Shubhangi Gupta",
    "Institute Name(College)": "Singapore Management University",
    "Field of study": "Economics and Statistics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Policy Research/ Quantitative Economics/Market Research",
    "Period of Internship": "Start May 1st, 2020. 3 months",
    "Current Location(With Country)":
      "Delhi (India)/ Singapore (either is fine, SG preferred)",
    "Does Remote Internship work for you?": "Yes- Delhi and Singapore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/12GOusRPocrVuvOJngQ27ar6FYrYWYnhYGrJ8ZVtFASA/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shubhangi-gupta-0293b5133/",
    "Contact Details (Email)": "shubhangig.2017@economics.smu.edu.sg",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 08:19:44",
    "Name of the student": "Divyanshu Thakur",
    "Institute Name(College)":
      "Indian Institute of Information Technology Manipur",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "3 months starting from 15 April",
    "Current Location(With Country)": "Delhi India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cL6RcyBBwJHkZMrn3OZ_30m2K2kTKlkn/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/divyanshu132/",
    "Contact Details (Email)": "divyanshut120@gmail.com",
    "Anything else you'd like to share?":
      "I'm a 2019 Google Summer of Code Developer and also mentoring GSoC this year.",
  },
  {
    Timestamp: "04/10/2020 08:49:43",
    "Name of the student": "Ankita Bakshi",
    "Institute Name(College)":
      "National Institute of Technology, Surat (SVNIT)",
    "Field of study": "Electronics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "6 months (July)",
    "Current Location(With Country)": "Singapore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ankita-bakshi88?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BQQ0X7q8bQNe2OFYKUVMESg%3D%3D",
    "Contact Details (Email)": "ankitabak@gmail.com",
    "Anything else you'd like to share?":
      "I can send in my resume through email.",
  },
  {
    Timestamp: "04/10/2020 09:07:46",
    "Name of the student": "Sanmid Anavkar",
    "Institute Name(College)": "Indiana University",
    "Field of study": "Master's of Science in Human-Computer Interaction",
    Education: "Post-Graduate",
    "Preferred domain of internship": "UX/Product designer Internship",
    "Period of Internship": "10th May 2020 for atleast 3 months",
    "Current Location(With Country)": "United States, Indianapolis",
    "Does Remote Internship work for you?":
      "Yes open to relocate as well as remote",
    "Link to Resume(Google Drive/Dropbox)":
      "https://uploads-ssl.webflow.com/5dad071965b2d9db8811a393/5e8eaedd3dac5928d37f8686_Sanmid_Anavkar_Designer.pdf",
    "LinkedIn profile link": "www.linkedin.com/in/sanmid-anavkar",
    "Contact Details (Email)": "sanmid.anavkar@gmail.com",
    "Anything else you'd like to share?": "https://www.sanmidanavkar.com/",
  },
  {
    Timestamp: "04/10/2020 09:26:24",
    "Name of the student": "Sarthak Agrawal",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Tech.",
    "Period of Internship": "2 months, ready to start immediately",
    "Current Location(With Country)": "MP",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17TECxtjh3Ih9oMD9t52bEpGPrEsnrmzv/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/sarthakagrawal8",
    "Contact Details (Email)": "sarthakagrawal8@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 09:37:48",
    "Name of the student": "Adrika Agrawal",
    "Institute Name(College)":
      "University of petroleum and energy studies (kandoli campus)",
    "Field of study": "Law",
    Education: "Undergraduate",
    "Preferred domain of internship": "Law",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Agra",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Adrikaagrawal07@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/10/2020 09:42:50",
    "Name of the student": "Neeti Mahajan",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies (UPES), Dehradun",
    "Field of study": "Earth Sciences",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Environmental Sciences, GIS, Earth Sciences, Geophysics, Geology",
    "Period of Internship":
      "A duration of one and a half to two months. Can start anytime from the given date, I.e. 11th April 2020.",
    "Current Location(With Country)": "Nagpur, Maharashtra, India",
    "Does Remote Internship work for you?":
      "Yes. I am open to migration to any other place of work. The preferred location will be Mumbai.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1OC747zoqAQy-BMIR5eJRAig9ci_y4I9-/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/neeti-mahajan-845446180",
    "Contact Details (Email)":
      "neetiumahajan@outlook.com OR neeti9816@gmail.com",
    "Anything else you'd like to share?":
      "Although my preferences are that of Earth Sciences, I have also am a freelance content writer and anything in that department will also suit me.\nRelocating also should not be a problem.\nThank you so much for the opportunity.\n\nRegards.",
  },
  {
    Timestamp: "04/10/2020 09:46:22",
    "Name of the student": "Shobhit Mishra",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies Dehradun",
    "Field of study": "Fire and Safety Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Fire Safety",
    "Period of Internship": "2 months, May 1st",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1bo0sPGuNQJ8qKd6KSSEA9n3O9AWsAL3l/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/itshobhit276",
    "Contact Details (Email)": "shobhit276@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/10/2020 10:02:59",
    "Name of the student": "Ajay Kharbade",
    "Institute Name(College)":
      "Jamnalal Bajaj Institute of Management Studies, Mumbai",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Marketing, Consulting, Business & Product Development",
    "Period of Internship": "2",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes,across PAN India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/183gfARWX7RJWcAEKXJZvKVNPGadqvmsF/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/ajay-k-756b2b80/",
    "Contact Details (Email)": "ajaykharbade21@jbims.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 10:04:25",
    "Name of the student": "Parakh Agarwal",
    "Institute Name(College)":
      "Army Institute of Management and Technology, Greater Noida",
    "Field of study": "MBA- Marketing & Business Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Business Analytics or Digital Marketing",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://a807cba2-8005-4c2e-97f7-89dc3a51e121.filesusr.com/ugd/d0d67b_8ce87e9d626a4cc59966035d804070a6.pdf",
    "LinkedIn profile link": "https://www.linkedin.com/in/parakh-agarwal/",
    "Contact Details (Email)": "parakh1995@gmail.com",
    "Anything else you'd like to share?":
      "I have a work experience of 3 years as Assistant Manager- Enterprise Channel Sales with Tata Teleservices Limited.",
  },
  {
    Timestamp: "04/10/2020 10:29:32",
    "Name of the student": "Abhijeet Jawaliya",
    "Institute Name(College)": "UPES",
    "Field of study": "Mining Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mining",
    "Period of Internship": "45 days starting from 1st of may",
    "Current Location(With Country)": "Bhilwara",
    "Does Remote Internship work for you?": "Yes any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/19hm59SElXRZpt6g7307_iX3UUug-AaKH/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/abhijeet-j-163a73a6",
    "Contact Details (Email)": "500061404@stu.upes.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 10:43:36",
    "Name of the student": "Swarna Siva Sunil chandra",
    "Institute Name(College)": "IIT BHU Varanasi",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Mechanical systems design and optimization, control systems",
    "Period of Internship": "1-2 months(starting from mid april)",
    "Current Location(With Country)": "Vijayawada, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1QwmlpCkWKuyIUok22R_wKtNZognKBUnV/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sunil-chandra-093813171",
    "Contact Details (Email)": "swarnasiva.schandra.mec17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 10:47:44",
    "Name of the student": "Jahnavi Jonnalagadda",
    "Institute Name(College)": "Chaitanya Bharathi Institute of Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Any domain",
    "Period of Internship": "3",
    "Current Location(With Country)": "Hyderabad India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/10Zt7WiQaCRsQvLLEO-s_xOqh5HOiVSrQ6cHHOIrNuXw/edit?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/jahnavijonnalagadda/",
    "Contact Details (Email)": "jahnavi30nov@gmail.com",
    "Anything else you'd like to share?":
      "Thank you for opening up the opportunities",
  },
  {
    Timestamp: "04/10/2020 10:51:15",
    "Name of the student": "Pratik Gaikwad",
    "Institute Name(College)":
      "Symbiosis Institute of Business Management Nagpur",
    "Field of study": "Operations and Supply Chain management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Supply chain analyst, Quality management and operations",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Nagpur India",
    "Does Remote Internship work for you?": "Yes, Nagpur, Pune and Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://s.docworkspace.com/d/AGV26TXWrPEswdKqvMCdFA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pratik-gaikwad-a639631a3",
    "Contact Details (Email)": "pratik.gaikwad2021@sibmnagpur.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 11:01:14",
    "Name of the student": "Esha Mondal",
    "Institute Name(College)": "Symbiosis Institute of Design",
    "Field of study": "Inderior Space Design",
    Education: "Undergraduate",
    "Preferred domain of internship": "Interior Space design",
    "Period of Internship": "4 months, starting from September.",
    "Current Location(With Country)": "Kolkata, India",
    "Does Remote Internship work for you?": "Bangalore, Mumbai, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1YEmuS34kipvJkoxzyuR3uvi9CdqJObQh/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/esha-mondal",
    "Contact Details (Email)": "emondal.id@gmail.com",
    "Anything else you'd like to share?":
      "https://drive.google.com/file/d/1Xz1Bsy87ZBXGVUk4TGQwpv-7fw3_iXGv/view?usp=sharing",
  },
  {
    Timestamp: "04/10/2020 11:07:09",
    "Name of the student": "Shivangi Chaturvedi",
    "Institute Name(College)":
      "University of petroleum and energy studies,dehradun",
    "Field of study": "Btech mining",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mining underground/metal",
    "Period of Internship": "45 days starting from 1st may",
    "Current Location(With Country)": "Agra,India",
    "Does Remote Internship work for you?": "Yes,any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/stu.upes.ac.in/file/d/1lz3wrz4x5MISBmiwuYnpDWgsDxExv6_n/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivangi-chaturvedi-736a5014b",
    "Contact Details (Email)": "shivangichaturvedi25@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/10/2020 11:49:29",
    "Name of the student": "Sukumar Guntru",
    "Institute Name(College)": "Indian Institute of Technology",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Frond end web development and Machine Learning",
    "Period of Internship": "May -June(2 months)",
    "Current Location(With Country)": "Bhubaneswar(India)",
    "Does Remote Internship work for you?": "HYderabad(India)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1nFlX6DarEeLwZ7fUfRKgv_K19Q7J6o4K",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "gs26@iitbbs.ac.in",
    "Anything else you'd like to share?": "NO",
  },
  {
    Timestamp: "04/10/2020 11:54:29",
    "Name of the student": "Vishvendra Singh",
    "Institute Name(College)":
      "University of petroleum and energy studies Dehradun",
    "Field of study": "Computer Applications",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Designing",
    "Period of Internship": "1-2 Months",
    "Current Location(With Country)": "Bulandshahr, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1sLbB1H82c2d2AbkgVq8-hA65ZuqQiPnz",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ch-vishvendra-singh-000129193/",
    "Contact Details (Email)": "edgy_eft9@protonmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 12:21:47",
    "Name of the student": "Arunima Krishnan",
    "Institute Name(College)": "Sri Venkateswara College",
    "Field of study": "BA(H) Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months (01/06/2020 to 31/07/2020)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, Delhi NCR is the preferred location",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1velIqqnopQ0_bgM-y3ixSdKmEDkSJ95_/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/arunima-krishnan-5b765519a",
    "Contact Details (Email)": "aru333666@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 12:26:47",
    "Name of the student": "Aklank Jain",
    "Institute Name(College)": "VGSoM, IIT Kharagpur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Markeing, Consulting, Product Management",
    "Period of Internship": "2",
    "Current Location(With Country)": "Chandigarh, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1BgtoDOOOM8JUOB6XzpE0OMZDcgi74ZQ1/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/aklankjain95/",
    "Contact Details (Email)": "aklank.jain.iitkgp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 12:39:16",
    "Name of the student": "Bhawna Chauhan",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Development(web)",
    "Period of Internship": "3 or 6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rNvhKayYIMFBNToFFrBd7C-ERlhbZ_Nw/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bhawna-chauhan-608b21138/",
    "Contact Details (Email)": "CBHAWANA603@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 12:43:37",
    "Name of the student": "Pritimoy Maity",
    "Institute Name(College)": "Narula Institute Of Technology",
    "Field of study": "Electrical Engineering(B.tech)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Sales,Marketing,Management",
    "Period of Internship":
      "Duration of months could be anything,I am immediately available",
    "Current Location(With Country)": "Kolkata (India)",
    "Does Remote Internship work for you?":
      "Yes remote internship works for me.Yes I can relocate,anywhere in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/l/scl/AACYbi4aoaVfjFNgNimftqDGTfba3RN_mCg",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pritimoy-maity-b44b5318b",
    "Contact Details (Email)": "pritimoymaity1996@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/10/2020 13:23:28",
    "Name of the student": "Aniket Charjan",
    "Institute Name(College)": "Indian Institute of Technology, Bhubaneshwar",
    "Field of study":
      "Mechanical engineering with Specialization in Thermal Sciences",
    Education: "Undergraduate",
    "Preferred domain of internship": "Either Core or Non-core",
    "Period of Internship": "2 months ( 15 may -15 july)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, (Pune, Banglore, delhi,nagpur,bhubaneshwar or rather any city would be fine)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1L5Bs_W9MCmzRi_g7-sbb8pLQcSUsrGDb/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/aniket-charjan-310a90163",
    "Contact Details (Email)": "aniketcharjan3@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 13:37:50",
    "Name of the student": "Vishant Batta",
    "Institute Name(College)": "Indian Institute of Technology(BHU), Varanasi",
    "Field of study": "Pharmaceutical Engineering and Technology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Management | Data Science | Deep Learning",
    "Period of Internship": "2-3 months (Starting immedietly)",
    "Current Location(With Country)": "Ludhiana, Punjab, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1b0U0NCMRn51SB3dBzDmusZkmXQQ2gUH4/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vishant-batta-40a93a150/",
    "Contact Details (Email)": "vishant.batta.phe17@iitbhu.ac.in",
    "Anything else you'd like to share?":
      "My internship at Yale University was cancelled due to the COVID-19 outbreak and I am looking out for opportunities.",
  },
  {
    Timestamp: "04/10/2020 13:51:57",
    "Name of the student": "Abhishek Anand",
    "Institute Name(College)": "IIT BHU",
    "Field of study": "Chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development/ Data Science",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Jamshedpur, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/1rumpxNzdrH2bX5rWI5zJFpNXL_o9SmY4/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-anand-80556a171",
    "Contact Details (Email)": "abhishek.anand.che17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 13:53:05",
    "Name of the student": "Ganesh Ram Koushik",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "ML, Cybersecurity",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Chennai",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Gi9f5xCvXolg3WTRq6MSpMvb6YludrHC/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ganesh-ram-koushik-88a79517b/",
    "Contact Details (Email)": "grk14@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 13:56:09",
    "Name of the student": "Ansh Agrawal",
    "Institute Name(College)": "IIT BHU",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development, Web Development , C++ Development",
    "Period of Internship": "2 months, 20th April",
    "Current Location(With Country)": "Azamgarh, Uttar Pradesh (276001) India",
    "Does Remote Internship work for you?":
      "Yes, Bangalore will be perfect location for me.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1csgtld4RF_p1xHzz1sU7CHNmtphip7Op",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ansh-agrawal-2520a916a/",
    "Contact Details (Email)": "ansh.agrawal.che17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 13:56:44",
    "Name of the student": "Neeti Mahajan",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies (UPES), Dehradun",
    "Field of study": "Earth Sciences",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Environmental Sciences, GIS, Earth Sciences, Geophysics, Geology",
    "Period of Internship":
      "A duration of one and a half to two months. Can start anytime from the given date, I.e. 11th April 2020.",
    "Current Location(With Country)": "Nagpur, Maharashtra, India",
    "Does Remote Internship work for you?":
      "Yes. I am open to migration to any other place of work. The preferred location will be Mumbai.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1OC747zoqAQy-BMIR5eJRAig9ci_y4I9-/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/neeti-mahajan-845446180",
    "Contact Details (Email)":
      "neetiumahajan@outlook.com OR neeti9816@gmail.com",
    "Anything else you'd like to share?":
      "Although my preferences are that of Earth Sciences, I have also am a freelance content writer and anything in that department will also suit me.\nRelocating also should not be a problem.\nThank you so much for the opportunity.\n\nRegards.",
  },
  {
    Timestamp: "04/10/2020 14:00:54",
    "Name of the student": "Ragini Lakra",
    "Institute Name(College)": "IIT BHU Varanasi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software engineering- C++ development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Kolkata, West Bengal, India",
    "Does Remote Internship work for you?":
      "Yes I am okay with remote internship work and I am open to relocate if situation improves and lockdown is over. My preferred city to relocate would be: 1.Kolkata 2.Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=12pIVmYIYVszc44iUkvJRJuEFTFJdiLCf",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ragini-lakra-04ab36192/",
    "Contact Details (Email)": "ragini.lakra.che17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 14:04:19",
    "Name of the student": "Shivam Dwivedi",
    "Institute Name(College)": "University of Petroleum & Energy Studies",
    "Field of study": "B Tech- Fire and Safety",
    Education: "Undergraduate",
    "Preferred domain of internship": "Fire and safety",
    "Period of Internship": "4-8 weeks. Starting as early as possible",
    "Current Location(With Country)": "Gurgaon, Haryana, India",
    "Does Remote Internship work for you?": "Dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MwSqaG-rnabE9nRQ6tiuqz057pgRN5TT/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivam-dwivedi-17b3ba17a",
    "Contact Details (Email)": "sd97070@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 14:18:28",
    "Name of the student": "Ankit Gupta",
    "Institute Name(College)": "Indian Institute Of Technology (BHU) Varanasi",
    "Field of study": "Chemical Engineering & Tech.",
    Education: "Undergraduate",
    "Preferred domain of internship": "Chemical Core",
    "Period of Internship": "16th April - 30th May'2020",
    "Current Location(With Country)": "Tonk (Rajasthan), India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FkgkNOKLU4WnXM_IO9LHJcz8GcMOXezK/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ankit-gupta-00b55b169",
    "Contact Details (Email)": "ankit.gupta.che17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 14:27:19",
    "Name of the student": "Pranav Tomar",
    "Institute Name(College)": "IIT (BHU) Varanasi",
    "Field of study": "Chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Frontend role, Backend role, Web Development",
    "Period of Internship":
      "I can start immediately, looking for a work from home internship till 15th of may. I can work remotely in July.",
    "Current Location(With Country)": "Meerut, U.P-250002, India",
    "Does Remote Internship work for you?":
      "Yes, Delhi, Mumbai, Chennai, Bangalore, Noida, Gurgaon, Kolkata, any tier 1 city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/13SOwaxewDsQIOn5YEAUg8P3ESH0iqavr/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pranav-tomar-64b67b177",
    "Contact Details (Email)": "pranav.tomar.che17@itbhu.ac.in",
    "Anything else you'd like to share?":
      "Developed a real time chat app, implemented a bubble sheet scanner",
  },
  {
    Timestamp: "04/10/2020 14:29:31",
    "Name of the student": "S.N.Pranav",
    "Institute Name(College)": "Indian Institute Of Technology Bhubaneswar",
    "Field of study": "Metallurgy and material science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Business/Material science",
    "Period of Internship": "2, 15/05/2020",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "Yes, Hyderabad.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1M9ev4YZmGMld7J3lP5Tcjr0rOzvqUkRL/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "snp11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 14:35:44",
    "Name of the student": "Anmol Agrawal",
    "Institute Name(College)": "IIT BHU Varanasi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Backend development",
    "Period of Internship": "2 months starting from 11th April",
    "Current Location(With Country)": "Bhopal",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1lFbTS40jkbwF2ow0oRApUA2XjguK-Zvd/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anmol-agrawal-96a21014b/",
    "Contact Details (Email)": "7233066232",
    "Anything else you'd like to share?":
      "I enjoy being challenged and engaging with projects that require me to work outside my comfort and knowledge set, as continuing to learn new languages and development techniques are important to me and the success of your organization. Your listed requirements closely match my background and skills. A few I would like to highlight that would enable me to contribute to your bottom line are:\n1. Thorough understanding of data structures and algorithms.\n2. Knowledge of backend development practices.\n3. Hands-on software troubleshooting experience.",
  },
  {
    Timestamp: "04/10/2020 14:44:41",
    "Name of the student": "Tripti Khushiram",
    "Institute Name(College)": "Indian Institute of Management Ranchi",
    "Field of study": "General Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing,Business Development",
    "Period of Internship": "2",
    "Current Location(With Country)": "Lucknow",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iimranchi.ac.in/file/d/1O1Cu-SMAqlUdvxDKLhONyFK7rCU4Azia/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tripti-khushiram-2909a6a6",
    "Contact Details (Email)": "tripti.khushiram@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 14:52:39",
    "Name of the student": "Shashwat Singh",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Electronics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Ready to intern in any field that helps in my professional growth and gives an enriching experience",
    "Period of Internship": "April -May/June",
    "Current Location(With Country)": "Lucknow",
    "Does Remote Internship work for you?": "Yes,Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ixv78LwLLAgQ4kJmBzqRv8pQnEU4sYtf/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shashwatsingh97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 15:22:50",
    "Name of the student": "Mohan Aditya Sabbineni",
    "Institute Name(College)": "IIT (BHU) Varanasi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Chemical Core engineering (process engineering / designing / optimisation)",
    "Period of Internship": "April 11 to May 30",
    "Current Location(With Country)": "Vijayawada, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1fm-DufFInqO2JP_1VUOOmLo4qHgKG4Qg/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mohan-aditya-sabbineni/",
    "Contact Details (Email)": "sabbineni.maditya.che17@itbhu.ac.in",
    "Anything else you'd like to share?":
      "I was offered an internship by an Indian multinational conglomerate. But due to recent consequences, I haven't received any kind of confirmation regarding the same yet. \nSo, I would like to utilise this situation properly to enrich my skills and progress in my career.",
  },
  {
    Timestamp: "04/10/2020 15:31:25",
    "Name of the student": "Prince Kumar",
    "Institute Name(College)": "IIT (BHU), Varanasi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science and Machine Learning",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/1tb3chFmoDSRhbJG8Pis06VLDW7aag7Da/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prince-kumar-b43794148",
    "Contact Details (Email)": "Mailmeatprince@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 15:35:56",
    "Name of the student": "Vikram Mehta",
    "Institute Name(College)": "IIT BHU Varanasi",
    "Field of study": "Ceramic Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1DTewBlRqFxENUN00ocwRAuCI5UeA3VGMLtKfp4yQq7I/edit?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/vikrammehta611",
    "Contact Details (Email)": "vikmehta611@gmail.com",
    "Anything else you'd like to share?":
      "I'm an extremely motivated and hardworking individual, with a zeal to succeed.",
  },
  {
    Timestamp: "04/10/2020 16:00:20",
    "Name of the student": "Lokesh Kumar R",
    "Institute Name(College)": "IIT BHU VARANASI",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Management or Business Analyst or Business Development",
    "Period of Internship": "6- 8 weeks open to start the work right away",
    "Current Location(With Country)": "Coimbatore, Tamil Nadu, India",
    "Does Remote Internship work for you?":
      "Yes, Bangalore, Mumbai will be more preferred",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/1wfGmZBo97F6LtAdI57VdB1cEinBrKdRJ/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/lokesh-k-497929136",
    "Contact Details (Email)": "lokesh.kumarr.che17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 16:14:22",
    "Name of the student": "Harshita Tiwari",
    "Institute Name(College)": "University of petroleum and energy studies",
    "Field of study": "Btech- computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer science",
    "Period of Internship": "1.5",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1jYtzRQphTLrwWewgR9n0-X-oZ8cab3IC/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harshita-tiwari-0a7a97160",
    "Contact Details (Email)": "Harshitatiwari235@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 16:16:15",
    "Name of the student": "Palak Jindal",
    "Institute Name(College)": "IILM GRADUATE SCHOOL OF MANAGEMENT",
    "Field of study": "FINANCE",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2-3 months 11/04/2020",
    "Current Location(With Country)": "Varanasi, India",
    "Does Remote Internship work for you?": "Yes,  DELHI , NOIDA, GURUGRAM",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/156aZBoEVtv3LP1B1GDDDiPrl_w1mv4Q4/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/palak-jindal-746446146",
    "Contact Details (Email)": "Palak.jindal.pgdm21@iilmcms.ac.in",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/10/2020 16:26:11",
    "Name of the student": "Sachin Rai",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "2 (post 15 may 2020)",
    "Current Location(With Country)": "Delhi",
    "Does Remote Internship work for you?": "Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1q3kJttsdD96mTiyGcO7JiG8E6LL1vpDv/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/sachin-rai-nits",
    "Contact Details (Email)": "raisachin416@gmail.com",
    "Anything else you'd like to share?": "No, that will be all.",
  },
  {
    Timestamp: "04/10/2020 17:00:46",
    "Name of the student": "sumit Ranadive",
    "Institute Name(College)": "Maharashtra institute of technology, pune",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Oil and gas industry or mechanical field",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Solapur ( India)",
    "Does Remote Internship work for you?": "Yes, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/166xgRFVq9ngDVSEIwDKMv1RI7GgDiGrJ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sumit-ranadive-9901b116a",
    "Contact Details (Email)": "sumitranadive18897@gmail.com",
    "Anything else you'd like to share?":
      "I am petroleum engineering student so I like to do internship which is related to oil and gas industry. I have no issue to do internship at all over India.",
  },
  {
    Timestamp: "04/10/2020 17:02:19",
    "Name of the student": "Suvajit Laik",
    "Institute Name(College)": "FORE School of Management",
    "Field of study": "PGDM in Finance and Marketing",
    Education: "",
    "Preferred domain of internship": "Finance, consulting and marketing",
    "Period of Internship": "6 weeks to 8 weeks",
    "Current Location(With Country)": "India, Any location",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "I can share as required as I have stored as remote storage",
    "LinkedIn profile link": "linkedin.com/in/suvajitlaik",
    "Contact Details (Email)": "pikulaik@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/10/2020 17:21:20",
    "Name of the student": "Anuj Agrawal",
    "Institute Name(College)": "IIT (BHU)",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "core engineering, process design, optimisation, R&D",
    "Period of Internship": "6-12 weeks",
    "Current Location(With Country)": "Raigarh, Chhattisgarh, India",
    "Does Remote Internship work for you?": "yes, Pan India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1peXXfIVZ02N_bLw9lgE7KeMP3vEDO0q-/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/anuj-agrawal-iit-bhu",
    "Contact Details (Email)": "anuj.agrawal.che17@itbhu.ac.in",
    "Anything else you'd like to share?":
      "I have also knowledge and experience of machine learning, data analysis & python, along with knowledge of business development & marketing, which can be coupled with my knowledge of chemical engineering.",
  },
  {
    Timestamp: "04/10/2020 17:40:52",
    "Name of the student": "MAHIMA KRITI",
    "Institute Name(College)": "NATIONAL INSTITUTE OF TECHNOLOGY, DURGAPUR",
    "Field of study": "BACHELOR OF TECHNOLOGY(INFORMATION TECHNOLOGY)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning(big data analytics)",
    "Period of Internship": "2 months (starting date -11/04/2020)",
    "Current Location(With Country)": "INDIA",
    "Does Remote Internship work for you?": "DELHI",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZNDE733frA9xpu2tB7qhRPamxevXEVBT/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "kritimahima17@gmail.com",
    "Anything else you'd like to share?":
      "I am a hardworking and passionate learner.I am looking for a remote internship which can contribute to my undertanding of real life problems and their solutions.",
  },
  {
    Timestamp: "04/10/2020 17:42:01",
    "Name of the student": "Jainam Ranawat",
    "Institute Name(College)": "Jamnalal Bajaj Institute of Management Studies",
    "Field of study": "Masters in Management Studies",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Sales and Marketing",
    "Period of Internship": "2 months (1st May - 30th June)",
    "Current Location(With Country)": "Mumbai (India)",
    "Does Remote Internship work for you?": "Yes (any city)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1k5xRD-t6TgM0LdrCWF1d2kRYZKB5kWMP/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/jainam-ranawat-ab274a1a6",
    "Contact Details (Email)": "jainamranawat21@jbims.edu",
    "Anything else you'd like to share?":
      "I am currently pursuing Masters in Management Studies from Jamnalal Bajaj Institute of Management Studies (JBIMS), Mumbai. I did my Bachelors of Commerce from Narsee Monjee College of Commerce and Economics. \nI have worked as a marketing intern at a start up company called 'Pebel' where I conducted opportunity sizing of the market for personalized Eco-friendly products and assisted in exhibiting products at Business-to-Business expo for large corporates, resellers, distributors and traders. \nI am a National Level athlete and have represented Maharashtra State at the All India Aquatic Championship in Diving event.",
  },
  {
    Timestamp: "04/10/2020 17:58:18",
    "Name of the student": "Ashish Raj",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Electrical",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Power system, control system,power electronics",
    "Period of Internship": "",
    "Current Location(With Country)": "Chaibasa, Jharkhand (INDIA)",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15VmsKLSsuvjWbRqObHrMqS2wbtHsU-6U/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/ashish-raj-9ab665164",
    "Contact Details (Email)": "ashish.raj034@gmail.com",
    "Anything else you'd like to share?": "I want to utilize myself.",
  },
  {
    Timestamp: "04/10/2020 18:01:32",
    "Name of the student": "yash rao",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Mathematics and Computing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Analytics, Machines Learning, Consulting, Product Management",
    "Period of Internship": "June- July 2020 (2 Months)",
    "Current Location(With Country)": "Delhi,India",
    "Does Remote Internship work for you?":
      "Yes can relocate to - Mumbai, Bangalore, Hyderabad, Singapore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iVdYwL49g-Ks2emjMfuMLDOEnCZXNviG/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/yashrao23",
    "Contact Details (Email)": "yrao1000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 18:02:12",
    "Name of the student": "Sweta Rani Sahu",
    "Institute Name(College)": "IIIT-BHUBANESWAR",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning, Data Science",
    "Period of Internship": "2-3 months. Can start immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Hyderabad, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iiit-bh.ac.in/file/d/1VDhD8BLa0EeZJ5rF6T6RbuvIhqTGAy9U/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sweta-rani-sahu-884415166/",
    "Contact Details (Email)": "b517055@iiit-bh.ac.in",
    "Anything else you'd like to share?":
      "Would try and render required solutions to the given task and give my best. Waiting for a positive response.",
  },
  {
    Timestamp: "04/10/2020 18:32:49",
    "Name of the student": "Suhani Brahme",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2 to 3 months, starting tomorrow",
    "Current Location(With Country)": "Raipur, Chhattisgarh",
    "Does Remote Internship work for you?": "Yes, i would prefer Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1NtAvdFaYX_e14_rCEPgkHeG9Gaoqe2o5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/suhani-brahme-a011131a1",
    "Contact Details (Email)": "suhanibrahme@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 19:11:58",
    "Name of the student": "Sravan",
    "Institute Name(College)": "BITS Pilani Hyderabad Campus",
    "Field of study": "M.Sc Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "6-8 weeks",
    "Current Location(With Country)": "Hyderabad",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/bits-pilani.ac.in/file/d/1Bxk6ck9gYQeNi85-n7Y6NZYtoqlYAfvO/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://in.linkedin.com/in/sravan-bharadwaj-1b4393187",
    "Contact Details (Email)": "f20160400@hyderabad.bits-pilani.ac.in",
    "Anything else you'd like to share?": "Nothing",
  },
  {
    Timestamp: "04/10/2020 19:30:21",
    "Name of the student": "Poorna Chandra",
    "Institute Name(College)": "Vellore Institute of Technology",
    "Field of study": "Btech CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "iOS Development, Backend",
    "Period of Internship": "1-2 months from 15-04-2020",
    "Current Location(With Country)": "Tirupati, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Bangalore, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1v3jWvEjweyr0N3BmIHfXlR7DXjzaGxOo/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/poorna-chandra-vemula/",
    "Contact Details (Email)": "developer.poornachandra@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 19:38:25",
    "Name of the student": "Aniket Agarwalla",
    "Institute Name(College)": "NIT SILCHAR",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "SDE",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "JORHAT,ASSAM",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1yELhT5WPT0aBlyuMpcKcVALDojSnO1gs/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aniket-agarwalla-63268a15a/",
    "Contact Details (Email)": "aniketagarwalla37@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 19:41:34",
    "Name of the student": "Indraani",
    "Institute Name(College)": "Avinashilingam university",
    "Field of study": "Travel and tourism management",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Anything related to travel and teaching industry",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Indraaniravi1510@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 19:42:10",
    "Name of the student": "Harsh Joshi",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies, Dehradun",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Application/Software Development",
    "Period of Internship": "April- August",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes(Bangalore, New Delhi, Hyderabad, Mumbai,Pune)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1jKF42M5Si4ohd_ltxd6Sp9kvevucZEgW/view?usp=sharing",
    "LinkedIn profile link": "https://linkedin.com/in/josharsh",
    "Contact Details (Email)": "harsh.joshi.pth@gmail.com",
    "Anything else you'd like to share?":
      "Portfolio Link: https://josharsh.github.io/Josharsh",
  },
  {
    Timestamp: "04/10/2020 20:13:28",
    "Name of the student": "Akshay Sanjay Vibhute",
    "Institute Name(College)":
      "Maharashtra Institute Of Technology Kothrud, Pune",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas (upstream)",
    "Period of Internship": "1 June - 20 July 2020",
    "Current Location(With Country)": "Buldhana, Maharashtra,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1LjE36WdOG5kU7VmCSxTNj0pcG08aSPcW",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshay-vibhute-60b29a199",
    "Contact Details (Email)": "akshayvibhute10@gmail.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/10/2020 20:50:07",
    "Name of the student": "Varsha Ravichandiran",
    "Institute Name(College)": "University at Buffalo SUNY",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Software Engineer Intern, Data Science Intern",
    "Period of Internship": "May 18 - Aug 14",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?":
      "Yes (Dallas, Atlanta, San Jose, Austin, Boston)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1K4FVn0uqjXWWrXsMZMTcUekRQZ1lVYQ9/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/varsharavichandiran",
    "Contact Details (Email)": "varsharavichandiran@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 21:07:32",
    "Name of the student": "Siddhant Jaiswal",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Health, Safety and Environment",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "1st preference- Health Safety and Environment(HSE),  Digital Marketing, Social Media Management.",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Any Location",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1mUAbrglwqPV-eU5Gj6RkOvCTgNCyc8ZV/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/siddhant-jaiswal-76aaa4131",
    "Contact Details (Email)": "Siddhantjaiswal20@gmail.com",
    "Anything else you'd like to share?": "Looking for research work.",
  },
  {
    Timestamp: "04/10/2020 21:12:40",
    "Name of the student": "Sarthak Kapoor",
    "Institute Name(College)": "Maharaja Agrasen College, University of Delhi",
    "Field of study": "Bachelor of Journalism and Mass Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Copywriting",
    "Period of Internship": "6 months. Can start immediately.",
    "Current Location(With Country)": "Kanpur, India",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1H8ALZTWvpBOVNukjmL4mJw0eLbC3SI_C/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sarthak-kapoor-4b2aa712a",
    "Contact Details (Email)": "sarthakkapoor.work@gmail.com",
    "Anything else you'd like to share?":
      "I am adept in Copywriting, Screenwriting and filmmaking, ideation, building creative campaigns. I've worked with major media houses such as NDTV, RED FM, Hindustan Times Media Ltd, Times Group.",
  },
  {
    Timestamp: "04/10/2020 21:48:36",
    "Name of the student": "Amitesh Panda",
    "Institute Name(College)": "IIT (BHU) Varanasi",
    "Field of study": "Chemical Engineering and Technology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Core Engineering (Design/Simulation, Optimization, Research)",
    "Period of Internship": "2 months (April 10 onwards)",
    "Current Location(With Country)": "Bhubneswar, Odisha (INDIA)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1oetCFp0CwU_8ByfN8qwJyF2AnSz6eVCu/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "amiteshp.cd.che17@itbhu.ac.in",
    "Anything else you'd like to share?":
      "I was offered an internship at Nanyang Technological University in the summers of 2020, but due to current pandemic situation it stands delayed for at least one year. Hence currently I am in search of internship that will provide me experience in designing, simulation or research oriented profiles. My aspirations is to work for Pharmaceutical conglomerate in their R&D team after the completion of my B.Tech Degree.\nTelephone Contact Number: 9565534929\nEmail ID: amiteshp.cd@itbhu.ac.in",
  },
  {
    Timestamp: "04/10/2020 21:53:56",
    "Name of the student": "Prakhathi Murugesan",
    "Institute Name(College)": "State University of New York at Buffalo",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "3 MONTHS starting from May 15",
    "Current Location(With Country)": "Buffalo, NY, United States",
    "Does Remote Internship work for you?": "Yes, willing to relocate",
    "Link to Resume(Google Drive/Dropbox)":
      "https://github.com/prakhathi-m/Profile/blob/master/Prakhathi-Resume.pdf",
    "LinkedIn profile link": "http://www.linkedin.com/in/prakhathimurugesan/",
    "Contact Details (Email)": "prakhath@buffalo.edu",
    "Anything else you'd like to share?": "http://github.com/prakhathi-m",
  },
  {
    Timestamp: "04/10/2020 22:26:59",
    "Name of the student": "S Rashmi Reddy",
    "Institute Name(College)": "Indian Institute of Technology,  Bhubaneswar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Automobiles,  Designing or any mechanical internship",
    "Period of Internship": "2 months,mid may to mid july",
    "Current Location(With Country)": "Hyderabad,",
    "Does Remote Internship work for you?": "Anywhere",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1EKv211FT4RPwYlxSLZwTZAqipgJpjR0n/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rashmi-reddy-053506153",
    "Contact Details (Email)": "rr22@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 22:31:58",
    "Name of the student": "Y Sindhu Sri",
    "Institute Name(College)":
      "National Institute of Technology Warangal(NITW)",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development Engineer",
    "Period of Internship": "6-8 weeks",
    "Current Location(With Country)": "Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Yes, Hyderabad/Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1_-A6zalKICiNjXwlaUhBVUIRzN0pIF_h",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sindhu-sri-95aa7b167?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B3O4jW5RvRRSpy2uIVyDvSg%3D%3D",
    "Contact Details (Email)": "sindusriyarlagadda@gmail.com",
    "Anything else you'd like to share?":
      "I was offered an internship by a multinational conglomerate. But due to recent consequences, I haven't received any kind of confirmation regarding the same yet. \nSo, I would like to utilize this situation properly to enrich my skills, work for a good project and progress in my career.",
  },
  {
    Timestamp: "04/10/2020 22:41:38",
    "Name of the student": "Akshay Kumar Jaiswal",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "B.Tech in Engineering Physics, 3rd year",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Analytics, Machine Learning, Business Analytics",
    "Period of Internship": "1 or 2 months. Start Date:- Anyday from today",
    "Current Location(With Country)": "Satna, MP (India)",
    "Does Remote Internship work for you?":
      "Yes. Preferred City: New Delhi, Gurgaon, Banglore, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1y5hnaRjg5YKd8O8q12W1F76djYYhL6BU/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshay-kumar-jaiswal-3319081a5",
    "Contact Details (Email)": "akshay21.iitd@gmail.com",
    "Anything else you'd like to share?":
      "I am currently pursuing Machine Learning, SQL, Python and Java that are helping me a lot to go through insights of Data Analytics. Recently, I was chosen as a Delegate for HPAIR Conference at Harvard University, Massachusetts, USA. I got the opportunity to discuss modern issues with world leaders and I also presented business solution models of implementing Internet Of Things like seat sensors and noise sensors to an NBA stadium for better fan experience for DELOITTE. My involvement in extracurricular activities has helped me grow as a person with strong Interpersonal skills. I consider myself to be a quick and dedicated learner, willing to provide complete commitment to the project I am associated with. I believe that such an opportunity would give me the skill of applying my knowledge to real-life scenarios and help me find a specific field to spend my life on. Needless to say, I am ready to put in any amount of effort that may be required to work on the internship.",
  },
  {
    Timestamp: "04/11/2020 00:36:16",
    "Name of the student": "",
    "Institute Name(College)": "Nakaar University of Law",
    "Field of study": "Law (Corporate and Commercial)",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Corporate houses, In house counsel, Private Sector Banks, Capital Market and Securities",
    "Period of Internship": "2 months. Start from July onwards.",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?":
      "Yes. Preferred city: Bangalore or Delhi, India.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TEClv_59N52j7a1lMa_GiiXDvhBpTMWB/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/prateek-gupta-india/",
    "Contact Details (Email)": "pratkgupta@gmail.com",
    "Anything else you'd like to share?":
      "Due to the Covid 19 situation, the placements in my college now stand cancelled. Looking preferably for a job as a fresher having Master of Laws degree.",
  },
  {
    Timestamp: "04/11/2020 00:56:37",
    "Name of the student": "SURBHI HARJPAL",
    "Institute Name(College)": "University of petroleum and energy studies",
    "Field of study": "B. Tech Geoinformatics Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Gis and remote sensing",
    "Period of Internship": "1 May 2020-30june 2020 (2 months)",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "harjpalsurbhi77@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 01:17:22",
    "Name of the student": "Christine Kim",
    "Institute Name(College)": "University of Pennsylvania",
    "Field of study": "Mangagement, Finance",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "finance, consulting, marketing, etc. (relatively open to anything within the business industry or non-profit sector)",
    "Period of Internship": "End of May - August",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?":
      "yes, also able to relocate (preferably Philadelphia, San Francisco, LA)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1akcvIvTsln_1kP2dVAfUowdPkOx0t27MOKMULmjJn3E/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/christine-k-202b92132/",
    "Contact Details (Email)": "kimck@wharton.upenn.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 01:17:26",
    "Name of the student": "Jayesh Sharma",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Cloud computing, Distributed systems, Full stack development",
    "Period of Internship": "2-3 months, 1st week of May",
    "Current Location(With Country)": "Agartala, Tripura, India",
    "Does Remote Internship work for you?": "yes, remote works",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1yer3x8wu1LVfBWoOu8OxXIrr-DKBSjSV/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/wjayesh/",
    "Contact Details (Email)": "js26@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 03:21:45",
    "Name of the student": "Quree Kumari",
    "Institute Name(College)": "Asansol engineering college",
    "Field of study": "Cse",
    Education: "Undergraduate",
    "Preferred domain of internship": "Java,ml,UI",
    "Period of Internship": "2 - 3 month",
    "Current Location(With Country)": "India,kolkata",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "Quree kumari",
    "Contact Details (Email)": "Myoffice123work@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 03:29:56",
    "Name of the student": "Mohith Kota",
    "Institute Name(College)": "IIIT Jabalpur",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "Any number of months. From now",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iiitdmj.ac.in/file/d/16VOuvTJYLSsBQ4BLADFJVOyKAjD7RLGM/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/mohith-kota",
    "Contact Details (Email)": "2016130@iiitdmj.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 03:40:30",
    "Name of the student": "Nani",
    "Institute Name(College)": "Indian institute of technology Tirupati",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core & non core",
    "Period of Internship": "Particularly job oriented",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "tme15b010@iittp.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 05:37:05",
    "Name of the student": "Abdul Kholia",
    "Institute Name(College)": "University of Texas at Dallas",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mechanical/Hardware Engineering",
    "Period of Internship": "May'20 till August'20",
    "Current Location(With Country)": "Dallas TX, USA",
    "Does Remote Internship work for you?":
      "Open to relocation anywhere in the US",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/samadkholia/",
    "Contact Details (Email)": "kholia97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 07:07:44",
    "Name of the student": "Alec Nickel",
    "Institute Name(College)": "Washington State University",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Scottsdale, Arizona. Or Seattle WA",
    "Period of Internship": "3-5 months, starting in May",
    "Current Location(With Country)": "Tempe, Arizona, United States",
    "Does Remote Internship work for you?":
      "Yes, my lease in Tempe starts in May",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RceZYbTaxe6pR8Xh1j5AH3fvuH_YHqVV/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/alecnickel",
    "Contact Details (Email)": "alecjn11@gmail.com",
    "Anything else you'd like to share?":
      "I am graduating with a bachelors on May 9th. I had a summer internship lined up from May to August in Scottsdale Arizona. I signed a lease two weeks before covid became out of control. My internship has been canceled, and I am looking for something in the Phoenix area, as I planned to live there to start. I currently live in Seattle, which will be a great option if I do not find anything in Arizona. My number is 425-985-5879 if you have any questions about my resume. Thank you!",
  },
  {
    Timestamp: "04/11/2020 08:11:27",
    "Name of the student": "Ruthwik",
    "Institute Name(College)": "IIITDM Kancheepuram",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product design, robotics ,Core Mechanical research",
    "Period of Internship": "1 and 3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15d47TDXxP0e9aIS0IXA1fhEfv9kN1msU/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/ruthwikdasyam/",
    "Contact Details (Email)": "ruthwikdasyam@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 08:35:00",
    "Name of the student": "GORJA SIDDHARDHA NAIDU",
    "Institute Name(College)": "Manipal Institute of Technology",
    "Field of study": "Aeronautical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Mechanical internship related to design or manufacturing",
    "Period of Internship": "4-6 months",
    "Current Location(With Country)": "Visakhapatnam, India",
    "Does Remote Internship work for you?": "Hyderabad, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15BIJCNAexpcI_lTX7MF5k9mmBkEba4TV/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out Siddhardha Naidu�s profile on LinkedIn https://www.linkedin.com/in/siddhardha-naidu-3600969b",
    "Contact Details (Email)": "siddhardh23@gmail.com",
    "Anything else you'd like to share?":
      "I'm graduated last year and I'm planning to do masters. So I want to do an internship in the gap",
  },
  {
    Timestamp: "04/11/2020 08:49:16",
    "Name of the student": "Saurabh Kumar Nagar",
    "Institute Name(College)": "Galgotias University",
    "Field of study": "MBA(Marketing & HR)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing but not for sales",
    "Period of Internship": "3",
    "Current Location(With Country)": "Greater Noida(India)",
    "Does Remote Internship work for you?": "Yes, Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1556I2BIjV1jKLohxlRRpK4lgsMYnAxBs/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saurabh-nagar-456225191",
    "Contact Details (Email)": "saurabhnagar256@gmail.com",
    "Anything else you'd like to share?":
      "I am looking for a job because due to covid-19 i am unable to get placement from the college.",
  },
  {
    Timestamp: "04/11/2020 09:02:20",
    "Name of the student": "JD Rudie",
    "Institute Name(College)": "Miami University",
    "Field of study": "Mathematics/Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering/Mathetmatics",
    "Period of Internship": "May 2020 - August 2020",
    "Current Location(With Country)": "Ohio, United States",
    "Does Remote Internship work for you?":
      "Yes open to relocate, no preference on relocation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1L8tglPGOg881KT1vB1L6vw9Ocs5lJfy5B3E9LdDZk2s/edit?usp=sharing",
    "LinkedIn profile link": "http://linkedin.com/in/jdrudie",
    "Contact Details (Email)": "rudiejd@miamioh.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 09:09:30",
    "Name of the student": "Shashank Giri",
    "Institute Name(College)": "IIM Indore",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance, Sales &Marketing",
    "Period of Internship": "8 weeks (ready to begin with immediate effect)",
    "Current Location(With Country)": "Ahmedabad (India)",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)": "Yes",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shashank-giri-6b025833/",
    "Contact Details (Email)": "shashankgiri9@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 09:32:16",
    "Name of the student": "Akshara Santharam",
    "Institute Name(College)": "SUNY Buffalo",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Software Engineering/Data Science/Data Analytics",
    "Period of Internship": "10 weeks",
    "Current Location(With Country)": "Buffalo, United States of America",
    "Does Remote Internship work for you?":
      "Yes, I am okay with any location within United States",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wuDpgA_9dtaD2PMuD1T-UIXarHUf_Ocx/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/akshara-santharam",
    "Contact Details (Email)": "aksharas@buffalo.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 09:58:13",
    "Name of the student": "Nitin Motwani",
    "Institute Name(College)": "Indian Institute of Management Kashipur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Marketing, Social Media Marketing, Digital Marketing, Research, HR",
    "Period of Internship": "2 months, 11/04/20",
    "Current Location(With Country)": "Jaipur, India",
    "Does Remote Internship work for you?":
      "Yes and if the situation improves I am ready to move to Delhi NCR and if the internship is paid, I will be ready to move to other locations as well.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://bit.ly/Nitin-resume-summer2020",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nitin-motwani-1312a3143",
    "Contact Details (Email)": "nitinmotwani96@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 10:05:25",
    "Name of the student": "KONAKANDLA ROHITH",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "ELECTRICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "CORE",
    "Period of Internship": "1 month,12/04/2020",
    "Current Location(With Country)": "GUNTUR,ANDHRA PRADESH,INDIA",
    "Does Remote Internship work for you?": "NOPE",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "kr26@iitbbs.ac.in",
    "Anything else you'd like to share?": "NOPE",
  },
  {
    Timestamp: "04/11/2020 10:08:13",
    "Name of the student": "Ajith Kumar Natarajan",
    "Institute Name(College)":
      "University at Buffalo - State University of New York",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software",
    "Period of Internship": "March 18 - August 28",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes, anywhere in US",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1jpd-CEI1Rx6VrSsoiKGAFxGChRYj1kcS",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ajithkumar-natarajan/",
    "Contact Details (Email)": "najit97@gmail.com",
    "Anything else you'd like to share?": "Thank you for the initiative!",
  },
  {
    Timestamp: "04/11/2020 10:23:36",
    "Name of the student": "Mallikarjun s s",
    "Institute Name(College)": "JNNCE",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Operstions. Marketing..analyst",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Banglore.( INDIA)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 10:58:07",
    "Name of the student": "Manoj Kumar Puppala",
    "Institute Name(College)": "BITS Pilani Hyderabad",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mechanical or Manufacturing",
    "Period of Internship": "6 months or 1year",
    "Current Location(With Country)": "Hyderabad",
    "Does Remote Internship work for you?": "yes, Vijayawada",
    "Link to Resume(Google Drive/Dropbox)":
      "file:///C:/Users/Chintu/Desktop/Manoj%20Files/Resume/Manoj%20CV%20without%20Start%20up.pdf",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/manoj-kumar-puppala-248b99187",
    "Contact Details (Email)": "f20170519@hyderabad.bits-pilani.ac.in",
    "Anything else you'd like to share?":
      "Actively looking for good ooportunity",
  },
  {
    Timestamp: "04/11/2020 11:24:02",
    "Name of the student": "Ritu Jacob",
    "Institute Name(College)": "Jesus and Mary College",
    "Field of study": "Economics (H)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance/Data Analytics/Marketing",
    "Period of Internship": "19 April-19 May",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1h7C6PjKYBSAqqODzlvSQW6VqT9tWeEnz/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/ritu-jacob-541568196",
    "Contact Details (Email)": "ritu00jacob@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 11:37:38",
    "Name of the student": "Sherin Sans",
    "Institute Name(College)": "Jesus and Mary College, University of Delhi",
    "Field of study": "Economics (honours)",
    Education: "Undergraduate",
    "Preferred domain of internship": "HR and content writing",
    "Period of Internship": "20th April,2020 ; 2-3 months of internship",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/1/mobile/folders/1518QNCltHA_-ahLQOFZar3qn9LeTyqRL?tab=ko&sort=13&direction=a",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shersans2106@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 11:46:54",
    "Name of the student": "Divyam Sood",
    "Institute Name(College)": "University of Petroleum & Energy Studies",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil & Gas",
    "Period of Internship":
      "Any duration will work between 12th April 2020 to 30th July 2020. 1-2 months preferred.",
    "Current Location(With Country)": "Kangra, Himachal Pradesh",
    "Does Remote Internship work for you?":
      "Open to Relocation anywhere in India.( Preferably North India)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1fNIlEopffUoeXEQPdguod5ehoz7XvcP0/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/divyam-sood-164574b8",
    "Contact Details (Email)": "divyamsood.sood@gmail.com",
    "Anything else you'd like to share?":
      "I am an undergraduate with experience as an intern in ONGC & Reliance Industries Ltd. I would like to help the organisation by bringing in my experience  of work and learning new things with them along the way.",
  },
  {
    Timestamp: "04/11/2020 11:56:13",
    "Name of the student": "Anuj Bansal",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study":
      "Applied petroleum engineering with specialisation in upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Upstream",
    "Period of Internship": "1.5 months",
    "Current Location(With Country)": "Karnal, haryana",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FRieijkeAOjjo7pvFoHAl040bjlgTb1P/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/anuj-bansal-3213a1170",
    "Contact Details (Email)": "500060747@stu.upes.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 11:57:36",
    "Name of the student": "Anjana Yadav",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study":
      "Applied Petroleum Engineering with specialization in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas and data science",
    "Period of Internship": "11/04/2020 (2 months)",
    "Current Location(With Country)": "Lucknow(India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1eoALPtfvvpoN-qI7B-bJnHlLE3K-xJ5r/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anjana-yadav-97ba5116a",
    "Contact Details (Email)": "anjanay135@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 11:58:11",
    "Name of the student": "Somu Suryansh",
    "Institute Name(College)": "UPES",
    "Field of study": "Applied Petroleum Engineering with Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum",
    "Period of Internship": "1.5 - 2",
    "Current Location(With Country)": "Ranchi, Jharkhand",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1THoCTcUg1TL89nZmfDQ4VLY7cN_pxAkc/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/somu-suryansh-5a9281117/",
    "Contact Details (Email)": "somusuryansh@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:01:20",
    "Name of the student": "Anirudh Joshi",
    "Institute Name(College)": "UPES",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas",
    "Period of Internship": "1 to 2 months",
    "Current Location(With Country)": "Jaipur India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "anirudhjoshi92@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:02:42",
    "Name of the student": "Shashank Tiwari",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study":
      "Applied Petroleum engineering with specialization in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Engineering",
    "Period of Internship": "1 months and 15 days, 1st May to 15th June",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, preferred city- Dehradun, Bhilai, Raipur, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18H-SxAt3sC7MBLZAMZKsaMKmkjKDJwIg/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shashank-tiwari-bbb614159",
    "Contact Details (Email)": "shashanktiwari989@gmail.com",
    "Anything else you'd like to share?":
      "I am a quick learner and I follow the principle of Ethics.",
  },
  {
    Timestamp: "04/11/2020 12:04:56",
    "Name of the student": "Reddimi Sai Sampath Reddy",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum",
    "Period of Internship": "1-2 months, 1st May",
    "Current Location(With Country)": "Visakhapatnam",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://s.docworkspace.com/d/AKLheN6Q77o9obe2vsCdFA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/reddimi-sai-sampath-reddy-645ba817a",
    "Contact Details (Email)": "s.sampathreddy14@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:05:03",
    "Name of the student": "RUTHALA SUMANTH NAIDU",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies, Dehradun",
    "Field of study": "Petroleum (Oil and Gas) Engineer",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and Gas",
    "Period of Internship": "2 months (13th April 2020-15th June 2020)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes (Anywhere in India)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=10fCiInJeKiix_lMRacJXCXqFp8ovc8fe",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sumanth-naidu-442748159.",
    "Contact Details (Email)": "sumanthnaidu98@gmail.com",
    "Anything else you'd like to share?":
      "As the present situation is not good, Please provide a good internship related to oil and gas field as it will be beneficial for us in future. I am ready to work from home or remote area.",
  },
  {
    Timestamp: "04/11/2020 12:08:34",
    "Name of the student": "Ashutosh Mathur",
    "Institute Name(College)": "UPES",
    "Field of study": "APE- Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "E&P",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-KCzbrofeCtVVN_OavMe3zSjOtC5VXJf",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ashutosh-mathur-75973817a",
    "Contact Details (Email)": "ashutoshmathur777@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:08:41",
    "Name of the student": "Ritik Pant",
    "Institute Name(College)": "University of Petroleum And Energy Studies",
    "Field of study":
      "B.Tech Applied Petroleum Engineering with specialization in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil & Gas",
    "Period of Internship": "6 weeks - 1 May to 15 June",
    "Current Location(With Country)": "Nainital, Uttarakhand (India)",
    "Does Remote Internship work for you?":
      "No, I am looking for a work from home internship completely.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1dbmwl0iExpkn4LrDIYDj65AYxKFwWBSPELyYQ1tQzGA/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritik-pant-015501180/",
    "Contact Details (Email)": "pantritik02@gmail.com",
    "Anything else you'd like to share?":
      "I am a B.Tech Applied Petroleum Engineering student with Specialization in Upstream looking for work from home internship in the field of oil & gas data analytics.",
  },
  {
    Timestamp: "04/11/2020 12:08:49",
    "Name of the student": "Shrinjoy Maiti",
    "Institute Name(College)": "UPES",
    "Field of study":
      "B.Tech Applied Petroleum Engineering with specialization in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and Gas",
    "Period of Internship": "1 May to 12 June",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1BQ41xxcwo0yPQDLKqdyeJkYdaYhp0fFJ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/shrinjoy-maiti-b64665170",
    "Contact Details (Email)": "maiti1998shrinjoy@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/11/2020 12:10:29",
    "Name of the student": "Yash A Shah",
    "Institute Name(College)": "Vellore institute of technology, Vellore",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mechanical, Aerospace",
    "Period of Internship": "6 months (Start anytime after July)",
    "Current Location(With Country)": "Kozhikode, Kerala",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14KfRWxfOOHGOKOw_SDIcZZB2Zno1LYQz/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "yashshah9698@gmail.com",
    "Anything else you'd like to share?":
      "Looking forward to learn something new and gain vital working skills",
  },
  {
    Timestamp: "04/11/2020 12:10:32",
    "Name of the student": "Kumar vatsal",
    "Institute Name(College)": "University of petroleum and energy studies",
    "Field of study": "B.tech Applied petroleum engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum engineering, marketing",
    "Period of Internship": "May to june",
    "Current Location(With Country)": "Lucknow, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1C-DOW9Flwb-wMzjifN9KjLKRMA0VzOgUG8wvwqDSqwM/edit?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kumar-vatsal-9a2b8a179",
    "Contact Details (Email)": "kvatsal2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:11:05",
    "Name of the student": "Polaki Dinesh",
    "Institute Name(College)": "UPES",
    "Field of study":
      "Applied petroleum engineering with specialization in upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum",
    "Period of Internship": "1 May to 1 June",
    "Current Location(With Country)": "Dehradun, India",
    "Does Remote Internship work for you?": "Yes, Dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uzdEYEN20ng9ixPxTN0mgZjk0GZswbXk/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dinesh-polaki-9704304b",
    "Contact Details (Email)": "dineshpolaki@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:19:59",
    "Name of the student": "Akshit Kamboj",
    "Institute Name(College)": "University of petroleum and energy studies",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Upstream Sector",
    "Period of Internship": "30 days",
    "Current Location(With Country)": "Yamunanagar, Haryana",
    "Does Remote Internship work for you?": "Yes, Any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1nW27Nvpahepdq935zZM1ylJaEaygeavR/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshit-kamboj-22860b17b",
    "Contact Details (Email)": "akshit.kamboj06@gmail.com",
    "Anything else you'd like to share?":
      "Please give me an opportunity to work in any company. I'll not let that down",
  },
  {
    Timestamp: "04/11/2020 12:21:22",
    "Name of the student": "Adarsh Kumar",
    "Institute Name(College)": "UPES DEHRADUN",
    "Field of study": "Btech APE-UP",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 month",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Patna",
    "Link to Resume(Google Drive/Dropbox)": "Ok",
    "LinkedIn profile link": "Adarsh Kumar",
    "Contact Details (Email)": "kumaradarsh151998@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/11/2020 12:24:06",
    "Name of the student": "Harshit Gupta",
    "Institute Name(College)": "University of petroleum and energy studies",
    "Field of study": "Petroleum engineering (upstream)",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "1may to 15june",
    "Current Location(With Country)": "Kanpur(Uttar Pradesh) india",
    "Does Remote Internship work for you?": "Dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1R73JkDDxhv9h2DYQBMb-P6XVQG2T8Bt_/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/harshitgupta-7a438515b",
    "Contact Details (Email)": "hg2911998@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:26:02",
    "Name of the student": "Anuj Bhatia",
    "Institute Name(College)": "UPES",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Engineering",
    "Period of Internship": "1st May-15th June",
    "Current Location(With Country)": "Meerut -  Uttar Pradesh",
    "Does Remote Internship work for you?":
      "Yes- Willing to relocate to any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/stu.upes.ac.in/file/d/1cKJ6kDuFqow5PDkVYubPj_zjD2Jvj18t/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anuj-bhatia-948357153",
    "Contact Details (Email)": "anujbhatia498@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:28:41",
    "Name of the student": "Pranjal Mehrotra",
    "Institute Name(College)":
      "University of petroleum and energy studies(UPES)",
    "Field of study": "Petroleum engineering with specialization in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Domain (mainly upstream)",
    "Period of Internship": "1st may-15 june",
    "Current Location(With Country)": "Allahabad(India)",
    "Does Remote Internship work for you?": "no",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VmjEOaB681d8c70NEdSemj46ncgX8ZA3/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pranjal-mehrotra-a5665114b",
    "Contact Details (Email)": "pranjalmehrotra123@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:29:33",
    "Name of the student": "Anuvrat Jhamad",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies, Dehradun",
    "Field of study": "B.Tech in Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum engineering",
    "Period of Internship": "2 months, 1st May to 30th June",
    "Current Location(With Country)": "India, Indore",
    "Does Remote Internship work for you?":
      "Yes, Mumbai, Pune, Ahmedabad, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/stu.upes.ac.in/file/d/1EDjpRvXYRQjH71xNQ4IpJ2QKcVezvtYm/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anuvrat-jhamad-811277181",
    "Contact Details (Email)": "Anuvrataj@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:42:00",
    "Name of the student": "Angel Susan John",
    "Institute Name(College)": "Jesus and Mary College, University of Delhi",
    "Field of study": "B.A Economics (H), 2nd year",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Public policy, Research, Development sector",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Dwarka, Delhi, India",
    "Does Remote Internship work for you?": "Delhi, Kochi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1IC9BQr4Npg0VZZ81bvkpssXMORU0eYf3/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/angel-susan-john",
    "Contact Details (Email)": "angeejohn13@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:47:16",
    "Name of the student": "Gyanendra Sharma",
    "Institute Name(College)": "University of Petroleum and Energy Studies.",
    "Field of study":
      "Applied petroleum engineering with specialization in upstream.",
    Education: "Undergraduate",
    "Preferred domain of internship": "Field or Desk internship",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "Bharatpur, Rajasthan (India)",
    "Does Remote Internship work for you?":
      "Yes, preferred cities would be Jaipur and Dehradun.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11mls1OgVrsvr1ttchX9ECDUE2cis4lzN/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gyanendra-sharma-691699179",
    "Contact Details (Email)": "gya7665@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:47:48",
    "Name of the student": "Anurag Mandal",
    "Institute Name(College)": "Indian Institute of Management Tiruchirappalli",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Analytics, Digital Marketing, Operations Management",
    "Period of Internship": "2 months starting before the end of April 2020",
    "Current Location(With Country)": "Ranchi",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iimtrichy.ac.in/file/d/1GWwXrux7S2eW-nRBOpZNbkh4QidMu_cL/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/ anurag-mandal-7a75ab18a",
    "Contact Details (Email)": "anurag.p19066@iimtrichy.ac.in",
    "Anything else you'd like to share?":
      "I would like to start as soon as possible.",
  },
  {
    Timestamp: "04/11/2020 12:49:51",
    "Name of the student": "Ridhi Puppala",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Mechanical Engineering, Robotics",
    Education: "Dual Degree (B.Tech in Mechanical + M.Tech in Robotics)",
    "Preferred domain of internship":
      "Robotics, Computer Vision, Machine Learning, Controls, System Modelling",
    "Period of Internship": "3 -12 months, Start date - 1 July 2020 or later",
    "Current Location(With Country)": "Hyderabad, Telangana, India",
    "Does Remote Internship work for you?":
      "Yes. Relocation accross any place in India. Preferably, Bengaluru, Chennai, Delhi, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GsGyLfBCw7VoyghqeFBYltmMGKNEn1YV/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ridhi-puppala-239756107/",
    "Contact Details (Email)": "puppala.ridhi.work@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 12:54:44",
    "Name of the student": "Priyanka Kumari",
    "Institute Name(College)": "Xavier Institute of Social Service",
    "Field of study": "Rural management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Management",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Dhanbad, India",
    "Does Remote Internship work for you?": "Yes, Rajasthan",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZFUXZwKbisxr7RSdNNrNpXjdut4E88hT/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyanka-kumari-a805b079",
    "Contact Details (Email)": "priyanka72282@gmail.com",
    "Anything else you'd like to share?":
      "I am also looking for virtual i.e. online work and full time proper job as I have completed my PGDM in Rural Management this year.",
  },
  {
    Timestamp: "04/11/2020 12:56:59",
    "Name of the student": "Aniket Tyagi",
    "Institute Name(College)": "UNIVERSITY OF PETROLEUM AND ENERGY STUDIES",
    "Field of study": "Petroleum engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Upstream sector in Petroleum",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Delhi,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MWx1OmiXBk1OyK1tDoD9KY9su_RD0xC1/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "meanikettyagi@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 13:00:15",
    "Name of the student": "Samridhee Sah",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study":
      "Applied Petroleum Engineering with Specialization in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Reservoir/Drilling",
    "Period of Internship": "1st May to 15th june",
    "Current Location(With Country)": "Raigarh,Chattisgarh(India)",
    "Does Remote Internship work for you?":
      "Yes,I  am ready to relocate if situation improves.I would choose somewhere near to my current location.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1HbtvxJ4i-u0vqt2hIDfS71k3QzBvcgyK/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/samridhee-sah-176138169",
    "Contact Details (Email)": "sahsamridhee@gmail.com",
    "Anything else you'd like to share?":
      "I would wish to add that I am currently doing some Oil & Gas courses in Coursera that will make my technical knowledge more productive. I am also taking up computer programming courses to learn to code.",
  },
  {
    Timestamp: "04/11/2020 13:03:53",
    "Name of the student": "Prakram Rathore",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study":
      "Applied Petroleum Engineering with specialization in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and Gas",
    "Period of Internship": "2 months, 1/05/2020",
    "Current Location(With Country)": "Jaipur,Rajasthan,India",
    "Does Remote Internship work for you?": "Dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1azwZ-t1ys6N8GsZHiCw7MFqsMFaLA3le/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prakram-rathore-4a7238173/",
    "Contact Details (Email)": "prakramrathore@gmail.com",
    "Anything else you'd like to share?":
      "Would like to explore more of me and the industry.",
  },
  {
    Timestamp: "04/11/2020 13:09:37",
    "Name of the student": "Devasya Shrivastava",
    "Institute Name(College)":
      "Jaypee Institute of Information Technology, Noida.",
    "Field of study": "Electronics and communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing analystics",
    "Period of Internship": "3 months starting ASAP (immediately)",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?":
      "Yes, Banglore, Pune, Hyderabad, Gurugram and Delhi.",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://drive.google.com/file/d/1VFFh_Cy0OF2xx_rRCo6TvpHQZxwbwEgw/view?usp=drivesdk",
    "Contact Details (Email)": "dev26anshu@gmail.com",
    "Anything else you'd like to share?":
      "This is a great initiative, thankyou.",
  },
  {
    Timestamp: "04/11/2020 13:14:03",
    "Name of the student": "Hemant Srivastava",
    "Institute Name(College)": "UPES",
    "Field of study": "Petroleum engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science",
    "Period of Internship": "1-2",
    "Current Location(With Country)": "UP, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ERCXv0luoTcu95gJaiIwwwZL2jwR-eKK/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/hemant-srivastava-2b852a173",
    "Contact Details (Email)": "hemantsrivastava139@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 13:15:22",
    "Name of the student": "Saurabh Semalti",
    "Institute Name(College)": "UPES",
    "Field of study": "engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas sector",
    "Period of Internship": "45 days starting from 1st may",
    "Current Location(With Country)":
      "249,Shamsergarh crossing, Miyanwala, Dehradun, Uttarakhand, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1_wjfNxATj2D5r6YndEn7HwCT8NbenegX/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "saurabhsemalti16@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 13:17:58",
    "Name of the student": "SYED AMAN HAIDER",
    "Institute Name(College)": "UPES",
    "Field of study":
      "B.tech in Petroleum engineering speicalization in upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil & Gas and Energy sector",
    "Period of Internship": "45 DAYS (1 MAY-15 JUNE)",
    "Current Location(With Country)": "INDIA",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/1/my-drive",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aman-haider-b92193178",
    "Contact Details (Email)": "aman.haider131@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 13:20:32",
    "Name of the student": "Aman Kumar",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study":
      "B. Tech in Applied Petroleum Engineering with specializaton in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and Gas domain related",
    "Period of Internship":
      "I am looking for at least one month or approximately 45 days internship. I would be happy enough as soon as it starts because now due to Corona Virus pandemic the colleges are also closed, and myself being a 3rd year undergraduate is actively looking for an internship. Hence, I would prefer if the internship commences in April itself.",
    "Current Location(With Country)": "Bhagalpur, Bihar",
    "Does Remote Internship work for you?":
      "Yes, I am happy to do remote internship. I am also open to relocate if the situation improves and Lockdown gets over. Frankly speaking, I have no preferred city choice and I am happy to work anywhere in India. But in such critical circumstances of Corona Virus pandemic, I would request you to please let me work close to my home if possible.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1obWFXXeyrhLmeFzvXuhtwEyl6pDbj0DH/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/aman-kumar-3516a116b",
    "Contact Details (Email)": "aman64121@gmail.com",
    "Anything else you'd like to share?": "No Sir.",
  },
  {
    Timestamp: "04/11/2020 13:26:11",
    "Name of the student": "Anhad Taneja",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Domain, Management",
    "Period of Internship": "1-2 Months....start immediately",
    "Current Location(With Country)": "Agra, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1bCLPSwk3qGy9E3Ex2-7BdqwJQyzkYfr_",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anhad-taneja-b15943147",
    "Contact Details (Email)": "anhadt@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 13:55:04",
    "Name of the student": "Neethesh Kumar Jayaraman",
    "Institute Name(College)": "UPES",
    "Field of study":
      "Applied petroleum engineering with specialization in upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Chennai",
    "Does Remote Internship work for you?": "Yes, Any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=16bVpE3s6pEHH0xKKgeD8icBITSx26Oty",
    "LinkedIn profile link": "http://www.linkedin.com/in/neethesh-jayaraman",
    "Contact Details (Email)": "neetheshkumar@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 14:35:34",
    "Name of the student": "Aman Pratap Singh Rajvi",
    "Institute Name(College)": "MDI Gurgaon",
    "Field of study": "Marketing and International Business",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "4 Months - May'20-August'20",
    "Current Location(With Country)": "SriGanganagar, Rajasthan, India",
    "Does Remote Internship work for you?":
      "Yes, Open for relocation to Gurgaon, Pune, Jaipur or Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Csp68JBWkgZdOZAWH9sXvhI_p1zZ8OIp/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/apsrajvi/",
    "Contact Details (Email)": "apsrajvi@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 14:47:26",
    "Name of the student": "Ishita Gupta",
    "Institute Name(College)": "Indian Institute of Technology Delhi",
    "Field of study": "Electrical Engineering (Power and Automation)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Data Analytics, Strategy and Consulting",
    "Period of Internship": "flexible with dates",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15xZAjusUvQd498xEyLss4pR27lt6HBLD/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ishita-gupta-8496b2143/",
    "Contact Details (Email)": "meepishita@gmail.com",
    "Anything else you'd like to share?":
      "I recently lost my internship at a SP500 US based Tech and Research firm. I am committed to learning and making the most out of this experience, please do let me know about any opportunities you might have :)",
  },
  {
    Timestamp: "04/11/2020 14:59:01",
    "Name of the student": "Sandeep Pareek",
    "Institute Name(College)": "Christ University, Bangalore",
    "Field of study": "Corporate finance or anything available",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months ( 12/04/2020)",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "Yes Anywhere within country",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AzLdYJ-mKxP6ZJgLWI7VtsuheheD_iu4/view?usp=drivesdk",
    "LinkedIn profile link": "LinkedIn.com/in/sandeep-pareek-649674bb",
    "Contact Details (Email)": "sandeeppareek300@gmail.com",
    "Anything else you'd like to share?":
      "I need internship at any cost it's disturbing my future, don't know what will happen .",
  },
  {
    Timestamp: "04/11/2020 15:04:16",
    "Name of the student": "Deepak Jangid",
    "Institute Name(College)": "IIT Roorkee",
    "Field of study": "Applied Mathematics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Development and UX/UI Design",
    "Period of Internship": "2 month from 15 April",
    "Current Location(With Country)": "Rajasthan, India",
    "Does Remote Internship work for you?":
      "Yes, Bangalore, Delhi, Gurgaon, Indore,  Guwahati",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1gUOgYxhWopaNKfdVzwBoLJdncBQgycid",
    "LinkedIn profile link": "https://www.behance.net/deepak8504",
    "Contact Details (Email)": "djangid@ma.iitr.ac.in",
    "Anything else you'd like to share?": "https://www.behance.net/deepak8504",
  },
  {
    Timestamp: "04/11/2020 15:09:18",
    "Name of the student": "Swapnil Rana",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study":
      "B.Tech in Applied Petroleum Engineering with specialization in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Peteoleum Engineering, Data Analysis",
    "Period of Internship": "1-2months,",
    "Current Location(With Country)": "Dehradun, India",
    "Does Remote Internship work for you?": "Yes, Mumbai, Gujarat",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1syg8acw2iq7W95oAiusAljV-cpZ1lrRF/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/swapnil-rana-7b1279198",
    "Contact Details (Email)": "500060104@stu.upes.ac.in",
    "Anything else you'd like to share?":
      "I am an engineering student and have keen interest in technology. Amidst the ongoing COVID-19 outbreak I am a suitable candidate for Home-internship as I can stay engaged in front of my laptop for hours. \nWhen it comes to technology I can self ignite huge interest in anything new easily and would love to gain practical knowledge through the internship.",
  },
  {
    Timestamp: "04/11/2020 16:15:22",
    "Name of the student": "Sahil Gupta",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electrical Engineering",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "New Delhi,India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1hC2S18WLag7uvLQcTjL2I50IbgiCHWvB/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sahil-gupta-509100165",
    "Contact Details (Email)": "27sahilgupta@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 16:18:14",
    "Name of the student": "Rohit Sikarwar",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Full Stack Web development",
    "Period of Internship": "2 month, iany date",
    "Current Location(With Country)": "Agra,UttarPradesh ,India",
    "Does Remote Internship work for you?": "Yes, Noida , Gurgaon, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/my-dr%20ive",
    "LinkedIn profile link": "www.linkedin.com/in/rohit-sikarwar1998",
    "Contact Details (Email)": "rohitsikarwar1998@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 16:59:21",
    "Name of the student": "Purvi Mandot",
    "Institute Name(College)": "The LNM Institute of Information Technology",
    "Field of study": "Computer and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science/Machine Learning/Deep Learning",
    "Period of Internship": "2 months,1st May",
    "Current Location(With Country)": "Udaipur - Rajasthan, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://documentcloud.adobe.com/link/review?uri=urn%3Aaaid%3Ascds%3AUS%3A3284fd42-816f-44ed-9e3b-dc3eab6a334b",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/purvi-mandot-985280152?originalSubdomain=in",
    "Contact Details (Email)": "17ucc044@lnmiit.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 17:21:10",
    "Name of the student": "HARSHIL PATHAK",
    "Institute Name(College)":
      "Search Results Web results  Faculty of Management Studies,MSU, Baroda",
    "Field of study": "operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "operations",
    "Period of Internship": "1",
    "Current Location(With Country)":
      " gf-2, soham appartment, cosmic enclave society, behind kalyan hall, sama, vadodara, Gujarat, India. PIN 390008",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=16jFDlT8qfCnBnF1L1oEwDeEEKNrGlHDX",
    "LinkedIn profile link": "www.linkedin.com/in/harshil-pathak-a32b8b72",
    "Contact Details (Email)": "pathakharshil30@gmail.com",
    "Anything else you'd like to share?": "-",
  },
  {
    Timestamp: "04/11/2020 18:00:11",
    "Name of the student": "Nishit Chhabra",
    "Institute Name(College)": "UPES",
    "Field of study": "APE Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas",
    "Period of Internship": "Atleast 1 month",
    "Current Location(With Country)": "Jamshedpur, Jharkhand, India",
    "Does Remote Internship work for you?": "Yes sure",
    "Link to Resume(Google Drive/Dropbox)": "Contact me for a CV",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nishit-chhabra-923837185",
    "Contact Details (Email)": "nshtchhabra16@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 18:12:23",
    "Name of the student": "Uzer Nizamudeen",
    "Institute Name(College)": "Saveetha Engineering College",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Logistics and Marketing",
    "Period of Internship": "3 Months",
    "Current Location(With Country)":
      "3/5, Bharathiyar Street, Chenguttai Katpadi, Vellore, Tamilnadu, India.",
    "Does Remote Internship work for you?": "Bangalore, Chennai and anywhere",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ppWHqbZeYGyvwfi-MTRrkYStdmFimNBs/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/uzer-nizamudeen-34bb07157",
    "Contact Details (Email)": "uzernizam03@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/11/2020 18:22:23",
    "Name of the student": "Shivansh Mittal",
    "Institute Name(College)":
      "Maharaja Agrasen Institute of Technology, New Delhi",
    "Field of study": "B.Tech(IT)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 months - 8th June'20",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GzO1KomTGENMT0P5WOW_r8ShNpgJqZRD/view",
    "LinkedIn profile link": "https://www.linkedin.com/in/shivansh2502/",
    "Contact Details (Email)": "shivanshmittal25@gmail.com",
    "Anything else you'd like to share?":
      "I got an internship at IHS Markit for this summer but it got canceled due to COVID-19.",
  },
  {
    Timestamp: "04/11/2020 18:30:48",
    "Name of the student": "Dheeraj Chaudhary",
    "Institute Name(College)": "IIIT Dharwad",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "ML/DL/Computer vision",
    "Period of Internship": "2 months ( 22nd May,2020 - 22nd July,2020)",
    "Current Location(With Country)": "Gorakhpur, Uttarpradesh (INDIA)",
    "Does Remote Internship work for you?": "Yes, Bengaluru",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iC9hXMNeKRhgNb0-2FANAKnogFg4EGYn/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/dheeraj-2000",
    "Contact Details (Email)": "17bcs009@iiitdwd.ac.in",
    "Anything else you'd like to share?":
      "I can also relocate to Delhi, Mumbai during the internship period if lockdown is over or Can work remotely also from Home, if the situation stays like this.\nI'm working on a research project which is basically to Smartly Monitor the Classrooms using ML/Deep Learning techniques, more than half of our final results have been achieved. \nAlso working on one more Research project of Finding Pseudocores in the domain of Social Network Analysis.",
  },
  {
    Timestamp: "04/11/2020 18:58:44",
    "Name of the student": "Kerthanya M S",
    "Institute Name(College)": "PSG College of Technology",
    "Field of study": "Biotechnology",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Biotechnology, Finance",
    "Period of Internship": "1-2 months May mid",
    "Current Location(With Country)": "Nilgiris India",
    "Does Remote Internship work for you?":
      "yes! coimbatore, chennai, bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1H-lAuHYnri_iTC_ZuQQcxESXsyUugCD9",
    "LinkedIn profile link": "www.linkedin.com/in/kerthanyamahesh20",
    "Contact Details (Email)": "kerthu20@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:00:20",
    "Name of the student": "Darshit Gadhiya",
    "Institute Name(College)": "ITM University, Vadodara",
    "Field of study": "Automobile Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Event Management, Any type of vehicle realted Electric,",
    "Period of Internship": "3 months, & from any starting date",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Any city",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/darshit-gadhiya-351076127",
    "Contact Details (Email)": "gadhiyadarshitd@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:03:58",
    "Name of the student": "Vanita Godwani",
    "Institute Name(College)":
      "Prin l n welingkar's institute of management development and research",
    "Field of study": "Business Design_Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months (1 may 2020 to 30 June 2020)",
    "Current Location(With Country)": "Mumbai India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Hj1nJBYRLoAidRCOzkSz_tgh9ldt0Y73/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vanita-godwani-63992ba8/",
    "Contact Details (Email)": "vanitagodwani96@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:04:01",
    "Name of the student": "Vanita Godwani",
    "Institute Name(College)":
      "Prin l n welingkar's institute of management development and research",
    "Field of study": "Business Design_Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months (1 may 2020 to 30 June 2020)",
    "Current Location(With Country)": "Mumbai India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Hj1nJBYRLoAidRCOzkSz_tgh9ldt0Y73/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vanita-godwani-63992ba8/",
    "Contact Details (Email)": "vanitagodwani96@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:08:49",
    "Name of the student": "Rahul Narasimhan R",
    "Institute Name(College)": "IIITDM Kancheepuram",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Project management/Systems engineering",
    "Period of Internship": "3 months. 15 April - July 15",
    "Current Location(With Country)": "Chennai-Tamil Nadu-India",
    "Does Remote Internship work for you?":
      "Remote internship works. I can also relocate if necessary later.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dG44PDuBZ7qwxJ2zzDKYc8EY51mJ1jDJ/view?usp=sharing",
    "LinkedIn profile link":
      "http://linkedin.com/in/rahul-narasimhan-b7137917a",
    "Contact Details (Email)": "rahulonrp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:08:57",
    "Name of the student": "Navneet  Kumar",
    "Institute Name(College)": "Indian Institute of Technology (BHU),Varanasi",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Coding (C++) or Structures in Aerospace and Civil Engineering",
    "Period of Internship": "2 months 10/04-10/06",
    "Current Location(With Country)": "Uttarpradesh India",
    "Does Remote Internship work for you?": "Yes,Any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VhNO3IPgcAZQhh5Um4x8SsiW_ryWfHIb/view?usp=sharing",
    "LinkedIn profile link": "-",
    "Contact Details (Email)": "navneet.kumar.civ17@itbhu.ac.in",
    "Anything else you'd like to share?": "-",
  },
  {
    Timestamp: "04/11/2020 19:20:18",
    "Name of the student": "Ankur kumar singh",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research, Mumbai",
    "Field of study": "Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Fintech",
    "Period of Internship": "2 months (1st May is the start date)",
    "Current Location(With Country)": "Mumbai (India)",
    "Does Remote Internship work for you?": "Yes, Delhi or Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-G3x5mgsoK0WnlYytHtCDAYwwLHSAGuV/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ankur-singh-080059109",
    "Contact Details (Email)": "Kumarankursingh007@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:20:47",
    "Name of the student": "Anvieta Sreekrisshna",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1t4C_TDoOR6eec0CISrT75BXuUoFuxeWV/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/anvieta-sreekrisshna-988854168",
    "Contact Details (Email)": "anvieta.sree.we@gmail.com",
    "Anything else you'd like to share?":
      "Marketing is vital in order to have a relevant business and I would be ecstatic to be a part of an esteemed organisation respectively.",
  },
  {
    Timestamp: "04/11/2020 19:28:56",
    "Name of the student": "Drashti Vora",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research, Mumbai",
    "Field of study": "Research and Business Analytics (Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance / Analytics",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?":
      "Yes. I am comfortable with a remote Internship and would prefer to work in Mumbai once the situation improves",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/117ysUtmkdgiq3i15jp339FeCkt1duQEh/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/drashti-vora-254429177",
    "Contact Details (Email)": "drashtivora11@gmail.com",
    "Anything else you'd like to share?":
      "I am actively looking for a summer internship in Finance/ Analytics/Market research",
  },
  {
    Timestamp: "04/11/2020 19:31:17",
    "Name of the student": "Shivendu Sinha",
    "Institute Name(College)": "Weschool Bangalore",
    "Field of study": "Pgdm Ebusiness",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics>Operations>Marketing>HR",
    "Period of Internship": "2months (4thMay, 2020)",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "Better to provide upload facility.",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivendu-sinha-249753b3",
    "Contact Details (Email)": "shivendu.sinha.we@gmail.com",
    "Anything else you'd like to share?":
      "Thanks for the initiative. For RESUME would suggest upload facility.",
  },
  {
    Timestamp: "04/11/2020 19:33:04",
    "Name of the student": "Rashi Kataruka",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research,Mumbai",
    "Field of study": "MBA (marketing)",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Business development and Research Analytics",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://s.docworkspace.com/d/ACzosgex3Jsu4dL5_66dFA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rashi-kataruka-9695b6168",
    "Contact Details (Email)": "katarukarashi@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:33:45",
    "Name of the student": "Mayur Deshmukh",
    "Institute Name(College)":
      "Welingkar Institute of Management Development & Research, Bangalore",
    "Field of study": "Operations, Analytics, SCM, Project Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Operations- IT Operations, PM; Data Analytics; Financial Research",
    "Period of Internship": "2",
    "Current Location(With Country)": "Nanded, India",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XJ8FpmTnJXIiNBfu7m8TGJhuN8AFF0Fb/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mayur-deshmukh-72066437/",
    "Contact Details (Email)": "mayur.deshmukh.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:34:35",
    "Name of the student": "Samiksha Jain",
    "Institute Name(College)": "IIT BHU Varanasi",
    "Field of study": "Data Science/SDE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science / SDE",
    "Period of Internship": "2 months ( Immediate joining)",
    "Current Location(With Country)": "Jaipur (Rajasthan) India",
    "Does Remote Internship work for you?":
      "Yes (open to relocate - no city preference)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1SKtk8PTYfs7boOOPFCr8Reg5rolHrv8x",
    "LinkedIn profile link": "http://linkedin.com/in/samiksha-jain-9a415b149",
    "Contact Details (Email)": "samsv2110@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:36:50",
    "Name of the student": "Vrushti Shah",
    "Institute Name(College)": "CEPT University",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Sustainability",
    "Period of Internship": "6 months (14/06/20- start)",
    "Current Location(With Country)": "Vadodara, India",
    "Does Remote Internship work for you?": "Yes, in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1K5mYD8b_lrHJ8M1he3EtHWNpR48INhxg/view?usp=drivesdk",
    "LinkedIn profile link": "-",
    "Contact Details (Email)": "vrushti1098@gmail.com",
    "Anything else you'd like to share?": "-",
  },
  {
    Timestamp: "04/11/2020 19:39:41",
    "Name of the student": "Anjali Singh",
    "Institute Name(College)":
      "Prin. L. N Welingkar Institute of Management and Development Research",
    "Field of study": "PGDM Retail Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 - 3 months",
    "Current Location(With Country)": "India - Mumbai",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1blfc1zOecjLekByLNl_6i-leSVHuE8LK",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anjali-singh-8ab378182",
    "Contact Details (Email)": "singhanjal05@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:39:41",
    "Name of the student": "Nikhil Chowdary Kotha",
    "Institute Name(College)":
      "Indian Institute of Information Technology Design and Manufacturing Kancheepuram",
    "Field of study": "ECE with specialisation in Design and Manufacturing",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electronics",
    "Period of Internship": "July 15 - Dec 15",
    "Current Location(With Country)": "Hyderabad, Telangana, India.",
    "Does Remote Internship work for you?":
      "Fine with relocation; as per demand.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aNJ0htOY_ASYUXC72NcTU6mLQ1BoMI6K/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sunnyhanu74@gmail.com",
    "Anything else you'd like to share?":
      "This platform is a saviour ! Thanks for the initiative",
  },
  {
    Timestamp: "04/11/2020 19:43:24",
    "Name of the student": "Krishnakumar Thangavel",
    "Institute Name(College)": "IIITDM KANCHEEPURAM",
    "Field of study": "Mechanical smart manufacturing",
    Education: "Undergraduate",
    "Preferred domain of internship": "Design, Mechanical, IoT",
    "Period of Internship": "5-6 Months",
    "Current Location(With Country)": "Chennai - India",
    "Does Remote Internship work for you?": "Yes, Anywhere in India",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/iamkkt",
    "Contact Details (Email)": "msm17b026@iiitdm.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:47:42",
    "Name of the student": "Shreyas Pawar",
    "Institute Name(College)": "Indian Institute of Technology, Goa",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Research internship in IOT or related field",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Nashik, Maharashtra, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1awgDyFQJmxCqyMwe30lDNgWPjjG5K5XX/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shreyas-pawar-790199178",
    "Contact Details (Email)": "shreyaspawar0610@gmail.com",
    "Anything else you'd like to share?":
      "I have done the basic iot course, I have lead the technical team of IIT Goa for the techfest of bits Goa. I have also been an active member of electronic and robotics club of IIT Goa.",
  },
  {
    Timestamp: "04/11/2020 19:48:40",
    "Name of the student": "Shivdutt kumar",
    "Institute Name(College)":
      "Prin L.N Welingker institute of management and  development research",
    "Field of study": "Retail management- Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing/ Brand positioning",
    "Period of Internship": "2",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "Yea",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "www.linkedin.com/in/shiv dutt-kumar-3720a3192/",
    "Contact Details (Email)": "shivdutt.nittin@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/11/2020 19:55:50",
    "Name of the student": "Ganeshprasad Shenoy",
    "Institute Name(College)": "Manipal Institute of Technology",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Mobile Application Development using Flutter",
    "Period of Internship": "2",
    "Current Location(With Country)": "Thane, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dKMfeY79Dp0j3xX4SEk_tAKi8Y-lEkW_/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ganeshprasad-shenoy-562930169/",
    "Contact Details (Email)": "shenoyganeshprasad@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:57:34",
    "Name of the student": "Manonmani",
    "Institute Name(College)": "IIITDM KANCHIPURAM",
    "Field of study": "Mechanical with design",
    Education: "Undergraduate",
    "Preferred domain of internship": "Manufacturing, design",
    "Period of Internship": "6 months ( mid may)",
    "Current Location(With Country)": "Chennai",
    "Does Remote Internship work for you?": "Anywhere in South India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1GYUutBchUasxBgx51gTgQInfXx10M_em",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "21099mano@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 19:57:41",
    "Name of the student": "Mayur Walunj",
    "Institute Name(College)":
      "Prin.L.N.Welingkar institute of management development and research, mumbai",
    "Field of study": "Healthcare management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "It for healthcare, medical devices or operations",
    "Period of Internship": "2 months: 01-may to 30-june",
    "Current Location(With Country)": "Kalyan",
    "Does Remote Internship work for you?": "Yes, Mumbai or Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1FL7g-SytsHxs8tgBBayNCekRukgRsAMx",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mayur-walunj-1a30bab2",
    "Contact Details (Email)": "mayurwalunj27@gmail.com",
    "Anything else you'd like to share?":
      "Hello, I know C, embedded C, python, SQL programming languages, currently looking for internship in healthcare domain only.",
  },
  {
    Timestamp: "04/11/2020 20:04:08",
    "Name of the student": "Radhika Wagh",
    "Institute Name(College)": "Prin L N Welingkar Institute of Management",
    "Field of study": "Mba",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "May and June",
    "Current Location(With Country)": "Maharashtra India",
    "Does Remote Internship work for you?": "Bangalore",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "radhika.wagh.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:05:15",
    "Name of the student": "Pushpesh Pathak",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Applied Petroleum Engineering Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum (Oil and Gas)",
    "Period of Internship": "45 Days starting from 01/05/2020",
    "Current Location(With Country)": "Berinag Pithoragarh Uttarakhand India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14GQljC3iyW4KW-1dplw4hHhJLAKZM1fM/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pushpesh-pathak-03b60317b",
    "Contact Details (Email)": "pushpeshssgk@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:08:22",
    "Name of the student": "Utsav Kadam",
    "Institute Name(College)": "IIT Guwahati",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Consulting/Strategy",
    "Period of Internship": "2-3. Can start immediately",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes, anywhere in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1OVclSCKdWB4EMvsqXWhM3MKkehfAriVo/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/utsav-kadam",
    "Contact Details (Email)": "utsavkadam@gmail.com",
    "Anything else you'd like to share?": "Hoping for the best!",
  },
  {
    Timestamp: "04/11/2020 20:08:32",
    "Name of the student": "Yash Suresh Rathod",
    "Institute Name(College)": "MIT School of Architecture Pune",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architectural Internship",
    "Period of Internship": "6 months starting from June 2020",
    "Current Location(With Country)": "Pune,India",
    "Does Remote Internship work for you?": "Mumbai, Bangalore, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1ukJgDZ-V8FoUjJmBJbtpO2GSPtfpWhYU",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "iyashrathod@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:10:03",
    "Name of the student": "Devanshi vyas",
    "Institute Name(College)": "Pandit Deendayal Petroleum University",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electrical domain",
    "Period of Internship": "6 weeks-(starting date 1st June)",
    "Current Location(With Country)": "Ahmedabad-Gujarat- India",
    "Does Remote Internship work for you?": "Yes- Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1zduuPxcyrLhOR5cOGPH6Ma6mONfC7Qxt/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/devanshi-vyas-588a2b194/",
    "Contact Details (Email)": "devanshivyas2410@gmail.com",
    "Anything else you'd like to share?":
      "I am pursuing my electrical engineering and would love to have a opportunity for internships to get hands-on experience in respective field.",
  },
  {
    Timestamp: "04/11/2020 20:14:28",
    "Name of the student": "Rohit Patel",
    "Institute Name(College)": "NMIMS Mumbai",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "Looking for 4 months, starting immediately",
    "Current Location(With Country)": "Mumbai, Maharashtra, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "rohit591",
    "Contact Details (Email)": "rohitpatel1192@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:20:25",
    "Name of the student": "Avyay Gokavarapu",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Industrial and Systems Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "Pune",
    "Does Remote Internship work for you?": "Yes, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1CBp7vEECc8uHZ92IcyIWeANBLN7yBu1H",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/avyay-gokavarapu-392926169/",
    "Contact Details (Email)": "prajvalavyay@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:26:28",
    "Name of the student": "Ritu Sharma",
    "Institute Name(College)":
      "Welingkar Institute of Management Development & Research",
    "Field of study": "Business Design",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Market Research",
    "Period of Internship": "2 months starting from 01/05/2020",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1SMaGi0LXTmFp1ObayBP2aeX-WCpmxFFk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritu-sharma-9956242b/",
    "Contact Details (Email)": "ritu2793@gmail.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/11/2020 20:26:57",
    "Name of the student": "S Kaushik",
    "Institute Name(College)":
      "Indian Institute of Information Technology, Design and Manufacturing Kancheepuram",
    "Field of study":
      "Electronics and Communication Engineering (spec. in Design and Manufacturing)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Healthcare, Biomedical",
    "Period of Internship": "5 months",
    "Current Location(With Country)": "Chennai",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1jtesMLQL1e1oOk9zZG-mfM-4NztPF82v/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/kaushiksuresh2110/",
    "Contact Details (Email)": "kaushik.suresh2110@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:27:16",
    "Name of the student": "Ravi Nishant Shankar Ravidas",
    "Institute Name(College)":
      "NITIE, National Institute of Industrial Engineering",
    "Field of study": "Supply Chain Management (MBA)",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Supply Chain, Operations, Product Management",
    "Period of Internship": "2 months starting ASAP",
    "Current Location(With Country)": "Ahmedabad, Gujarat, India",
    "Does Remote Internship work for you?":
      "Yes, I'm open to remote internship",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1R2fwH0OSRXOiVmXY_QnjrQ6tQdeDNR6_",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nishant-ravi-15a697112/",
    "Contact Details (Email)": "nishantravi96@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:27:43",
    "Name of the student": "Shobhit Mishra",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies Dehradun",
    "Field of study": "Fire and Safety",
    Education: "Undergraduate",
    "Preferred domain of internship": "Safety Consultancy",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1bo0sPGuNQJ8qKd6KSSEA9n3O9AWsAL3l/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shobhit276@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/11/2020 20:28:31",
    "Name of the student": "Sayali desai",
    "Institute Name(College)": "Mit school of architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Urban design",
    "Period of Internship": "3-6months",
    "Current Location(With Country)": "Kalyan, india",
    "Does Remote Internship work for you?": "Yes, mumbai",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Sayalid19998@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/11/2020 20:28:34",
    "Name of the student": "Shristi Agrawal",
    "Institute Name(College)": "National Institute of Technology Raipur",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software engineering intern, Backend developer",
    "Period of Internship": "1.5 months Start date-immediately",
    "Current Location(With Country)": "Raigarh, Chhattisgarh,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1n5H9nuTtSdrczQN6UgM8xCbJ_7pg5teB8Jw-qiMr62I/edit?usp=sharing",
    "LinkedIn profile link": "inkedin.com/in/shristi-agrawal-ba3692157/",
    "Contact Details (Email)": "agrawalshristi2@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:29:25",
    "Name of the student": "Manali Gokani",
    "Institute Name(College)": "Welingkar Institute",
    "Field of study": "PGDM ( Media & Entertainment)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2-3 months starting from April / May",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "No.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Y6b6y0JXOnEamXfytoSjRrLBeZj8BYUG/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/manali-gokani-7035a0184",
    "Contact Details (Email)": "manaligokani7777@gmail.com",
    "Anything else you'd like to share?":
      "Hey, I would also like to explore digital marketing, media and branding. Thanks for the great initiative.",
  },
  {
    Timestamp: "04/11/2020 20:37:27",
    "Name of the student": "Padmaja Yadav",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months, May- June",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1fiV-m4IFJtZDvne5sEI0vhkoib2lehpE/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/padmaja-yadav/",
    "Contact Details (Email)": "9702950993",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:39:55",
    "Name of the student": "Siddharth Shah",
    "Institute Name(College)": "Indian Institute of Technology Goa",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Cyber Security",
    "Period of Internship": "25th May - 15th July (approx. 2 months)",
    "Current Location(With Country)": "Mumbai, Maharashtra",
    "Does Remote Internship work for you?":
      "Yes, I'm comfortable with all locations.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/14v7ZKy1shNXjdh7vdYRApCwj55PsiolU?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/siddharth-shah-37ba44183/",
    "Contact Details (Email)": "siddharth.shah.18001@iitgoa.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:41:37",
    "Name of the student": "Bhavika Makhija",
    "Institute Name(College)": "Cept University",
    "Field of study": "URBAN DESIGN",
    Education: "Undergraduate",
    "Preferred domain of internship": "Urban design or architect firm",
    "Period of Internship": "5 months",
    "Current Location(With Country)": "Ahmedabad, Gujarat",
    "Does Remote Internship work for you?":
      "Yess. Pune, Bangalore, Hyderabad, chennai, kerela, Goa, udaipur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/cept.ac.in/file/d/1zxtI0Z5tqE9Aq0noVJT-2eqhHu1bOZB_/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bhavika-makhija-85223517b",
    "Contact Details (Email)": "makhija.prakash.bud17@gmail.com",
    "Anything else you'd like to share?":
      "I am more interested in firms that have urban design projects and more likely to deal with the ongoing positions where we can add urban design to the architecture so that people are entertained without going outside as i m experimenting with it these days...",
  },
  {
    Timestamp: "04/11/2020 20:45:31",
    "Name of the student": "ANKITA TRIPATHI",
    "Institute Name(College)": "WELINGKAR, BANGALORE",
    "Field of study": "FINANCE",
    Education: "Post-Graduate",
    "Preferred domain of internship": "FINANCE",
    "Period of Internship": "2 MONTHS, STARTING FROM MAY",
    "Current Location(With Country)": "DELHI",
    "Does Remote Internship work for you?": "YES, BANGALORE",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1KvitUcH1XfS8uDwHZFyByx8d144_9J8Y",
    "LinkedIn profile link": "linkedin.com/in/ankitatripathi1",
    "Contact Details (Email)": "ankita.tripathi.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:46:26",
    "Name of the student": "Himalay Zaveri",
    "Institute Name(College)": "CEPT UNIVERSITY",
    "Field of study": "BACHELORS IN URBAN DESIGN",
    Education: "Undergraduate",
    "Preferred domain of internship": "URBAN DESIGN",
    "Period of Internship": "6 MONTHS",
    "Current Location(With Country)": "INDIA",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://issuu.com/himalayzaveri6610/docs/00-converted?utm_source=conversion_success&utm_campaign=Transactional&utm_medium=email",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "himalay.zaveri.bud17@cept.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:50:17",
    "Name of the student": "Nadeem",
    "Institute Name(College)": "",
    "Field of study": "",
    Education: "",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Umo7vOiXsRbJeVSHeqIunXYNfn7dw9S_/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/syed-abdur-rahman-nadeem-98691a171",
    "Contact Details (Email)": "Unqnadeem4@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:54:31",
    "Name of the student": "Kaushal Tank",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "PGDM-Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Supply Chain Management and Operations",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Nashik, Maharashtra, India",
    "Does Remote Internship work for you?":
      "Mumbai, Pune, Bangalore, Delhi, Ahmedabad, Rajkot",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kaushal-tank-179419104/",
    "Contact Details (Email)": "tank.kaushal@gmail.com",
    "Anything else you'd like to share?":
      "My internship with India's No.1 Retailing Brand got revoked because of Covid-19",
  },
  {
    Timestamp: "04/11/2020 20:59:06",
    "Name of the student": "Gaurav Kumar",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Software Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Tech",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Anywhere in PAN India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CpaQWoe4pBIi_3YoBCUJMYNxlHe-3Oto/view?usp=drivesdk",
    "LinkedIn profile link": "Linkedin.com/in/gaurav-kumar9891",
    "Contact Details (Email)": "gaurav.kumar.mission.2017@gmail.com",
    "Anything else you'd like to share?": "Thanks for helping us",
  },
  {
    Timestamp: "04/11/2020 21:00:21",
    "Name of the student": "MAHIPAL SINGH RATHORE",
    "Institute Name(College)": "INDIAN INSTITUTE OF TECHNOLOGY GOA",
    "Field of study": "MECHANICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "AUTOMOBILE, COMPUTATIONAL FLUID DYNAMICS",
    "Period of Internship": "6 MONTHS",
    "Current Location(With Country)": "SIROHI, RAJASTHAN , INDIA",
    "Does Remote Internship work for you?": "YES, AHMEDABAD",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1URimh1W8RHhV_YjSp42ng-0WbNjLVLtg/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mahipal-rathore-a24184181",
    "Contact Details (Email)": "mahipal.rathore.17003@iitgoa.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 21:02:24",
    "Name of the student": "Afreen Bano",
    "Institute Name(College)":
      "Welingkar Institute of Management, Development and Research, Mumbai",
    "Field of study": "PGDM Retail Management, Marketing",
    Education: "",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Allahabad, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1MlimiqpUiM4CWhQeiEgLgytNeiTUEzUs",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/afreen-bano-83198918b/",
    "Contact Details (Email)": "afreenb59919@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 21:19:13",
    "Name of the student": "Adhikansh Singh",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science, Software Engineering",
    "Period of Internship": "13/04/2020 - 20/06/2020",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1F6WvE5lagV66MHWKBICmU8FlodeidyK0",
    "LinkedIn profile link": "https://www.linkedin.com/in/adhikansh113/",
    "Contact Details (Email)": "singhadhikansh113@gmail.com",
    "Anything else you'd like to share?":
      "I am a budding programmer and a Machine Learning and Data Science enthusiast with a  keen interest in Software Development and Deep Learning and its applications. \nI had secured an internship at a reputed company in software development but due to the COVID 19 outbreak, the internship was cancelled.\n\nCurrently a 3rd year undergraduate student pursuing Computer Science and Engineering at IIT Kharagpur, I have always had an interest in problem solving and learning new skills.",
  },
  {
    Timestamp: "04/11/2020 21:21:48",
    "Name of the student": "Tarun Gupta",
    "Institute Name(College)": "IIT Indore",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Engineering, Machine Learning and Data Analytics",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1t5-BMQF50HnLuO1PcEJPRDjiFxO-oPiB/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tarun-gupta-116860178",
    "Contact Details (Email)": "tarungupta360@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 22:13:59",
    "Name of the student": "Shikha Verma",
    "Institute Name(College)": "Indian Institute of Technology Goa",
    "Field of study": "Computer science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "4 immediately",
    "Current Location(With Country)": "Jaipur(India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitgoa.ac.in/file/d/1vC57mCUmonuQtX5qJIfeSY0QKciW0aPe/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/itsshikha",
    "Contact Details (Email)": "shikha.verma.16001@iitgoa.ac.in",
    "Anything else you'd like to share?":
      "I have a very strong base of DSA and I can learn new languages very quickly.",
  },
  {
    Timestamp: "04/11/2020 22:19:49",
    "Name of the student": "Prerna Gupta",
    "Institute Name(College)": "Welingkar Institute, Bangalore",
    "Field of study": "Business Design & Innovation",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "May-June",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15LOTxX0tCgh2bogaI-KCe9AUxolvvGm1/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prerna-gupta-50ba16151",
    "Contact Details (Email)": "prerna.gupta.we@gmail.com",
    "Anything else you'd like to share?":
      "Due to COVID situation, I lost my internship. And I am open for any sort of internship or live projects in Marketing domain.",
  },
  {
    Timestamp: "04/11/2020 22:26:01",
    "Name of the student": "Animesh Sharma",
    "Institute Name(College)": "Indian Institute of Technology, Goa",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Embedded Systems",
    "Period of Internship": "6 Months, 1st June",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1jyNqfFJEAteJ3ghcMXsnbL4X40RM4fyn/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/animesh-sharma810/",
    "Contact Details (Email)":
      "animesh.sharma.17003@iitgoa.ac.in, animeshsharma8991@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 22:31:28",
    "Name of the student": "Trisha Welde",
    "Institute Name(College)": "Symbiosis Centre for Media and Communication",
    "Field of study": "Media and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Media",
    "Period of Internship": "",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "No, I am not open to relocate.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1x_ckWLciYd7odKrsgt2B1hpct8FzMB3z/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/trisha-welde-139870165/",
    "Contact Details (Email)": "trishawelde@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 22:33:03",
    "Name of the student": "Adarsh Mohan",
    "Institute Name(College)": "Manipal Institute Of Technology",
    "Field of study": "Information Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analyst",
    "Period of Internship": "4(june30th)",
    "Current Location(With Country)": "Chennai(India)",
    "Does Remote Internship work for you?": "Yes,Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ycSFYbNR-Mf6V28wgl4TaQPc3lOm_eob/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/adarsh-mohan-005035159",
    "Contact Details (Email)": "adarshm123@gmail.com",
    "Anything else you'd like to share?":
      "I would really like to work in Bangalore but I know beggars cant be choosers.",
  },
  {
    Timestamp: "04/11/2020 23:16:00",
    "Name of the student": "Sakshi tyagi",
    "Institute Name(College)": "Jaypee institute of information technology",
    "Field of study": "Btech biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Healthcare,lifescience,pharmacy",
    "Period of Internship": "5-6",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes,noida-ncr",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EG7lZCWqkO9hWE-ukF5S9JQm8ZYCzEb5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/sakshi-tyagi-94b05b17a",
    "Contact Details (Email)": "sakshityagi2398@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 23:23:43",
    "Name of the student": "SHUBHAM GUPTA",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Energy Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Consulting/Finance/Business Development",
    "Period of Internship": "2 to 3 months, can start asap",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Mumbai, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://bighome.iitb.ac.in/index.php/s/c95oPeAy9xxfbEb#pdfviewer",
    "LinkedIn profile link": "https://www.linkedin.com/in/gshubham855",
    "Contact Details (Email)": "gshubham855@gmail.com",
    "Anything else you'd like to share?":
      "Personal Website: https://sites.google.com/view/gupta-shubham/home",
  },
  {
    Timestamp: "04/11/2020 23:28:40",
    "Name of the student": "Siddharth Dangwal",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Quantum computation and information or machine learning research",
    "Period of Internship": "2 months 1 May to 28 June 2020",
    "Current Location(With Country)": "Dehradun, Uttarakhand, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aPSXzVPesgtEFX2_yywp3FaBpizMhwvv/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/siddharth-dangwal-2b16ab153/",
    "Contact Details (Email)": "dangwal.sid6@gmail.com",
    "Anything else you'd like to share?":
      "I would like to work on research based internships primarily. For quantum computation any sort of internship would do, right from quantum software development projects to quantum machine learning to fidelity improvement research projects.",
  },
  {
    Timestamp: "04/11/2020 23:35:03",
    "Name of the student": "Devansh Gupta",
    "Institute Name(College)": "Institute of Management Technology, Ghaziabad",
    "Field of study": "PGDM(Marketing)",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Marketing, Strategy, Market Research, Consulting, Operations",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ghaziabad, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1vUIiFos-Fw5gWI2oi31g7vfrX_fWE8oq",
    "LinkedIn profile link": "https://www.linkedin.com/in/guptadevansh/",
    "Contact Details (Email)": "devansh0324@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:09:29",
    "Name of the student": "Suyash Upadhyay",
    "Institute Name(College)": "Maharaja Surajmal Institute, GGSIPU",
    "Field of study": "Business Administration",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance, Strategy, Marketing, Consulting",
    "Period of Internship": "2 months starting immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Delhi, Mumbai, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DGfJYm_3BWGZJzyAnrm6XkYi-_zHifKj/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out Suyash Upadhyay�s profile on LinkedIn https://www.linkedin.com/in/suyashupadhyay",
    "Contact Details (Email)": "suyashupadhyay9182@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:19:39",
    "Name of the student": "Yogesh Sonawane",
    "Institute Name(College)": "MET Institute of Managment",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital marketing, business devolpment",
    "Period of Internship": "1-3 months",
    "Current Location(With Country)": "Mumbai(India)",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=10eAGJIydiYF18EFM5N2jt-hKErHtGWn9",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/yogesh-sonawane-a84a7098/",
    "Contact Details (Email)": "yssonawane987@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:30:35",
    "Name of the student": "Shubham Amritkar",
    "Institute Name(College)": "Balaji Institute of Modern Management",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2",
    "Current Location(With Country)": "Thane, Mumbai, India",
    "Does Remote Internship work for you?": "YEs",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1CvOl9St_Ski_UC00Ze1aRIvyhpyIYouF",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shubham-amritkar-6b900a165/",
    "Contact Details (Email)": "shubham.amritkar192@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:33:14",
    "Name of the student": "Amit Tiwari",
    "Institute Name(College)": "Balaji institute of modern management",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital marketing and sales",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Gurgaon",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "tiwaribamit@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:39:41",
    "Name of the student": "Aditi Saxena",
    "Institute Name(College)": "Indian Institute of Technology Goa",
    "Field of study": "Computer Science of Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computational Biology, Machine Learning",
    "Period of Internship": "2 months, starting 15 May 2020",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ngvq5HAOQeo1GgMLiS66c09aIdJb-1P2/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/aditi-saxena-09a339188/",
    "Contact Details (Email)": "aditi.saxena.18001@iitgoa.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:53:09",
    "Name of the student": "Aakash Baliyan",
    "Institute Name(College)": "University of Petroleum and energy studies",
    "Field of study":
      "B-tech, Petroleum Engineering with specialization in upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Upstream Sector",
    "Period of Internship": "1.5 months, starting date - 1st May",
    "Current Location(With Country)": "Delhi",
    "Does Remote Internship work for you?": "yes, anywhere within the country",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1QdejoSd9-DE0m86sEYKlhyzJPaiDGrAj",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aakash-baliyan-6a9271181/",
    "Contact Details (Email)": "balyanbaliakash@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:55:51",
    "Name of the student": "Ravi singh",
    "Institute Name(College)": "Balaji institute of Mordern Management Pune",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital Marketing",
    "Period of Internship": "2  months",
    "Current Location(With Country)": "Pune",
    "Does Remote Internship work for you?": "Hyderabad Pune indore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/167O1SIHadfYH0u6b0B4lo-MaTixHtJ3z/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/ravi-singh-",
    "Contact Details (Email)": "ravisb1995@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:56:06",
    "Name of the student": "Dibin raj",
    "Institute Name(College)": "Balaji institute of modern management",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months(between April and June)",
    "Current Location(With Country)": "Damoh, M.P.(INDIA)",
    "Does Remote Internship work for you?": "Yes,pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1QBzOHsMTqPmw_DX2YX3e11VctwyMGGu7/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/dibin-raj-653213192",
    "Contact Details (Email)": "dibinraj50@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 00:56:58",
    "Name of the student": "Saransh Kumar",
    "Institute Name(College)": "National Institute of Technology, Silchar",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning, Data Science",
    "Period of Internship": "2 months, April-end",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saransh-kumar-7a2a78186/",
    "Contact Details (Email)": "saranshkumar80@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 01:02:25",
    "Name of the student": "Meghna Singh",
    "Institute Name(College)": "BIMM Sri Balaji University.",
    "Field of study": "PGDM in Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing, Sales or Market research",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Indore (MP), India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "singhmeghna179gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 02:55:10",
    "Name of the student": "Ritesh Kumar Biswal",
    "Institute Name(College)": "Balaji Institute of modern management, pune",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2",
    "Current Location(With Country)": "Visakhapatnam (Andhra Pradesh), India",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "This is our college Resume - https://drive.google.com/file/d/1gU6-k3fRgG4aW1j_Os4wSlf0M2CzwEPX/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritesh-kumar-8b825a181",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?":
      "I forgot to add some of my certifications too - Basics of Cybersecurity and Digital Marketing",
  },
  {
    Timestamp: "04/12/2020 03:06:45",
    "Name of the student": "Pratham Choudhary",
    "Institute Name(College)": "Rajiv Gandhi Institute of Petroleum Technology",
    "Field of study": "Oil and Gas",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Marketing, Content Writing and others work from home opportunities",
    "Period of Internship": "1-2 month",
    "Current Location(With Country)": "Faridabad, Haryana, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17-ECIVDQiLz3nAJ7NJoTK8yZUjXEwd-1/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pratham-choudhary-63b3b0170",
    "Contact Details (Email)": "epe18030@rgipt.ac.in",
    "Anything else you'd like to share?":
      "I've been content writer for a number of student chapters but I'd happy to work in marketing and finance to learn more as my future endeavour is to pursue MBA",
  },
  {
    Timestamp: "04/12/2020 04:26:03",
    "Name of the student": "Arshad Ayoob",
    "Institute Name(College)": "IIM Indore",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Analytics, Operations, Supply Chain Management, Marketing",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Kochi, India",
    "Does Remote Internship work for you?": "Yes. Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1P64clyATc4qwHLIcosXnJJwmo4g8Ecye",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arshad-ayoob-52626913b/",
    "Contact Details (Email)": "p19arshada@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 04:45:50",
    "Name of the student": "Mohammad Aman",
    "Institute Name(College)": "Defence Institute of Advanced Technology Pune",
    "Field of study": "Aerospace engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Dynamics and control",
    "Period of Internship": "12 months",
    "Current Location(With Country)": "Pune Maharashtra India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16WmMVknzrVR4lTga9FqKZc8NCiuzcd1z/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mdaman0054@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 09:12:56",
    "Name of the student": "DEEPENDRA KUMAR",
    "Institute Name(College)": "GREATER NOIDA INSTITUTE OF TECHNOLOGY",
    "Field of study": "MECHANICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "6 Month",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1gEGMUv1tkNTj3pAh4dBSiYHDKvz1827v/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "kumardeependra278@gmail.com",
    "Anything else you'd like to share?": "Contact no - 9430572326",
  },
  {
    Timestamp: "04/12/2020 09:12:58",
    "Name of the student": "Tejas Anup Deshmukh",
    "Institute Name(College)":
      "Symbiosis institute of business management Nagpur",
    "Field of study": "Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations",
    "Period of Internship": "2 months from 15th April",
    "Current Location(With Country)": "Nagpur, Maharashtra, India",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocate in Bangalore and Pune",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tejas-deshmukh-ba06151a3",
    "Contact Details (Email)": "tejasdeshmukh740@gmail.com",
    "Anything else you'd like to share?":
      "I want internship strictly related to my domain ( Operations Management)",
  },
  {
    Timestamp: "04/12/2020 09:19:49",
    "Name of the student": "Apaar Mudgal",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Development/Management, Operations, Analytics, Supply Chain",
    "Period of Internship": "2 months starting from 24/4/20",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1FF8-ESSVysdmMKw8xYKnpPucMRBz11Hs",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/apaar-mudgal-931707153/",
    "Contact Details (Email)": "apaarmudgal4@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 09:27:30",
    "Name of the student": "Swagat Mohapatra",
    "Institute Name(College)": "JAIPURIA INSTITUTE OF MANAGEMENT, NOIDA",
    "Field of study": "PGDM",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2",
    "Current Location(With Country)": "Odisha, India",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ekvVVQLEFyWpKq3wCsTyhel_iiFElOdE/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/swagat-mohapatra-a1136312b/",
    "Contact Details (Email)": "swagat.mohapatra.21n@jaipuria.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 09:32:09",
    "Name of the student": "Harshit Anand",
    "Institute Name(College)": "Kalinga Institute Of Industrial Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning",
    "Period of Internship": "Preferably 2 months.",
    "Current Location(With Country)": "Ranchi(India)",
    "Does Remote Internship work for you?": "Bhubaneswar",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "harshitanand99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 09:40:08",
    "Name of the student": "Dhrubajyoti Ray",
    "Institute Name(College)": "Indian Institute of Technology Kharagpur",
    "Field of study": "Chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business development and Market Research",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cxTmqF4U1pMfAZfrMy-9tMzqEvnheog6/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dhrubajyoti-ray-38186646",
    "Contact Details (Email)": "ankur.ray1999@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 09:49:31",
    "Name of the student": "Syed kashifuddin saqlain",
    "Institute Name(College)": "Gurunanak institutions technical Campus",
    "Field of study": "Mechanical Engineering",
    Education: "Graduate",
    "Preferred domain of internship": "Design in MEP",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Hyderabad",
    "Does Remote Internship work for you?": "Hyderabad",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Kashifsaqlain3@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 09:58:29",
    "Name of the student": "Yazmeen Torres",
    "Institute Name(College)": "Florida State University",
    "Field of study": "Biomedical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Medical Device, Biotechnology, Biomedical Engineering related fields but open to new expereinces!",
    "Period of Internship": "Summer: May-August",
    "Current Location(With Country)": "Miami, Florida",
    "Does Remote Internship work for you?":
      "Yes, open to relocation to any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VMo1jfX7HksgRpIHiUIc-Aq7qCsa-BFi/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/yazmeentorres/",
    "Contact Details (Email)": "yazmeen98@gmail.com",
    "Anything else you'd like to share?":
      "Experience: previous summer internship where Lean Six Sigma skills were acquired, MATLAB proficient, circuitry/breadboard basics and electrical circuit analysis, beginner design skills in Solid Works",
  },
  {
    Timestamp: "04/12/2020 10:14:44",
    "Name of the student": "Shubham Jha",
    "Institute Name(College)":
      "Sant Longowal Institute of Engineering and Technology, Punjab",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software, AI and Machine Learning",
    "Period of Internship": "2 months starting immediately",
    "Current Location(With Country)": "Bihar, India",
    "Does Remote Internship work for you?":
      "Yes, although I'd prefer work from home internship, if needed i can relocate to Noida, Gurugram, New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uamhJaIZHIAllrrLwmuhUG_17u0MaajI/view?usp=sharing",
    "LinkedIn profile link": "https://in.linkedin.com/in/shbhmjha",
    "Contact Details (Email)": "Shbhmkmrjha@gmail.com",
    "Anything else you'd like to share?":
      "Hi! I am an inquisitive individual who wants to make the digital world better place, self initiator to solve any technical\nproblems, love to explore innovative technologies in our system and how these technologies can enhance the lives of\npeople with critical thinking.",
  },
  {
    Timestamp: "04/12/2020 10:22:07",
    "Name of the student": "Siddhi pandey",
    "Institute Name(College)": "Kalinga Institute Of Industrial Technology",
    "Field of study": "Cse Data science, IOT",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science, IOT",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Gorakhpur Uttar pradesh",
    "Does Remote Internship work for you?": "Yes (Kolkata/Delhi/Hyderabad)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1F2FBsCb1hxU1B-IWTZqXAyXuF9FfvYlF",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/siddhi-pandey-141a8b179",
    "Contact Details (Email)": "1705077@kiit.ac.in",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/12/2020 10:29:20",
    "Name of the student": "Utkarsh Gupta",
    "Institute Name(College)": "Indian institute of Technology, BHU",
    "Field of study": "Chemical Engineering and Technology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Artificial Intelligence, Data Science , Product Management",
    "Period of Internship": "2",
    "Current Location(With Country)": "Lucknow (India)",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Y-ZLlLQ_tvGx_wj3v2SPXqNgEGWAUxGw/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.in/in/utkarshgupta112358132134a",
    "Contact Details (Email)": "utkarsh.gupta.che17@itbhu.ac.in",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/12/2020 10:32:25",
    "Name of the student": "Archit Budhiraja",
    "Institute Name(College)": "Balaji Institute of Modern Management, SBU",
    "Field of study": "MBA Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing Research, Sales",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ambala, Haryana, India",
    "Does Remote Internship work for you?":
      "Yes, I can relocate to Pune, Chandigarh or Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15ZVKMz-6xLU6wIysW4sSmtBtpnoNMSKw/view?usp=drivesdk",
    "LinkedIn profile link":
      "http://linkedin.com/in/archit-budhiraja-143b64188",
    "Contact Details (Email)": "budhiraja.archit@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 10:34:09",
    "Name of the student": "Archit Budhiraja",
    "Institute Name(College)": "Balaji Institute of Modern Management, SBU",
    "Field of study": "MBA Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing Research, Sales",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ambala, Haryana, India",
    "Does Remote Internship work for you?":
      "Yes, I can relocate to Pune, Chandigarh or Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15ZVKMz-6xLU6wIysW4sSmtBtpnoNMSKw/view?usp=drivesdk",
    "LinkedIn profile link":
      "http://linkedin.com/in/archit-budhiraja-143b64188",
    "Contact Details (Email)": "budhiraja.archit@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 10:46:13",
    "Name of the student": "Dheeresh Agarwal",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Minerals, Metallurgical, and Materials Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "1.Machine Learning, Deep learning, and AI.  2.Office productivity 3.Design (Phototshop)",
    "Period of Internship": "2 months 20 May 2020",
    "Current Location(With Country)": "Odisha, Bhubaneswar",
    "Does Remote Internship work for you?": "Yes, Bhubaneswar",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1LzsKqGV60OEMzvYflu3wN7wF_Huzpqkr/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/dheereshaggarwal",
    "Contact Details (Email)": "da11@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "https://github.com/dheereshaggarwal\nhttps://www.hackerrank.com/dheereshaggarwal",
  },
  {
    Timestamp: "04/12/2020 10:54:16",
    "Name of the student": "Gazal Gupta",
    "Institute Name(College)": "Balaji Institute of Modern Management",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "",
    "Period of Internship": "1may to june i.e 2 months",
    "Current Location(With Country)": "Shahjahanpur, Uttar Pradedh (India)",
    "Does Remote Internship work for you?": "Pune, Maharashtra",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EwIqcbAVwxtSd2kMNt8mLneExt_Bt0J2/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out Gazal Gupta�s profile on LinkedIn https://www.linkedin.com/in/gazal-gupta-228a84192",
    "Contact Details (Email)": "gazalgupta866@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 10:55:12",
    "Name of the student": "K Shravan kumar",
    "Institute Name(College)": "Sri balaji society",
    "Field of study": "MBA Marketing",
    Education: "Graduation",
    "Preferred domain of internship": "Marketingw",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Pune, Maharashtra, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "Yes",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/k-shravan-kumar-b44533118",
    "Contact Details (Email)": "Shravan2049.sk@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 11:02:35",
    "Name of the student": "Dr. Sheetal Sippy",
    "Institute Name(College)":
      "Welingkar Institute of Management Studies, Mumbai",
    "Field of study": "MBA-Healthcare Management",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Marketing, Marketing-Communications, Marketing Intelligence",
    "Period of Internship": "May-July",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes, remote internship preferable",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18szC97zVvh4OlbpMoPeunkxfPXOoWd1m/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dr-sheetal-sippy-849742147",
    "Contact Details (Email)": "sheetalsippy.weschool@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 11:11:54",
    "Name of the student": "Sidharth Jindal",
    "Institute Name(College)": "Manipal Institute of Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "Open for any- June Firs Week",
    "Current Location(With Country)": "Bengaluru, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1BXzZURu5Iwjkfs-edZXABD8rzVdve4UL",
    "LinkedIn profile link": "https://www.linkedin.com/in/sidharth-jindal/",
    "Contact Details (Email)": "sidharthjindal2811@gmail.com",
    "Anything else you'd like to share?":
      "Hello there,\n\nI hope you are doing well.\n\nI am Sidharth, graduated from Manipal Institute of Technology, Manipal. I am actively looking for a job in the field of Data Science. During my 6 month tenure at Ather Energy I have worked on multiple projects involving modelling, prediction and converting data into insights. My work at Ather involved tech stack from writing efficient queries to extract data from cloud to visually presenting the insights using R.\nFew of my successful projects were classifying riders across the city based on common and consistent riding patterns being observed. Develop an algorithm to estimate the minimum rest time to be given to battery after some discharge. Enhancing of an automated run pipeline on Airflow using Google Cloud Composer which runs periodically providing real time insights to product team.\nI am grateful to have worked on such interesting projects which gave me a true understanding of core concepts.\n\nIf you think I would be a good match to your requirements or if you want to find out more about me, let's connect!\n\n--\nBest\nSidharth Jindal\nPhone: +918142847710",
  },
  {
    Timestamp: "04/12/2020 11:30:32",
    "Name of the student": "Gazal Gupta",
    "Institute Name(College)": "Balaji Institute of Modern Management",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "",
    "Period of Internship": "1may to june i.e 2 months",
    "Current Location(With Country)": "Shahjahanpur, Uttar Pradedh (India)",
    "Does Remote Internship work for you?": "Pune, Maharashtra",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EwIqcbAVwxtSd2kMNt8mLneExt_Bt0J2/view?usp=drivesdk",
    "LinkedIn profile link":
      "Check out Gazal Gupta�s profile on LinkedIn https://www.linkedin.com/in/gazal-gupta-228a84192",
    "Contact Details (Email)": "gazalgupta866@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 12:29:38",
    "Name of the student": "rohith kumar gadalay",
    "Institute Name(College)": "university at buffalo(SUNY)",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "software engineer/application developer/data engineer",
    "Period of Internship":
      "for a period of maximum three months from may 18th 2020",
    "Current Location(With Country)": "Buffalo,newyork-usa",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1_ux9L4qe_PSCzFeVAmn6anBkXYfAxvY4",
    "LinkedIn profile link": "https://www.linkedin.com/in/rohithgadalay/",
    "Contact Details (Email)": "rohithku@buffalo.edu",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/12/2020 12:59:51",
    "Name of the student": "AKHOURI SHAILJA SINHA",
    "Institute Name(College)": "BIMM, PUNE",
    "Field of study": "MARKETING",
    Education: "Post-Graduate",
    "Preferred domain of internship": "MARKETING AND SALES, DIGITAL MARKETING",
    "Period of Internship": "2 months (1st may to 30th june)",
    "Current Location(With Country)": "Ranchi, India",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AiBYkyUmwqlGOJtScR9vxugl3q8-_JYN/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shailja-sinha-16260015a",
    "Contact Details (Email)": "akhouri.shailja59@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 13:03:03",
    "Name of the student": "Samruddhi Date",
    "Institute Name(College)": "MIT School of Architecture,loni kalbhor,Pune",
    "Field of study": "Architecture",
    Education: "12pass, Architecture 4 th year",
    "Preferred domain of internship": "Architecture Firm",
    "Period of Internship": "90 days",
    "Current Location(With Country)": "Pune (India)",
    "Does Remote Internship work for you?": "Yes.Mumbai,Panji",
    "Link to Resume(Google Drive/Dropbox)":
      "https://l.instagram.com/?u=https%3A%2F%2Fissuu.com%2Fsamruddhidate6215%2Fdocs%2Farchitectural_portfolio&e=ATMSBqkZpN2j-h3HntLsrFZt9piPMcQqS3UUqhRtFqhNKJhRGk4dNMH_SiVw4MRDznUm5Y4ilKSIjwvfJqX75kOGBiE6Y48j&s=1",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "dsamruddhi000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 13:57:58",
    "Name of the student": "Shivank Gupta",
    "Institute Name(College)": "United college of engineering and research",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Everything related to IT but not sales and promotions",
    "Period of Internship": "4-6 weeks",
    "Current Location(With Country)": "gorakhpur, india",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/12qUOQC8F0NskzWizP4Khfgk9b9RFOz61/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/shivanktpod/",
    "Contact Details (Email)": "shivanktpod@gmail.com",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/12/2020 14:01:53",
    "Name of the student": "Sparsh Kedia",
    "Institute Name(College)": "National Institute of Technology, Durgapur",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "3 months starting 15th April, 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Any City.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1X892fkvUQUysuAiqyqLbcxRW_VOg-yQ3",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sparsh-kedia-616821150/",
    "Contact Details (Email)": "SPARSH.KEDIA@GMAIL.COM",
    "Anything else you'd like to share?":
      "Skills : Web Development(Django,MySQL,MongoDB, Bootstrap,HTML), Competitive Programming(DS and Algorithms)",
  },
  {
    Timestamp: "04/12/2020 14:03:14",
    "Name of the student": "Juibala Bobade",
    "Institute Name(College)": "We School,Bengaluru",
    "Field of study": "HR",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Work from Hime",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "Mumbai(India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Kg1wptUb8BimdL6Ipd3bnglSp1vt-_0s",
    "LinkedIn profile link": "www.linkedin.com/in/juibala-b-bobade44",
    "Contact Details (Email)": "juibala.bobade.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 14:26:03",
    "Name of the student": "Binshad",
    "Institute Name(College)": "MES KVM College",
    "Field of study": "M.com",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Content Writing, Data Entry",
    "Period of Internship": "1 Month",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "Binshad Vaheed",
    "Contact Details (Email)": "ttbinshad747@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 14:26:27",
    "Name of the student": "Muhammad Tufail",
    "Institute Name(College)": "Abdul Wali Khan University Mardan",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "CERN summer student program and UGRAD 2020",
    "Period of Internship": "2 months and 1 semester for UGRAD",
    "Current Location(With Country)":
      "District Mardan, Khyber Pakhtunkhwa,Pakistan",
    "Does Remote Internship work for you?":
      "Yes, maybe in Islamabad Pakistan if exam are not in summer",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CGx7fcEGKCfbZBwZCWCcQO-XcIE-r87j/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/tufailkaran",
    "Contact Details (Email)": "tufailkaran434@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/12/2020 14:34:07",
    "Name of the student": "Kallam Hema Harshitha",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "B-Tech in Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning/Deep Learning",
    "Period of Internship": "Maximum of 2 months.Start from 25th July.",
    "Current Location(With Country)": "Hyderabad (India)",
    "Does Remote Internship work for you?": "I am open for remote internships.",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "khh10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 14:46:19",
    "Name of the student": "Gauranshi Chauhan",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance, machine learning, data analytics",
    "Period of Internship": "1-2",
    "Current Location(With Country)": "Udaipur, Rajasthan",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1nkc-N6mQy0SJbFrFB75cUWLehvUjB5YB/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/gauranshi-chauhan",
    "Contact Details (Email)": "gauranshi2016@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 15:47:35",
    "Name of the student": "Shruti Mittal",
    "Institute Name(College)": "Hindu college, University of delhi",
    "Field of study": "Bcom honours",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance and accounting",
    "Period of Internship": "2 months starting immediately",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?":
      "Yes remote internship works for me. After lockdown I'm available for doing internship in Gurgaon and delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VAJQjrpUOQ4WWKzhcWZlaJlRbY9xLFFc/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rjshruti29@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 15:47:49",
    "Name of the student": "Arnab Pandit",
    "Institute Name(College)": "DIT university",
    "Field of study": "Btech petroleum engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas",
    "Period of Internship": "6 week",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZfPZUiV9Xp_lJSyVcFAyl5JPbMRp0UoN/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arnab-pandit-6800aa158",
    "Contact Details (Email)": "arnabpe@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 15:49:25",
    "Name of the student": "Ankit Jaiswal",
    "Institute Name(College)": "IIT Goa",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2 to 3 months",
    "Current Location(With Country)": "Patna, Bihar, India",
    "Does Remote Internship work for you?": "Yes, Mumbai, Delhi, Hyderabad etc",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1z1IH_wi91YNlD2hs305OsKuDT6cuPya3",
    "LinkedIn profile link": "https://www.linkedin.com/in/ankit-jaiswal-18001",
    "Contact Details (Email)": "ankit.jaiswal.18001@iitgoa.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 16:02:18",
    "Name of the student": "Jhalak Rastogi",
    "Institute Name(College)": "IILM-AHL, Jaipur",
    "Field of study": "PGDM (FINANCE)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "Full Time",
    "Current Location(With Country)": "Jaipur (India)",
    "Does Remote Internship work for you?": "Yes, PAN India",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jhalak-rastogi-72663a157/",
    "Contact Details (Email)": "jhalak.rastogi.pgdm20@iilm.ac.in",
    "Anything else you'd like to share?":
      "I will inculcate all the skills in my organisation, whatever i have learned during my PGDM course and help my company to grow to their bottom as well as top line. I will put all my efforts to make it happen.",
  },
  {
    Timestamp: "04/12/2020 16:07:04",
    "Name of the student": "Janga Abhi Sai Subhash Reddy",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Mechanical engineering (B tech)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science/ML",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1JFLgYC3dWAg3jXg0tpe9r66i3qkQMdFE/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/abhi-reddy-0a6b2415a",
    "Contact Details (Email)": "abhisubhash.kkd@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 16:43:26",
    "Name of the student": "Mishal Ali",
    "Institute Name(College)": "DePauw University",
    "Field of study": "Biochemistry and Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Related to health, data science, math or anthropology",
    "Period of Internship": "05/26/20 - 08/20/20",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?":
      "Yes, anywhere within the United States",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1ijlYHAge7ry9tBKGfz9YfNpY4dL8qIvHCWJrQ4FSiR4/edit",
    "LinkedIn profile link": "https://www.linkedin.com/in/mishal-ali/",
    "Contact Details (Email)": "mishalali_2022@depauw.edu",
    "Anything else you'd like to share?":
      "If any of the links don't work, please contact me at my email address or my cell: 765-721-4322",
  },
  {
    Timestamp: "04/12/2020 16:51:08",
    "Name of the student": "Prabha Sahiti Mandaleeka",
    "Institute Name(College)":
      "Indian Institute of Information Technology, Design and Manufacturing, Kancheepuram",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Healthcare technology; Medical Imaging",
    "Period of Internship": "3 months - 1 May, 2020",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?":
      "Yes, open to relocating to Bangalore, Chennai and Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://prabhasahiti.github.io/CV_Prabha.pdf",
    "LinkedIn profile link": "https://www.linkedin.com/in/prabhasahiti/",
    "Contact Details (Email)": "sahitiprabha@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 16:57:20",
    "Name of the student": "Abhishek Nigam",
    "Institute Name(College)": "JIIT",
    "Field of study": "Ece",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Communication, telecom,data science,machine learning, deep learning,software development",
    "Period of Internship": "4-6 weeks",
    "Current Location(With Country)": "Kanpur,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-nigam-b53760136/",
    "Contact Details (Email)": "8090262080",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 17:18:36",
    "Name of the student": "Shruti Thote",
    "Institute Name(College)": "IIM",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "16 April 2020 (2 months)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shruti-thote-bb6957104/",
    "Contact Details (Email)": "sthote0@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 17:28:52",
    "Name of the student": "Siddharth Patel",
    "Institute Name(College)": "K.J somiaya institute of Management",
    "Field of study": "M",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Bm3y8fUQE5oWUF5tP_1eetdBCyuGfJj9/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/siddharth-patel-304a43122",
    "Contact Details (Email)": "siddharth.mp@somaiya.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 17:43:52",
    "Name of the student": "Harshit Anand",
    "Institute Name(College)": "Kalinga Institute of Industrial Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning or Software Development",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Ranchi",
    "Does Remote Internship work for you?":
      "Yes(Bhubaneswar, Bengaluru, Guwahati, Kolkata)",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "1705238@kiit.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 17:59:46",
    "Name of the student": "Aryan Setu",
    "Institute Name(College)": "NIT Silchar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "SOftware, Management, Core",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Jharkhand,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1ODi4TiVhtLBV01iR8VhN5h8p9x1BawPw",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aryan-setu-823364152/",
    "Contact Details (Email)": "aryansetu2017@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 18:08:27",
    "Name of the student": "Harshvardhan Beria",
    "Institute Name(College)": "KALINGA INSTITUTE OF INDUSTRIAL TECHNOLOGY",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "IoT, Cloud, Software Development",
    "Period of Internship": "2 months, Starting 1st May",
    "Current Location(With Country)": "Kolkata, India",
    "Does Remote Internship work for you?": "Yes, Bangalore/Hyderabad/Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Rs-yvgx2kX6qbhZftnRGc7nnXj_A2aYB/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harshvardhan-beria-2316ab153/",
    "Contact Details (Email)": "harshvardhanberia@gmail.com",
    "Anything else you'd like to share?": "Nil",
  },
  {
    Timestamp: "04/12/2020 18:12:11",
    "Name of the student": "Bhabani Mohapatra",
    "Institute Name(College)": "IIT Guwahati",
    "Field of study": "Product Design",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product Design",
    "Period of Internship": "2-3 months. Start date: Immediately",
    "Current Location(With Country)": "Bhubaneswar",
    "Does Remote Internship work for you?": "Sure",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1QL9i_ZVSzbq1Hwy_toMMyE8ESAJT5545/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/bhabanismoh",
    "Contact Details (Email)": "bhabani10121999@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 18:28:15",
    "Name of the student": "Dhairya Chheda",
    "Institute Name(College)": "Prin L N Welingkar Institute of Management",
    "Field of study": "PGDM Healthcare",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Healthcare",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-z7aXWKcThFaNb1_U-tj7yZKYKZF51-L/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dhairya-chheda-417190155",
    "Contact Details (Email)": "dhairyachheda06@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 18:41:30",
    "Name of the student": "Deepnakshu Das",
    "Institute Name(College)": "NMIMS, Bangalore.",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing Branding and Sales.",
    "Period of Internship": "Six to Eight weeks starting immediately",
    "Current Location(With Country)": "Mumbai, India.",
    "Does Remote Internship work for you?": "Bangalore.",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/deepankhshudas",
    "Contact Details (Email)": "deepankshu.das51@nmims.edu.in",
    "Anything else you'd like to share?": "NA.",
  },
  {
    Timestamp: "04/12/2020 19:29:57",
    "Name of the student": "Abhijit Burman",
    "Institute Name(College)": "Jalpaiguri Government engineering College",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development, Softwere Development",
    "Period of Internship": "i am free from April to July.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Pretty Well.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-yPTemvKM1ox7UV4l5wylWHQybX4Rz4L/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhijit-burman-100133157/",
    "Contact Details (Email)": "abhijitburman7@gmail.com",
    "Anything else you'd like to share?":
      "I will Highly appriciated if i get any internship related to my technology domain area, mention in my CV, then it will be very helpful for me.",
  },
  {
    Timestamp: "04/12/2020 19:30:18",
    "Name of the student": "Kushagra Shresth",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Applied Petroleum Engineering-Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil And Gas Sector",
    "Period of Internship": "1st May to 15th June 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17kmIjKMe187wh7LY1LKg-qFw8zoLZoqB/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kushagra-shresth-8aa33a145",
    "Contact Details (Email)": "kushagrashrestha@gmail.com",
    "Anything else you'd like to share?":
      "I am a young, responsible and confident person. I abide by principles of life. I posses leadership skills and have headed certain events in my college. In a nutshell i would say that i am accountable and responsible fellow and i prefer to �put first things first'",
  },
  {
    Timestamp: "04/12/2020 19:33:34",
    "Name of the student": "Dristi Jadhav",
    "Institute Name(College)": "DIT University, Dehradun",
    "Field of study": "BTech in Petroleum engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Either petroleum or sales and marketing related",
    "Period of Internship": "Preferably a month or two",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "Yes. It surely does.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AGimxLQqTvB4fLkjUCQLJaZvvle1sres/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "dristijadhav04@gmail.com",
    "Anything else you'd like to share?":
      "https://www.linkedin.com/in/dristi-jadhav-86b2a5184",
  },
  {
    Timestamp: "04/12/2020 19:42:29",
    "Name of the student": "Sanika Bapat",
    "Institute Name(College)": "MIT School Of Architecture",
    "Field of study": "Fourth year    B. Arch",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "Minimum 90 working days starting from June 2020",
    "Current Location(With Country)":
      "Incomet tax lane, prabhat road, Pune, Maharashtra",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=15B3ZB17IbW1IoSrcPBsHzU6HLR51W-j9",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sanika@bapat.net",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 19:45:37",
    "Name of the student": "Priyanshi Jain",
    "Institute Name(College)": "Indian Institute of Management, Kashipur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing, Strategy",
    "Period of Internship": "2 months, starting from mid-April",
    "Current Location(With Country)": "Jabalpur, Madhya Pradesh, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iimkashipur.ac.in/file/d/1glthnyu9Gcbd9ksChlX2gemgoxqGBzbW/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "priyanshi.mba19059@iimkashipur.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 19:53:48",
    "Name of the student": "Aditi Naudiyal",
    "Institute Name(College)": "DIT university",
    "Field of study": "B.tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas sector",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Dehradun",
    "Does Remote Internship work for you?": "Yes...New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AtQiJge0qqxhHbKUtvcdg8s8YKzgKPCu/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aditi-naudiyal-4a63441a6",
    "Contact Details (Email)": "aditinaudiyal2199@gmail.com",
    "Anything else you'd like to share?":
      "I am a responsible person and I finish all my tasks on time",
  },
  {
    Timestamp: "04/12/2020 20:08:38",
    "Name of the student": "Md Kashif Aftab",
    "Institute Name(College)": "Dit University, Dehradun",
    "Field of study": "B.tech in petroleum and energy studies",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Petroleum or sales and marketing related",
    "Period of Internship": "One or two months",
    "Current Location(With Country)": "Bihar, India",
    "Does Remote Internship work for you?": "Delhi, Dehradun, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AMVcYBMaB3E08Zy0YEV4Qm9hc4wneP2I/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kashif-aftab-23b873192",
    "Contact Details (Email)": "kashifaftab7@gmail.com",
    "Anything else you'd like to share?":
      "Looking forward to a positive response",
  },
  {
    Timestamp: "04/12/2020 20:38:33",
    "Name of the student": "Shivani Dutt",
    "Institute Name(College)": "Symbiosis Institute of Management Studies",
    "Field of study": "MBA-FINANCE",
    Education: "CURRENTLY PURSUING MBA IN FINANCE",
    "Preferred domain of internship": "FINNCE",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "WORK FROM HOME",
    "Does Remote Internship work for you?": "WORK FROM HOME",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-lj5-CfADOkv7yFfk8CV8Cai7bwKF5u9",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivani-dutt-7a43b255",
    "Contact Details (Email)": "shivanidutt4july@gmail.com",
    "Anything else you'd like to share?": "Great need of internship",
  },
  {
    Timestamp: "04/12/2020 20:53:58",
    "Name of the student": "Rohan Jacob",
    "Institute Name(College)": "TERI School of Advanced Studies",
    "Field of study": "MA Sustainable Development Practice",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Renewable Energy and Research",
    "Period of Internship": "2 months.  June 1st",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Bangalore, Mumbai, Goa",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1LJveq9BNLDgt_pkmVRXxNkUIxLHVrMed/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rohan-jacob-5a3655198",
    "Contact Details (Email)": "rohanjacob812@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 21:41:31",
    "Name of the student": "Sumit Ranadive",
    "Institute Name(College)": "Sumit Ranadive",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas industry",
    "Period of Internship": "1month",
    "Current Location(With Country)": "Solapur (India )",
    "Does Remote Internship work for you?": "Yes, pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/166xgRFVq9ngDVSEIwDKMv1RI7GgDiGrJ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sumit-ranadive-9901b116a",
    "Contact Details (Email)": "sumitranadive18897@gmail.com",
    "Anything else you'd like to share?":
      "I like to do internship in oil and gas industry. I have no issue to do internship in all over India.",
  },
  {
    Timestamp: "04/12/2020 23:19:46",
    "Name of the student": "Suraj Danaraddi",
    "Institute Name(College)": "Chalmers university of technology",
    "Field of study": "Automotive engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Automotive,  artificial intelligence or  control engineering",
    "Period of Internship": "6 months, start date  - 1st june 2020",
    "Current Location(With Country)": "Sweden",
    "Does Remote Internship work for you?":
      "Preference 1 - any city in Europe, preference  2 - any city in europe",
    "Link to Resume(Google Drive/Dropbox)":
      "www.linkedin.com/in/suraj-danaraddi",
    "LinkedIn profile link": "www.linkedin.com/in/suraj-danaraddi",
    "Contact Details (Email)": "surajs@student.chalmers.se",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 23:26:53",
    "Name of the student": "Saksham Alag",
    "Institute Name(College)": "SRM Institute of Science & Technology",
    "Field of study": "Electronics & Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Any Domain",
    "Period of Internship": "2 months, starting 12th April 2020",
    "Current Location(With Country)": "New Delhi ( India)",
    "Does Remote Internship work for you?":
      "Yes, preferred location would be Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1BiRKNJ3HQLi6FrBb7RAQqgrOf3YzVHu7/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/sakshamalag/",
    "Contact Details (Email)": "sakshamalag249@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/12/2020 23:36:09",
    "Name of the student": "Lavina Ladla",
    "Institute Name(College)": "Faculty of Management studies,MSU,Baroda",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": " 2-3 months, April",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "Baroda",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/13fPXYOxyc_2Umy-O4isRSOXA4obdtnIz/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/lavina-ladla-84b71a192",
    "Contact Details (Email)": "lavina.ladla.fms19@gmail.com",
    "Anything else you'd like to share?":
      "Projects can also be helpful which provide me knowledge management.",
  },
  {
    Timestamp: "04/13/2020 00:04:55",
    "Name of the student": "Kunal Shakya",
    "Institute Name(College)": "MRIU",
    "Field of study": "Mechanical Engineer",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "kunalshakya01@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 00:27:01",
    "Name of the student": "Akanksha Srivastava",
    "Institute Name(College)": "Jk business School",
    "Field of study": "Digital Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital Marketing",
    "Period of Internship": "2 months from 1st July 2020 to 31st August 2020",
    "Current Location(With Country)": "Gurgaon, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-T-cK23U-gPBhBLz8k0A-mCAmjrKzXRB/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akanksha-srivastava-68446b197",
    "Contact Details (Email)": "akankshasrivas444@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 00:48:38",
    "Name of the student": "Yatin Singla",
    "Institute Name(College)": "washington state university",
    "Field of study": "computer science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "software engineering, product management",
    "Period of Internship": "3 months, 5th may",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "yes, california, new york",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/19WsyPDCIVl2AR8RVYsGB4bj1vt9CuCzJ/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/ysingla",
    "Contact Details (Email)": "yatinsingla2@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 01:05:18",
    "Name of the student": "Shubhanshu Gupta",
    "Institute Name(College)": "Balaji Institute of Telecom and Management",
    "Field of study": "PGDM (Marketing & Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Market Research, Digital marketing, Marketing & Sales",
    "Period of Internship": "2 (1 May onwards)",
    "Current Location(With Country)": "Konch (Uttar Pradesh) (India)",
    "Does Remote Internship work for you?": "Lucknow, Delhi NCR, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17wT8s8wGeDNJKJj-JUA3XVZhtc4dhawg/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shubhanshu-gupta-94bb88147",
    "Contact Details (Email)": "shubh201296@gmail.com",
    "Anything else you'd like to share?":
      "I am a marketing professional and a fresher. My Summer Internship has been cancelled by the Co. due to Covid19 outbreak. I would really appeciate if you help me out.",
  },
  {
    Timestamp: "04/13/2020 02:12:33",
    "Name of the student": "Hitesh Bhardwaj",
    "Institute Name(College)": "Pixel italy",
    "Field of study": "Project planning and management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Project management",
    "Period of Internship": "3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.linkedin.com/in/hitesh-bhardwaj-820513113",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/hitesh-bhardwaj-820513113",
    "Contact Details (Email)": "hitesh.bhardwaj1010@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/13/2020 02:28:48",
    "Name of the student": "Moselyn Mailula",
    "Institute Name(College)": "University of Johannesburg",
    "Field of study": "Extraction Metallurgy",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Metallurgy",
    "Period of Internship": "24 months",
    "Current Location(With Country)": "Limpopo,South Africa",
    "Does Remote Internship work for you?": "Yes, anywhere around the world",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Mailulamphokeng@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 04:09:10",
    "Name of the student": "Janam Mehta",
    "Institute Name(College)": "University of Bristol",
    "Field of study": "International Business",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Brand Strategy or Marketing",
    "Period of Internship": "2/3 Immediate",
    "Current Location(With Country)": "United Kingdom",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1pvlg6qF9ANRN_2dCRoRgJTutgQ0liMMY",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/janam-m-9162a0a1?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bt3xnmEzGRW2gC7W8wgBzZQ%3D%3D",
    "Contact Details (Email)": "janamehta003@gmail.com",
    "Anything else you'd like to share?":
      "Currently based out in UK, looking for Remote internship. Not to worry of the time difference or communication.",
  },
  {
    Timestamp: "04/13/2020 06:40:46",
    "Name of the student": "Sushovan Sen",
    "Institute Name(College)": "Institute of Engineering & Management",
    "Field of study": "MBA",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months,June to August",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes,Kolkata,West Bengal",
    "Link to Resume(Google Drive/Dropbox)":
      "https://1drv.ms/w/s!AglArc4YLc6egSlWgGuGWHcTfOz5",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sushovan-sen-b9952113a",
    "Contact Details (Email)": "sushovansen89@gmail.com",
    "Anything else you'd like to share?":
      "I will give my level best to achieve the goals of the internship.",
  },
  {
    Timestamp: "04/13/2020 06:42:03",
    "Name of the student": "Arpan Bhattacharya",
    "Institute Name(College)": "IFMR",
    "Field of study": "Finance, research, equity, financial markets",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance, data analysis",
    "Period of Internship": "Immediately available, 3-4 months",
    "Current Location(With Country)": "Bengaluru (India)",
    "Does Remote Internship work for you?": "Yes, Bengaluru",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1coqSsJ7MzduJldg6v8MfZQ--Sve2q_aH/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arpan-bhattacharya-0b3119138/",
    "Contact Details (Email)": "veddeomali94@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 07:17:25",
    "Name of the student": "Nicole Wong",
    "Institute Name(College)": "Gonzaga University",
    "Field of study":
      "Business Administration with Human Resources Concentration",
    Education: "Undergraduate",
    "Preferred domain of internship": "Human Resources",
    "Period of Internship": "3; starting May 15th",
    "Current Location(With Country)": "Sacramento, CA",
    "Does Remote Internship work for you?": "Yes;  Spokane, WA",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18cYpK4yZ7zHWEennkRXNCcoLgRPMLKh0/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/nicole-wong1125",
    "Contact Details (Email)": "nwong2@zagmail.gonzaga.edu",
    "Anything else you'd like to share?":
      "I am currently at junior at Gonzaga University, searching for an internship for summer 2020, preferably in Spokane, WA.",
  },
  {
    Timestamp: "04/13/2020 09:02:50",
    "Name of the student": "Atharva Tanksale",
    "Institute Name(College)":
      "Indian Institute of Science Education and Research (IISER) Pune",
    "Field of study": "Mathematics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics, Data Science, Quant",
    "Period of Internship": "",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RRYsN31qj_wznpnj4g2fUBIQ9aCAXeVk/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/atharva-tanksale/",
    "Contact Details (Email)": "atharva.tanksale@students.iiserpune.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 09:30:09",
    "Name of the student": "Nitish Arora",
    "Institute Name(College)": "Ambedkar University, Delhi",
    "Field of study": "Masters in Social Design",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Art, Design thinking, technology, innovation",
    "Period of Internship": "From June to August.",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Yes, I'm open to various other cities.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/eskrsuy1cptrirl/Nitish%20Arora_CV.pdf?dl=0",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "nitisharora41@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 10:12:49",
    "Name of the student": "Aishwarya Ramanathan",
    "Institute Name(College)": "IIM Indore",
    "Field of study": "Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Marketing, general management, strategy, product management",
    "Period of Internship":
      "1.5 to 2 months starting around April 20 or before too",
    "Current Location(With Country)": "Chennai",
    "Does Remote Internship work for you?":
      "Yes, open to relocate to Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iimidr.ac.in/file/d/1yJ-ccyIY_om7Q61-yVzT33iG0XfCgv6q/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aishwarya-ramanathan-105197186",
    "Contact Details (Email)": "i16aishwaryar@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 10:13:41",
    "Name of the student": "Saksham Panda",
    "Institute Name(College)": "National Institute of Design",
    "Field of study": "Lifestyle Accessory Design",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Service design",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Chanderi, Madhya Pradesh, India",
    "Does Remote Internship work for you?":
      "Bangalore, Mumbai, Delhi in order of preference.",
    "Link to Resume(Google Drive/Dropbox)": "www.sakshampanda.com",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/saksham-panda-5a2784165",
    "Contact Details (Email)": "Saksham_p@nid.edu",
    "Anything else you'd like to share?":
      "Visit my work at www.sakshampanda.com",
  },
  {
    Timestamp: "04/13/2020 10:44:21",
    "Name of the student": "Prathamesh Prakash Karbhari",
    "Institute Name(College)": "Maharashtra Institute of Technology Pune",
    "Field of study": "Bachelor of Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Engineering",
    "Period of Internship": "4 weeks to 6 weeks",
    "Current Location(With Country)": "Pune (India)",
    "Does Remote Internship work for you?": "Pune 'Visi",
    "Link to Resume(Google Drive/Dropbox)": "Visible to All'",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prathamesh-karbhari-66442815a",
    "Contact Details (Email)": "Prathameshkarbhari51@gmail.com",
    "Anything else you'd like to share?": "+91 9960749093 WhatsApp No",
  },
  {
    Timestamp: "04/13/2020 10:51:03",
    "Name of the student": "Rohan Singh Rauthan",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "BTech APE Upstrean",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum",
    "Period of Internship": "45 Days. Starting from 1st May 2020",
    "Current Location(With Country)": "Dehradun, Uttarakhand, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18sTBcKHDK6taSj4u1TrltzhDLwVULLu0/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rohanrauthan124@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 11:00:24",
    "Name of the student": "Ranjit Pradhan",
    "Institute Name(College)": "IIM Kashipur",
    "Field of study": "General management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Marketing, Business Development, Analytics",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Kolkata, West Bengal, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/19wp8j6Gkp0cjuRZWJQYyLezBcLCUNUn1/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ranjit-pradhan-94223999/",
    "Contact Details (Email)": "ranjitpradhan608@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 11:01:13",
    "Name of the student": "Shivani Adsar",
    "Institute Name(College)": "Northeastern University",
    "Field of study": "Data Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "1 July 2020, 6 months",
    "Current Location(With Country)": "Boston, USA",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uMmYfZrx298E9BbprtxekchyNexAM5HO/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivani-adsar-88100189/",
    "Contact Details (Email)": "shivaniadsar12@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 11:14:56",
    "Name of the student": "Aayush Kumar",
    "Institute Name(College)": "IIT Hyderabad",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "looking for Full Time Position in Cyber Security",
    "Period of Internship": "Full time employee",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "www.jockaayush.live/CV.pdf",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "aayushku01@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 11:31:05",
    "Name of the student": "Thana Shree Jeevanandam",
    "Institute Name(College)": "University At Buffalo",
    "Field of study": "Computer Science and Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Engineering, Machine Learning",
    "Period of Internship": "3 months. From May 17",
    "Current Location(With Country)": "Buffalo, United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZLmUsxU9rzMRe5Q303ZbbkMZVzaGUYD9/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/thanashree/",
    "Contact Details (Email)": "thanashreej@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 12:00:14",
    "Name of the student": "Apurva Rahul Utpat",
    "Institute Name(College)": "MIT School Of Architecture",
    "Field of study": "B.Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architecture, Interior Design",
    "Period of Internship": "4 months, Starting from 15/06/2020",
    "Current Location(With Country)": "Pandharpur, India",
    "Does Remote Internship work for you?":
      "Yes . Pune, Bangalore , Goa , Hyderabad , Pondicherry , Mumbai , Singapore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1BDXSje__ByKJ7GNQoKvRwGSeO7kNq6DH",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "utpat.apurva@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 12:07:35",
    "Name of the student": "Sarthak Taneja",
    "Institute Name(College)": "Chandigarh University",
    "Field of study": "B.E. CSE in Information Security",
    Education: "Undergraduate",
    "Preferred domain of internship": "Information Security",
    "Period of Internship": "6",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Bangalore.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://1drv.ms/w/s!AoowQtKouhfgj25Z4ldQBSVB4IRz",
    "LinkedIn profile link": "www.linkedin.com/in/debagga",
    "Contact Details (Email)": "tanejasarthak12@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 12:22:09",
    "Name of the student": "Harshit Gupta",
    "Institute Name(College)": "IMT Ghaziabad",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months, 20/04/2020",
    "Current Location(With Country)": "Jaipur, India",
    "Does Remote Internship work for you?":
      "Yes, my preferred city is gurgoan, delhi, jaipur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1QQJM3ug6AkH2R-HBmeYUd-8iVjlzzyEp",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harshit-gupta-93a5a294",
    "Contact Details (Email)": "harshit.231195@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 12:26:36",
    "Name of the student": "Uddesh Katyayan",
    "Institute Name(College)": "Indian Institute of Technology, Delhi",
    "Field of study": "Computer Science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software development, Machine learning, Systems and related Computer science fields",
    "Period of Internship": "24th April to 28 th June, 2 months",
    "Current Location(With Country)": "Ranchi, India",
    "Does Remote Internship work for you?":
      "Yes remote internship is fine. I can relocate to any city in India or abroad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1HbZUaxl8eb_pb4k5J3WWrPWR1fT5iCS4/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/uddesh-katyayan-415373154",
    "Contact Details (Email)": "uddeshkatyayan@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 12:30:46",
    "Name of the student": "Mahika Mathur",
    "Institute Name(College)": "BML Munjal University",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "1 month.Starting 20th April 202",
    "Current Location(With Country)": "Jaipur, India",
    "Does Remote Internship work for you?": "Yes, Gurgoan",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1D58KA5yNqLoxn42gmhfmHIFPpImtpxB4",
    "LinkedIn profile link": "www.linkedin.com/in/mahika-mathur",
    "Contact Details (Email)": "mahika.mathur.19mb@bmu.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 12:51:33",
    "Name of the student": "Devanshi Shah",
    "Institute Name(College)": "CEPT UNIVERSITY",
    "Field of study": "ARCHITECTURE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architectural",
    "Period of Internship": "June 2020- December 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1G0txTliYup72hsHDAnPyHMK1Yctjebi3",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shah.devanshi.14arches@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 12:54:59",
    "Name of the student": "Suchita Jain",
    "Institute Name(College)": "Pearl academy",
    "Field of study": "Interior design / content writer in interior design",
    Education: "Undergraduate",
    "Preferred domain of internship": "-",
    "Period of Internship": "1 -2 month",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Mumbai only.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AuNMC-QdeBkbSAmKDYMnQdDtW45-tTy0/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/suchitajain10?originalSubdomain=in#search",
    "Contact Details (Email)": "suchitajain2525.sj@gmail.com",
    "Anything else you'd like to share?":
      "My more preference is in Content writing in Design",
  },
  {
    Timestamp: "04/13/2020 13:14:35",
    "Name of the student": "Parakh Agarwal",
    "Institute Name(College)": "Army Institute of Management and Technology",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing, Finance",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Greater Noida, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://a807cba2-8005-4c2e-97f7-89dc3a51e121.filesusr.com/ugd/d0d67b_8ce87e9d626a4cc59966035d804070a6.pdf",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ctpo@aimt.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 13:16:36",
    "Name of the student": "Pratibha Sen",
    "Institute Name(College)":
      "Delhi Technological University (DTU), formerly DCE",
    "Field of study": "B.Tech in Engineering Physics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Non Tech Analyst roles and Marketing R&D roles",
    "Period of Internship": "2-3 months, 25-05-2020",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?":
      "Yes. Yes open to relocate after lockdown, Bangalore, Mumbai, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1N573M5Q5YyQ-G89x_Vo9oX7Z7PdeUXe3",
    "LinkedIn profile link": "https://www.linkedin.com/in/pratibhasen",
    "Contact Details (Email)": "senpratibha01@gmail.com",
    "Anything else you'd like to share?":
      "I am a quality and result oriented college student currently pursuing B.Tech in Engineering Physics with major in \nElectronics from Delhi Technological University. During the course of my academic career, I also managed to acquire 9 months of Corporate work experience. I had the privilege of working with MASH Project Foundation, New Delhi in a Corporate Executive role in my free time, where I learned valuable professional skills such as project planning, \nresearch and development, and experimental design. \nI am actively and sincerely looking for any opportunities of a fruitful internship for Summer 2020.",
  },
  {
    Timestamp: "04/13/2020 13:31:52",
    "Name of the student": "Ajanta Kancharla",
    "Institute Name(College)": "Mahindra Ecole Centrale, Hyderabad",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development ( preferably on Python)",
    "Period of Internship": "Starting immediately, for 2-3 months",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Yes, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11NAo7DCDH4-Sd08RvD_-CJ-ajjhhmRG2/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/ajanta-kancharla-685675156",
    "Contact Details (Email)": "Kancharla.ajanta@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 14:57:33",
    "Name of the student": "Sowmiya V J",
    "Institute Name(College)": "Christ university",
    "Field of study": "MBA marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "6 weeks to 8 weeks (April 15)",
    "Current Location(With Country)": "Coimbatore, Tamilnadu, India",
    "Does Remote Internship work for you?": "Yes, banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1yDC-o9YkBvsQIs_I2MZr-z3y0ZabUQi2",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/sowmiya-venugopal-7982b9104",
    "Contact Details (Email)": "sowmiya.vj@mba.christuniversity.in",
    "Anything else you'd like to share?":
      "This is really nice initiative when all students are struggling with such uncertainty happened. Thanks for the offer. I would be really thankful for this opportunity",
  },
  {
    Timestamp: "04/13/2020 15:48:59",
    "Name of the student": "Ashish Gupta",
    "Institute Name(College)": "Indian Institute of Technology(IIT), Delhi",
    "Field of study": "Mathematics and Computing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development(Machine Learning or Algorithms preferred)",
    "Period of Internship": "2 months(From May)",
    "Current Location(With Country)": "Prayagraj, India",
    "Does Remote Internship work for you?": "Yes- Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1f6BI4INwcv6FeRbw92it16XL9HckBdR5/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/ashish-gupta-585a82169",
    "Contact Details (Email)": "ashish.gupta0925@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 15:50:05",
    "Name of the student": "Ayan Adhya",
    "Institute Name(College)": "Indian Institute of Technology (IIT), Goa",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development, Web Development, Machine Learning",
    "Period of Internship": "2-3 months, Start Date - 1st June 2020",
    "Current Location(With Country)": "Vadodara, Gujarat ( India )",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=12tT4EDTXvJuIod1a7EZcdZMNNNn3dDkA",
    "LinkedIn profile link": "https://www.linkedin.com/in/ayan-adhya/",
    "Contact Details (Email)": "ayan.adhya.18003@iitgoa.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 17:32:27",
    "Name of the student": "shreya chaudhary",
    "Institute Name(College)": "NIT Kurukshetra",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Content",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shreya.ayanna.164@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 19:12:14",
    "Name of the student": "Aayush Totuka",
    "Institute Name(College)": "Christ University",
    "Field of study": "Bachelors of Business Administration(BBA)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Strategic Management, Consulting, Research, core marketing roles",
    "Period of Internship":
      "2-3 months. Can start Immediately. Want an opportunity which can eventually get converted to fulltime",
    "Current Location(With Country)": "Jaipur, India",
    "Does Remote Internship work for you?":
      "Yes. Can relocate to Gurgaon, Mumbai, Bengaluru",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1a7cXa3k9pxMlFctxcjx97nvW659PijNh",
    "LinkedIn profile link": "http://linkedin.com/in/aayush-totuka-0a3a60159",
    "Contact Details (Email)": "aayushtotuka08@gmail.com",
    "Anything else you'd like to share?":
      "I have internship experiences with Vodafone Idea limited (Branding) and Bayside Media Pvt Ltd(Sales head). I see myself as a motivated and versatile individual who is always looking to expand the domain of experiences and knowledge. I have experience in both leading and being part of teams. My key skill is clarity in communication and decisive critical reasoning skills",
  },
  {
    Timestamp: "04/13/2020 19:32:28",
    "Name of the student": "Sharanya Saha",
    "Institute Name(College)": "Symbiosis School of Economics, Pune",
    "Field of study": "M.Sc. Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Research based on Financial Economics",
    "Period of Internship": "1st May- 30th June",
    "Current Location(With Country)": "West Bengal, India",
    "Does Remote Internship work for you?": "No.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/sse.ac.in/file/d/1zVIiviJjbL0xkarxKxFKIQgJxZsQi_PT/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sharanya-saha-43135282",
    "Contact Details (Email)": "sharanyasaha@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 19:48:56",
    "Name of the student": "BARNALIKKA PRADHAN",
    "Institute Name(College)": "SYMBIOSIS SCHOOL OF ECONOMICS",
    "Field of study": "ECONOMICS",
    Education: "Post-Graduate",
    "Preferred domain of internship": "DATA ANALYTICS",
    "Period of Internship": "1ST MAY 2020 (2 MONTHS AT THE MOST)",
    "Current Location(With Country)": "DARJEELING, WEST BENGAL",
    "Does Remote Internship work for you?": "GURGAON, PUNE",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Nu3LRhIb9_JivvuvnAtK2yB1nYrRlbue/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/barnalikka-pradhan-84036516a/",
    "Contact Details (Email)": "barnalikka.pradhan.2019@sse.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 20:06:03",
    "Name of the student": "Kritica Rani",
    "Institute Name(College)": "Amity University Kolkata",
    "Field of study": "B.tech(Biotechnology)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing and sales",
    "Period of Internship": "6 months ( looking for permanent job)",
    "Current Location(With Country)": "Kolkata",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1c6jB2P2X1SeGWCiGypdrhcDCI3_hZEf9/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kritica-rani-831a90134",
    "Contact Details (Email)": "drkritica97@gmail.com",
    "Anything else you'd like to share?":
      "I am very innovative and creative thinker. I give my best in whatever I do.",
  },
  {
    Timestamp: "04/13/2020 20:25:30",
    "Name of the student": "Nayan Chourasia",
    "Institute Name(College)": "Department of Management, Bits Pilani",
    "Field of study": "General MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Finance, Strategy, General MBA, Marketing",
    "Period of Internship": "2months starting 1st May",
    "Current Location(With Country)": "Katni, MP, India",
    "Does Remote Internship work for you?": "No, would prefer work from home",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1kjboXp3XtC6W9nT3okYll053FyyzbGOA/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nayan-chourasia-63760574/",
    "Contact Details (Email)": "nayanchourasia7@gmail.com",
    "Anything else you'd like to share?": "No,thank you",
  },
  {
    Timestamp: "04/13/2020 20:36:42",
    "Name of the student": "Sampatharao Swetha",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Btech, Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "45days",
    "Current Location(With Country)": "Srikakulam, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14qFEK3EF7qKxmsKZRnP52nQj3lrzFD4q/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ss91@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 20:41:49",
    "Name of the student": "Bhumika Ajmera",
    "Institute Name(College)": "BITS PILANI",
    "Field of study": "MBA - Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "www.linkedin.com/in/ bhumika-ajmera-986b6a129",
    "Contact Details (Email)": "bhumika1097@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 20:47:29",
    "Name of the student": "Sampatharao Swetha",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core",
    "Period of Internship": "45days",
    "Current Location(With Country)": "Srikakulam, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14qFEK3EF7qKxmsKZRnP52nQj3lrzFD4q/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ss91@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 20:47:46",
    "Name of the student": "Gadi Venkata Naga Sai Chandana",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core",
    "Period of Internship": "1 - 2 months",
    "Current Location(With Country)": "Visakhapatnam, Andhra Pradesh",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1i81NbjrUZDrif18rJ0-4zcXvLlaNnLug/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/gadi-sai-chandana-3114531a2",
    "Contact Details (Email)": "gsc10@iitbbs.ac.in",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/13/2020 21:00:43",
    "Name of the student": "Paritosh Narendra Wankhade",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Coding.",
    "Period of Internship": "2 months, first week of may",
    "Current Location(With Country)": "Nagpur, India.",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1YGXK6DVkJoNIXeftKhAAP6u3oRBKVnFC",
    "LinkedIn profile link": "www.linkedin.com/in/ paritosh-wankhade-040a95152",
    "Contact Details (Email)": "wpn10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 21:08:38",
    "Name of the student": "Akanksha Mudgal",
    "Institute Name(College)":
      "Birla Institute of Technology and Science, Pilani",
    "Field of study": "MBA - General Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Operations, Finance, Supply Chain Management",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Pali, Rajasthan (India)",
    "Does Remote Internship work for you?": "Jaipur, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/bits-pilani.ac.in/file/d/1jsi7bLKsHddANeSs0NRy_glXVHtfApdd/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akanksha-mudgal-457485b2",
    "Contact Details (Email)": "aknshamudgal@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 21:26:52",
    "Name of the student": "Shivani Tripathi",
    "Institute Name(College)": "IIT Bhilai",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "IT related",
    "Period of Internship": "2 months, 1/05/2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1jaUmVvuH_aqig99_IqzfHmGEoNGLFyfL",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivani-tripathi-a63353154/",
    "Contact Details (Email)": "shivanit@iitbhilai.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 22:30:23",
    "Name of the student": "SAI SASHANK NARNE",
    "Institute Name(College)": "INDIAN INSTITUTE OF TECHNOLOGY BHUBANESWAR",
    "Field of study": "MECHANICAL",
    Education: "Undergraduate",
    "Preferred domain of internship": "MECHANICAL",
    "Period of Internship": "1 MONTH",
    "Current Location(With Country)": "GUNTUR, ANDHRA PRADESH, INDIA",
    "Does Remote Internship work for you?": "KHORDHA",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "SAISASHANK333@GMAIL.COM",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 22:50:11",
    "Name of the student": "Emily Chen",
    "Institute Name(College)": "Vanderbilt University",
    "Field of study": "Political Science, Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Pre-law, NGOs",
    "Period of Internship": "2, start date - mid May-end of May",
    "Current Location(With Country)": "Memphis, TN (USA)",
    "Does Remote Internship work for you?": "Yes - any city!",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18XShgvAd0BZCnZteA1uF0dN--BONFvjG/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "emily.chen@vanderbilt.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 22:52:25",
    "Name of the student": "Akshat Singhal",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Cloud, ML",
    "Period of Internship": "6-8 weeks",
    "Current Location(With Country)": "Jaipur, Rajasthan, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RyrSKqlKvgpvD9B-6m85zsbD5VxtpmYl/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/akshatsinghal13/",
    "Contact Details (Email)": "sakshat1999@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 22:53:50",
    "Name of the student": "Namulindwa brenda",
    "Institute Name(College)": "Makerere university business school",
    "Field of study": "Bachelor's in finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance department",
    "Period of Internship": "2 months starting 1st  june",
    "Current Location(With Country)": "Kyotera uganda",
    "Does Remote Internship work for you?": "Kampala",
    "Link to Resume(Google Drive/Dropbox)": "Yes",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "brendanamu20@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 23:16:09",
    "Name of the student": "Brian Qi",
    "Institute Name(College)": "University of California, Berkeley",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "3-5 month internship; May-Aug or Aug-Dec",
    "Current Location(With Country)": "Berkeley, California (Alameda County)",
    "Does Remote Internship work for you?":
      "Remote Internship works for me. Willing to relocate if situation improves. Preferred location for relocating is in Bay Area.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/berkeley.edu/file/d/1RmeJKybWX280F034L59sZ2MsJUehIdZW/view?usp=sharing",
    "LinkedIn profile link": "http://linkedin.com/in/brian-qi",
    "Contact Details (Email)": "bqi7@berkeley.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 23:59:16",
    "Name of the student": "Surbhi Jain",
    "Institute Name(College)": "Amity University, Noida",
    "Field of study": "Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Research, data analysis, business development",
    "Period of Internship": "1 month minimum (14th April to 15th May 2020)",
    "Current Location(With Country)": "New Delhi,India",
    "Does Remote Internship work for you?": "Yes; Mumbai,Gurugram,Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11ZUcIs1iEMdCJls5Ho7pQQcec9iLVwkA/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/surbhi-jain-9b1a3813b",
    "Contact Details (Email)": "surbhi481997@gmail.com",
    "Anything else you'd like to share?": "Contact No: 9716011367",
  },
  {
    Timestamp: "04/14/2020 00:00:58",
    "Name of the student": "Adityaraj Singh Chouhan",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning (Deep Learning)",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Bhopal, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1OaVqexOKvIXXW7Ig-u1mUoHspJLTl6jV",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/adityaraj-singh-chouhan-695134178/",
    "Contact Details (Email)": "adityaraj.avanti@gmail.com",
    "Anything else you'd like to share?":
      "https://github.com/Adityaraj975/Deep-Learning-Specialization",
  },
  {
    Timestamp: "04/14/2020 00:14:22",
    "Name of the student": "Sachin Pandey",
    "Institute Name(College)": "IIT Patna",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1l_AyDY1smAGabWSLaxJ1n_cMMXmCvcow/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/sachin92102/",
    "Contact Details (Email)": "sachinpandey9918784075@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 00:18:13",
    "Name of the student": "Suyash Raj",
    "Institute Name(College)":
      "University of Petroleum & Energy Studies (UPES)",
    "Field of study": "Applied Petroleum Engineering (upstream)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Petroleum Engineering, Reservoir Engineering, Drilling, Logging & Well Testing, Data Science (ML) and  Data Analytics.",
    "Period of Internship": "1 May Onwards",
    "Current Location(With Country)": "Ranchi, Jharkhand (INDIA)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1AirEZmhkh-v0XAVCiQxiaXDZ23Sl-vYR",
    "LinkedIn profile link": "www.linkedin.com/in/sr10",
    "Contact Details (Email)": "suyash10.official@gmail.com",
    "Anything else you'd like to share?":
      "I am a pre-final year Petroleum Engineering student looking form some internship/project which will enhance my data science skill by using it in petroleum sector. I am working on Pressure decline curve using concepts of Machine Learning.",
  },
  {
    Timestamp: "04/14/2020 00:37:15",
    "Name of the student": "Priyanuj Bordoloi",
    "Institute Name(College)":
      "Indian Institute of Science Education and Research Kolkata",
    "Field of study": "Physics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Photonics and computational physics",
    "Period of Internship": "Until June 1st",
    "Current Location(With Country)": "Guwahati, India",
    "Does Remote Internship work for you?": "Yes, remote internship works",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyanuj-bordoloi-356404184/",
    "Contact Details (Email)": "pb.iiserkol@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 00:44:01",
    "Name of the student": "Suhani Brahme",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2 to 3 months, starting tomorrow",
    "Current Location(With Country)": "Raipur, Chhattisgarh",
    "Does Remote Internship work for you?": "Yes, i would prefer Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1NtAvdFaYX_e14_rCEPgkHeG9Gaoqe2o5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/suhani-brahme-a011131a1",
    "Contact Details (Email)": "suhanibrahme@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 00:44:18",
    "Name of the student": "Suhani Brahme",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2 to 3 months, starting tomorrow",
    "Current Location(With Country)": "Raipur, Chhattisgarh",
    "Does Remote Internship work for you?": "Yes, i would prefer Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1NtAvdFaYX_e14_rCEPgkHeG9Gaoqe2o5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/suhani-brahme-a011131a1",
    "Contact Details (Email)": "suhanibrahme@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 01:44:56",
    "Name of the student": "Abhishek Kumar",
    "Institute Name(College)": "Kiit university",
    "Field of study": "Computer science and system engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software engineering internship",
    "Period of Internship": "3 to 6",
    "Current Location(With Country)": "Jamshedpur,india",
    "Does Remote Internship work for you?":
      "Yes remote will work  yes I can relocate Bangalore,Pune,delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/kiit.ac.in/file/d/1cY3YT_Mh_2FI4TDIvHiqdosPQbEidp9Z/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sayabhi15u@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 02:01:52",
    "Name of the student": "Md Kashif Aftab",
    "Institute Name(College)": "Dit University, Dehradun",
    "Field of study": "B.tech in petroleum and energy studies",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Petroleum or sales and marketing related",
    "Period of Internship": "One or two months",
    "Current Location(With Country)": "Bihar, India",
    "Does Remote Internship work for you?": "Delhi, Dehradun, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AMVcYBMaB3E08Zy0YEV4Qm9hc4wneP2I/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kashif-aftab-23b873192",
    "Contact Details (Email)": "kashifaftab7@gmail.com",
    "Anything else you'd like to share?":
      "Looking forward to a positive response",
  },
  {
    Timestamp: "04/14/2020 05:15:04",
    "Name of the student": "Drake Connell",
    "Institute Name(College)": "Auburn University",
    "Field of study": "Human Resources",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Charlotte, NC",
    "Period of Internship": "05/04-07/31",
    "Current Location(With Country)": "Auburn, AL (United States)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "www.linkedin.com/in/wdconnell",
    "Contact Details (Email)": "connell.wd@gmail.com",
    "Anything else you'd like to share?":
      "I�m looking to relocate to Charlotte, NC.",
  },
  {
    Timestamp: "04/14/2020 05:58:45",
    "Name of the student": "Abhishek Nigam",
    "Institute Name(College)": "JIIT",
    "Field of study": "Ece",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data science,AI,machine learning,telecom,vlsi or any such domain or interested to work in new technologies too.",
    "Period of Internship": "4-6weeks",
    "Current Location(With Country)": "Kanpur,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "nigamyash11@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/14/2020 06:23:13",
    "Name of the student": "Jason Patskanick",
    "Institute Name(College)": "University of Georgia",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business preferably in consulting or analytics",
    "Period of Internship": "Preferably 3 months and May 8th",
    "Current Location(With Country)": "Atlanta, Georgia",
    "Does Remote Internship work for you?":
      "Preferably work in Atlanta, Georgia or surrounding area",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1WgH8QN2z0v9wuZ8DNYwYjFT_KX-3aWDg/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/jason-patskanick",
    "Contact Details (Email)": "Jason.patskanick@gmail.com",
    "Anything else you'd like to share?": "Graduating in May 2020.",
  },
  {
    Timestamp: "04/14/2020 07:04:45",
    "Name of the student": "Kalpit Yadav",
    "Institute Name(College)": "IIT Kanpur",
    "Field of study": "EE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engg and Data Science",
    "Period of Internship": "2 months - starting mid April",
    "Current Location(With Country)": "Kanpur- India",
    "Does Remote Internship work for you?": "Yes. Any major city is preferred",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kalpit-yadav-011791147/",
    "Contact Details (Email)": "kalpit@iitk.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 07:45:39",
    "Name of the student": "Drake Connell",
    "Institute Name(College)": "Auburn University",
    "Field of study": "Human Resources",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Charlotte, NC",
    "Period of Internship": "05/04-07/31",
    "Current Location(With Country)": "Auburn, AL (United States)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "www.linkedin.com/in/wdconnell",
    "Contact Details (Email)": "connell.wd@gmail.com",
    "Anything else you'd like to share?":
      "I�m looking to relocate to Charlotte, NC.",
  },
  {
    Timestamp: "04/14/2020 08:13:57",
    "Name of the student": "Supratim Dhar",
    "Institute Name(College)": "IIT Kgp",
    "Field of study": "Finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Sure",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "supratimdhar21@yahoo.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 09:27:35",
    "Name of the student": "Anjita jangid",
    "Institute Name(College)": "SMS, University of Hyderabad",
    "Field of study": "Healthcare and Hospital Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing and Operations",
    "Period of Internship":
      "7-8 weeks, starting now if remote, if in-office- strting after lift of lockdown",
    "Current Location(With Country)": "Jaipur, Rajasthan, India",
    "Does Remote Internship work for you?": "Yes, Any city",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anjita-jangid-778651192",
    "Contact Details (Email)": "anjitajangid@hotmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 09:49:06",
    "Name of the student": "Seher Mehta",
    "Institute Name(College)": "Amity University",
    "Field of study": "B.B.A in international business",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Management and Marketing \n\nStarting from the position of a mere community member at Young Engine to climbing up the ladder to join the leadership board, I traversed from implementing strategies to formulating them and have upscaled the reach by 20x (times). \nMy past experience has helped me experiment with various sides of Marketing and I have successfully developed data-driven marketing strategies & cultivated communities around Brand to:\n1. Elevate Brand Visibility\n2. Upgrade Brand Perception and Differentiate Positioning among users.\n3. Build Robust customer relationships through experiential engagement avenues.",
    "Period of Internship":
      "2 months\n\nMy Internship at United Nations and Start-up Monk demanded the management of teams of 120+ people thereby adding leadership and team management to my repository of skills. \n\nI want to dive into as diverse set of projects as possible to savour new challenges and fill my backpack with learnings, experiences and knowledge",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1QZRTwAjMpu3d6IIqiG-LaIZBfjgwth90/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/sehermehta",
    "Contact Details (Email)": "sehermehta99@gmail.com",
    "Anything else you'd like to share?":
      "I�m a Strategic Marketer currently pursuing B.B.A in International Business. Project management is a Wholesome Package catering to my insatiable appetite to Solve consumer problems, Create, Experiment and Learn. Thus, I intend to utilise the expertise gained from pursuing 15+ projects at 8 organisations to the utmost potential.\n\nPursuing a multitude of diverse roles at  Start-ups at different stages aided me to inbuilt a problem-solving mechanism.\nI�ve always been fiercely independent and competitive and like to see tangible results for the effort I put in. Sales align with this aspect of my personality. Devoting a healthy share of my time in the sales department at multiple companies empowered me to understand consumer psychology and discover multiple user touchpoints further enabling me to establish fruitful marketing strategies. My regular interactions involved negotiation with a dynamic set of clients as well as guiding teams thereby enabling me to master my communication skills.",
  },
  {
    Timestamp: "04/14/2020 10:01:22",
    "Name of the student": "Taritla Ratna Shyli",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Civil engineering",
    "Period of Internship": "1 month",
    "Current Location(With Country)":
      "Kothapeta, Rajahmundry ,East Godavari district, Andhrapradesh, India",
    "Does Remote Internship work for you?": "Yes, Rajahmundry",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iZ1kCeD5BByhknXJIQMX-B5TUz41SITQ/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "trs11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 10:15:36",
    "Name of the student": "Taritla Ratna Shyli",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Civil engineering",
    "Period of Internship": "1 month",
    "Current Location(With Country)":
      "Kothapeta, Rajahmundry, East Godavari district, Andhrapradesh, India",
    "Does Remote Internship work for you?": "Yes, Rajahmundry",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iZ1kCeD5BByhknXJIQMX-B5TUz41SITQ/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "trs11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 11:56:10",
    "Name of the student": "Samiksha Bhopale",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months, may 5 would be start date",
    "Current Location(With Country)": "Nanded, maharashtra,  India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/samiksha-bhopale-b7852a125/",
    "Contact Details (Email)": "8857832428",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 12:20:48",
    "Name of the student": "Mansi Jain",
    "Institute Name(College)": "Maharaja Agrasen Institute of Technology",
    "Field of study": "Bachelor of Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Developer",
    "Period of Internship":
      "3 months from june 1st else depends upon requirement of the company",
    "Current Location(With Country)": "New Delhi ( India )",
    "Does Remote Internship work for you?":
      "yes, I can relocate and my preferred city would be Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SPql7CVDbOe-_VfGxpfC3RxoOCeZ_idm/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mansi-jain-b1b739184/",
    "Contact Details (Email)": "mansijain2405@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 12:56:54",
    "Name of the student": "Aashish Choudhary",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analysis, finance, technical,core",
    "Period of Internship": "2/3 starting from april",
    "Current Location(With Country)": "Nagaur, Rajasthan, India",
    "Does Remote Internship work for you?":
      "Yes i would like to work from home",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1LRIcaIwtIOjVrxNPjZlrm7ykm4jh4GNA",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "aashishchoudharyhhm@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 13:09:01",
    "Name of the student": "Dhwani Doshi",
    "Institute Name(College)": "CEPT University",
    "Field of study": "Urban design",
    Education: "Undergraduate",
    "Preferred domain of internship": "Urban design",
    "Period of Internship": "6months (june-december)",
    "Current Location(With Country)": "Ahmedabad, Gujarat, India",
    "Does Remote Internship work for you?":
      "Anywhere in india. Singapore in abroad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1rwSAq3P_alqoFelRgZHLMJEV44bIH9RK",
    "LinkedIn profile link": "https://www.linkedin.com/in/dhwani-doshi-dd",
    "Contact Details (Email)": "dd.dhwani.doshi@gmail.com",
    "Anything else you'd like to share?":
      "https://issuu.com/doshidhwani./docs/internship1",
  },
  {
    Timestamp: "04/14/2020 13:42:52",
    "Name of the student": "Soh Kai Jian",
    "Institute Name(College)": "Nanyang Technological University (Singapore)",
    "Field of study": "Business (Banking and Finance)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "3 months (Starting May 1st 2020)",
    "Current Location(With Country)": "Singapore",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/181oU09VVgjxn9LlGrjmf1DhZTWAjhLM-/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/kaijiansoh/",
    "Contact Details (Email)": "kaijiansoh@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 13:45:21",
    "Name of the student": "Shubhi Mangal",
    "Institute Name(College)": "Shiv Nadar University",
    "Field of study": "MBA-Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance, Data Analytics",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Delhi NCR, India",
    "Does Remote Internship work for you?": "Anywhere in Delhi and Delhi NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1s9IrbI49C3cQvxGH5PQyuLwyvsSJw7c0",
    "LinkedIn profile link": "www.linkedin.com/in/shubhimangal98",
    "Contact Details (Email)": "shubhimangal1998@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 14:28:48",
    "Name of the student": "Parth Upadhyay",
    "Institute Name(College)": "ESC Rennes, France",
    "Field of study": "MSc in International Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Financial Analysis, Risk Management, Corporate Finance",
    "Period of Internship": "6",
    "Current Location(With Country)": "Rennes, France",
    "Does Remote Internship work for you?":
      "Yes, Open to relocate in Jaipur, Mumbai, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/10ZQEFFg8I7TjdN3erBNx9Gste7v4fTTk/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/parthupadhyay31/",
    "Contact Details (Email)": "parthupadhyay22@gmail.com",
    "Anything else you'd like to share?":
      "I am available starting from July/August 2020 if the situation gets better in France and Non-EU borders open.",
  },
  {
    Timestamp: "04/14/2020 14:32:14",
    "Name of the student": "Koushika Bandineni",
    "Institute Name(College)":
      "Indian Institute of Information Technology (Design and Manufacturing) Kancheepuram",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development, Machine Learning",
    "Period of Internship": "5 months (12 May 2020)",
    "Current Location(With Country)": "Hyderabad, Telangana, India",
    "Does Remote Internship work for you?": "Chennai,Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1C8MhtZ3kYkKM8skVQh6tRLNZKDBTYo80/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/koushika-bandineni-22722317a",
    "Contact Details (Email)": "koushikabandineni@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 14:44:11",
    "Name of the student": "Nalam sai Srinivas",
    "Institute Name(College)": "Gitam university",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Construction management",
    "Period of Internship": "1-5 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Visakhapatnam",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1OGXxPaackN98B6lZzU11R3oppT2lnf0B/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sai-srinivas-6a0729171",
    "Contact Details (Email)": "nalamsaisrinivas@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 14:57:22",
    "Name of the student": "Shilpa Joseph",
    "Institute Name(College)": "Amrita Vishwa vidyapeetham, kollam, Kerala",
    "Field of study":
      "Computer Science Engineering, specialization in Machine Learning",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Machine Learning / software engineer",
    "Period of Internship": ">6",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1CtGFcnGH2Cw2SECBoaWRiL006cB4o7Bi",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shilpajosephp4@gamil.com",
    "Anything else you'd like to share?":
      "I'm passionate in ML and AI and have an educational background in ML and also did many ML based projects as part of my curriculum",
  },
  {
    Timestamp: "04/14/2020 15:43:16",
    "Name of the student": "Amit Kumar",
    "Institute Name(College)": "NIT RAIPUR",
    "Field of study": "Bio-medical-Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Programming",
    "Period of Internship": "45 days. (20/4/2020)",
    "Current Location(With Country)": "Barauni, Bihar, india",
    "Does Remote Internship work for you?":
      "Yes, I will be good for me if you relocate in any of these cities ( Patna,Raipur, Bangalore).",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1Oo-FLF4MXPdN4AJctESsbMJyJs9ir-1A_rwoav2RH7U/edit?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/amit-kumar-6a89a7181",
    "Contact Details (Email)": "amitkri8989@gmail.com",
    "Anything else you'd like to share?":
      "As the document provided above, I am a Beginner in Data structure, and my field of study is not related to IT-sector, but I eager to improve my knowledge in IT field.so I think, this internship will help me a lot more in the field of programming...",
  },
  {
    Timestamp: "04/14/2020 15:54:23",
    "Name of the student": "Aashish Rai",
    "Institute Name(College)": "S.V. National Institute of Technology Surat",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer Vision",
    "Period of Internship": "2 months (anytime)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      'No, I would prefer "work from home".',
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1MUZnxiEH33LrLCv-H9Pysv3JDsmO1mII",
    "LinkedIn profile link": "https://www.linkedin.com/in/aashishrai3799",
    "Contact Details (Email)": "aashishrai3799@gmail.com",
    "Anything else you'd like to share?":
      "Due to my strong exposure and a year+ experience, I would prefer to work in the domain of Computer Vision/Image Processing/Deep Learning.",
  },
  {
    Timestamp: "04/14/2020 16:16:02",
    "Name of the student": "Neelu Gupta",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "1-2 months, starting immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Delhi NCR, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ovxJWvlwe9R4JZ-pAioC5D5NNTCyY0lz/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/neelu-gupta",
    "Contact Details (Email)": "gptneelu1997@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 16:24:20",
    "Name of the student": "Samyak Agarwal",
    "Institute Name(College)": "Amity University Haryana",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "data analyst",
    "Period of Internship": "4 months from 1st June 2020",
    "Current Location(With Country)": "Gurugram, India",
    "Does Remote Internship work for you?": "yes, Gurugram",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cbOdmM0tQLsSPucXXRle6SKJebvqISzM/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/samyak-agarwal-540590158",
    "Contact Details (Email)": "samyakagarwal20@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/14/2020 16:27:24",
    "Name of the student": "Pratyush Kesarwani",
    "Institute Name(College)": "Nit Raipur",
    "Field of study": "Biomedical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Healthcare sector OR data Analytics",
    "Period of Internship": "20-4-20 to 20-5-20",
    "Current Location(With Country)":
      "23A/14A Rajendra Nagar katghar Prayagraj UP",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cPm7fxc_JxNNWzN5_pgddhFrmtrDRUAQ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pratyush-kesarwani-2b6601171",
    "Contact Details (Email)": "pratyushkesharwani039@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 16:46:11",
    "Name of the student": "Ankit Verma",
    "Institute Name(College)":
      "Rajiv Gandhi Institute of Petroleum Technology, Jais",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Industry (Upstream)",
    "Period of Internship": "4 - 8 weeks",
    "Current Location(With Country)": "Lucknow, Uttar Pradesh",
    "Does Remote Internship work for you?":
      "Yes, the remote internship works for me however as I am a student currently pursuing BTech in Petroleum Engineering so I have to join the college to complete my academics when the lockdown gets over. Thus , I will prefer working remotely .",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1cFaReZ7ym0Caw8gLZJilthTogg3qJrtP",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ankit-verma-4227b4156/",
    "Contact Details (Email)": "epe17007@rgipt.ac.in",
    "Anything else you'd like to share?":
      "I thank you for taking such an initiative for the student community who is facing difficulty in finding the internships due to the Covid-19 outbreak.",
  },
  {
    Timestamp: "04/14/2020 17:15:34",
    "Name of the student": "Neha Sonthalia",
    "Institute Name(College)": "XIMB",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2months (ending by June end)",
    "Current Location(With Country)": "Bhubaneswar (India)",
    "Does Remote Internship work for you?": "Yes, Bangalore or Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1hMbuM6ouHnqysX3LLssJaoUBv8WTihog/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/nehasonthalia001/",
    "Contact Details (Email)": "um19223@stu.ximb.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 18:04:33",
    "Name of the student": "Vedang Karwa",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Electrical Eng. and Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning, Computer Vision , SDE",
    "Period of Internship":
      "start date - 1 May 2020, end Date 30th June 2020 (2 months)",
    "Current Location(With Country)": "Jodhpur, India",
    "Does Remote Internship work for you?":
      "Yes, remote works for me. Also I am willing to relocate in case to Delhi, Mumbai, Bangalore, Madras out of India also",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Jzr3Bv-OajHdkjQPrz_XWsyDViaACNiS/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vedang-karwa-012645165/",
    "Contact Details (Email)": "vedangkarwa1@gmail.com",
    "Anything else you'd like to share?": "I am in very need of this.",
  },
  {
    Timestamp: "04/14/2020 18:28:41",
    "Name of the student": "Devesh singh",
    "Institute Name(College)": "Delhi technological University",
    "Field of study": "Mathematics and computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software engineering",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "Https:bit.ly/deveshcvs",
    "LinkedIn profile link": "https://www.linkedin.com/in/d3v3sh5ingh",
    "Contact Details (Email)": "d3v3sh.singh@gmail.com",
    "Anything else you'd like to share?":
      "My offer is revoked for internship this summer.I am looking for work from home or in office summer internship actively.",
  },
  {
    Timestamp: "04/14/2020 18:32:38",
    "Name of the student": "Evita Rodrigues",
    "Institute Name(College)": "St. Stephen's College",
    "Field of study": "Political Science and Economics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Social Consultancy, Public Policy, Social Science Research,",
    "Period of Internship": "2 months - starting April 15",
    "Current Location(With Country)": "Goa, India",
    "Does Remote Internship work for you?": "Remote, can relocate to Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TrAny-KsURLqGGq94XTbyKvHnsRI09KG/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/evita-rodrigues-a07204aa",
    "Contact Details (Email)": "evitarodrigues2911@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 18:49:04",
    "Name of the student": "Shreya Balakrishnan",
    "Institute Name(College)": "Indian Institute of Technology, Hyderabad",
    "Field of study": "Master of Design",
    Education: "Post-Graduate",
    "Preferred domain of internship": "UX Design",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?":
      "Yes, preferably Bangalore and Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PCcMxuR1HjdSs7Op6A4ATPwNGp_3ICt2/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shreya-balakrishnan-950a29104/",
    "Contact Details (Email)": "shreyabala29@gmail.com",
    "Anything else you'd like to share?":
      "Portfolio LInk : https://bit.ly/38BpY4V",
  },
  {
    Timestamp: "04/14/2020 19:07:13",
    "Name of the student": "Jayaditya Gupta",
    "Institute Name(College)":
      "IIT, Delhi (Indian Institute of Technology, Delhi)",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "2; 25th April,2020",
    "Current Location(With Country)": "Jaipur, Rajasthan",
    "Does Remote Internship work for you?": "Delhi, Bengaluru, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=16xe3twfT_l8ut86lME3WhkgTR0kg6Nno",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jayaditya-gupta-a11a8a40/",
    "Contact Details (Email)": "jaygupta999@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 19:07:49",
    "Name of the student": "aiishvar chandra",
    "Institute Name(College)": "Welingkar Institute of management",
    "Field of study": "PGDM-Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Banaglore/Mumbai/Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1MwAqYMASomSviPyQR-X-YwCsi-87oMY1",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aiishvar-chandra-74649578/",
    "Contact Details (Email)": "aiishvar@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 19:44:21",
    "Name of the student": "Sweta Rani Sahu",
    "Institute Name(College)": "IIIT-BHUBANESWAR",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine learning, Data Science, Software development",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Hyderabad, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iiit-bh.ac.in/file/d/1VDhD8BLa0EeZJ5rF6T6RbuvIhqTGAy9U/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sweta-rani-sahu-884415166",
    "Contact Details (Email)": "s.swetasahu98@gmail.com",
    "Anything else you'd like to share?":
      "Would try my best and carry out the assigned task very smoothly and efficiently and render optimized solutions.",
  },
  {
    Timestamp: "04/14/2020 20:43:30",
    "Name of the student": "Nehal Joshi",
    "Institute Name(College)": "JIIT NOIDA",
    "Field of study": "Computer Science, Electronics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data science, Artificial intelligence, Machine learning",
    "Period of Internship": "start date immidiately, end date - 31-07-20",
    "Current Location(With Country)": "Delhi(India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1LQ4-Xg19R3NBdFLpVzOFb67701TkDbaPIpcDY81DJ3k",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "2nehaljoshi@gmail.com",
    "Anything else you'd like to share?":
      "I combine my work with day to day problems, so I could understand their need. I have completed my training in machine learning and I'm very familiar with all the associated algorithms including deep learning frameworks. I have a broad spectrum of knowledge including probability and random processes, economics, finance, human resource management and many more subjects that can contribute a lot towards this opportunity. I have also worked to text classification, text sentiment analysis, I've made a simple voice recognition program in python as mentioned in my CV. I am currently working on writing a research paper on the transmission of an image losslessly and safely through a series of image processing techniques and encrypting it so as to enhance it's security and also embedding information into it for its recovery. I have also worked with web scraping, data cleaning, data extraction, making decisions upon seeing trends in data on exploring it extensively. I have a great interest in combining them with machine learning and artificial intelligence. I am not driven by materialism, I'm rather driven by the need to solve a real-life problem practically. Furthermore, I've made several short and scalable programs with considerably high accuracy. I would request you to refer to some of the projects I've worked on, which include working on some basic algorithms and some scraping projects. In addition to these projects, I have also done a sentiment analysis of Youtube comments based on a particular channel/video.\n\nHERE IS A LINK TO SOME WORK SAMPLES: \nhttps://drive.google.com/open?id=1u_M7bHFlukfSC1AO-GA9XqdqeurwWnAY",
  },
  {
    Timestamp: "04/14/2020 20:58:57",
    "Name of the student": "Abhishek Singh",
    "Institute Name(College)":
      "Jaypee Institute of Information technology noida",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Front end development ui development",
    "Period of Internship":
      "3-4 months internship starting from first or second week of may",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Noida Ghaziabad delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TrmoWLACMhaFjLyHVKZLxgPy2t-QDG5p/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-singh-303985165",
    "Contact Details (Email)": "abhishek.singh5665720@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/14/2020 21:33:58",
    "Name of the student": "Ritam Roy",
    "Institute Name(College)":
      "Symbiosis Institute of Digital and Telecom Management",
    "Field of study": "Analytics and Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Business Analyst, Market Research, Audit, Consultancy",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Kolkata, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uMYBJ_nzU014ckqnLa-YPPAtIAJby5nM/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/ ritam-roy-236023181",
    "Contact Details (Email)": "ritam.roy1921@sitm.ac.in",
    "Anything else you'd like to share?":
      "I am ready to start my internship as early as possible. I am flexible with work from home opportunity and after the lockdown ready to move to applicable location",
  },
  {
    Timestamp: "04/14/2020 21:44:16",
    "Name of the student": "Naman Jain",
    "Institute Name(College)": "Jaipuria Institute of Management, Jaipur",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "15-April- June",
    "Current Location(With Country)": "Jaipur, Rajasthan, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/jaipuria.ac.in/file/d/1ofe-Qkhz7wlo3hGJgYCd1v2f8kAX4rj5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/naman-jain-442a18124/",
    "Contact Details (Email)": "naman.gmna19@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 22:13:09",
    "Name of the student": "Yash Raj",
    "Institute Name(College)": "Rajiv Gandhi Institute of Petroleum Technology",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas",
    "Period of Internship": "1-2 months. I can start internship immediately.",
    "Current Location(With Country)": "Patna, Bihar.",
    "Does Remote Internship work for you?":
      "Yes. Lucknow, Raebareli, Amethi, Ahmedabad, Dehradun, Patna, Nalanda.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/rgipt.ac.in/file/d/1iSJkIn7pajYi6yLJ4UfxJ9npel2yEfuw/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/yash-raj-411092153",
    "Contact Details (Email)": "epe17059@rgipt.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 22:29:35",
    "Name of the student": "Abid Rais",
    "Institute Name(College)":
      "New York University, Tandon School of Engineering",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "Last week of May to end of August.",
    "Current Location(With Country)": "Brooklyn, New York, United States",
    "Does Remote Internship work for you?":
      "I am open to relocation and I have no preference on where the internship will take place. I am open to remote internships.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://abidrais.pro/abidraisResume.pdf",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "abidrais1843@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 22:46:41",
    "Name of the student": "Devansh Tandon",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Business Administration and Environmental Studies",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance/Investment Banking",
    "Period of Internship": "3 Months (May 15th- August 15th)",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes, can relocate to Los Angeles",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/150nif0HLrxXE5BcmHdY8tLh3d6cQFmqD/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/devansh-tandon/",
    "Contact Details (Email)": "dtandon@usc.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 22:57:34",
    "Name of the student": "Anirudha Hankare",
    "Institute Name(College)": "VAMNICOM Pune",
    "Field of study": "PGDM ABM",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Agriculture and allied sectors",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "PAN India",
    "Does Remote Internship work for you?": "PAN India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iMe_bX8WtEgqPwjR4xoArNMX0kS9HEz7/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "anirudh.vamnicom19@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 23:17:06",
    "Name of the student": "Abhigyna Gaddipati",
    "Institute Name(College)": "Indian Institute of Management, Indore",
    "Field of study": "General Management",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months, April-June",
    "Current Location(With Country)": "Hyderabad, Telangana, India",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1PnSpPqa6icvnjKL0FIlnEwgZ3dfRh4gS",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhigyna-gaddipati-a86059112/",
    "Contact Details (Email)": "p19abhigynag@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 23:28:38",
    "Name of the student": "Abhinav Pateria",
    "Institute Name(College)": "IIT Kanpur",
    "Field of study": "Data Analytics, Data Science , Machine Learning",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Analytics, Data Science , Machine Learning",
    "Period of Internship": "2, immediately",
    "Current Location(With Country)": "Kanpur, India",
    "Does Remote Internship work for you?": "Yes . Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cW3sk5eN6MqfVOI4OEuFZgaw3DLhvlr4/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhinav-pateria-14a170181",
    "Contact Details (Email)": "pateriaabhinav2@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 23:30:51",
    "Name of the student": "Ishaan Ahuja",
    "Institute Name(College)": "Chitkara University",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "2-4 months,can start immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ishaanahuja101@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/14/2020 23:34:59",
    "Name of the student": "Ishaan Ahuja",
    "Institute Name(College)": "Chitkara University",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "2-4 months, can start immediately",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AVDzqZcDMbuvjoGxMlTHSAJD7AHju-sn/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/ishaan2908",
    "Contact Details (Email)": "ishaanahuja101@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 00:51:56",
    "Name of the student": "Abhishek Dhiman",
    "Institute Name(College)": "Delhi Technological University (formerly DCE)",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "strategy, consulting, business analysis, business intelligence, data science/analysis, supply chain management(SCM)",
    "Period of Internship": "2 months (6-8 weeks) preferably June (flexible)",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "yes, preferably Delhi, Gurgaon (Flexible)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1EWHTch5ZBeXh8ORoBAtm88Kwi3JsVJ6I",
    "LinkedIn profile link": "linkedin.com/in/abhishek-dhiman-2769b4165",
    "Contact Details (Email)": "abhishekkumar.ak25@gmail.com",
    "Anything else you'd like to share?":
      "In case the recruiter requires an additional skill from the applicant, I will be looking forward to learning it during the quarantine period.",
  },
  {
    Timestamp: "04/15/2020 01:09:03",
    "Name of the student": "Aastha Dhamija",
    "Institute Name(College)": "Seattle Pacific University",
    "Field of study": "MS - Information Systems",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Product Management, Cybersecurity, Risk Management",
    "Period of Internship": "3-6 months | Start date: June 15, 2020",
    "Current Location(With Country)": "Seattle, USA",
    "Does Remote Internship work for you?": "Yes, California",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TPVt9w1LHEssGYEmoi-HG7xQaohT_kDo/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/aasthadhamija/",
    "Contact Details (Email)": "aastha.1202@gmail.com",
    "Anything else you'd like to share?":
      "I lost my summer internship at a leading financial institution as a product management intern in their cybersecurity division. Any kind of support would be much appreciated.",
  },
  {
    Timestamp: "04/15/2020 01:37:56",
    "Name of the student": "Shantanu Shinde",
    "Institute Name(College)": "California State University, Fresno State",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Engineer intern",
    "Period of Internship": "12 weeks",
    "Current Location(With Country)": "Fresno, California, United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dBiIaYfDdckZH21erPioYz4h4EHXL8pq/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/shantanushindee",
    "Contact Details (Email)": "shantanu_shinde_@mail.fresnostate.edu",
    "Anything else you'd like to share?":
      "I am Shantanu, and i am looking for a summer internship opportunity.\nI am a graduate student at CSU Fresno State. I have a 3.2 years of experience as a software engineer.",
  },
  {
    Timestamp: "04/15/2020 04:12:36",
    "Name of the student": "Abhishek Mishra",
    "Institute Name(College)":
      "University of Petroleum & Energy Studies, Dehradun",
    "Field of study": "Geo-informatics",
    Education: "Undergraduate",
    "Preferred domain of internship": "GIS domain.",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Dehradun, India",
    "Does Remote Internship work for you?":
      "yes, Gurgaon and Delhi is my preferred city to relocate.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1f3RM1kgtX5K7iP2OcL7bhDVsAXQcUluW",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-mishra-44ab00160/",
    "Contact Details (Email)": "mishra1234shabhi@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/15/2020 04:18:04",
    "Name of the student": "KUNAL BAMBARDEKAR",
    "Institute Name(College)": "University of Toronto",
    "Field of study": "ECE",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Analyst",
    "Period of Internship": "4/5 months",
    "Current Location(With Country)": "Canada",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1g6w2sjHcS_F8NLhRCe5rNYcSKRtMOlni/view?usp=drivesdk",
    "LinkedIn profile link": "https://in.linkedin.com/in/kunalbambardekar",
    "Contact Details (Email)": "kunal.bambardekar@mail.utoronto.ca",
    "Anything else you'd like to share?": "I'm open to remote internships too.",
  },
  {
    Timestamp: "04/15/2020 10:26:25",
    "Name of the student": "Krupal Patel",
    "Institute Name(College)": "Pandit Deendayal Petroleum University",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Oil and gas sector",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Gujarat,  India",
    "Does Remote Internship work for you?":
      "Ready to relocate anywhere in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/pdpu.ac.in/file/d/1AlPJJd3kJP2RvNoew9F7LOJDS0P_8zhX/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/krupal-patel-a6245b160",
    "Contact Details (Email)": "Krupal31032@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 13:29:54",
    "Name of the student": "Shubhnao Dixit",
    "Institute Name(College)": "IITRAM Ahmedabad",
    "Field of study": "Btech Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting,Business Management,Supply Chain",
    "Period of Internship": "45 Days/2 Months, From 20th April onwards",
    "Current Location(With Country)": "Jabalpur, Madhya Pradesh, India",
    "Does Remote Internship work for you?": "Yes, Ahmedabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1o36e-YGF48feTjoBZFsX_i4gFK796HD6/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/shubhnaodixit",
    "Contact Details (Email)": "shubhnao@gmail.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/15/2020 14:53:05",
    "Name of the student": "shambhavi suryavanshi",
    "Institute Name(College)": "",
    "Field of study": "",
    Education: "",
    "Preferred domain of internship": "",
    "Period of Internship": "",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/stu.upes.ac.in/file/d/1RTGQ0jmZR2srHH9lXoaqRZOFugm7CSRs/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shambhavi-suryavanshi-94579216a",
    "Contact Details (Email)": "suryavanshishambhavi14@gmail.com",
    "Anything else you'd like to share?":
      "I am looking for an online internship with preference in oil and energy industry; except for that I am interested in singing and writing too .",
  },
  {
    Timestamp: "04/15/2020 14:58:08",
    "Name of the student": "Errol Winston Mascarenhas",
    "Institute Name(College)": "M.S. Ramaiah Institute of technology",
    "Field of study": "chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Energy,oil,process engineering, reactor design,material science",
    "Period of Internship": "20th April- 2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Preferred location-Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1LoV1aCt0Sqnb8hAefQeA094S3gWohEpI/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/errol-mascarenhas-a354936a/",
    "Contact Details (Email)": "errolwm@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 15:26:07",
    "Name of the student": "Tanya Sachdeva",
    "Institute Name(College)":
      "Welingkar institute of management development and research Mumbai",
    "Field of study": "PGDM MARKETING",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Marketing / market research/ brand management/product management/ product research",
    "Period of Internship": "2",
    "Current Location(With Country)": "Mumbai India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1j272MBHtyfXgIQxBBz228VBVITb8eKVR/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tanya-sachdeva-b15774a9",
    "Contact Details (Email)": "tanyasachdeva1702@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 16:26:07",
    "Name of the student": "Abhishek Gupta",
    "Institute Name(College)": "Sir padampat Singhania University, Udaipur",
    "Field of study": "B.tech CSE(IOT)",
    Education: "Undergraduate",
    "Preferred domain of internship": "IOT & Big data domain",
    "Period of Internship": "2-3 month",
    "Current Location(With Country)": "Gangapur City,india",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/19YDzeTxL50FYVJ8Ha5c-xaep9aWkniDY/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-gupta-1a9a4b147",
    "Contact Details (Email)": "1502abhishekgupta@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 17:04:27",
    "Name of the student": "Anjali Shukla",
    "Institute Name(College)": "United College of Engineering and Research",
    "Field of study": "B.Tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Information Technology",
    "Period of Internship": "60 days 30th June",
    "Current Location(With Country)": "Prayagraj, India",
    "Does Remote Internship work for you?": "Yes, Lucknow, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VyK4YN63REu7okKrssayr7VQ8sr4JxMv/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://drive.google.com/file/d/1W3dA6kQCYUoc7YTBH4DwMeyPLVVFe4VJ/view?usp=drivesdk",
    "Contact Details (Email)": "anjalishuklaucer@gmail.com",
    "Anything else you'd like to share?":
      "If internship of work from home could be available that'd be very kind.",
  },
  {
    Timestamp: "04/15/2020 17:22:58",
    "Name of the student": "Asma Imam",
    "Institute Name(College)": "Jamia Millia Islamia",
    "Field of study": "MBA(International Business)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing/ HR",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Delhi NCR, Mumbai, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Q_qRZ02Mr7VCh4_m3OKlEZ3SJkDeH4Sp/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/asma-imam",
    "Contact Details (Email)": "asmaimam397a@gmail.com",
    "Anything else you'd like to share?":
      "Just looking for an organisation where I can learn and grow. Looking forward to get some great opportunities with me.",
  },
  {
    Timestamp: "04/15/2020 19:11:52",
    "Name of the student": "Kartik",
    "Institute Name(College)": "NSIT, Delhi",
    "Field of study": "CS",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning, NLP, CV",
    "Period of Internship": "2-4",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1iC5inkuFn67tmnTBOxoPqPn_Y-D5Zq1G",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "kartikaggarwal98@gmail.com",
    "Anything else you'd like to share?":
      "https://www.linkedin.com/in/kartikaggarwal98",
  },
  {
    Timestamp: "04/15/2020 19:37:28",
    "Name of the student": "Palak Mahajan",
    "Institute Name(College)": "Punjab Engineering College",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data science, development or testing, financial analyst",
    "Period of Internship": "6 months from 1 May 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1M83sIQ58JCvACWSJQEajgdc0G9jt6Bc6GZMPnhu1daI/edit?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "palakmahajan97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 19:51:04",
    "Name of the student": "Reuben Sewak",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Environmental Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      " Research intern, on water resources, air pollution, sustainability",
    "Period of Internship": "1-2 Months, 20th April, 1July",
    "Current Location(With Country)": "Vasundhra Enclave, Delhi , India",
    "Does Remote Internship work for you?": "Not confortable with relocation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1u6YzejaxVqYj9AqSc6szGDL4U1dmdMFa/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "reubensewak@gmail.com",
    "Anything else you'd like to share?":
      "I'm currently in my third year,  so I'm quite flexible on working hours",
  },
  {
    Timestamp: "04/15/2020 21:07:54",
    "Name of the student": "Pranshu soni",
    "Institute Name(College)":
      "Institute of infrastructure technology research and management",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Technical and non-technical",
    "Period of Internship": "1 month,start date-20th april",
    "Current Location(With Country)": "Chhatarpur(M.P),india",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DNSWzYS8_cgEfXIRPPssehekLVwAA2iC/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pranshu-soni-b17529161",
    "Contact Details (Email)": "pranshu.kvchh@gmail.com",
    "Anything else you'd like to share?":
      "In this pandemic,it's great getting internship",
  },
  {
    Timestamp: "04/15/2020 21:10:30",
    "Name of the student": "Vrushti Shah",
    "Institute Name(College)": "CEPT UNIVERSITY",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Any",
    "Period of Internship": "6 months (14/06/20- starting date)",
    "Current Location(With Country)": "Ahmedabad, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1K5mYD8b_lrHJ8M1he3EtHWNpR48INhxg/view?usp=drivesdk",
    "LinkedIn profile link": "-",
    "Contact Details (Email)": "vrushti1098@gmail.com",
    "Anything else you'd like to share?": "-",
  },
  {
    Timestamp: "04/15/2020 21:13:01",
    "Name of the student": "Vivek Singh",
    "Institute Name(College)": "Indian Institute of Management Ranchi",
    "Field of study": "Finance and Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance and Marketing",
    "Period of Internship": "45 to 60 days, immediately",
    "Current Location(With Country)": "Himachal, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CZEuscfgrRB17ImajvaVOqQW1IzT9udJ/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vivek-singh-04ba81184/",
    "Contact Details (Email)": "vivek.singh19@iimranchi.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 21:52:34",
    "Name of the student": "Swetalina dash",
    "Institute Name(College)": "BIMM, PUNE",
    "Field of study": "PGDM( Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2month (May to June)",
    "Current Location(With Country)": "Odisha (India)",
    "Does Remote Internship work for you?": "Yes Odisha And Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ybw4VCOMUMzD30M_bJLqrxzq7MsJfk49/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/swetalina-dash-969910187",
    "Contact Details (Email)": "swetalinadash97@gmail.com",
    "Anything else you'd like to share?":
      "Having experience of 2 years in Vedanta Ltd",
  },
  {
    Timestamp: "04/15/2020 22:57:29",
    "Name of the student": "ABHINAV JAYANTI",
    "Institute Name(College)": "CEPT UNIVERSITY",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architecture",
    "Period of Internship": "22 weeks",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, any place is fine.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/cept.ac.in/file/d/1uhBY4r8mTBJaArU4U5uNgWC89ImcLhiW/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "abhinavjayanti19@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 23:57:13",
    "Name of the student": "Adarsh Singh",
    "Institute Name(College)":
      "United College of Engineering and Research,Allahabad",
    "Field of study": "B.Tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Information Technology,Machine Learning",
    "Period of Internship": "60Days, 30June",
    "Current Location(With Country)": "Prayagraj,Uttar Pradesh,India",
    "Does Remote Internship work for you?": "New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wKnUojkQzK3b58gl5Cbr5RcXatp49UpM/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/adarsh-singh-826565183",
    "Contact Details (Email)": "kv4669@gmail.com",
    "Anything else you'd like to share?":
      "I'll prefer Working from Home if Possible",
  },
  {
    Timestamp: "04/16/2020 00:04:27",
    "Name of the student": "Harsh Chudasama",
    "Institute Name(College)": "IIT (BHU) Varanasi",
    "Field of study": "Pharmaceutical engineering",
    Education: "Integrated Dual Degree (BTech+MTech)",
    "Preferred domain of internship": "Product management",
    "Period of Internship":
      "15th April, as I am final year student no time bound to complete internship",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Remote internship will be suitable until lockdown ends, I am willing to locate any metro city in India if require after lockdown.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1k1gStThpNIJblX37z288q7YoaK2FGPiA/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harsh-chudasama-128a40104",
    "Contact Details (Email)": "harsh.chudasama.phe15@iitbhu.ac.in",
    "Anything else you'd like to share?": "Thank you for your efforts.",
  },
  {
    Timestamp: "04/16/2020 00:44:10",
    "Name of the student": "Ashish Yadav",
    "Institute Name(College)": "NIT Surat",
    "Field of study": "Electronics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Engineering and Web development",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EV3n2I1kzoITUBFdRyGFrjmxm8UP4-Hj/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/theashishyadav",
    "Contact Details (Email)": "nowwhoisashish@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 00:45:42",
    "Name of the student": "Ashish Yadav",
    "Institute Name(College)": "NIT Surat",
    "Field of study": "Electronics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering or Web development",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/19dxnN3UIR8M7riq0Vy0A3pdPfvisMjEj/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/theashishyadav",
    "Contact Details (Email)": "anujashish1602@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 01:14:13",
    "Name of the student": "Ravi Prakash Singh",
    "Institute Name(College)": "Indian Institute of Technology, Goa",
    "Field of study": "B.Tech (Mathematics And Computing)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development, Database",
    "Period of Internship": "Lockdown Period",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Qt0aro8-0k1Hat9Unhq8HG0vtB6u-jH9",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ravi-singh-936521191/",
    "Contact Details (Email)": "ravi.singh.19032@iitgoa.ac.in",
    "Anything else you'd like to share?": "My Website:- www.leomajor.github.io",
  },
  {
    Timestamp: "04/16/2020 02:41:32",
    "Name of the student": "Sahil Bansal",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Supply chain, Product Management",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1fHAAtyPqfQkC1r-sYyMvvV4NusTsx22H/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sahil-bansal-77964a158",
    "Contact Details (Email)": "sahil.airus@gmail.com",
    "Anything else you'd like to share?": "-",
  },
  {
    Timestamp: "04/16/2020 03:24:04",
    "Name of the student": "Rakshit Koul",
    "Institute Name(College)": "IITRAM",
    "Field of study": "B.Tech mechanical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "1-2, immediately",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "https://www.linkedin.com/in/rakshitkoul",
    "Contact Details (Email)": "rakshit.koul.99@gmail.com",
    "Anything else you'd like to share?": "Just need it immediately.",
  },
  {
    Timestamp: "04/16/2020 10:43:25",
    "Name of the student": "Rahil Taneja",
    "Institute Name(College)": "Symbiosis Center for Mangement Studies, Pune",
    "Field of study": "Business Administration",
    Education: "Undergraduate",
    "Preferred domain of internship": "Business Development, Marketing, HR",
    "Period of Internship": "1 month starting immediately",
    "Current Location(With Country)": "Gurgaon- India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1V_UnsBlR83Cfn-CgjsO6N5sxhAK-ABYb",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rahil-taneja-1b161117b",
    "Contact Details (Email)": "rahil.taneja8@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 10:59:19",
    "Name of the student": "Prachi shah",
    "Institute Name(College)":
      "Pandit Deendayal petroleum University Gandhinagar",
    "Field of study": "Chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Environment and energy sector",
    "Period of Internship": "2 months (any date would be preferable)",
    "Current Location(With Country)": "Amalsad, gujarat, india",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1NjQI_fICXJW0meUTiRCFy3RAZ7gaRDzi",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prachi-shah-04306415a/",
    "Contact Details (Email)": "shahpn18@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 11:50:31",
    "Name of the student": "Rahul Rao Shinde K",
    "Institute Name(College)": "Jain University",
    "Field of study": "Btech in electronics and communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Python,SQL,",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Bangalore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rahulraoshinde26@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 12:05:40",
    "Name of the student": "Tanishq Agarwal",
    "Institute Name(College)": "IIT BHU",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Operations, Supply Chain Management",
    "Period of Internship": "1-2 months, as soon as possible",
    "Current Location(With Country)": "Alwar, Rajasthan, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/itbhu.ac.in/file/d/1TVmHthwW7QAhghEfZZl4BTQS55zQf5du/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://drive.google.com/a/itbhu.ac.in/file/d/1TVmHthwW7QAhghEfZZl4BTQS55zQf5du/view?usp=drivesdk",
    "Contact Details (Email)": "tanishqagarwal.mec18@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 12:23:43",
    "Name of the student": "Vishnu Vardhan",
    "Institute Name(College)": "SSN college of engineering",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Digital marketing",
    "Period of Internship": "1Month",
    "Current Location(With Country)": "Chennai,Tamil Nadu,India",
    "Does Remote Internship work for you?": "Yes, anywhere in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1KrBePksgFH2HliVzoh3lWma473o7exgp/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "vishnu.vsvardhan.vardhan@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 12:28:07",
    "Name of the student": "Neeraj Khatri",
    "Institute Name(College)": "IIT Goa",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Deep Learning, Machine Learning",
    "Period of Internship": "6, 15th June 2020",
    "Current Location(With Country)": "Indore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1l3Q9QEMcWvZoUIaOLstU3PM7QbCnphyY",
    "LinkedIn profile link": "https://www.linkedin.com/in/neeraj-khatri/",
    "Contact Details (Email)": "neeraj.khatri.17001@iitgoa.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 12:36:38",
    "Name of the student": "Kushank",
    "Institute Name(College)": "VIPS",
    "Field of study": "Computer Applications",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data analyst,Digital Marketing,Marketing",
    "Period of Internship": "3 months,16th april afterwards",
    "Current Location(With Country)": "delhi,india",
    "Does Remote Internship work for you?": "yes,anywhere",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kushank-chhabra-977343122/",
    "Contact Details (Email)": "kushankchhabra17@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 13:10:28",
    "Name of the student": "Dakshita Gupta",
    "Institute Name(College)": "New Delhi Institute of Management",
    "Field of study": "BBA",
    Education: "Undergraduate",
    "Preferred domain of internship": "Delhi",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Faridabad ( india)",
    "Does Remote Internship work for you?": "Faridabad and delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Eiph7NOuyi5jDwzIWXu2I4gtTvgDsCeT/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "gsdakshitagupta@gmail.com",
    "Anything else you'd like to share?":
      "1)Work from home will also be suitable \n2) please try to provide good job opportunity with enough stipend",
  },
  {
    Timestamp: "04/16/2020 14:07:20",
    "Name of the student": "Aditya Kommineni",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning",
    "Period of Internship": "2-3(Between 20th April - 15th July)",
    "Current Location(With Country)": "Hyderabad",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1JdfN7IYe5-rGQIuqV4jx8nILZQP3BaugrvKBtSKt7x0",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aditya-kommineni-ba7193154/",
    "Contact Details (Email)": "aditya16.k@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 14:45:30",
    "Name of the student": "Aryan Saxena",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1NvNT9vZxL70_GlidGrvSLMAj-7LQOITj",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aryan-saxena-516593184/",
    "Contact Details (Email)": "aryansaxena0308@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 17:41:14",
    "Name of the student": "toluwani ogunsanya",
    "Institute Name(College)": "University of Ottawa",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering",
    "Period of Internship": "3-4 months. I can start in May.",
    "Current Location(With Country)": "Ottawa, Canada",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1qwvbioXoWdO86_g_enI0TkJIhaSrrARk/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/tolu-og/",
    "Contact Details (Email)": "ogunsanyatoluwani@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 18:07:43",
    "Name of the student": "Rohan Sharma",
    "Institute Name(College)": "IIT DELHI",
    "Field of study": "Textile Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics, ML",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Ahmedabad",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iiV-Y6IumK7KtbilQTR3TTsK0VBTKhgm/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/rohan-sharma-58338717a",
    "Contact Details (Email)": "rohanlalit500@gmail.com, tt1180909@iitd.ac.in",
    "Anything else you'd like to share?":
      "I have shared my CV for research intern, please accept it the same for the internship which I am seeking for.",
  },
  {
    Timestamp: "04/16/2020 18:39:02",
    "Name of the student": "Tanushree Shenwai",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "Civil engineering & M.Tech in Environmental engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business development and analyst, data analyst and marketing",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Nagpur Maharashtra, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1tF05DDTqoyBHGjim0NqLAoUecLRDxPAr/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tanushree-shenwai-98b289188",
    "Contact Details (Email)": "tss10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 18:52:15",
    "Name of the student": "Rakshit Koul",
    "Institute Name(College)": "IITRAM",
    "Field of study": "B.Tech ME",
    Education: "Undergraduate",
    "Preferred domain of internship": "Supply Chain",
    "Period of Internship": "1 to 2",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15_JLezjfJ1i96QNpk3kTBQNqNfaJHMNd/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/rakshitkou",
    "Contact Details (Email)": "rakshit.koul.99@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/16/2020 19:49:28",
    "Name of the student": "Piyush",
    "Institute Name(College)": "Indian Institute of Technology Delhi",
    "Field of study": "Chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Including but not limited to data analyst, AI, ML",
    "Period of Internship": "2 (May 2020- June 2020)",
    "Current Location(With Country)": "New Delhi (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "kashyappiyush81@gmail.com",
    "Anything else you'd like to share?": "9910730175- Contact detail",
  },
  {
    Timestamp: "04/16/2020 20:57:39",
    "Name of the student": "Eashta Gupta",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "Marketing- Product management/B2B sales/market research",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Retail, FMCG",
    "Period of Internship": "1st May 2020 to 30th June 2020",
    "Current Location(With Country)": "Lucknow, India",
    "Does Remote Internship work for you?":
      "Yes, I would like to relocate to Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1E5Kdxl9T1SpvpTEpr4j81HgmfIPPIYNl/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/eashta-gupta",
    "Contact Details (Email)": "eashta.gupta.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 21:24:13",
    "Name of the student": "SOMYA BATRA",
    "Institute Name(College)": "Miranda House",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing, Finance, Strategy Consulting",
    "Period of Internship": "1-2 months, immediately",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1aOQ2fFSBZhSLiUfO842wPOkRafxsAgcK",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/somya-batra-53515373/",
    "Contact Details (Email)": "somya.batra@mirandahouse.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 21:25:55",
    "Name of the student": "Hansalpara Nirav",
    "Institute Name(College)": "Nirma University",
    "Field of study": "B.Tech ( Instrumentation and control)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Automation, Process Control",
    "Period of Internship": "6 Months",
    "Current Location(With Country)": "Ahmedabad (India)",
    "Does Remote Internship work for you?": "Yes...but not outside state",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nirav-hansalpara-86b57b17b",
    "Contact Details (Email)": "niravhansalpara54@gmail.com",
    "Anything else you'd like to share?":
      "Please ... If you gave me an opportunity",
  },
  {
    Timestamp: "04/16/2020 22:20:30",
    "Name of the student": "Swagat Susmoy",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "One to two months. From 5th of may",
    "Current Location(With Country)": "Angul, Odisha, India",
    "Does Remote Internship work for you?": "Yes. Any",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1d7Mzviyc6tGdIPDPfc1BwsZokSXJ7nuk/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/swagatsusmoy",
    "Contact Details (Email)": "swagatsusmoy@gmail.com",
    "Anything else you'd like to share?":
      "I am seeing the internship as a mentored training. As I have had no work experience till today I would like a mentor and I will give my best.",
  },
  {
    Timestamp: "04/16/2020 22:24:39",
    "Name of the student": "Trushali Hindocha",
    "Institute Name(College)":
      "KJ Somaiya Institute of Management Studies and Research Mumbai",
    "Field of study": "MBA Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months 18th April",
    "Current Location(With Country)": "Mumbai India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "trushali.h@somaiya.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 22:56:34",
    "Name of the student": "Satyam Rajput",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "(B.Tech) Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Oil & Gas, CGD, Data analyst,market research",
    "Period of Internship": "1-3 month starting from 15 May",
    "Current Location(With Country)": "Dehradun, India",
    "Does Remote Internship work for you?": "Yes, All cities in northern India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Zjn-guLpoKdsdSJ2t6g5i5yQLeyyOJ4I",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/satyam-rajput-92237215b/",
    "Contact Details (Email)": "Satyamrajput15797@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 01:20:37",
    "Name of the student": "Sreekanth Vadigi",
    "Institute Name(College)":
      "Indian Institute of Technology (IIT), Bhubaneswar",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software development,  Machine Learining",
    "Period of Internship": "2 months during the summer 2020",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aueO8Kyg25YrRCAH166wEq_IjjPZT6gl/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sreekanth2567@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 06:13:31",
    "Name of the student": "Isabel Brunkan",
    "Institute Name(College)": "Minerva Schools at Keck Graduate Institute",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science or Software Engineering or Product Management",
    "Period of Internship": "10-12 weeks start date after May 16",
    "Current Location(With Country)": "Seattle, USA",
    "Does Remote Internship work for you?": "Yes!",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/19C9eQxFgOzUua-9qZR2O2wYQCFAERbrv/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/isabelbrunkan/",
    "Contact Details (Email)": "ibrunkan@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 09:56:45",
    "Name of the student": "Mohit Chandran",
    "Institute Name(College)":
      "Indian Institute of Information Technology Design & Manufacturing Kancheepuram",
    "Field of study":
      "Electronics and Communication Engineering with specialization in Design and Manufacturing",
    Education: "Undergraduate",
    "Preferred domain of internship": "Android App Development,Design",
    "Period of Internship": "5, May 12th,2020",
    "Current Location(With Country)": "Chennai,India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18gThh7jtYQQufUOLSkDNMlHeL80tBXUe/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mohit-chandran-6a7a251a2/",
    "Contact Details (Email)": "edm17b013@iiitdm.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 12:23:27",
    "Name of the student": "Prerna Gupta",
    "Institute Name(College)": "Welingkar Institute Bangalore",
    "Field of study": "PGDM - BUSINESS DESIGN",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months. Starting immediately",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15VW1gnr0YsYBs4G0Yc4iS8Uu6iNqz9wt/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "prerna.gupta.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 12:38:53",
    "Name of the student": "Sakshi Agarwal",
    "Institute Name(College)": "Lady Shri Ram College for Women",
    "Field of study": "Sociology & Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "",
    "Period of Internship": "2",
    "Current Location(With Country)": "Kolkata",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RFiz5VWaUw4DvuF6rP9ZNDBTjUaDpQWY/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/sakshi416",
    "Contact Details (Email)": "sakshiagarwal416@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 15:10:30",
    "Name of the student": "Aman Beniwal",
    "Institute Name(College)": "Nirma University",
    "Field of study": "BBA - Marketing",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing & Branding",
    "Period of Internship": "2 Months, May-June Preffered",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1La4TQN6NfT0fPAZQq8be_mwpFmlafr2U",
    "LinkedIn profile link": "https://www.linkedin.com/in/aman-beniwal/",
    "Contact Details (Email)": "beniwalaman2@gmail.com",
    "Anything else you'd like to share?":
      "I am an undergraduate student pursuing my BBA-MBA from Nirma University, Ahmedabad and I would like to apply for a 2-month (May-June) Internship in the domain of Marketing and Branding. I have a keen interest in Marketing and branding and I aspire to build a career in the same.\n\nI am a creative-minded individual having knowledge and experience in Digital Marketing, Social Media Marketing, Data Analysis, Graphic Designing, Cinematography and Photography. \n\nAn internship opportunity at your reputed company would help me in gaining extensive knowledge and vast experience.\n\nThanking you in anticipation.",
  },
  {
    Timestamp: "04/17/2020 15:19:05",
    "Name of the student": "Siddharth Lotia",
    "Institute Name(College)": "IIIT Naya Raipur",
    "Field of study": "Electronics and Communicatiom",
    Education: "Undergraduate",
    "Preferred domain of internship": "IoT And Cloud Computing",
    "Period of Internship": "2, 25-04-2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Raipur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ud-HjwB91s8KwDL7VpCsZCNXDT_Uq2SM/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/siddharth-lotia-108b73188/",
    "Contact Details (Email)": "siddharth18101@iiitnr.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 15:21:10",
    "Name of the student": "Archit Mittal",
    "Institute Name(College)": "Delhi College of Engineering (DTU)",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Development, Product Development, Marketing, Research",
    "Period of Internship": "3 (18-04--18-07-20)",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Indore, Nodia, Gurugram",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=13V_T5dhKXhBTY19ESfK3aSPfdYUoFX46",
    "LinkedIn profile link": "https://www.linkedin.com/in/archit-mittal-/",
    "Contact Details (Email)": "architmittalcc@gmail.com",
    "Anything else you'd like to share?":
      "Admit this lockdown period it would be great to have an internship to improve my skill set",
  },
  {
    Timestamp: "04/17/2020 17:12:00",
    "Name of the student": "Krish Gupta",
    "Institute Name(College)": "IIT Gandhinagar",
    "Field of study": "Materials Science & Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Materials Science/Computational Materials",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Gandhinagar, Gujarat, India",
    "Does Remote Internship work for you?":
      "Yes both online and offline internships work for me. Preferred location would be Bangalore, Mumbai, Varanasi and Delhi.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XfNnbmUAAWITZlBFH3M6asqkiFMnmxxy/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/krish-gupta-367187173/",
    "Contact Details (Email)": "krish.gupta@iitgn.ac.in",
    "Anything else you'd like to share?":
      "I am also interested in Machine Learning related projects",
  },
  {
    Timestamp: "04/17/2020 18:00:24",
    "Name of the student": "Vinay Kapri",
    "Institute Name(College)":
      "Sydenham Institute of Management Studies(SIMSREE), Mumbai",
    "Field of study": "MBA-Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Sales and Marketing",
    "Period of Internship": "2 months (Available for immediate joining)",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://documentcloud.adobe.com/link/track?uri=urn:aaid:scds:US:ac7c9f3e-83ec-42b6-a422-01145dd26259",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vinay-kapri-865a20117?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BNmxwlI09TSOFvnqrbfgjbw%3D%3D",
    "Contact Details (Email)": "vinaykapri.1921@simsree.org",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 18:41:06",
    "Name of the student": "Dakshita Gupta",
    "Institute Name(College)": "New Delhi Institute of management, ipu",
    "Field of study": "BBA",
    Education: "Undergraduate",
    "Preferred domain of internship": "Human resource and finance",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Faridabad ( India )",
    "Does Remote Internship work for you?": "Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Eiph7NOuyi5jDwzIWXu2I4gtTvgDsCeT/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "gsdakshitagupta@gmail.com",
    "Anything else you'd like to share?": "Thanks for this opportunity",
  },
  {
    Timestamp: "04/17/2020 19:45:17",
    "Name of the student": "Drashti Vora",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research, Mumbai",
    "Field of study": "PGDM Research and Business Analytics (Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics / Finance",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes. Mumbai.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/117ysUtmkdgiq3i15jp339FeCkt1duQEh/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/drashti-vora-254429177",
    "Contact Details (Email)": "drashtivora11@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 19:53:29",
    "Name of the student": "Shruthi Ramesh",
    "Institute Name(College)":
      "Welingkar Institute of Management, Mumbai, India",
    "Field of study": "MBA - Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Product management, General Management",
    "Period of Internship": "2 months (1st May - 30th June 2020)",
    "Current Location(With Country)": "Mumbai, Maharashtra, India",
    "Does Remote Internship work for you?":
      "Yes, open for remote internship. Preferred city for on-site is Mumbai.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/0B7nudMeSLPoYdFNMdnpsRzl2N0ZvV0JlcmhDWXU0aElLQWg4/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/shruthiramesh18",
    "Contact Details (Email)": "shruthiramesh18@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 19:55:09",
    "Name of the student": "Somia Hota",
    "Institute Name(College)": "Welingkar Institute of Management, Mumbai",
    "Field of study": "PGDM-EBIZ",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations",
    "Period of Internship": "1st may (2 months)",
    "Current Location(With Country)": "Odisha, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1BhZ1Cn5NsPUz3WPdrexkecwFuZpMoeRN/view?usp=drivesdk",
    "LinkedIn profile link":
      "LinkedIn: https://www.linkedin.com /in/somia-hota-746845b2",
    "Contact Details (Email)": "somiahota039@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 19:59:42",
    "Name of the student": "Hiral Oza",
    "Institute Name(College)": "Welingkar institute of management",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations/Marketing",
    "Period of Internship": "1st May- 2 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes. Any tier 1 cities",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/13q1tP1fvj_Hrki1pGHPOJRH_YXGoGlhh/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/hiral-oza-099437171",
    "Contact Details (Email)": "hiraloza.co@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 20:17:52",
    "Name of the student": "Saptarshi Ghosal",
    "Institute Name(College)":
      "Institute of Management Studies, Banaras Hindu University",
    "Field of study": "Strategy, Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance, Strategy",
    "Period of Internship": "3 months from 1st May 2020",
    "Current Location(With Country)": "Mysore, India",
    "Does Remote Internship work for you?":
      "Remote internship is acceptable, Willing to relocate",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1q-wf-74aEZ1ZaGLA0sRPJISpzWryXQx9",
    "LinkedIn profile link": "Do not currently have an active Linkedin account",
    "Contact Details (Email)": "ghosalsaptarshi1@gmail.com",
    "Anything else you'd like to share?":
      "Thank you, This initiative will come as a boon to me.",
  },
  {
    Timestamp: "04/17/2020 20:55:13",
    "Name of the student": "Nishesh Bhama",
    "Institute Name(College)": "Welingkar Institute of Management, Mumbai",
    "Field of study": "PGDM Full time Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months starting on May 1",
    "Current Location(With Country)": "Mumbai, Maharashtra, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "Nishesh Bhama",
    "Contact Details (Email)": "nishesh.bhama@yahoo.co.in",
    "Anything else you'd like to share?": "Phone 9920027968",
  },
  {
    Timestamp: "04/17/2020 21:09:39",
    "Name of the student": "Parth Mittal",
    "Institute Name(College)":
      "Indian Institute of Technology, Delhi (IIT Delhi)",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Consultancy, data analytics",
    "Period of Internship": "1.5- 2 months 20/04/2020 to 20/06/2020",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?":
      "yes . preferably new delhi or mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-koFgYrhpAga7ti4AT-k6XveIoK5HAGK",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/parth-mittal-37557617b",
    "Contact Details (Email)": "parthvm27499@gmail.com",
    "Anything else you'd like to share?":
      "Was offered internship for business development profile in a leading B2B trading company but the offer got rescinded due to Covid outbreak.",
  },
  {
    Timestamp: "04/17/2020 21:16:31",
    "Name of the student": "Malav A. Desai",
    "Institute Name(College)": "Syracuse University",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Software Development, Web Design(Front-end)",
    "Period of Internship": "3 months or a CO-OP",
    "Current Location(With Country)": "Syracuse,New York, USA",
    "Does Remote Internship work for you?": "Yes, Absolutely anywhere in USA",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "malavdesai2013@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 21:20:20",
    "Name of the student": "Anshika jain",
    "Institute Name(College)":
      "Welingkar institute of management and development research",
    "Field of study": "PGDM-RESEARCH AND BUSINESS ANALYTICS",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance,Analytics,Data science",
    "Period of Internship": "2 months,from 3rd may",
    "Current Location(With Country)": "Indore,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dIpi6Ce4Zzn25q2XuCfEo-NVfvgj6WNx/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anshika-jain-862595142",
    "Contact Details (Email)": "anshika.jain1022@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/17/2020 21:23:45",
    "Name of the student": "Muthanna K E",
    "Institute Name(College)":
      "Prin. L. N. Welingkar Institute of Management Development and Research, Mumbai",
    "Field of study":
      "PGDM (Planning to take Operations Specialization in 2nd year)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations, Consulting",
    "Period of Internship": "May 1, 2020 to June 30,2020",
    "Current Location(With Country)":
      "Bengaluru City, India (Permanent Residence)",
    "Does Remote Internship work for you?":
      "Yes, preferred city for Remote Internship is Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1zXEpcM88ocsoyqj3lbJ24m4o9O3VAggt",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/muthanna-k-e-2508336b/",
    "Contact Details (Email)": "muthannake.weschool@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 21:31:08",
    "Name of the student": "Muthanna K E",
    "Institute Name(College)":
      "Prin. L. N. Welingkar Institute of Management Development and Research, Mumbai",
    "Field of study":
      "PGDM (PLanning to pursue Operations Specialization in 2nd year)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations, Consulting",
    "Period of Internship": "May 1, 2020 to June 30, 2020",
    "Current Location(With Country)": "Bengaluru, India (Permanent Residence)",
    "Does Remote Internship work for you?":
      "Yes, Preferred city for remote internship is Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1zXEpcM88ocsoyqj3lbJ24m4o9O3VAggt",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/muthanna-k-e-2508336b/",
    "Contact Details (Email)": "muthannake.weschool@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 22:24:35",
    "Name of the student": "Mitesh Nahar",
    "Institute Name(College)": "Welingkar college",
    "Field of study": "Research and business analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance, analytics",
    "Period of Internship": "2",
    "Current Location(With Country)": "Vapi",
    "Does Remote Internship work for you?": "Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15Xeo7k42ldtPp1SppkyDfkvwuj6mmpQv/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/mitesh-nahar-086271179",
    "Contact Details (Email)": "miteshnahar6827@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 23:21:26",
    "Name of the student": "Sachin Jain",
    "Institute Name(College)": "Goa Institute of Managemet",
    "Field of study": "Marketing/ Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing/Operations",
    "Period of Internship": "6 weeks",
    "Current Location(With Country)": "Any",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1MYUxrKBEr1pvWgrudce4fX6GD3o-hLvP",
    "LinkedIn profile link": "https://www.linkedin.com/feed/",
    "Contact Details (Email)":
      "captainjcksachin@gmail.com ; sachin.jain19@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 23:33:18",
    "Name of the student": "Rahul Rao Shinde K",
    "Institute Name(College)": "Jain University",
    "Field of study": "Btech in electronics and communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Python,SQL",
    "Period of Internship": "6 months",
    "Current Location(With Country)": "Bangalore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rahulraoshinde26@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 23:34:21",
    "Name of the student": "Bagavathi Mahadevan Veeralakshmanan",
    "Institute Name(College)": "Purdue University",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Consulting, Strategy, Operation",
    "Period of Internship": "Immediately Available",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes willing to relocate/ Remote Internships also work",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/1/my-drive",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bagavathi-veeralakshmanan/",
    "Contact Details (Email)": "bveerala@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 00:26:02",
    "Name of the student": "DIPALI KHATRI",
    "Institute Name(College)":
      "WELINGKAR INSITUTE OF MANAGEMENT DEVELOPMENT & RESEARCH",
    "Field of study": "RESEARCH AND BUSINESS ANALYTICS",
    Education: "Post-Graduate",
    "Preferred domain of internship": "MARKETING",
    "Period of Internship": "2 MONTHS",
    "Current Location(With Country)": "MUMBAI, MAHARASHTRA, INDIA",
    "Does Remote Internship work for you?":
      "No, it would not be possible for me to relocate",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1QbNI_QKgdhb8Tr0xKziran6AVIwS6DiX",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dipali- khatri-683489118",
    "Contact Details (Email)": "dipalikhatri05@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 00:45:42",
    "Name of the student": "Dhaval Chheda",
    "Institute Name(College)": "",
    "Field of study":
      "Finance, Research, Legal, Cybersecurity, Information Technology, Data Analytics, Cognitive abilities, Psychology, Accounting, Auditing, Taxation, Costing, etc",
    Education: "Pursuing Post Grads currently",
    "Preferred domain of internship":
      "Research, Analytics, Investment Banking, Public and Foreign Policies, Planning and Analysis",
    "Period of Internship": "8",
    "Current Location(With Country)": "Mumbai, Maharashtra,  India",
    "Does Remote Internship work for you?":
      "Yes, Looking only for remote and virtual internships",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1w9uaUE4RLndWpQZ0AGNpaATsPmEEQtuy",
    "LinkedIn profile link": "https://www.linkedin.com/dhaval-c-03a151160",
    "Contact Details (Email)": "dhavalcssp@gmail.com",
    "Anything else you'd like to share?":
      "Looking to contribute and provide the best available experience and knowledge of various domains which I possess in order to create a value to every process i am indulged in. Having a versatile work ex of 8+ years has helped me to know more about how to get things done in more effective and efficient manner which had helped me to get the things done in the bestest possible manner in a short span of time with quality assurance and effectively. \nFor more details on ky profile kindly refer my linkedin profile through web rather than my resume as the same is not updated at latest.\nThanks for this great opportunity which you are providing to several candidates in this covid 19 scenario. Truly a wonderful contribution.",
  },
  {
    Timestamp: "04/18/2020 01:09:12",
    "Name of the student": "kumar vatsal maheshwari",
    "Institute Name(College)": "FMS-IRM Jaipur",
    "Field of study": "marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "sales and marketing",
    "Period of Internship": "2 months start from july 2020",
    "Current Location(With Country)": "Jaipur ( India)",
    "Does Remote Internship work for you?": "yes, jaipur and Vadodara",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1HOMad2Izw7yMCrc42KYstULCNA0HP7Nk/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kumar-vatsal-maheshwari-1aaaa515b",
    "Contact Details (Email)": "vatsalmaheshwari2010@gmail.com",
    "Anything else you'd like to share?": "n",
  },
  {
    Timestamp: "04/18/2020 02:10:07",
    "Name of the student": "ANUJ PAHARIA",
    "Institute Name(College)": "IIT (ISM) Dhanbad",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Mecahnical Engineering core,Product and Marketing roles",
    "Period of Internship": "2-3 months starting 01/05/2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes,Pan-India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1R2aK5K7rTcv27R3YV4tYCuc9_D553UtC/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/anuj-paharia-8833b4172",
    "Contact Details (Email)": "anujpaharia880@gmail.com",
    "Anything else you'd like to share?":
      "Open for opportunities in core sector but not limited to.Also having experience as Marketing and Operations Intern.",
  },
  {
    Timestamp: "04/18/2020 10:06:43",
    "Name of the student": "Shamshad Alam",
    "Institute Name(College)": "IIM Raipur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing/Operations",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Deoria(India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1b5OfssTwcQfTqu9xLfNlKHkkQ-jtzHGj",
    "LinkedIn profile link": "https://www.linkedin.com/in/imshamshad/",
    "Contact Details (Email)": "shamshad1228@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 10:07:41",
    "Name of the student": "Sonam Kumari",
    "Institute Name(College)": "National Institute of Design, Andhra Pradesh",
    "Field of study": "Industrial design",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product design",
    "Period of Internship": "4-6 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uLE5S0SBfXHaaVa9u_woEmtwVct4kv_M/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sonam-kumari-8a9839163/",
    "Contact Details (Email)": "sonamk825@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 10:13:34",
    "Name of the student": "ROHIT AGRAWAL",
    "Institute Name(College)": "IIT(ISM) DHANBAD",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product Management, Sales and Marketing",
    "Period of Internship": "6-8 weeks",
    "Current Location(With Country)": "Kota, Rajasthan (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ela7EMYajaDgxsJw9ZQ6-ZZPiU8m9VtI/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rohit-agrawal-49b27b167/",
    "Contact Details (Email)": "rohitagrawal0399@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 10:21:30",
    "Name of the student": "Rohit Raj",
    "Institute Name(College)": "Lloyd law college",
    "Field of study": "Law (B.A.LLB)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Legal field ( legal researcher)",
    "Period of Internship": "1 month ( June)",
    "Current Location(With Country)": "Bihar, (India)",
    "Does Remote Internship work for you?": "Banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xfkRnLCwxgYopCibzNDxo5FUzQC-vjYy/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/rohit-raj-15008a190",
    "Contact Details (Email)": "officialrohitraj01@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/18/2020 11:10:58",
    "Name of the student": "Jigyasa agarwal",
    "Institute Name(College)": "Jaypee institute of information technology",
    "Field of study": "Computer science engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software developer",
    "Period of Internship": "2-6: 30th may 2020",
    "Current Location(With Country)": "Noida, india",
    "Does Remote Internship work for you?": "Yes. Anywhere in india",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/13OkGa_MgoBNBcvwthBPU6ZlIVYSpDYkR/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jigyasa-agarwal-20811a165",
    "Contact Details (Email)": "jigyasagarwal73@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 11:42:53",
    "Name of the student": "Ujjwal Shrivastava",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Business Analytics",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Aurangabad Maharashtra India",
    "Does Remote Internship work for you?": "Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1qgrVo5TJgUDMeWqVr71KGTLxd37QrKU9/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ujjwal-shrivastava-ab17b7171",
    "Contact Details (Email)": "ujjwalshrivastava15@gmail.com",
    "Anything else you'd like to share?":
      "I am hard working student. Willing to work in the field of Analytics. Learning is my main motto during the internship.",
  },
  {
    Timestamp: "04/18/2020 11:43:16",
    "Name of the student": "Shailesh Bhardwaj",
    "Institute Name(College)": "Nit kurukshetra",
    "Field of study": "MBA-FINANCE",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Delhi NCR",
    "Does Remote Internship work for you?": "Yes, gurugram",
    "Link to Resume(Google Drive/Dropbox)": "",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shailesh-bhardwaj-53aa23131",
    "Contact Details (Email)": "Bhardwajshailesh7@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 11:58:32",
    "Name of the student": "Prabhleen",
    "Institute Name(College)": "National institute of technology kurukshetra",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Karnal, Haryana",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)": "yes",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Advravindersingh4@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 12:04:50",
    "Name of the student": "surbhi",
    "Institute Name(College)": "NIT, kurukshetra",
    "Field of study": "mba",
    Education: "Post-Graduate",
    "Preferred domain of internship": "finance",
    "Period of Internship": "2",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "yes delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1IqY8fPgYOq85nrRwnEr4jsmAmgmoBIhZ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/surbhi-garg-27bbb1190",
    "Contact Details (Email)": "surbhigarg757@gmail.com",
    "Anything else you'd like to share?":
      "i have done btech in it. so i am very good with conputer and numbers. Also i did accounting and finance certification course from IIM, banglore",
  },
  {
    Timestamp: "04/18/2020 13:06:14",
    "Name of the student": "Hritik Rastogi",
    "Institute Name(College)": "IIT ISM Dhanbad",
    "Field of study": "B.Tech Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine learning, Deep learning, Data science",
    "Period of Internship": "2 months Immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes Remote internship works for me, preferred locations : Mumbai , Pune, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iCUubja92nGZ-w8hpIDhHD6bFChZGWaY/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/hritik-rastogi-0b6b32165/",
    "Contact Details (Email)": "hritikrastogi1231@gmail.com",
    "Anything else you'd like to share?":
      "I am a passionate, dedicated and fast learner having good problem-solving skills. I own the flexibility to adapt to new challenges coming up. My technical skills include Deep learning, machine learning, and web scraping.",
  },
  {
    Timestamp: "04/18/2020 15:29:52",
    "Name of the student": "Karishma Gupta",
    "Institute Name(College)": "World College of Technology & Management",
    "Field of study": "Computer Science Engineering (B.TECH)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Analysis, Data Science, Product Management",
    "Period of Internship": "3-4 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "I am available for both Remote internship as well as open to relocate. Preferred Location: Delhi, Gurgaon, Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1hveWAV0zWQII4wKjzZf3wtd9kZxSX-CK",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/karishma-gupta-32b10b168/",
    "Contact Details (Email)": "gkarishma489@gmail.com",
    "Anything else you'd like to share?":
      "I am a fast learner. I can give my 100% to the organization.",
  },
  {
    Timestamp: "04/18/2020 15:43:10",
    "Name of the student": "Nirav Savla",
    "Institute Name(College)": "IIM Lucknow",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Strategy, Finance, Operations",
    "Period of Internship": "6-8 weeks, 20/04/2020",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes, PAN India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1IZRm7zCmhLkUVGsw8Z7435aWv6sLYlLI",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nirav-savla-iiml-iitb/",
    "Contact Details (Email)": "pgp35188@iiml.ac.in",
    "Anything else you'd like to share?":
      "\nQuick Background:\nIIM L - CGPA 8.21 - Section Rank 1 \nIIT B - CGPA - 8.64 Best Thesis Award",
  },
  {
    Timestamp: "04/18/2020 15:50:37",
    "Name of the student": "Ramaa Pratyusha",
    "Institute Name(College)": "Indian Institute of Technology",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Market research,  Content writing",
    "Period of Internship": "2 months ; April 20,2020",
    "Current Location(With Country)": "Kurnool, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Remote only",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1F9qaZFf6mnKb90xWPQd_t3wLgRnf_C9D/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "pratyushathogarchety@gmail.com",
    "Anything else you'd like to share?":
      "I am an enthusiast learner with high levels of dedication and grasping. I look forward to utilizing my skills for a meaningful cause and sharpening them with experience and efforts. I am co-founder of the start-up E-Agri which is in prototyping stage.",
  },
  {
    Timestamp: "04/18/2020 15:52:23",
    "Name of the student": "Shubham Samdani",
    "Institute Name(College)": "MDI Gurgaon",
    "Field of study": "MBA, Strategy and Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Strategy and Marketing",
    "Period of Internship": "2 months, 20/04/2020",
    "Current Location(With Country)": "Delhi",
    "Does Remote Internship work for you?": "Yes, Gurgaon, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1wmqBJkuiMXTGQu0AfeTyDUMp8P1_CF-O/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/shubham-samdani/",
    "Contact Details (Email)": "pgim19shubham_s@mdi.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 16:20:14",
    "Name of the student": "AMIT KUMAR VERMA",
    "Institute Name(College)": "IIT DELHI",
    "Field of study": "Engineering Analysis and Design",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Machin Learning, Data science, Artificial Intelligence",
    "Period of Internship": "May-June",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Axcel42tgAm7dWf0bNIeUzgdGN5oDlzP",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/amit-kumar-verma-614646183",
    "Contact Details (Email)": "amitmegec@gmail.com",
    "Anything else you'd like to share?":
      "I am a data science & ML enthusiast looking for internship opportunities.",
  },
  {
    Timestamp: "04/18/2020 17:13:25",
    "Name of the student": "Shivam Sharma",
    "Institute Name(College)": "Maulana Azad National Institute of Technology",
    "Field of study": "Electronics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development, Machine Learning",
    "Period of Internship": "3 months, May to July",
    "Current Location(With Country)": "Lucknow, India",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.linkedin.com/in/shivam-sharma-manit/detail/overlay-view/urn:li:fsd_profileTreasuryMedia:(ACoAACRgdmEBZZtuyTAUayamSyX_4dnNMSnGno8,1579420008295)/",
    "LinkedIn profile link": "https://www.linkedin.com/in/shivam-sharma-manit/",
    "Contact Details (Email)": "shivamsharma.manit@gmail.com",
    "Anything else you'd like to share?":
      "My name is Shivam Sharma and I am currently pursuing my Bachelors in Engineering in Electronics and Communication from Maulana Azad National Institute of Technology, Bhopal.\n\nI am looking to apply for summer internship, if available at your firm, in the field of Machine Learning or Software Engineering. I have attached my detailed resume for the same.\n\nThough my discipline is Electronics, Competitive Coding, Software\nDevelopment and Machine Learning have always been my keen interests.\n\nWhen I couldn't get Computer Science as a discipline in my college, I kept learning through various certification courses that I undertook from online from Stanford University (on scholarship), University of Michigan  (on scholarship) , UC San Diego (on scholarship) and Deep Learning Online.\n\nIf there are any open internships in the field of data science or engineering, given an opportunity, I'd love to showcase my skills to you.\n\nLook forward to hearing from you.",
  },
  {
    Timestamp: "04/18/2020 17:14:50",
    "Name of the student": "Christi Kuruvilla",
    "Institute Name(College)": "Prestige Institute of Management and Research",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "HR",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "YES",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1q3703HjdWZjUyghCNbOcX8rRdCNeWX1V",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/christi-kuruvilla-772b48101/",
    "Contact Details (Email)": "christikuruvilla04@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 17:19:05",
    "Name of the student": "Shivam Sharma",
    "Institute Name(College)": "IIPS, DAVV UNIVERSITY",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance and Marketing",
    "Period of Internship": "TWO MONTHS",
    "Current Location(With Country)": "INDORE, INDIA",
    "Does Remote Internship work for you?": "PUNE",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/100eh4jFePyh6I_itJm_l3y_XFCs7yVVs/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shivam-sharma-849b9376",
    "Contact Details (Email)": "sharma.shivambe@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/18/2020 17:42:09",
    "Name of the student": "Saksham Kukreja",
    "Institute Name(College)":
      "Department of Business Administration, National Institute of Technology Kurukshetra",
    "Field of study": "Master's of Business Administration (MBA)",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Financial  planing and Financial consultancy",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Kurukshetra, Haryana, India",
    "Does Remote Internship work for you?":
      "yes, New Delhi, Gurugram, Chandigarh, Mumbai, Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1SRcR9ZFlu1i8pJL4A09eJg13Nw53-4ol",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saksham-kukreja-80b24b136",
    "Contact Details (Email)": "saksham_41910010@nitkkr.ac.in",
    "Anything else you'd like to share?":
      "I am not a student who has lost his summer internship opportunity due to COVID-19 but i am a student finding it tough to get one due to it.",
  },
  {
    Timestamp: "04/18/2020 17:53:41",
    "Name of the student": "Natani.Raghunandan",
    "Institute Name(College)": "Indian Institute of Technology,Bhubaneswar",
    "Field of study": "Bachelor of Technology,Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mechanical Engineering",
    "Period of Internship": "2 months or 10 weeks,May 1",
    "Current Location(With Country)":
      "Dno.6-14-59,14/3,Arundalpet,Guntur,Andhra Pradesh,India",
    "Does Remote Internship work for you?":
      "Yes,Hyderabad,Visakhapatnam,Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-CrKUpRJ6bwGJt_ar4PgcFmFeKbROZ0r",
    "LinkedIn profile link": "linkedin.com/in/natani-raghunandan-5a22aa189",
    "Contact Details (Email)": "nr11@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 18:26:08",
    "Name of the student": "Derien Jackson",
    "Institute Name(College)": "Miami University",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Cincinnati/Chicago/Charlotte",
    "Period of Internship": "May 2020- August 2020",
    "Current Location(With Country)": "Hamilton, OH, USA",
    "Does Remote Internship work for you?": "yes (no preference)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1M8mYT-4puHp8IRQIqdruTuRaGzqCuVyV/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/derien-jackson",
    "Contact Details (Email)": "jacks136@miamioh.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 18:57:46",
    "Name of the student": "Tanu Shree Sharma",
    "Institute Name(College)": "ICG College",
    "Field of study": "Human Resource Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Human Resource Management",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1kMgXmAJ01UtMjQqR5bmU50bxr-e5YoDD/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/ tanu-shree-sharma-987b0622",
    "Contact Details (Email)": "imtanu.sharma@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 21:13:47",
    "Name of the student": "Kumar Aakash",
    "Institute Name(College)": "Indian Institute of Foreign Trade,Delhi",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Product Managament/Marketing/Strategy",
    "Period of Internship": "2 months (20-04-2020)",
    "Current Location(With Country)": "Delhi (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1HojI_nbfPoX93NZawNr0hDruP7GSCn8l/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/kumar-aakash1/",
    "Contact Details (Email)": "kumar_d21@iift.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/18/2020 21:15:09",
    "Name of the student": "Sohini De",
    "Institute Name(College)":
      "IIT Bombay, Shailesh J Mehta school of management",
    "Field of study": "MBA - General Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Strategy, Consulting, Operations, IT",
    "Period of Internship": "4-8 weeks",
    "Current Location(With Country)": "Kollata",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/sjmsom.in/file/d/1K1DR_slTCRXsqurvaxwgumgPWxbi8z_i/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/mwlite/in/sohinide93",
    "Contact Details (Email)": "sohini.de@sjmsom.in",
    "Anything else you'd like to share?":
      "\n- I have been a campus finalist for Corporate competitions organized by P&G and JnJ on our campus. \n\n- I have also had a live corporate project opportunity in digital marketing and brand development with Pucho Technology. ",
  },
  {
    Timestamp: "04/18/2020 21:24:24",
    "Name of the student": "Xipeng Chai",
    "Institute Name(College)": "Carnegie Mellon University",
    "Field of study": "Computer Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "software engineering",
    "Period of Internship": "May to August",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZyRiWnmXcwe1JsZulbO5hHRusQQtxDnS/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/xipeng-tony-chai-305b01150/",
    "Contact Details (Email)": "xipengc@andrew.cmu.edu",
    "Anything else you'd like to share?":
      "I know java, JavaScript ,CSS,HTNL . I'd love to learn . Thanks",
  },
  {
    Timestamp: "04/18/2020 23:09:46",
    "Name of the student": "Amoli Birewar",
    "Institute Name(College)": "Symbiosis Center for Media & Communication",
    "Field of study": "Media & Communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Content Creation, Video Production & Editing, Journalism",
    "Period of Internship": "1-3 months, can start immdiately",
    "Current Location(With Country)": "Pune, Maharashtra, India",
    "Does Remote Internship work for you?": "yes, mumbai, bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1hPPviQ8NMAPWLqfaQaPvWSXXMpKg91U1/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/amoli-birewar-009711195/",
    "Contact Details (Email)": "amolib01@gmail.com",
    "Anything else you'd like to share?":
      "https://amolibirewar.wixsite.com/-portfolio",
  },
  {
    Timestamp: "04/18/2020 23:12:49",
    "Name of the student": "Hannah Sarasu John",
    "Institute Name(College)":
      "Symbiosis Centre for Media and Communication, Pune",
    "Field of study": "Media and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Content Creation - Writing, PR, Journalism",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Pune, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1bhslqPwwFQ3LucDfifVKc2CD0T47mHWv",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "hannahsarasujo@gmail.com",
    "Anything else you'd like to share?":
      "I am very interested in politics, writing and have my own blog. I have been interested in PR and Journalism.",
  },
  {
    Timestamp: "04/19/2020 00:30:15",
    "Name of the student": "PALAVALASA RAHUL YOGANAND",
    "Institute Name(College)": "INDIAN INSTITUTE OF TECHNOLOGY BHUBANESWAR",
    "Field of study": "MECHANICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "MECHANICAL or SDE",
    "Period of Internship": "8 Weeks, First week of May",
    "Current Location(With Country)": "Visakhapatnam,Andhra Pradesh,India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FngdgriwXZQI0bKDHWQYzBOFfjT8r1_w/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rahul-yoganand-a81a1017b",
    "Contact Details (Email)": "pry10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 01:05:41",
    "Name of the student": "Akshay Jain",
    "Institute Name(College)":
      "Indian Institute of Information Technology Dharwad",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning, NLP, Data Science, Python",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "Indore, India",
    "Does Remote Internship work for you?": "Yes, Bangalore and Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZLcdLdoxKfz8_mneQ4zq6hHdBhjS6Mr0/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/theakshayjain",
    "Contact Details (Email)": "akshayjain.iiitdwd@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 01:11:13",
    "Name of the student": "Kushal Sharma",
    "Institute Name(College)": "Indian Institute of Management Indore",
    "Field of study": "Master of business administration",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Sales & Marketing, Product Management, Project Management, Consultant",
    "Period of Internship": "2months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15CCOHeky2FHWECsiXuRlm6O07MXNFKfA/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kushal-sharma-b254aa104",
    "Contact Details (Email)": "p19kushals@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 06:37:59",
    "Name of the student": "Himanshu Kriplani",
    "Institute Name(College)": "University of Southern California",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Software Engineering, Data engineering, Data science",
    "Period of Internship": "14 weeks maximum",
    "Current Location(With Country)": "Los Angeles, USA",
    "Does Remote Internship work for you?":
      "Yes, I am open to anywhere in the USA.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://himanshk96.github.io/assets/files/Himanshu.pdf",
    "LinkedIn profile link": "https://www.linkedin.com/in/himanshu-kriplani/",
    "Contact Details (Email)": "kriplani@usc.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 07:32:00",
    "Name of the student": "Sandeep kashyap",
    "Institute Name(College)": "J.c bose university  YMCA",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Supply chain management,purchase",
    "Period of Internship": "8 weeks",
    "Current Location(With Country)": "Faridabad, Haryana ( India )",
    "Does Remote Internship work for you?": "NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DE3Gj7hSUee2zxvICNm-LYjqnsWx8-Cu/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sandeep-kashyap-084a00147",
    "Contact Details (Email)": "sandeep231kashyap@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 08:26:43",
    "Name of the student": "Tushar Singla",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "B.Tech Instrumentation Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Management, Business Development",
    "Period of Internship": "20-04-20 (start date) till June",
    "Current Location(With Country)": "Anandpur Sahib, Ropar, Punjab, India",
    "Does Remote Internship work for you?": "Yes. Any metro city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FOIAJVn1ce4GgIGwCEKK-rfFbHXeI6NW/view",
    "LinkedIn profile link": "https://www.linkedin.com/in/singla-tushar/",
    "Contact Details (Email)": "singlatushar2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 08:44:32",
    "Name of the student": "Shardul Singh",
    "Institute Name(College)": "Shiv Nadar University",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "python",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Noida, Uttar Pradesh, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1B5xKwzAtik5238c-YQrZ7jylNNyrY3_a",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shardul-singh-95636916a/",
    "Contact Details (Email)": "shardulsinghtomar@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 09:31:44",
    "Name of the student": "Simran Koul",
    "Institute Name(College)": "CHITKARA UNIVERSITY",
    "Field of study": "BE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics, SDE",
    "Period of Internship": "6, june",
    "Current Location(With Country)": "Mohali, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1xbEbMol2QE11PeD7IgA8168JLDMYATOs",
    "LinkedIn profile link": "https://www.linkedin.com/in/simrankoul",
    "Contact Details (Email)": "simranknight2@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 09:46:40",
    "Name of the student": "Arth Sojitra",
    "Institute Name(College)": "Indian Institute of Technology Bhubaneswar",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship": "Mathematics, physics, simulations",
    "Period of Internship": "2-3, Starting immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iitbbs.ac.in/file/d/1Kz_e-WfCzd1Pt0AlwAMMvvp-jNFPh_3F/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "as76@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 09:49:49",
    "Name of the student": "Abhimanyu Pratap Singh",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "CAD and Simulation",
    "Period of Internship": "2 Months (May-June 2020)",
    "Current Location(With Country)": "Allahabad, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XPzbz33W-yu8arZQyNJ_IQwLF9c0Tmi4/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "abhimanyu230599@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 09:59:46",
    "Name of the student": "GLASTON D'SOUZA",
    "Institute Name(College)": "National College of Ireland",
    "Field of study": "Data Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "Ireland",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1S3XBODZSrhdMd_rPosEHD6wThXNjUM-x/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mr.glaston@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 10:10:58",
    "Name of the student": "Prabhas Naidu",
    "Institute Name(College)": "IIT BHUBANESHWAR",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Social media marketing",
    "Period of Internship": "May to june",
    "Current Location(With Country)": "Bobbili, INDIA",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "I am just a btech 1st year student",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "apn10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 10:46:19",
    "Name of the student": "Jayakiran Guntuku",
    "Institute Name(College)":
      "Indian Institute of Information Technology Nagpur",
    "Field of study": "Electronics and communication engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analysis",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AdxwMqJMHtjZHXXprVtQd0afJBkmCjxl/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jayakiran-guntuku-3b5a23131/",
    "Contact Details (Email)": "jaikiranjay@gmail.com",
    "Anything else you'd like to share?": "Please share job offers also!",
  },
  {
    Timestamp: "04/19/2020 11:00:53",
    "Name of the student": "Saptarshi Saikia",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "MBA-Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Sales and Marketing",
    "Period of Internship": "Two months",
    "Current Location(With Country)": "North Lakhimpur, Assam, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18aSIgn7kaKHbIInGmwtuWf6ukXWvhhBC/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saptarshi-saikia-886418192",
    "Contact Details (Email)": "saptarshisaikia@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 11:43:42",
    "Name of the student": "Asif Shahriar",
    "Institute Name(College)": "University of Calgary",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Project management/ transportation",
    "Period of Internship": "4 months/ May",
    "Current Location(With Country)": "Calgary, Canada",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://1drv.ms/b/s!AozfJtfRyqlLkGV_DRFpZvWwSpDq",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "asif.shahriar@ucalgary.ca",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 11:52:51",
    "Name of the student": "T V B S GOPAL",
    "Institute Name(College)": "IIT BHUBANESWAR",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship": "Android App Development",
    "Period of Internship": "1st May and 1-2 Months",
    "Current Location(With Country)": "Guntur",
    "Does Remote Internship work for you?": "Bhubaneswar",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1skTPG268-72UsYKwA8yQXxfH5ccUnw_L",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "tvb10@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I'm intrested in Android App Development",
  },
  {
    Timestamp: "04/19/2020 12:02:23",
    "Name of the student": "Devasya Shrivastava",
    "Institute Name(College)":
      "Jaypee Institute of Information Technology, Noida",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data analytics, Marketing Analystics, Market Research, Business Analystics, Digital Marketing",
    "Period of Internship": "1 to 3",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Yes, NCR and banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1_jK92o83v0qVKBdd_57UmFrFDw_5ebre/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/devasya-shrivastava-362800182",
    "Contact Details (Email)": "dev26anshu@gmail.com",
    "Anything else you'd like to share?":
      "This is a good initiative. Thank you!",
  },
  {
    Timestamp: "04/19/2020 12:59:16",
    "Name of the student": "Mayuri More",
    "Institute Name(College)": "Faculty of Management Studies Delhi",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "22nd April to 30th June (8-10 weeks)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes. I would be willing to relocate to Mumbai.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rC6QV3xd0Q32_aMya7YB5D05ObvHLpbD/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/mayurimore",
    "Contact Details (Email)": "Mayuri.m21@fms.edu",
    "Anything else you'd like to share?":
      "I am looking for Summer Internship in Finance. I have a master's degree in Banking & Finance and thus have knowledge about Financial Instruments. I have also worked to build Investor Pipeline for one of my Live projects. I have always been passionate about my interest in financial sector and I am always looking forward to gain more experience and build career in this sector. This internship opportunity is aligned with my interests and skills which is why I would like to be able to work for this. Along with that I think I would be able to provide the efforts and skills required for this internship. I would be glad if you consider me for this position.",
  },
  {
    Timestamp: "04/19/2020 13:51:27",
    "Name of the student": "Gouri Ikhe",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Metallurgical and Materials Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Strategy, Market Research",
    "Period of Internship": "8-10 weeks",
    "Current Location(With Country)": "Nagpur, Maharashtra, India",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocate if the situation improves.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1npOrBGc1Ov2AVzIHZWGK7z-BaBG5d6CI/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/gouri-ikhe-849707147",
    "Contact Details (Email)": "gouriikhe@gmail.com",
    "Anything else you'd like to share?":
      "am confident that with my analytical skills, undergraduate experiences and strong motivation to excel, I will be able to live up to the rigors of this position.",
  },
  {
    Timestamp: "04/19/2020 13:56:01",
    "Name of the student": "G Ruthvik",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Civil engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Civil engineering",
    "Period of Internship": "1-2 months, April 22",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Yes, Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AA-n4DP5vI6NuInwh_HUafk_YHXmeWEh/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/galem-ruthvik-44157b195?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3ByHs9f6wlRQiT62onPbPm8Q%3D%3D",
    "Contact Details (Email)": "gr10@iitbbs.ac.in",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/19/2020 14:19:41",
    "Name of the student": "Palak Jindal",
    "Institute Name(College)": "IILM GRADUATE SCHOOL OF MANAGEMENT",
    "Field of study": "PGDM",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance 2",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Varanasi,India",
    "Does Remote Internship work for you?": "Yes(Delhi, Noida, Gurugram)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/156aZBoEVtv3LP1B1GDDDiPrl_w1mv4Q4/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/palak-jindal-746446146",
    "Contact Details (Email)": "palakjindal840@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 14:25:03",
    "Name of the student": "Kranthi kumar",
    "Institute Name(College)": "IILM Graduate school of Management",
    "Field of study": "PGDM",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months, can start immediately",
    "Current Location(With Country)": "Andhra Pradesh",
    "Does Remote Internship work for you?":
      "Yes can relocate to Delhi and Gurgaon",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/file/d/1u513G-nhtzX-ZoNsvjnas899lS8Wa8Kt/edit?usp=docslist_api&filetype=msword",
    "LinkedIn profile link": "http://linkedin.com/in/kranthi-kumar-3b2543190",
    "Contact Details (Email)": "kranthikumarpenta123@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/19/2020 14:39:54",
    "Name of the student": "Mayuri Avinash Kondhare",
    "Institute Name(College)": "MIT school of architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "On site work and designing",
    "Period of Internship": "Six month intership. 1 june",
    "Current Location(With Country)": "Hadapsar,Pune,India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "Gmail.com",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mayurikondhare@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 14:50:13",
    "Name of the student": "Nirav Savla",
    "Institute Name(College)": "IIM Lucknow",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Strategy/Finance/Operations",
    "Period of Internship": "6-8 weeks, 20/04/2020",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/folders/1yYsmsYaNh4vOEKNek7gAZ8XNG-Zcl1n7",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nirav-savla-iiml-iitb/",
    "Contact Details (Email)": "pgp35188@iiml.ac.in",
    "Anything else you'd like to share?":
      "Quick Background:\nIIM L - CGPA 8.21 - Section Rank 1 (Specialisation - Finance, Strategy)\nIIT B - CGPA 8.64 - Best Thesis Award (Chemical Engineering)\nGeneral Mills - Modelling Analyst - 2 yrs\nOther Internships and Live Projects - India Internet Fund, DRDO, SABIC, Netcore Solutions",
  },
  {
    Timestamp: "04/19/2020 15:30:46",
    "Name of the student": "Shraddha bafna",
    "Institute Name(College)": "MIT School Of  Architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architecture",
    "Period of Internship": "4-5 months from june 2020",
    "Current Location(With Country)": "Shirpur india",
    "Does Remote Internship work for you?": "Ahmedabad, nashik,pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://issuu.com/shraddha.bafna98/docs/architectural_portfolio/s/10449483",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shraddha-bafna-bb57511a4",
    "Contact Details (Email)": "Shraddha.bafna98@gmail.com",
    "Anything else you'd like to share?":
      "Yes, I will be thankful ,if I get practical training at this platform",
  },
  {
    Timestamp: "04/19/2020 15:44:00",
    "Name of the student": "Aman Kumar",
    "Institute Name(College)": "University of Petroleum & Energy Studies",
    "Field of study":
      "Applied Petroleum Engineering with specializaton in Upstream",
    Education: "Undergraduate",
    "Preferred domain of internship": "Petroleum Exploration & Production",
    "Period of Internship":
      "I am looking for approximately 30-45 days of internship. I will be happy if the internship commences as soon as possible.",
    "Current Location(With Country)": "Bhagalpur,Bihar",
    "Does Remote Internship work for you?":
      "Yes, I am ready to relocate if the situation improves and the Lockdown gets over. I will prefer working anywhere across India.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ob-M7BEUdFYhp-Q-pBH_45OH0RGSJzja/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/aman-kumar-3516a116b",
    "Contact Details (Email)": "aman64121@gmail.com",
    "Anything else you'd like to share?":
      "No. I just want to say that being a Pre-Final   year student, I am actively looking for an Internship to apply my basic skills and knowledge and to get an exposure to real time data's.",
  },
  {
    Timestamp: "04/19/2020 15:49:05",
    "Name of the student": "Apurva Rahul Utpat",
    "Institute Name(College)": "MIT School Of Architecture",
    "Field of study": "B.Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architecture / Interior",
    "Period of Internship": "4 Months",
    "Current Location(With Country)": "Pandharpur.",
    "Does Remote Internship work for you?":
      "Yes. Pune, Goa , Mumbai , Bangalore , Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1BDXSje__ByKJ7GNQoKvRwGSeO7kNq6DH",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "utpat.apurva@gmail.com",
    "Anything else you'd like to share?":
      "Myself Apurva, I am a 4th year B.arch student ,having keen interest in sustainable , indian , contemporary aspects of architecture and interiors . I would like to give my best while working with professional team.",
  },
  {
    Timestamp: "04/19/2020 15:56:06",
    "Name of the student": "Harshada Yesane",
    "Institute Name(College)": "Cummins college of engineering for women,Pune",
    "Field of study": "Information Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning,Data Science",
    "Period of Internship": "2 months.Start date:19 April 2020",
    "Current Location(With Country)": "Ichalkaranji,India",
    "Does Remote Internship work for you?": "Yes.Pune,Bangalore,Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1seFT6BRJslGL27394IFsyMOnw2nkPGDx/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/harshada-yesane/",
    "Contact Details (Email)": "harshadayesane124@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 16:01:51",
    "Name of the student": "Shubham B. Raut",
    "Institute Name(College)": "M.I.T.A.D.T.University, Pune.",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architecture",
    "Period of Internship": "1 Month",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1wzJJrhIEoCj7Y0InLm1w_dnzt7IKXV4n",
    "LinkedIn profile link":
      "https://drive.google.com/open?id=15gbfFvDJTpxrXAL0H7ZdqOcRz2W1_0j3",
    "Contact Details (Email)": "shubhamraut166@gmail.com",
    "Anything else you'd like to share?":
      "Dedicated professional with plenty of enthusiasm to learn and know new thing every day.",
  },
  {
    Timestamp: "04/19/2020 16:06:16",
    "Name of the student": "Sumit Kumar",
    "Institute Name(College)": "FMS(Faculty of Management Studies) Delhi",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Product Management, Marketing, Strategy, Operations",
    "Period of Internship": "8 weeks, available immediately",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VzLQ9IIhQSwvKwZM40f_3DKUQTNqQwS2/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/sumitrajveer/",
    "Contact Details (Email)": "sumit.k21@fms.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 16:15:43",
    "Name of the student": "Harshada Yesane",
    "Institute Name(College)": "Cummins college of engineering for women,Pune",
    "Field of study": "IT",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "ML,Data Science,Software engineering development,data analytics",
    "Period of Internship": "2 months,Start date:19 April 2020",
    "Current Location(With Country)": "Pune,India",
    "Does Remote Internship work for you?": "Yes.Pune,Bangalore,Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1seFT6BRJslGL27394IFsyMOnw2nkPGDx/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/harshada-yesane/",
    "Contact Details (Email)": "harshadayesane124@gmail.com",
    "Anything else you'd like to share?":
      "I've filled this form again because my resume link can not be viewed by all.Please refer to this info.",
  },
  {
    Timestamp: "04/19/2020 16:17:48",
    "Name of the student": "Shubham Kumar Maurya",
    "Institute Name(College)": "Lovely Professional University",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "1 may to july",
    "Current Location(With Country)": "varanasi uttar pradesh India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=16pys72D1hYxkTvMOV3MSD7eYyHqNuIRf",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shubham-maurya-91044614a/",
    "Contact Details (Email)": "shubh27296@gmail.com",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/19/2020 16:31:05",
    "Name of the student": "Pahul Singh",
    "Institute Name(College)": "DTU",
    "Field of study": "Btech CS",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Community Management/software Development",
    "Period of Internship": "2 months 1 May",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1NiFNH2xAbaegDiIKuRr75z1Wt4nOE3DD/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pahul-singh-41747a131/",
    "Contact Details (Email)": "pahulsingh101010@gmail.com",
    "Anything else you'd like to share?":
      "I have done 2 internship as a software developer and i have been actively handling two big communities naming Microsoft Student Partner and Google Crowdsource",
  },
  {
    Timestamp: "04/19/2020 16:32:10",
    "Name of the student": "Shweta Sandeep Velde",
    "Institute Name(College)": "MIT School of Architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "India",
    "Period of Internship": "June 2020",
    "Current Location(With Country)": "Nashik (India)",
    "Does Remote Internship work for you?":
      "Mumbai, Pune, Bangalore, Ahemadabad, Nashik.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/d3di80lmo8tbznn/Resume.pdf?dl=0",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shweta-velde-1227201a7/",
    "Contact Details (Email)": "shwetavelde@gmail.com",
    "Anything else you'd like to share?":
      "Also view my architecture portfolio on Dropbox and issuu.",
  },
  {
    Timestamp: "04/19/2020 16:43:42",
    "Name of the student": "Prateek Gupta",
    "Institute Name(College)": "Nalsar University of Law, Hyderabad",
    "Field of study": "Law - Corporate and Commercial",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Law, Legal, Corporate and Commercial, Capital and Securities Market, Competition Law, in house counsel",
    "Period of Internship": "Start from July, Long term",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TEClv_59N52j7a1lMa_GiiXDvhBpTMWB/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/prateek-gupta-india/",
    "Contact Details (Email)": "pratkgupta@gmail.com",
    "Anything else you'd like to share?":
      "Looking for a job in the legal field.",
  },
  {
    Timestamp: "04/19/2020 16:46:41",
    "Name of the student": "Arunesh Saami Nagesh",
    "Institute Name(College)": "IIM Indore",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Product management, Operations, Consulting",
    "Period of Internship": "2 months, May 1st week",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZQ9sKvjW6EoqdH4lBbVHBsgwHVPxZsrv/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arunesh-saami-nagesh-01566899/",
    "Contact Details (Email)": "p19aruneshn@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 16:55:06",
    "Name of the student": "Arun Kumar Bisariya",
    "Institute Name(College)": "IIT BHUBANESHWAR",
    "Field of study": "Electrical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Web development, management, product manager",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Gwalior, india",
    "Does Remote Internship work for you?": "Yes, delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PW3NjcDMBhERsFvy1z8wV_TMgNfiRx_5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arun-kumar-bisariya-42599b192",
    "Contact Details (Email)": "arun.dakshana17@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 16:58:32",
    "Name of the student": "Akhouri Shailja Sinha",
    "Institute Name(College)": "BIMM, Pune",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2months",
    "Current Location(With Country)": "Ranchi, Jharkhand, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1AiBYkyUmwqlGOJtScR9vxugl3q8-_JYN/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shailja-sinha-16260015a",
    "Contact Details (Email)": "akhouri.shailja59@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/19/2020 17:12:16",
    "Name of the student": "Deepika Singh",
    "Institute Name(College)": "IIT(ISM) Dhanbad",
    "Field of study": "Rf and microwave engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Antenna, antenna design, rf, rf design, 5g",
    "Period of Internship": "1/5/2020 - 10/12/2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Delhi, gurgaon, noida,pune, banglore, chennai, hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1kXZcaGSsJaZlSxEQxndnRJwhmoar87XL/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/deepika-singh-699ba076",
    "Contact Details (Email)": "singhdeepa022@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 17:18:34",
    "Name of the student": "Shriyadita Roy",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, AI/ML, Strategy, Management Consulting",
    "Period of Internship": "2-4 months, April 20",
    "Current Location(With Country)": "Kolkata, India",
    "Does Remote Internship work for you?": "Yes, Bangalore, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-K23ZVgWmKR2IQF9zaQidH1kMf5H3iMo/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/shriyaditaroy1999/",
    "Contact Details (Email)": "shriyaditaroy.iitkgp@gmail.com",
    "Anything else you'd like to share?":
      "I had gotten an internship at a reputed firm but unfortunately my offer was rescinded due to the pandemic. I hope I manage to get an internship soon enough, so that I'm able to learn and contribute towards something productive.",
  },
  {
    Timestamp: "04/19/2020 17:18:42",
    "Name of the student": "PRACHI KANKARIYA",
    "Institute Name(College)": "MIT ADT UNIVERSITY PUNE",
    "Field of study": "ARCHITECTURE",
    Education: "Undergraduate",
    "Preferred domain of internship": "LANDSCAPE DESIGNING",
    "Period of Internship": "1ST MAY TO 30TH JUNE",
    "Current Location(With Country)": "DHULE, MAHARASHTRA , INDIA",
    "Does Remote Internship work for you?": "NASIK, PUNE , MUMBAI",
    "Link to Resume(Google Drive/Dropbox)": "Google Drive",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "kankariyaprachi21@gmail.com",
    "Anything else you'd like to share?":
      "it is really a good opportunity to work online and learn something new.",
  },
  {
    Timestamp: "04/19/2020 17:34:52",
    "Name of the student": "Thokala Eswar  Chand",
    "Institute Name(College)": "Sree Nidhi Institute of Science and Technology",
    "Field of study": "Data Science, Machine Learning",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science, Machine Learning",
    "Period of Internship": "1 to 6 months",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1QuheRtPd-ACBAN-NbasV70IY7NdNbmIF",
    "LinkedIn profile link": "linkedin.com/in/eswar-chand-b8280a190",
    "Contact Details (Email)": "eswarchandt@gmail.com",
    "Anything else you'd like to share?":
      "In my resume, i also attached my kaggle profile link. In that there were many projects",
  },
  {
    Timestamp: "04/19/2020 17:41:46",
    "Name of the student": "Keshav Goyal",
    "Institute Name(College)":
      "Sardar Vallabhbhai National Institute of Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2months 20th April",
    "Current Location(With Country)":
      "Amalapuram East Godavari Dist Andhra Pradesh India.",
    "Does Remote Internship work for you?": "Bangalore,pune,hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1beX9iMXqbY6ItefK2ZRQFteJuG79ERuoDEo8GMBBpWo/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/keshav-goyal-b66982166/",
    "Contact Details (Email)": "keshavgoyal2014@gmail.com",
    "Anything else you'd like to share?":
      "I am proficient in NodeJS and ReactJS",
  },
  {
    Timestamp: "04/19/2020 17:46:02",
    "Name of the student": "Abhishek Nigam",
    "Institute Name(College)": "JIIT",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "machine Learning,Data Analyis,Artificial Intelligence,Natural Language Processing,Telecom,VLSI,Software Development,Python,C++ Programmer",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Kanpur-India",
    "Does Remote Internship work for you?":
      "Yes iam able to relocate,Preffered city is Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZlbsioJTEsc4YFx26oUNVP1le_WKWm_u/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-nigam-b53760136/",
    "Contact Details (Email)": "nigamyash11@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 17:52:33",
    "Name of the student": "Samruddhi Date",
    "Institute Name(College)": "MIT SCHOOL OF ARCHITECTURE, LONI KALBHOR,PUNE",
    "Field of study": "Architecture",
    Education: "4 th year B.Arch",
    "Preferred domain of internship": "Architecture",
    "Period of Internship": "90 days",
    "Current Location(With Country)": "Pune",
    "Does Remote Internship work for you?": "Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://issuu.com/samruddhidate6215/docs/architectural_portfolio",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "dsamruddhi000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 18:10:56",
    "Name of the student": "Sakshi Ganesh Sharma",
    "Institute Name(College)":
      "MIT ADT University School of Architecture, Pune",
    "Field of study": "B.Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architecture",
    "Period of Internship": "1 Month",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/1/my-drive",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sakshi-sharma-3787241a7/",
    "Contact Details (Email)": "sakshisharmag107@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 18:22:23",
    "Name of the student": "Suyesha Magar",
    "Institute Name(College)": "Mit school of architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Summer internship from june to november",
    "Period of Internship": "6 months starting from 1 june",
    "Current Location(With Country)": "Pune maharashtra, india",
    "Does Remote Internship work for you?": "Goa",
    "Link to Resume(Google Drive/Dropbox)":
      "https://issuu.com/suyeshamagar/docs/portrait",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "suyeshamagar98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 18:23:13",
    "Name of the student": "Abhishek Singh",
    "Institute Name(College)": "JIIT Noida",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Front end developer (web developer)",
    "Period of Internship": "3-4 months starting from 2nd week of may",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Ghaziabad noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TrmoWLACMhaFjLyHVKZLxgPy2t-QDG5p/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "abhishek.singh5665720@gmail.com",
    "Anything else you'd like to share?":
      "https://www.linkedin.com/in/abhishek-singh-303985165",
  },
  {
    Timestamp: "04/19/2020 18:23:17",
    "Name of the student": "Priyanka Kumari",
    "Institute Name(College)": "Xavier Institute of Social Service",
    "Field of study": "Rural Management",
    Education: "PGDM",
    "Preferred domain of internship": "Management",
    "Period of Internship": "April to June 2months",
    "Current Location(With Country)": "Dhanbad, India",
    "Does Remote Internship work for you?": "Yes, Rajasthan",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZFUXZwKbisxr7RSdNNrNpXjdut4E88hT/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyanka-kumari-a805b079",
    "Contact Details (Email)": "priyanka72282@gmail.com",
    "Anything else you'd like to share?": "Thanks",
  },
  {
    Timestamp: "04/19/2020 18:51:36",
    "Name of the student": "Radhika Wagh",
    "Institute Name(College)": "Prin L N WELINGKAR INSTITUTE  OF MANAGEMENT",
    "Field of study": "PGDM MARKETING",
    Education: "Post-Graduate",
    "Preferred domain of internship": "MARKETING",
    "Period of Internship": "2 MONTHS (MAY AND JUNE)",
    "Current Location(With Country)": "INDIA",
    "Does Remote Internship work for you?": "YES, BANGALORE",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1S-pWz1SqbnWNTh_4G5FBNZ_q6PDMfhJs",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "radhika.wagh.we@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 19:27:46",
    "Name of the student": "Errol Winston Mascarenhas",
    "Institute Name(College)": "M.S. Ramaiah Institute of Technology",
    "Field of study": "Chemical engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Oil and energy, Chemicals, manufacturing, waste water treatment , catalysis, fuel cells",
    "Period of Internship": "June to August",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "no",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1LoV1aCt0Sqnb8hAefQeA094S3gWohEpI/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/errol-mascarenhas-a354936a/",
    "Contact Details (Email)": "errolwm@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 19:30:28",
    "Name of the student": "Dhruv Ajay Ray",
    "Institute Name(College)":
      "Indian Institute of Technology (IIT), Bhubaneswar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "IoT solutions (Arduino, RasberryPi), Web Development/architecture, Machine Learning, Data Analytics",
    "Period of Internship": "2 months, Start May 2020",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1bUG_F6FTG5e7wnXKGDCoH6VTHT3ZMyQ7",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dhruv-ajay-ray-847a93195/",
    "Contact Details (Email)": "dhruv.ray2001@gmail.com",
    "Anything else you'd like to share?":
      "Motivated and extremely dedicated, I would love to work in the areas mentioned and expand my knowledge base along the way while collecting extremely valuable industry experience.",
  },
  {
    Timestamp: "04/19/2020 19:42:07",
    "Name of the student": "Divya Kansal",
    "Institute Name(College)": "Indian Institute of Management, Udaipur",
    "Field of study": "Product Management, Strategy Consulting, Anaytics",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Product Management, Strategy Consulting, Anaytics",
    "Period of Internship": "2 months (April-June)",
    "Current Location(With Country)": "Patiala, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.linkedin.com/posts/divya-kansal-44a935145_resume-ugcPost-6646127575670321152-iauQ",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/divya-kansal-44a935145/",
    "Contact Details (Email)": "divya.kansal.2019@iimu.ac.in",
    "Anything else you'd like to share?":
      "I have always focussed on having a great learning experience in my life. I have worked with the Royal Bank of Scotland for 3 years. At RBS also, I had ensured to explore all opportunities coming my way by coming out of my comfort zone. I worked on projects like Big Data Analytics, AWS cloud deployments, migration of data from RBS on-premise to AWS cloud. I also got the opportunity to travel to the UK to represent RBS on the Global Platform.",
  },
  {
    Timestamp: "04/19/2020 20:24:56",
    "Name of the student": "Edward Allan",
    "Institute Name(College)":
      "Department of Management Studies, National Institute of Technology, Trichy.",
    "Field of study": "Master of Business Administration (Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 - 3 months, starting immediately",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?":
      "Yes, I am willing to relocate to Bangalore.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://1drv.ms/b/s!AkVBwJ9jJrq9iRGWmmTHyZuw5R2-",
    "LinkedIn profile link": "www.linkedin.com/in/edward-allan",
    "Contact Details (Email)": "s.edwardallan@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 20:40:21",
    "Name of the student": "Aarushi Khandelwal",
    "Institute Name(College)": "SRCC",
    "Field of study": "Commerce",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting/Strategy/ Finance/Investment Banking",
    "Period of Internship": "2 months, starting immediately",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1t5RE9CxiT7K_1HzeKU4it94krb_aEEh4",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aarushi-khandelwal-548107151/",
    "Contact Details (Email)": "aarushikhandelwal2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 20:41:21",
    "Name of the student": "Yogesh Sonawane",
    "Institute Name(College)": "MET Institute of Managment",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Sales, Business Development, Strategy, Digital Marketing",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "Mumbai; India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1yrdEGLGuvyH5lZu8bUy_NCPIfPmwDdvb",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/yogesh-sonawane-a84a7098/",
    "Contact Details (Email)": "yssonawane987@gmail.com",
    "Anything else you'd like to share?":
      "Management Students looking for internship opportunity, one of the top management student also work as placement coordinator of my PGDM batch",
  },
  {
    Timestamp: "04/19/2020 21:34:20",
    "Name of the student": "Prannesh S",
    "Institute Name(College)": "",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineer Trainee",
    "Period of Internship": "",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1IiIKIAlwaBKq5weDe4aU3FkW461v05ej",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prannesh-sathyamoorthy-a5282a15a/",
    "Contact Details (Email)": "pranneshsathiyamoorthy@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 22:11:09",
    "Name of the student": "Rishabh Dev Sharma",
    "Institute Name(College)": "Shri Guru Tegh Bahadur Khalsa",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance and Economics",
    "Period of Internship": "1 to 2 months",
    "Current Location(With Country)": "Noida,India",
    "Does Remote Internship work for you?": "Noida, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1I84cSq42Te4gCSXxzWpSwuWXB52WewZ_/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rishabh-dev-sharma-45907b193",
    "Contact Details (Email)": "Krishdsharma2001@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 22:16:27",
    "Name of the student": "Prajwal sunil kulkarni",
    "Institute Name(College)": "MIT school of architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "small firms",
    "Period of Internship": "june to december",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Ahmadabad,Goa,Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FVpgflFihZOT9jS3mRmpXt2oHAR5mN3P/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "architectprajwal@gmail.com",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/19/2020 22:38:07",
    "Name of the student": "Gazal Gupta",
    "Institute Name(College)": "Balaji Institute of Modern Management",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital marketing, market research",
    "Period of Internship": "2 months, 1may to june",
    "Current Location(With Country)": "Shahjahanpur, Uttar Pradesh ( India)",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EwIqcbAVwxtSd2kMNt8mLneExt_Bt0J2/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gazal-gupta-228a84192",
    "Contact Details (Email)": "gazalgupta866@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/19/2020 23:03:29",
    "Name of the student": "Anshul Lal",
    "Institute Name(College)": "Narsee Monjee Institute of Management Studies",
    "Field of study": "Finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Business Analytics",
    "Period of Internship": "2 months or 8 weeks starting from 20-04-2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1WgOIss1byaR84rk60Dgm9T9Ir-Us8YhG/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/anshul-lal",
    "Contact Details (Email)": "anshul.481996@gmail.com",
    "Anything else you'd like to share?":
      "I have the ability of quick learning and I can understand new technologies very easily. I have skills in fulfilling all the responsibilities. I am an analytics and data visualization enthusiast. I am proficient in using tools like MS Excel, MS Power BI and Tableau and I am undergoing a course for Python, R, SQL and Marketing Analytics. I like statistics a lot. I can actually add more value to your company as I am very keen to learn more about the field and build a career in it. Therefore, I think I will be a good option for this internship.",
  },
  {
    Timestamp: "04/19/2020 23:30:10",
    "Name of the student": "Romit Khurd",
    "Institute Name(College)": "MIT School of Architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architectural Intership",
    "Period of Internship": "4 months",
    "Current Location(With Country)": "Pune, Maharashtra , India",
    "Does Remote Internship work for you?": "Yes, Banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1b3vqAsoxcVUw-m5Im8CL4Brp3IDPBwUf/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "romit.khurd@gmail.com",
    "Anything else you'd like to share?":
      "Looking for a minimum 90 days internship as a part of academics.",
  },
  {
    Timestamp: "04/19/2020 23:46:55",
    "Name of the student": "Afreen Bano",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research, Mumbai",
    "Field of study": "PGDM - Retail Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2-3 months, starting from 1st  May",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1MlimiqpUiM4CWhQeiEgLgytNeiTUEzUs",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/afreen-bano-83198918b/",
    "Contact Details (Email)": "afreenb59919@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 00:06:37",
    "Name of the student": "Ayush Rawat",
    "Institute Name(College)": "XLRI,Jamshepur",
    "Field of study": "Finance/Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance/Operations",
    "Period of Internship": "2 months ( Starting whenever possible)",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Yes. Open to relocation also to any city in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CR9fOMGQjEvRHZkauaNlvwxNtmBxcC_S/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ayush-rawat-9450869a/",
    "Contact Details (Email)": "b19072@astra.xlri.ac.in",
    "Anything else you'd like to share?":
      "Would prefer internship in Finance/Operations domain but open to other domains also.",
  },
  {
    Timestamp: "04/20/2020 00:21:22",
    "Name of the student": "Mohit Chandran",
    "Institute Name(College)":
      "Indian Institute of Information Technology Design and Manufacturing, Kancheepuram",
    "Field of study":
      "Electronics and Communications with Design and Manufacturing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "App Development, Design, Embedded System",
    "Period of Internship": "5 Months, May 12,2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DCBSLesyObJzrb3-YyAGbjAA13iSxNEL/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mohit-chandran-6a7a251a2/",
    "Contact Details (Email)": "edm17b013@iiitdm.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 00:37:29",
    "Name of the student": "Arif khan",
    "Institute Name(College)": "Institute of Logistics and Aviation Management",
    "Field of study": "Logistics and Supply chain Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Logistics, Supply chain, Brand Management and Strategic management",
    "Period of Internship": "3 months, immediately available.",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1kk2TYG3pzeh8NZCWzsjjg3f7_IHwJtNs/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/arif-khan-24690715b/",
    "Contact Details (Email)": "khan.arif7@outlook.com",
    "Anything else you'd like to share?":
      "I am a fun loving person, who loves to break down complex problems and I am always eager to learn something new and unique.",
  },
  {
    Timestamp: "04/20/2020 01:15:36",
    "Name of the student": "Prashi Goyal",
    "Institute Name(College)": "Shaheed Sukhdev College of Business Studies",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Marketing, Data Science, Research, Consulting",
    "Period of Internship": "2-3 months from 20th April 2020",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aog7706Qa-Ls6ogH5yVKv95V8D_o8lV8/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/prashi-goyal-ab323316a",
    "Contact Details (Email)": "goyalprashi@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 01:50:02",
    "Name of the student": "Gazal Gupta",
    "Institute Name(College)": "Balaji Institute of modern management",
    "Field of study": "MBA- Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Market research, digital marketing",
    "Period of Internship": "2 months,  april , may and june",
    "Current Location(With Country)": "Shahjahanpur, Uttar Pradesh ( India)",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EwIqcbAVwxtSd2kMNt8mLneExt_Bt0J2/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gazal-gupta-228a84192",
    "Contact Details (Email)": "Gazalgupta866@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 02:19:12",
    "Name of the student": "Saurabh Mishra",
    "Institute Name(College)": "Indian Institute of Foreign Trade",
    "Field of study": "International Business (Finance)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "8 weeks starting immediately",
    "Current Location(With Country)": "Lucknow",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1F-htFnEeJ_VgR6QEDrahW3Ob0Bmzjxeh/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saurabh-mishra-57753913b",
    "Contact Details (Email)": "saurabhmishra.iift1921@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 03:24:54",
    "Name of the student": "Suraj PV Rajesh",
    "Institute Name(College)": "IIM Amritsar",
    "Field of study": "MBA Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-1LkcY9t66Do3fswAAcEcjvTc8pZ7O23/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/suraj-pv-rajesh?originalSubdomain=in",
    "Contact Details (Email)": "surajr05@iimamritsar.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 05:25:06",
    "Name of the student": "Mansi Wagh",
    "Institute Name(College)": "University at Buffalo,SUNY",
    "Field of study": "Masters in Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Computer Science",
    "Period of Internship": "3 months (15th May 2020)",
    "Current Location(With Country)": "Buffalo,New York,United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1OIMtRfV5ha7gyXTIIf8ZewetJ_v_OQ3t",
    "LinkedIn profile link": "https://www.linkedin.com/in/mmwagh/",
    "Contact Details (Email)": "waghmansi01@gmail.com",
    "Anything else you'd like to share?":
      "I will be graduating in December 2020. So, open to opportunities for full-time as well.",
  },
  {
    Timestamp: "04/20/2020 07:28:29",
    "Name of the student": "Isabella Fadool",
    "Institute Name(College)": "University of Michigan",
    "Field of study": "Biomedical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Healthcare",
    "Period of Internship": "Start May-August, open",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "yes, any",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1D0a1y_vzDyN4l4_-fJN-qr4glYjGz7sa/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/isabellafadool/",
    "Contact Details (Email)": "fadooli@umich.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 08:37:08",
    "Name of the student": "Mohit Gupta",
    "Institute Name(College)": "Madan Mohan Malaviya University of Technology",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Operation, Strategy, Consulting",
    "Period of Internship": "2 months starting from 10-15 of May.",
    "Current Location(With Country)": "Orai, U.P. (India)",
    "Does Remote Internship work for you?":
      "No, I have semester exam if situation improves and lockdown is over.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CRb1ScU0nzp1y4qysu1iRgTQ_UVhQ_Qq/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mohit-gupta-9020a3158",
    "Contact Details (Email)": "2017011068@mmmut.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 09:41:02",
    "Name of the student": "Naman agarwal",
    "Institute Name(College)": "GLA university",
    "Field of study": "Btech(CS)",
    Education: "Undergraduate",
    "Preferred domain of internship": "1 week",
    "Period of Internship": "",
    "Current Location(With Country)": "Raniganj, lakhimpur kheri, UP,  India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)": "Dropbox",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/naman-agarwal-9742a4198",
    "Contact Details (Email)": "namanagarwaldbs438@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 09:51:11",
    "Name of the student": "Dhrubajyoti Ray",
    "Institute Name(College)": "Indian Institute of technology Kharagpur",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software development/Business Development/Product Management",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cxTmqF4U1pMfAZfrMy-9tMzqEvnheog6/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dhrubajyoti-ray-38186646",
    "Contact Details (Email)": "ankur.ray1999@gmail.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/20/2020 09:51:33",
    "Name of the student": "Yash Parashar",
    "Institute Name(College)": "GLA University, Mathura",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Business expansion",
    "Period of Internship": "20 may to 20 july 2020",
    "Current Location(With Country)": "mathura, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1X1dnfIwJ-YrRRSnWheOXzbLH_DQJdk5X/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/yash-parashar-201514172/",
    "Contact Details (Email)": "yash.parashar01@gmail.com",
    "Anything else you'd like to share?":
      "I have been in NDA, Pune for two years then had to leave NDA due an accident on training",
  },
  {
    Timestamp: "04/20/2020 10:21:51",
    "Name of the student": "Anish Kashyap",
    "Institute Name(College)": "Mission San Jose High School",
    "Field of study": "Drone engineering",
    Education: "Upcoming senior in High school",
    "Preferred domain of internship": "Drone and Robotics",
    "Period of Internship": "Summer - open",
    "Current Location(With Country)": "Fremont, CA",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "drive.google.com/anishkashyap03/resume",
    "LinkedIn profile link": "www.linkedin.com/in/dronezest",
    "Contact Details (Email)": "anishkashyap03@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 11:13:16",
    "Name of the student": "Barnalikka Pradhan",
    "Institute Name(College)": "Symbiosis School of Economics",
    "Field of study": "M.Sc Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Analytics",
    "Period of Internship": "01/05/2020( 2 MONTHS)",
    "Current Location(With Country)": "West Bengal",
    "Does Remote Internship work for you?": "Yes, Gurgaon, Pune, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Nu3LRhIb9_JivvuvnAtK2yB1nYrRlbue/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/barnalikka-pradhan-84036516a/",
    "Contact Details (Email)": "barnalikkapradhan04@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 11:30:46",
    "Name of the student": "PURVA SHARMA",
    "Institute Name(College)": "MIT School Of Architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Urban Design",
    "Period of Internship": "4 Months",
    "Current Location(With Country)": "RAIPUR, CHHATTISGARH , INDIA",
    "Does Remote Internship work for you?": "BANGALORE",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1QN9LjYd0pcazOQ176oHV6RqMUo2d8jKW/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/purva-sharma-b37228189",
    "Contact Details (Email)": "sharmapurva28@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 11:58:55",
    "Name of the student": "Jay Surana",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Textile technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Coding, data science",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VMJ3edqzOsvOgaYiAFfcWh-FCiyQ-6vm/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/jay-surana-0854a0131",
    "Contact Details (Email)": "jaysurana13399@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 12:13:49",
    "Name of the student": "Harshvardhan Beria",
    "Institute Name(College)": "Kalinga Institute of Industrial Technology",
    "Field of study": "B.Tech in Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer Science",
    "Period of Internship": "3 months, starting 1st of May'20",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes. Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Rs-yvgx2kX6qbhZftnRGc7nnXj_A2aYB/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "harshvardhanberia@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 12:16:25",
    "Name of the student": "Heet Tike",
    "Institute Name(College)": "Shri Ram College of Commerce, Delhi University",
    "Field of study": "B.A. Economics (Hons)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Flexible except business development/marketing/sales",
    "Period of Internship": "Immediately - June 2020.",
    "Current Location(With Country)": "Ahmedabad, India.",
    "Does Remote Internship work for you?": "Yes!",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GO2Of7nZzrqhm6Uu-ks-PiWw4rD65NQQ/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/heet-tike-18910b16a",
    "Contact Details (Email)": "heettike@gmail.com",
    "Anything else you'd like to share?":
      "First game of international football at 14. First entrepreneurial venture at 17. Beatboxer, state topper in class XII.",
  },
  {
    Timestamp: "04/20/2020 12:34:35",
    "Name of the student": "SAGAR RAHINJ",
    "Institute Name(College)": "SRI BALAJI UNIVERSITY",
    "Field of study": "PGDM(MARKETING)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "No",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sagar-rahinj-5a1187184",
    "Contact Details (Email)": "rahinjsagar3012@gmail.com",
    "Anything else you'd like to share?":
      "Secured 2rd rank in  INDUCTION PRESENTATION IN SRI BALAJI UNIVERSITY.\nSECURED 3rd RANK IN CLASS IN SEM-1",
  },
  {
    Timestamp: "04/20/2020 12:45:04",
    "Name of the student": "Satya Narayan Padhy",
    "Institute Name(College)": "K L University",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "3-4 months (Starting from April)",
    "Current Location(With Country)": "Bhubaneswar, Odisha",
    "Does Remote Internship work for you?":
      "Yes, I can relocate to he nearby areas such as Hyderabad, Kolkata, Mumbai,(neighbouring regions of Odisha)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1TOSHVtpD7R8IkwO3FxIe0os8s9Nek692",
    "LinkedIn profile link": "https://www.linkedin.com/in/satyanpadhy/",
    "Contact Details (Email)": "snpadhi12@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 13:23:34",
    "Name of the student": "Aashi Mundra",
    "Institute Name(College)": "NIT Surat",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software developer",
    "Period of Internship": "2",
    "Current Location(With Country)": "Jahazpur,Rajasthan,India",
    "Does Remote Internship work for you?": "Yes. Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TPZyLuVZNLM91fzAx1RAxDyIdEglFDc3/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "aashimundra123@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 13:27:36",
    "Name of the student": "Tejas Sathe",
    "Institute Name(College)": "Mit School of Architecture, Pune",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architecture",
    "Period of Internship": "90 days, from 1 st of June",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1eqwOZYM7eVoQWZ0-JS6EjObtjGz5DHDk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "tejassathe70@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 13:28:37",
    "Name of the student": "Jagriti Choithani",
    "Institute Name(College)": "Balaji Institute Of Modern Management (BIMM)",
    "Field of study": "",
    Education: "",
    "Preferred domain of internship":
      "MBA/PGDM- Personnel management & Human Resource Development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Bhopal (India)",
    "Does Remote Internship work for you?": "Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TbO6JNpGyequaKQR7f45G7zgIHbXcQFr/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jagriti-choithani-9b771815b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BvcjugywQRDKzePl68rJ9uA%3D%3D",
    "Contact Details (Email)": "jchoithani@gmail.com",
    "Anything else you'd like to share?":
      "I am keen in looking forward to all the HR fronts and would definitely like to contribute to the organization along with gaining knowledge.",
  },
  {
    Timestamp: "04/20/2020 13:52:12",
    "Name of the student": "Mayank Singh",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Software engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "SDE, Data science",
    "Period of Internship": "2-3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Any",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ciywn4T0YWNWWPHAIYD1AoTvdtZDk7El/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mayanksingh202@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 14:41:58",
    "Name of the student": "Ramneek Singhal",
    "Institute Name(College)": "IIM Kashipur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Analytics, Search Engine Optimisation",
    "Period of Internship": "2 months and starting immediately",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Remote internships will be ideal in these uncertain times.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/folders/1ylo_R_0c5CurNlwUgojZEBFGOIWc37x0",
    "LinkedIn profile link": "https://www.linkedin.com/in/ramneek-singhal/",
    "Contact Details (Email)": "ramneek.mba19133@iimkashipur.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 15:17:17",
    "Name of the student": "Sudharshan PJ",
    "Institute Name(College)": "University of Edinburgh",
    "Field of study": "MSc Artificial Intelligence",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Data Science/Machine Learning Researcher",
    "Period of Internship": "3-6 months, September 2020 onwards",
    "Current Location(With Country)": "Edinburgh, United Kingdom",
    "Does Remote Internship work for you?": "Yes, any city is fine",
    "Link to Resume(Google Drive/Dropbox)": "https://bit.ly/cv_pj",
    "LinkedIn profile link": "https://www.linkedin.com/in/pjsudharshan",
    "Contact Details (Email)": "pjsudharshan@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 15:22:03",
    "Name of the student": "Kshitij Nath",
    "Institute Name(College)": "Jaypee Institute Of Information Technology",
    "Field of study": "Electronics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web - Development (Django)",
    "Period of Internship": "2 months (22nd April 2020)",
    "Current Location(With Country)": "Greater Noida West (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1d7YbNtmfJD1WklZd0l9czD7E64tTXxxu",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kshitij-nath-97a05a1a0/",
    "Contact Details (Email)": "kshitijnath@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 16:20:35",
    "Name of the student": "Pranav Dev",
    "Institute Name(College)": "IIT Roorkee",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development, Data Science, Machine learning, Automobiles",
    "Period of Internship": "2-2.5 months. 21/4/20",
    "Current Location(With Country)": "Haridwar, India",
    "Does Remote Internship work for you?": "Yes, New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1OJ1nu-jErTVJQ0l6n4cjVZ78DfG6-K1z&usp=gmail",
    "LinkedIn profile link": "https://www.linkedin.com/in/pranavdev1/",
    "Contact Details (Email)": "pranav250250@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 19:22:20",
    "Name of the student": "Mayank Agarwal",
    "Institute Name(College)": "Indian Institute of Technology Delhi",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Strategy, Operations, Management or even technical",
    "Period of Internship": "8 weeks preferably. I can start immediately.",
    "Current Location(With Country)": "Hazaribag, Jharkhand, India",
    "Does Remote Internship work for you?": "Yes, New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/161ecSgz0hnXFwogZ2L-uBSWKzaezX0Bx/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/mayank-a-02067ab8",
    "Contact Details (Email)": "mayank25798@gmail.com",
    "Anything else you'd like to share?":
      "I am a junior undergrad of Chemical engineering batch at IIT Delhi. I was offered a research opportunity at INPT, France but due to the ongoing situation that stands cancelled and I am in look for a summer internship. \nI am available immediately for a work from home internship. I have 2 years experience working for an NGO first as a manager and currently as an EVP (Operations).",
  },
  {
    Timestamp: "04/20/2020 19:24:23",
    "Name of the student": "Shipra Choudhary",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "C++ Programming/ Web development",
    "Period of Internship": "2 months (10th May onwards)",
    "Current Location(With Country)": "New Delhi,  India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1n-4G89lppWs15m53B3Nq5fU7SI3YjAUC",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "cshipra23@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 19:25:18",
    "Name of the student": "Amrit Sunil Chugani",
    "Institute Name(College)": "Oklahoma State University, USA",
    "Field of study": "Industrial Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Product Management, Consulting, Strategy, Business Analytics",
    "Period of Internship": "May - August",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1ermA4cbVxdbBKfH216-sPt2e-Vdmk9dE",
    "LinkedIn profile link": "https://www.linkedin.com/in/amrit-c-5a13a092/",
    "Contact Details (Email)": "achugan@okstate.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 22:02:52",
    "Name of the student": "Muskaan Jain",
    "Institute Name(College)": "JK Lakshmipat University",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning",
    "Period of Internship": "2-3,Immediately",
    "Current Location(With Country)": "Meerut,India",
    "Does Remote Internship work for you?": "Yes, Bangalore,Pune,Delhi,Jaipur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17MGZL3Z3oxbfmR8CABDoQm-UKHbVPn0e/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/muskaanjain246/",
    "Contact Details (Email)": "muskaanjain246@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 01:54:13",
    "Name of the student": "",
    "Institute Name(College)": "Amity University",
    "Field of study": "B.sc interior designer",
    Education: "Undergraduate",
    "Preferred domain of internship": "Interior design",
    "Period of Internship": "",
    "Current Location(With Country)": "Dubai",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "http://online.fliphtml5.com/qfex/fshf/",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Mrs.srm7@gmail.com",
    "Anything else you'd like to share?": "Paid opportunities preferred",
  },
  {
    Timestamp: "04/21/2020 09:50:07",
    "Name of the student": "Sanmid Anavkar",
    "Institute Name(College)": "Indiana University",
    "Field of study": "Master's of Science in Human-Computer Interaction",
    Education: "Post-Graduate",
    "Preferred domain of internship": "UX/Product designing",
    "Period of Internship": "3 months starting from 05/10/2020",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://uploads-ssl.webflow.com/5dad071965b2d9db8811a393/5e8eaedd3dac5928d37f8686_Sanmid_Anavkar_Designer.pdf",
    "LinkedIn profile link": "www.linkedin.com/in/sanmid-anavkar",
    "Contact Details (Email)": "sanmid.anavkar@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 11:36:17",
    "Name of the student": "Bhaskar Kishor",
    "Institute Name(College)": "IIT BBS",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "8 weeks from may 1",
    "Current Location(With Country)": "Patna, India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1IXhPakMx6sXKduXc06pkyIw7Pyqiyh15",
    "LinkedIn profile link": "https://linkedin.com/in/bhaskar-kishor",
    "Contact Details (Email)": "bhaskarkishor23@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 11:40:01",
    "Name of the student": "REVANTH GORRIPATI",
    "Institute Name(College)": "Birla Institute of Technology & Science",
    "Field of study": "Mechanical- Design Engineer",
    Education: "Post-Graduate",
    "Preferred domain of internship": "CAE, FEA , Product Design",
    "Period of Internship": "Preferably 6 months or more",
    "Current Location(With Country)":
      "Rajahmnundry, East godavari, Andhra Pradesh, India.",
    "Does Remote Internship work for you?":
      "No constraints on location within India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.linkedin.com/in/revanth-gorripati-39bb3118/",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/revanth-gorripati-39bb3118/",
    "Contact Details (Email)": "grevanth.16@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 12:29:54",
    "Name of the student": "Sanika Bapat",
    "Institute Name(College)": "MIT SCHOOL OF ARCHITECTURE, Pune",
    "Field of study": "ARCHITECTURE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Sustainable building design",
    "Period of Internship": "3 months starting from June 2020",
    "Current Location(With Country)": "Pune, Maharastra",
    "Does Remote Internship work for you?":
      "Pune, Mumbai, Ahmadabad, Bangalore,",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=15B3ZB17IbW1IoSrcPBsHzU6HLR51W-j9",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sanika@bapat.net",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 13:44:48",
    "Name of the student": "Kush suryavanshi",
    "Institute Name(College)":
      "Infian Institute of Information technology design and manufacturing kancheepuram",
    "Field of study": "Smart manufacturing",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning",
    "Period of Internship": "5",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes- Bangalore, pune , Ahmedabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1lb6dlW_MZuqecr4vxf_3bTU3PkqAMOaE/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/kush-s-344651128",
    "Contact Details (Email)": "Kush2101999@gmail.com",
    "Anything else you'd like to share?": "I m looking for a summer internship",
  },
  {
    Timestamp: "04/21/2020 14:05:46",
    "Name of the student": "Kanishk batra",
    "Institute Name(College)": "Rukmini Devi institute of advance study",
    "Field of study": "BBA GENERAL",
    Education: "Undergraduate",
    "Preferred domain of internship": "Digital marketing, finance",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Delhi (India)",
    "Does Remote Internship work for you?":
      "Yes,i preferred delhi city for the work",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/114A1I-62teVGxxknaTIf2nBvq3RgZGi5/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://drive.google.com/file/d/114A1I-62teVGxxknaTIf2nBvq3RgZGi5/view?usp=drivesdk",
    "Contact Details (Email)": "kanishkbatra18@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 14:29:35",
    "Name of the student": "SHAGUN DUBEY",
    "Institute Name(College)": "IILM Graduate School of Management",
    "Field of study": "Marketing and HR",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "MARKETING, STRATEGIC MANAGEMENT, PROGRAM MANAGEMENT, CONTENT WRITING, COPYWRITING",
    "Period of Internship": "2 TO 3 MONTHS can start immediately",
    "Current Location(With Country)": "Noida( India )",
    "Does Remote Internship work for you?": "Delhi, Gurgaon,",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1SDPb37iM_GdqQtQxbB6yJBBHw5zM3vT8",
    "LinkedIn profile link": "www.linkedin.com/in/shagun-dubey-b16522191",
    "Contact Details (Email)": "dubeyshagun96@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 17:56:31",
    "Name of the student": "Chiranjeev Singh Rathore",
    "Institute Name(College)": "Indian Institute of Technology Kharagpur",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Product, Sales, Management",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1K93vwSuHwMDDBxJYpp2qQ3feL8_HcPvD/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/chiranjeev-singh-rathore-183721135/",
    "Contact Details (Email)": "chiranjeevsinghrathore99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 18:22:48",
    "Name of the student": "Shivank Gupta",
    "Institute Name(College)": "Ucer",
    "Field of study": "Cs",
    Education: "Undergraduate",
    "Preferred domain of internship": "Full stack",
    "Period of Internship": "4-6 weeks",
    "Current Location(With Country)": "Prayagraj",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/12qUOQC8F0NskzWizP4Khfgk9b9RFOz61/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/shivanktpod",
    "Contact Details (Email)": "shivanktpod@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/21/2020 18:45:12",
    "Name of the student": "Kaushik Ramnath Vyas",
    "Institute Name(College)":
      "National Institute of Technology Tiruchirappalli",
    "Field of study": "Instrumentation and Control Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Instrumentation and Controls, Data Science and Analytics, Finance",
    "Period of Internship": "2 months, April 25",
    "Current Location(With Country)": "Singapore",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=12d62Ehwm5V3hNv4HUU3vba8Zi7h7LAQS",
    "LinkedIn profile link": "linkedin.com/in/kaushik-r-vyas/",
    "Contact Details (Email)": "kramnathvyas@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 19:18:09",
    "Name of the student": "Rachit Thakur",
    "Institute Name(College)": "MIT College of Engineering, Pune",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer Science",
    "Period of Internship": "3-4",
    "Current Location(With Country)": "New delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Qsz2yk1k_SoH7AD9Zi1pUAfRCMNvRUce",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 19:21:34",
    "Name of the student": "sandeep kashyap",
    "Institute Name(College)": "YMCA university",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Supplychain, Marketing , retail",
    "Period of Internship": "May - July",
    "Current Location(With Country)": "Faridabad, haryana (india)",
    "Does Remote Internship work for you?":
      "Yes,  Noida , greater noida , gurugram , palwal",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DE3Gj7hSUee2zxvICNm-LYjqnsWx8-Cu/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sandeep-kashyap-084a00147",
    "Contact Details (Email)": "sandeep231kashyap@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/21/2020 20:32:32",
    "Name of the student": "Devika Ghosh",
    "Institute Name(College)": "Duke University - The Fuqua School of Business",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "June 1-September 1",
    "Current Location(With Country)": "Chicago, IL USA",
    "Does Remote Internship work for you?": "Yes - open to relocate",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1kt1c2AhrZBnbWKWwjg0WRDmZPaGVkVpv",
    "LinkedIn profile link": "https://www.linkedin.com/in/devikaghosh/",
    "Contact Details (Email)": "devikaghosh10@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 21:12:18",
    "Name of the student": "Aditi Deshpande",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "PGDM E-business - Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "IT - Operations",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "WFH preferred",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZGIx8Fi8TqTQjxXmwapfEWC_FI3JhxGJ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aditi-deshpande-ajdsobpdj",
    "Contact Details (Email)": "aditideshpande15694@gmail.com",
    "Anything else you'd like to share?":
      "I do have work experience from Tata Consultancy Services as a software tester. I am also working as Placement Secretary in Welingkar Institute of Management. I do have taken lead and handled various events in the college.",
  },
  {
    Timestamp: "04/21/2020 21:45:49",
    "Name of the student": "Mansi Jain",
    "Institute Name(College)": "Maharaja Agrasen Institute of Technology",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Developer",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, I would like to relocate to Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1SPql7CVDbOe-_VfGxpfC3RxoOCeZ_idm",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mansi-jain-b1b739184/",
    "Contact Details (Email)": "mansijain2405@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:26:30",
    "Name of the student": "Ayush Malik",
    "Institute Name(College)": "Carnegie Mellon University",
    "Field of study": "Information Systems Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "3 months, starting May 4th 2020",
    "Current Location(With Country)": "Adelaide, Australia",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1R_SBqCUI7GKVIQ0rdDtoS1Uk2ArI9Sqb/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/ayushmalik29/",
    "Contact Details (Email)": "malikayush29@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:29:28",
    "Name of the student": "Ritik Gupta",
    "Institute Name(College)": "Jaypee institute of information technology",
    "Field of study": "B.Tech in computer science engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "An internship of",
    "Period of Internship": "From today till 6 months",
    "Current Location(With Country)": "Noida, Uttar Pradesh, India",
    "Does Remote Internship work for you?": "Yes, Delhi NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17w4P8TQeLu8Oy5htQr4exvMEOUToGV35/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ritikgupta654@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:44:24",
    "Name of the student": "Ravi Kumar",
    "Institute Name(College)": "APJ ABDUL KALAM TECHNICAL UNIVERSITY",
    "Field of study": "MECHANICAL ENGINEERING",
    Education: "",
    "Preferred domain of internship": "Oil and Gas",
    "Period of Internship": "12 months (1.5.2020)",
    "Current Location(With Country)": "Pune(India)",
    "Does Remote Internship work for you?": "Yes( Gujarat )",
    "Link to Resume(Google Drive/Dropbox)": "Google drive",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ravikumar79@outlook.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:45:11",
    "Name of the student": "Sophie Beder",
    "Institute Name(College)": "University of Michigan",
    "Field of study": "Marketing and Entrepreneurship",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "Summer or longer",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xTuohLiTy0xmYBLl3w8JR0ZizBBY1ZO9/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/sophie-beder",
    "Contact Details (Email)": "sbeder@umich.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 00:44:30",
    "Name of the student": "UZER NIZAMUDEEN",
    "Institute Name(College)": "Saveetha Engineering College",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Logistics and Marketing",
    "Period of Internship": "3-6 Months",
    "Current Location(With Country)": "Vellore, Tamilnadu, India",
    "Does Remote Internship work for you?": "Yes, Any Where",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1srE1pt_Iiit5tVHBuZ9BNY3Bm1CJUdNk/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/uzer-nizamudeen-34bb07157",
    "Contact Details (Email)": "uzernizam03@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 02:30:27",
    "Name of the student": "Dheeresh Agarwal",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Minerals, Metallurgical, and Materials Sciences",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning",
    "Period of Internship": "2 months 1-May 2020",
    "Current Location(With Country)": "Agra",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1M4I190QNYS7tQDQCx74TvaAKhnrAfgVM/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/dheereshaggarwal/",
    "Contact Details (Email)": "da11@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "https://www.hackerrank.com/dheereshaggarwal\nhttps://github.com/dheereshaggarwal",
  },
  {
    Timestamp: "04/22/2020 08:30:25",
    "Name of the student": "Shyam kumar",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "MECHANICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "ANTROID APP DEVELOPMENT(COMPUTER SCIENCE)",
    "Period of Internship": "either 1 or 2 months(may start from may 1st)",
    "Current Location(With Country)":
      "mahabubabad,  dist:-mahabubad,state:-telangana ,india",
    "Does Remote Internship work for you?": "yes.hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/folders/1ZAPq9JrFYPNk3IdyHzUjtT7g0IsQSAbj",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shyam-kumar-9265ba157/",
    "Contact Details (Email)": "ask10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 09:59:36",
    "Name of the student": "Sunny Dhama",
    "Institute Name(College)": "JIIT",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "React/React Native Development MERN stack",
    "Period of Internship": "Immediately to 3/6 months",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.sunnydhama.com/assets/resume.pdf",
    "LinkedIn profile link": "https://linkedin.com/in/sunnydhama",
    "Contact Details (Email)": "dhamasunny98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 10:30:31",
    "Name of the student": "Aradhaya Makkar",
    "Institute Name(College)": "BITS PILANI",
    "Field of study": "B.E.Mechanical + Msc. Economics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance, Management Consulting, Strategy",
    "Period of Internship": "2 months( may2020 - June2020)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes (Delhi, Chandigarh)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1eRLNVf4qqNvLFPlsl88tQiL0T_nta7Mp/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/aradhaya-makkar-771b79155",
    "Contact Details (Email)": "f20170595@pilani.bits-pilani.ac.in",
    "Anything else you'd like to share?":
      "I had got an Investment Banking internship in Unitus Capitals an Investment Bank based in Banglore but the offer was rescinded due to the ongoing Corona situation.",
  },
  {
    Timestamp: "04/22/2020 10:33:45",
    "Name of the student": "Vidhi Seth",
    "Institute Name(College)": "Guru Gobind Singh Indraprastha University",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineering, Web Development",
    "Period of Internship": "available immediately till August",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, open to relocation everywhere",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/my-drive",
    "LinkedIn profile link": "https://www.linkedin.com/in/vidhiseth/",
    "Contact Details (Email)": "vidhiseth.nov@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 10:44:01",
    "Name of the student": "Prashant Kumar",
    "Institute Name(College)": "IIT(ISM) Dhanbad",
    "Field of study": "Electrical Enegineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "software development",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Bihar,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1HCrc0YZoNHZ6u-OsN22kfiLNY6J05YATF27VsFfjofY/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prashant-kumar-9796a8153/",
    "Contact Details (Email)": "prashantfcb10@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 10:57:05",
    "Name of the student": "Rajveer singh",
    "Institute Name(College)": "IIT(ISM)",
    "Field of study": "Electronics and Instrumentation Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web development (Django)",
    "Period of Internship": "",
    "Current Location(With Country)": "India(Kanpur Nagar)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/ism.ac.in/file/d/1-S4PBdy7dY11JHCa7pR48eQ1VJfEJjD3/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/raajveer",
    "Contact Details (Email)": "rexraajveer@gmail.com",
    "Anything else you'd like to share?":
      "I am not the smartest, but i put my best to and get that shit done.",
  },
  {
    Timestamp: "04/22/2020 10:57:42",
    "Name of the student": "Logeshwari",
    "Institute Name(College)": "Institute of insurance and risk management",
    "Field of study": "Business analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Business analytics",
    "Period of Internship": "2",
    "Current Location(With Country)": "Hyderabad",
    "Does Remote Internship work for you?": "Yes. Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "LinkedIn.com/in/logeshwari-r-980a1a1a2",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "logeshwariravi24@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 12:17:47",
    "Name of the student": "Vivid Thingnam",
    "Institute Name(College)": "IIT (ISM) Dhanbad",
    "Field of study": "Environmental Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Environmental Management",
    "Period of Internship": "2 months from may second week",
    "Current Location(With Country)": "Imphal west, Manipur (India)",
    "Does Remote Internship work for you?":
      "yes, remote internship works.. delhi, kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1gFJZkTyWvH9PItfkJWohmPtedEWwcjta",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vivid-thingnam-044aa4179",
    "Contact Details (Email)": "vividthingnam@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 13:09:33",
    "Name of the student": "Nishant Ray",
    "Institute Name(College)": "IIT Dhanbad",
    "Field of study": "Electronics And Instrumentation Engg.",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development And ML",
    "Period of Internship": "2",
    "Current Location(With Country)": "Himachal Pradesh (India)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18FYDCyL_PWDbuZCtjHchU_BoLySLNvZE/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rai.nishant97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 13:16:44",
    "Name of the student": "Nishant Ray",
    "Institute Name(College)": "IIT Dhanbad",
    "Field of study": "ELECTRONICS AND INSTRUMENTATION ENGG.",
    Education: "Undergraduate",
    "Preferred domain of internship": "WebD and ML",
    "Period of Internship": "2",
    "Current Location(With Country)": "Himachal Pradesh (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18FYDCyL_PWDbuZCtjHchU_BoLySLNvZE/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rai.nishant97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 13:53:05",
    "Name of the student": "VIBHANSHU DIVYAL",
    "Institute Name(College)": "GANDHI INSTITUTE FOR TECHNOLOGY",
    "Field of study": "ELECTRICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "POWER GENERATION AND DISTRIBUTION",
    "Period of Internship": "6 month, immediately",
    "Current Location(With Country)": "GAYA, BIHAR (INDIA)",
    "Does Remote Internship work for you?": "YES, DELHI, HYDERABAD",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1143pSWg49e10cCio6hpO3VJQBlsx_duP/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vibhanshu-divyal-6593b214b",
    "Contact Details (Email)": "vibhanshudivyal.bput@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 16:04:35",
    "Name of the student": "Aastha Juneja",
    "Institute Name(College)":
      "Jaypee Institute Of Information Technology Noida",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine learning, Data Science, Python development.",
    "Period of Internship":
      "1 to 2 months, start date : immediately if I got selected.",
    "Current Location(With Country)": "Bharatpur, Rajasthan, India",
    "Does Remote Internship work for you?":
      "I prefer to do work from home internship but if relocation is done I would prefer Noida and Gurugram.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Q9qYtrrg6Th46DRpXzWq4C0fEAeHOIQ1/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/aasthajuneja27",
    "Contact Details (Email)": "aasthajuneja27@gmail.com",
    "Anything else you'd like to share?":
      "I am really looking forward to this opportunity and I think I will be able to find the the perfect platform for me to develop and nourish my skills. I have made certain projects on machine learning mainly based on regression, prediction and classification and used a bunch of algorithms like linear regression, Logistic Regression, decision tree, random forest etc. Honestly I have doing coding since 2nd year of my college and ever since I have been learning something new and productive.My coding skills are not perfect but as an intermediate Learner, I am improving my skills everyday.I really love to do coding in python. I have a gold badge(5 star) in python and a silver badge(4 star) in problem solving on hackerraank. I have a Quotient skill 99.61 percentile in python with overall current rank of 289 in python skills on techgig platform. In open coding challenge I have scored 160 out of 200 on techgig. I am 2 star competitor on codechef. I am really interested in what I am doing and really wants to go in that. Always wants to learn more and build something new all by my self. I am always Confident and sincere with my work. It will be an honour if you will consider my request for internship opportunity . I will try my all level best to complete my work on time with focus and sincerity.",
  },
  {
    Timestamp: "04/22/2020 16:29:35",
    "Name of the student": "Mayank Kumar Prajapati",
    "Institute Name(College)": "IIT Dhanbad",
    "Field of study": "Electronics and Instrumentation Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software development or Machine learning or Data science",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes,I am open to relocate to pune, gurgaon, delhi,banglore, calcutta, hyderabad,",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1vxg_GlFM_N_yzilj47zLSrPKU2w7T2S2LJevTKVWQDQ/edit",
    "LinkedIn profile link": "https://www.linkedin.com/in/mayank5464942/",
    "Contact Details (Email)": "mayank5464942@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 17:06:43",
    "Name of the student": "Owais Hasnath Ahmed",
    "Institute Name(College)": "IIT(ISM) Dhanbad",
    "Field of study": "B.tech Electronics and instrumentation",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development or web development",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Kolkata, west bengal,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XKOc-HK6JqAgoi6ztI6klky-kjeMQgHZ/view?usp=drivesdk",
    "LinkedIn profile link": "https://linkedin.com/in.oahmed97",
    "Contact Details (Email)": "owaishunter78@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 17:37:22",
    "Name of the student": "Abhinav Ajith",
    "Institute Name(College)":
      "Government Engineering College, Barton Hill, Trivandrum",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product Design/Robotics/Research",
    "Period of Internship": "From August 2020 onwards",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, but I am interested in handson experience. I would like to relocate to Banglore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1Dzin8O12JsJmPw1qkHbtnDpBWqWTognB",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhinav-ajith-90baab157/",
    "Contact Details (Email)": "abhinavajith1729@gmail.com",
    "Anything else you'd like to share?":
      "If you find me worthy please don't hesitate to give me an oppertunity.",
  },
  {
    Timestamp: "04/22/2020 18:36:37",
    "Name of the student": "Abhimanyu Singh Rawat",
    "Institute Name(College)":
      "Dr.Akhilesh Das Gupta Institute of Technology and Management",
    "Field of study": "",
    Education: "Undergraduate",
    "Preferred domain of internship": "Frontend Web Development",
    "Period of Internship": "1-3 starting Immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1nUpGxbp-00uPsLZPQlRA0h7hE9PqTmra/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhimanyu-rawat-3a4754161/",
    "Contact Details (Email)": "mannurawat2010@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 21:02:43",
    "Name of the student": "Charitha M S",
    "Institute Name(College)": "SDMIMD, MYSORE, KARNATAKA",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Content writing, Marketing or Systems",
    "Period of Internship": "2 months, immediately!",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "I prefer work from home",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MNQOE9uuY1q03-u1J093H33jpM1XjV1a/view?usp=drivesdk",
    "LinkedIn profile link": "Charitha M S",
    "Contact Details (Email)": "charithasatheesh@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 22:57:18",
    "Name of the student": "Gaurav Agarwal",
    "Institute Name(College)":
      "Indian Institute of Information Technology Nagpur",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development, Full Stack Development, Cloud Development",
    "Period of Internship":
      "5 months starting from August, or 6 months starting from January",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocate if situation improves",
    "Link to Resume(Google Drive/Dropbox)":
      "https://resume-gaurav.s3.ap-south-1.amazonaws.com/gaurav.pdf",
    "LinkedIn profile link": "https://www.linkedin.com/in/g-agarwal/",
    "Contact Details (Email)": "gauravggg21@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 00:34:39",
    "Name of the student": "Ayush Bansal",
    "Institute Name(College)":
      "jaypee institute of information technology, Noida",
    "Field of study": "computer science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software engineering",
    "Period of Internship": "2 or 3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1DfBV0tHG-bLygNslNqSm-SdhVeqS5E20",
    "LinkedIn profile link": "https://www.linkedin.com/in/ayushbansal129/",
    "Contact Details (Email)": "abnsl0014@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 01:04:07",
    "Name of the student": "Shubhangi Agarwal",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Full stack development, Backend development, SDE intern",
    "Period of Internship": "2 months, starting immediately.",
    "Current Location(With Country)": "Panvel, India",
    "Does Remote Internship work for you?": "Remote internship works for me.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14mwxYfRutsYknoQwTSRvGo3qA2dRagrU/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shubhangi2965@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 08:30:27",
    "Name of the student": "Shweta velde",
    "Institute Name(College)": "MIT School of architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "India",
    "Period of Internship": "From June 2020",
    "Current Location(With Country)": "Nashik(India)",
    "Does Remote Internship work for you?": "Pune, nashik, Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/s/d3di80lmo8tbznn/Resume.pdf?dl=0",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shweta-velde-1227201a7/",
    "Contact Details (Email)": "shwetavelde@gmail.com",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "04/23/2020 08:56:56",
    "Name of the student": "Mayuri Sawant",
    "Institute Name(College)": "ACCA",
    "Field of study": "ACCA",
    Education: "Chartered Accountancy",
    "Preferred domain of internship":
      "Accounting | Finance | Audit and Assurance",
    "Period of Internship": "4 months . Start date : available immediately",
    "Current Location(With Country)": "Muscat Oman",
    "Does Remote Internship work for you?": "Yes please.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/17bJC6_oxTZUvByPC9kOWz3zuvQtnQqpe/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mayuri-sawant-476489157",
    "Contact Details (Email)": "mayu15sawant@gmail.com",
    "Anything else you'd like to share?":
      "I am fluent in IFRS ISAs and IASs. In the final stage of ACCA certificate",
  },
  {
    Timestamp: "04/23/2020 10:08:07",
    "Name of the student": "Aishwarya Ramanathan",
    "Institute Name(College)": "IIM Indore",
    "Field of study": "Management",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Marketing, consulting, business development, product management",
    "Period of Internship": "8 weeks available immediately",
    "Current Location(With Country)": "Chennai",
    "Does Remote Internship work for you?": "Yes, Bangalore, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iimidr.ac.in/file/d/0BzAoIV3uV2u1OXl2VDQ0QnpSakZOZk9nWFJiRkZwX0oyOE9J/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "i16aishwaryar@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 10:11:07",
    "Name of the student": "Ayushi Sur",
    "Institute Name(College)": "INSTITUTE OF CHEMICAL TECHNOLOGY",
    "Field of study": "Oils, Oleochemicals and surfactants Technology",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Personal care",
    "Period of Internship": "1 year",
    "Current Location(With Country)": "Navi Mumbai",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GjkzsLZ7WpQbiZQEClTD9az5TLXj_eaE/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "surayushi1421@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 10:25:41",
    "Name of the student": "Madhurima Mahajan",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Metallurgical and Materials Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Artificial Intelligence and Deep learning, IoT, Computer Vision, Embedded Systems, Sustainability, robotics, Human-computer interaction, mobility",
    "Period of Internship": "2-3 months starting from May",
    "Current Location(With Country)": "Hyderabad, India",
    "Does Remote Internship work for you?": "yes, any city works",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SNRT5LNAdPgWLhPO72ZH2Sff5h85sNfT/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/madhurima-mahajan-916ab3140",
    "Contact Details (Email)": "mmks1211@gmail.com",
    "Anything else you'd like to share?":
      "I'm interested to join MIT Media Lab next year for graduate study. Hence, I'm looking for multidisciplinary projects or internship areas.",
  },
  {
    Timestamp: "04/23/2020 10:32:52",
    "Name of the student": "Madhurima Mahajan",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Metallurgical and Materials Engineering",
    Education: "Dual degree (B.Tech and M.Tech)",
    "Preferred domain of internship":
      "Artificial Intelligence, Deep learning, Computer Vision, Robotics, IoT, Embedded Systems, Human Computer Interaction, Sustainability, Mobility, VR/AR, Materials Science",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Hyderabad (India)",
    "Does Remote Internship work for you?": "Yes, any city works.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SNRT5LNAdPgWLhPO72ZH2Sff5h85sNfT/view",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/madhurima-mahajan-916ab3140",
    "Contact Details (Email)": "mmks1211@gmail.com",
    "Anything else you'd like to share?":
      "I'm interested to pursue Masters at MIT media lab next year. Hence, I'm looking for multi-disciplinary and innovative projects and internship roles.",
  },
  {
    Timestamp: "04/23/2020 19:13:14",
    "Name of the student": "salman k",
    "Institute Name(College)": "IIM SIRMAUR",
    "Field of study": "Business management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/iimsirmaur.ac.in/file/d/1bQ_9ji3RKI4P85jBW6KTVey6Vm-GAUqB/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mba05073@iimsirmaur.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 19:19:07",
    "Name of the student": "V Ratna Kishore VANKADARI",
    "Institute Name(College)": "CEPT UNIVERSITY",
    "Field of study": "STRUCTURAL ENGINEERING",
    Education: "Post-Graduate",
    "Preferred domain of internship": "STRUCTURAL ENGINEERING",
    "Period of Internship": "MORE THAN 6 MONTHS",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1ACqWNksjAs10gOtVOHGF20udlJGDbPXj",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/v-ratna-kishore-vankadari-379214106",
    "Contact Details (Email)": "ratnakishorerk@gmail.com",
    "Anything else you'd like to share?":
      "I pursued Masters in Structural Engineering at CEPT Gujarat and I�ve always wanted to start my own business sometime down the line. But before that I want to explore and absorb what the industry could possibly give and treat myself with significant journey.\nI�m writing this email to express my interest in working for the competant company as an Intern/Entry level engineer.You can tell I�m not doing this for money but for the experience and I�m passionate about it.\nGiven a chance, I�d like to discuss my qualification and accomplishments in an interview. I would love to begin my career with the competant company, and I am confident that I would be a beneficial addition to the company.\nI know this is not the greatest time to discuss about this opportunity with the world being paused for quite a time, I wanted to reach out to see if you are interested in me once the world resumes.",
  },
  {
    Timestamp: "04/23/2020 19:23:58",
    "Name of the student": "G.Pragnya",
    "Institute Name(College)": "Institute of Insurance and Risk Management",
    "Field of study": "Insurance,Business Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "May 1st to June 30 th",
    "Current Location(With Country)": "Karimnagar (India)",
    "Does Remote Internship work for you?": "Karimnagar",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/file/d/1VjKRFncw2v7ojHLoxeG-x-bmi8u4XcX-/edit?usp=docslist_api&filetype=msword",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "gaddampragnya@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 19:29:59",
    "Name of the student": "Hrithik Agrawal",
    "Institute Name(College)": "Indian Institute of Technology Bhubaneswar",
    "Field of study": "Metallurgy and Materials Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance related",
    "Period of Internship": "One or two. No start date, can start right now",
    "Current Location(With Country)": "Jabalpur, Madhya Pradesh",
    "Does Remote Internship work for you?":
      "Yes, I'll be able to relocate to Bhubaneswar if situation improves",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1cfdzXN6opc479MseB7PnAclvnF9imAtH/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/hrithik-agrawal-4ba0271a2",
    "Contact Details (Email)": "ha12@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 20:21:22",
    "Name of the student": "Bisesh Kumar Padhi",
    "Institute Name(College)": "Indian Institute of Technology, Bhubaneswar",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning",
    "Period of Internship": "2 months (starting from 5th May)",
    "Current Location(With Country)": "Angul, Odisha , India",
    "Does Remote Internship work for you?":
      "Yes, remote internship works for me but if situation improves I am ready to relocate , preferably to Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1tO1eeEpmEsaP1sVmN5j82_zVe71FjsqJ/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/bisesh-padhi-017318189",
    "Contact Details (Email)": "bkp10@iitbbs.ac.in",
    "Anything else you'd like to share?":
      "I have a deep-rooted interest in Machine Learning and am currently gaining insights on convolutional neural networks. I would particularly prefer working in computer vision and object detection related projects but in general I am open to all sorts of machine learning related projects.",
  },
  {
    Timestamp: "04/23/2020 20:31:34",
    "Name of the student": "Ashish Gokarnkar",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Industrial & Systems Engineering, Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Consulting, Data Science, Cyber Security, Front and Back end Web Development",
    "Period of Internship": "2 - 4 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)": "bit.ly/iitkgp_ashish",
    "LinkedIn profile link": "https://www.linkedin.com/in/ashish-gokarnkar/",
    "Contact Details (Email)": "ashish.gokarnkar@iitkgp.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 20:50:36",
    "Name of the student": "Akshat Srivastava",
    "Institute Name(College)": "IIT Roorkee",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "UI/UX, Product Design",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No please dont relocate",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1K2EPhLdwNBIMPnbM4UkAyU0eURQe7K1j?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshat-srivastava-086462172/",
    "Contact Details (Email)": "asr2k18@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/23/2020 22:39:52",
    "Name of the student": "G.Pragnya",
    "Institute Name(College)": "Institute of Insurance and Risk Management",
    "Field of study": "Insurance,Business Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "May 1st to June 30 th",
    "Current Location(With Country)": "Karimnagar (India)",
    "Does Remote Internship work for you?": "Karimnagar",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/file/d/1VjKRFncw2v7ojHLoxeG-x-bmi8u4XcX-/edit?usp=docslist_api&filetype=msword",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "gaddampragnya@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/24/2020 08:28:47",
    "Name of the student": "Ashish Gokarnkar",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Industrial and Systems Engineering, Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Management Consulting, Data Science, Business Development",
    "Period of Internship": "2 - 4 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Mumbai",
    "Link to Resume(Google Drive/Dropbox)": "bit.ly/iitkgp_ashish",
    "LinkedIn profile link": "https://www.linkedin.com/in/ashish-gokarnkar/",
    "Contact Details (Email)": "ashish.gokarnkar@iitkgp.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/24/2020 08:40:25",
    "Name of the student": "Jatin Nanda",
    "Institute Name(College)":
      "FIIB- Fortune Institute of international business",
    "Field of study": "Finance amd analytic",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Financial analyst",
    "Period of Internship": "2",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GQ8uIqy52SF6gKeIyXqJVaXGfTLh6DD_/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jatin-nanda-2a3155141/",
    "Contact Details (Email)": "21-jatin.nanda@fiib.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/24/2020 11:06:38",
    "Name of the student": "Aastha Juneja",
    "Institute Name(College)":
      "Jaypee Institute Of Information Technology Noida",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning and data science",
    "Period of Internship": "2 months. Immediately.",
    "Current Location(With Country)": "Bharatpur Rajasthan",
    "Does Remote Internship work for you?":
      "Yes. Remote intership will work for me. If relocated I would prefer Noida, Delhi and Gurugram.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Q9qYtrrg6Th46DRpXzWq4C0fEAeHOIQ1/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/aasthajuneja27/",
    "Contact Details (Email)": "aasthajuneja27@gmail.com",
    "Anything else you'd like to share?":
      "A 3rd Year student trynna make it through. I am a learner in the field of machine learning and data science. Constantly working to improve my data structure and algorithm skills. Usually I code in python. Looking forward to learn more about Data science to nourish my skills.",
  },
  {
    Timestamp: "04/24/2020 11:26:50",
    "Name of the student": "Padmini Rai",
    "Institute Name(College)": "Banasthali Vidyapith",
    "Field of study": "BTech Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Engineer, Web Development , Content Writing ,IT(General)",
    "Period of Internship": "2 months, 26.04.20",
    "Current Location(With Country)": "Varanasi",
    "Does Remote Internship work for you?":
      "Yes, only remote internship is preferred.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1aYjVCXVkNT0QfCoPfZ7p8Xyp1YMIstb-/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/padmini-rai-29a37718a/",
    "Contact Details (Email)": "pmnrai2013@gmail.com",
    "Anything else you'd like to share?":
      "Eager to work on new technologies to gain hands on experience.",
  },
  {
    Timestamp: "04/24/2020 13:43:53",
    "Name of the student": "JANYAVULA RAJASREE",
    "Institute Name(College)":
      "Institute of Insurance and Risk Management - IIRM",
    "Field of study": "Insurance and Business Analyst",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Insurance",
    "Period of Internship": "45-90days",
    "Current Location(With Country)": "Hyderabad(India)",
    "Does Remote Internship work for you?": "Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1g7XG2dHRs76kQeBy9z3tjCaq2iHV_EhZ/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rajasree-janyavula-0b9bb2168/",
    "Contact Details (Email)": "rajasree98.janyavula@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/24/2020 14:11:38",
    "Name of the student": "Sourajit Roy",
    "Institute Name(College)":
      "Symbiosis Institute of Digital and Telecom Management",
    "Field of study": "MBA - Systems and Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Market Research, Product Management, Data Analyst, Strategy Consulting",
    "Period of Internship": "2 months. 1st May",
    "Current Location(With Country)": "Kolkata",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/sitm.ac.in/file/d/1--0D_7E1KfkQ_XRRPzj4MoZuU4LTSSAQ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sourajit-roy-2a5193181",
    "Contact Details (Email)": "sourajit.sourajit.roy1921@sitm.ac.in",
    "Anything else you'd like to share?":
      "Dear sir/madam, \nI hope you are doing well! I would like to thank you for providing me this opportunity in challenging times like these. My name is Sourajit Roy and I am currently pursuing my MBA in Systems and Finance from Symbiosis Institute of Digital and Telecom Management (SIDTM). At SIDTM, I part of various student-driven committees where I get the opportunity to interact with top-notch corporates in the industry for guest lectures, webinars, events, etc. I had secured an internship as a Junior Research Associate in a leading market research firm. Unfortunately, due to the outbreak of the COVID-19, my internship opportunity is delayed indefinitely.",
  },
  {
    Timestamp: "04/24/2020 14:33:00",
    "Name of the student": "Priyanka Halder",
    "Institute Name(College)": "Symbiosis Centre for media and communication",
    "Field of study": "B.A in Mass Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Kolkata",
    "Period of Internship": "1 or 2 months. After the pandemic ends",
    "Current Location(With Country)": "Malda, West Bengal, India.",
    "Does Remote Internship work for you?": "Yes. Kolkata",
    "Link to Resume(Google Drive/Dropbox)": ".",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyanka-halder-1aaa861a0",
    "Contact Details (Email)": "Mepriyankahalder00@gmail.com",
    "Anything else you'd like to share?": "No.",
  },
  {
    Timestamp: "04/24/2020 19:39:38",
    "Name of the student": "Ritam Roy",
    "Institute Name(College)":
      "Symbiosis Institute of Digital and Telecom Management",
    "Field of study": "Analytics and Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Analytics, Data Analysis, Business Analyst, Market Research",
    "Period of Internship": "2",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "Yes(any city in India)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1uMYBJ_nzU014ckqnLa-YPPAtIAJby5nM",
    "LinkedIn profile link": "www.linkedin.com/in/ritam-roy-236023181",
    "Contact Details (Email)": "ritam.roy1921@sitm.ac.in",
    "Anything else you'd like to share?":
      "Me being part of the Analytics and Finance batch of SIDTM harnesses a passion for data analysis, business analysis, predictive analytics and also Market research. I have 2 months of work experience in Cognizant Technology Solution and I am very motivated and Hard working personal. I am ready to work as soon as I get the opportunity.",
  },
  {
    Timestamp: "04/24/2020 20:44:59",
    "Name of the student": "Anjita jangid",
    "Institute Name(College)": "SMS, University of Hyderabad",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing, Operations",
    "Period of Internship": "2 months, starting immediately",
    "Current Location(With Country)": "Jaipur, Rajasthan, India",
    "Does Remote Internship work for you?":
      "Yes, remote internship works for me and I'm ready to relocate to Hyderabad.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/13d0I9no1mOupGzSsJ4ERyxQKUSobR091/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "anjitajangid@hotmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/24/2020 21:20:57",
    "Name of the student": "Nidhi Ranjalkar",
    "Institute Name(College)": "Emerson College",
    "Field of study": "Publishing and Writing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Editorial",
    "Period of Internship": "2-3 months (June 1-August 1)",
    "Current Location(With Country)": "Boston, USA",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1njBXyaSofggass2fecMCReAa0TFxCrHq/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/nidhi-r-258a05a9/",
    "Contact Details (Email)": "ranjalkarn@gmail.com",
    "Anything else you'd like to share?":
      "I can also work with content writing, copyediting and  marketing strategy along with developmental editing",
  },
  {
    Timestamp: "04/24/2020 22:25:10",
    "Name of the student": "Manali Gokani",
    "Institute Name(College)": "Welingkar College",
    "Field of study": "PGDM Media & Entertainment",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing / Digital Marketing",
    "Period of Internship": "2-3 months starting from May",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dMpdopMRqX9e_D88KaiYYQLCl8qHeFyI/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/manali-gokani-7035a0184",
    "Contact Details (Email)": "manaligokani7777@gmail.com",
    "Anything else you'd like to share?": "Thanks for the great initiative.",
  },
  {
    Timestamp: "04/24/2020 22:28:46",
    "Name of the student": "Jyoti",
    "Institute Name(College)":
      "J.c.bose university of science and technology,ymca.",
    "Field of study": "Commerce",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Financial statement analysis",
    "Period of Internship": "6-8weeks",
    "Current Location(With Country)": "Faridabad (India)",
    "Does Remote Internship work for you?": "Yes, Delhi NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/181StT-UPMU8D369SKc4rYPhf73o1c32g/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/jyoti-sen-4998921a6",
    "Contact Details (Email)": "senjyoti943@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/24/2020 23:17:10",
    "Name of the student": "Abhishek Kumar Pal",
    "Institute Name(College)": "IIT(ISM) Dhanbad",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development or Software Development",
    "Period of Internship": "2 months from 10 May to 8 July",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DVvApEsD8NcPPQwvyslPF5Zx4N9gb6u2/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-pal-6a980418b/",
    "Contact Details (Email)": "himansupal1998@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/25/2020 00:36:24",
    "Name of the student": "Lokesh M",
    "Institute Name(College)": "Psg Institute of management",
    "Field of study": "Management (Marketing)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months, May month first week",
    "Current Location(With Country)": "Trichy, India",
    "Does Remote Internship work for you?":
      "Yes, i do prefer (chennai,bangalore)-India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1_5b4UDubD6UkDcrEiA3yGYaSYH_Vm5Or/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/lokesh-m-1632971a3",
    "Contact Details (Email)": "Lokeshmohan1997@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/25/2020 11:50:48",
    "Name of the student": "Nikhil Agrawal",
    "Institute Name(College)": "Indian Institute of Technology Roorkee",
    "Field of study": "Polymer science and engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=19GwndklbLKnmbRKefTXd8qeZ-nwsQs6b",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nikhil-agrawal-295b66161/",
    "Contact Details (Email)": "niks76692@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/25/2020 12:09:28",
    "Name of the student": "somya gupta",
    "Institute Name(College)": "amity university madhya pradesh",
    "Field of study": "btech cse",
    Education: "Undergraduate",
    "Preferred domain of internship": "computer science",
    "Period of Internship": "2 months 1 june",
    "Current Location(With Country)": "jhansi,uttar pradesh india",
    "Does Remote Internship work for you?": "gwalior, pune,delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1FJTPFo3uFZxSFE0woaHLreKsO7HB3dY4?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/somya-gupta-b3192614b",
    "Contact Details (Email)": "iamgsomya@gmail.com",
    "Anything else you'd like to share?":
      "As i'm pursuing Btech and its my major internship and during this period i really want internship . i'm good in app development and in java",
  },
  {
    Timestamp: "04/25/2020 12:24:10",
    "Name of the student": "Nimisha Srivastava",
    "Institute Name(College)": "Amity University, Gwalior",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Coding(C, C++, Java), Machine Learning, Networking, Android",
    "Period of Internship": "45-60 days | 1/6/20",
    "Current Location(With Country)": "Lucknow (UP), India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XJZ5uV-nfq2rdopxxwAXeKToS-LLU84p/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nimisha-srivastava-727107154/",
    "Contact Details (Email)": "nimishasri98@gmail.com",
    "Anything else you'd like to share?":
      "I would prefer online internships over offline ones. If it's a paid one, it shouldn't be too expensive.",
  },
  {
    Timestamp: "04/25/2020 14:38:49",
    "Name of the student": "Prakhar Prakash Singh",
    "Institute Name(College)":
      "University of Petroleum and Energy Studies, Dehradun",
    "Field of study": "Btech- Fire & Safety Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Waste to Energy",
    "Period of Internship": "Two Months intern. & start from 1 May 2020.",
    "Current Location(With Country)": "Jabalpur, MP, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1a7FWLMCPyk3QHdV2OdPtyF9IWYejyn56/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prakhar-prakash-singh-067068190",
    "Contact Details (Email)": "prakharprakashsingh@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/25/2020 21:35:13",
    "Name of the student": "Saarthak Gupta",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Civil Engineering (3rd year)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance, Business Analytics",
    "Period of Internship": "6-8 weeks. Starting from June'20",
    "Current Location(With Country)": "Delhi (India)",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1vb_vT7ENbvN1CULi5QK3S0lI6IApiGV0",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "saarthak1602@gmail.com",
    "Anything else you'd like to share?": "No preference for a stipend",
  },
  {
    Timestamp: "04/26/2020 01:29:26",
    "Name of the student": "Prateek Jain",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "3 Months - May 01, 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Preferred city - Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1dddtM2nSL893yevp9RWChDvJwbmMjvjP/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prateek-jain-852295154/",
    "Contact Details (Email)": "prateekjainpk@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/26/2020 03:50:35",
    "Name of the student": "Varsha Ravichandiran",
    "Institute Name(College)": "University at Buffalo SUNY",
    "Field of study": "Computer Science and Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software Developer Intern",
    "Period of Internship": "May 18 - Aug 14",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1WX8a6alOKrS3Deir5O8x8j_EJRPueEsq/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/varsharavichandiran",
    "Contact Details (Email)": "varsharavichandiran@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/26/2020 11:05:13",
    "Name of the student": "Nidhi Gupta",
    "Institute Name(College)": "Amity University gwalior",
    "Field of study": "Btech cse",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Python with datascience or machine learning or project based",
    "Period of Internship": "One and a half month",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://s.docworkspace.com/d/AHfsWT7zz7Ag4Z_Po8WdFA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nidhi-gupta-12b095192",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/26/2020 21:08:32",
    "Name of the student": "Devasya Shrivastava",
    "Institute Name(College)":
      "Jaypee institute of information technology, Noida",
    "Field of study": "Electronics and communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Market Research: Digital Marketing; Marketing Analystics; Analystics; Management consulting",
    "Period of Internship": "2 to 3 months",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1_jK92o83v0qVKBdd_57UmFrFDw_5ebre/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/devasya-shrivastava-362800182",
    "Contact Details (Email)": "dev26anshu@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/26/2020 23:05:15",
    "Name of the student": "Shubham Kachroo",
    "Institute Name(College)": "YMCA University of Science and Technology",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "Mid May",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes, Delhi/NCR",
    "Link to Resume(Google Drive/Dropbox)": "bit.ly/2y3oXFI",
    "LinkedIn profile link": "https://www.linkedin.com/in/alchemister",
    "Contact Details (Email)": "shubhamkachroo@yahoo.co.in",
    "Anything else you'd like to share?":
      "I have worked on numerous technologies including Android Development, Machine Learning, Blockchain, FrontEnd and AR. Moreover, I have also contributed in some open source projects which helped me in VCS knowledge. So, I am comfortable in working with new technology even if I have to learn it.",
  },
  {
    Timestamp: "04/26/2020 23:05:56",
    "Name of the student": "Teghmann",
    "Institute Name(College)": "Delhi College of Engineering",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Analyst - Consulting, Strategy, Business Operations, Market Research, Business Analyst",
    "Period of Internship": "2-3 ( Immediate joining )",
    "Current Location(With Country)": "New Delhi (India)",
    "Does Remote Internship work for you?":
      "Yes ( Yes open to relocation, anywhere)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/folders/1Kp06_jzIGmSqvSO5so3HFXN59-_E0kVj",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "teghmann@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/26/2020 23:57:02",
    "Name of the student": "MOHANAHARI S",
    "Institute Name(College)": "IIIT D&M Kancheepuram",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product Development/Design",
    "Period of Internship": "1 month - 1st May",
    "Current Location(With Country)": "Chennai,INDIA",
    "Does Remote Internship work for you?":
      "Yes good with Remote internship,No for the relocation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rCBILhWxrNxhUw5tKOHSweYhwWE6TqPR/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mohanahari-sundaresan-85b35a153/",
    "Contact Details (Email)": "mohanahari1999@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/27/2020 01:02:41",
    "Name of the student": "jyoti gogia",
    "Institute Name(College)": "NSUT",
    "Field of study": "BBA",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing/Content writing",
    "Period of Internship": "3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "New delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "C:\\Users\\hp\\Downloads\\resume link.pdf",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jyoti-gogia-04a4771a7/",
    "Contact Details (Email)": "jyotigogia434@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/27/2020 07:24:43",
    "Name of the student": "Anis Sabeer",
    "Institute Name(College)": "BITS Pilani,Pilani",
    "Field of study": "B.E. Manufacturing",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product managment",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/112_nmb-Jvgd6n2fslCldF-pRoAPs5UTL/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "f2016850@pilani.bits-pilani.ac.in",
    "Anything else you'd like to share?": "Stipend is not an issue",
  },
  {
    Timestamp: "04/27/2020 08:07:58",
    "Name of the student": "Oum Kale",
    "Institute Name(College)": "kiit",
    "Field of study": "cse",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Intern",
    "Period of Internship": "2",
    "Current Location(With Country)": "Parbhani, Maharashtra(India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PW-CfSP-7uUu7X6xzBw0yU2OnFdg7nGE/view?usp=drivesdk",
    "LinkedIn profile link": "https://in.linkedin.com/in/oumnkale",
    "Contact Details (Email)": "oumkalecoding@gmail.com",
    "Anything else you'd like to share?": "Thank you",
  },
  {
    Timestamp: "04/27/2020 09:51:20",
    "Name of the student": "Tanay Tushar",
    "Institute Name(College)": "Welingkar Institute of Management, Bengaluru",
    "Field of study": "PGDM(Business Design & Innovation), Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months( 1.05.2020 - 31.06.2020)",
    "Current Location(With Country)": "Agra, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1r7nKQm9PoeD16Ps-1PqJG0o78lM-_8Fp/view",
    "LinkedIn profile link": "linkedin.com/in/tanay-tushar-51105a184",
    "Contact Details (Email)": "tanay.tushar.we@gmail.com",
    "Anything else you'd like to share?":
      "I am Optimist person with Never-Giving-Up Attitude",
  },
  {
    Timestamp: "04/27/2020 11:38:25",
    "Name of the student": "Avani P. Makhesana",
    "Institute Name(College)": "Pandit Deendayal Petroleum University",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Nanotechnology, Energy, SDGs, Recycling, Waste managment related Research and Development, Marketing, Analysis",
    "Period of Internship": "1.5 or 2 months, 1 May,2020",
    "Current Location(With Country)":
      "Sarvoday park, Chikhali, Navsari, Gujarat, India",
    "Does Remote Internship work for you?":
      "Yes, Rajkot or Gandhinagar, Gujarat, India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1JQ0ZNEU09b-PIq4iJZIKJljg9cB6QAng",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/avani-makhesana-b11b27159",
    "Contact Details (Email)": "avanee14@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/27/2020 12:16:51",
    "Name of the student": "Arshpreet Singh",
    "Institute Name(College)": "JIIT Noida",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning",
    "Period of Internship": "2-4 months, any date",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RHLEz7deTqTcht2iC2sZ2SptY-oo_qTi/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arshpreet-singh-791721173",
    "Contact Details (Email)": "arshpreet1010@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/27/2020 16:07:05",
    "Name of the student": "AJAY KUMAR KUSHWAHA",
    "Institute Name(College)": "JAYPEE INSTITUTE OF INFORMATION TECHNOLOGY",
    "Field of study": "INFORMATION TECHNOLOGY",
    Education: "Undergraduate",
    "Preferred domain of internship": "DATA SCIENCE, MACHINE LEARNING, SDE",
    "Period of Internship": "3-4",
    "Current Location(With Country)": "Noida",
    "Does Remote Internship work for you?": "Any metro city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=13CvTvYNMa8sLcUXEONi9non8IInhIi71",
    "LinkedIn profile link": "https://www.linkedin.com/in/ajay-k-19b304158/",
    "Contact Details (Email)": "vidyajaykushwaha@gmail.com",
    "Anything else you'd like to share?":
      "You are doing a great job, by helping the people in need.",
  },
  {
    Timestamp: "04/27/2020 21:52:09",
    "Name of the student": "Mayuk Basu",
    "Institute Name(College)": "Indian Institute of Technology Dhanbad",
    "Field of study": "B.tech Electronics& Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics/ Business Analysis",
    "Period of Internship": "2 months (3rd May 2020)",
    "Current Location(With Country)": "West Bengal, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1ycNnFwbOH_F344_KnnV2NG_uFkwHsWuFGsAYRjfNKoY/edit?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/mayuk-basu-279042194",
    "Contact Details (Email)": "mayukbasu20@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/27/2020 22:08:36",
    "Name of the student": "Natasha Stamp",
    "Institute Name(College)": "University of Southern California",
    "Field of study":
      "Majoring in law history and culture with a minor in business",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Marketing, UX Writing(anything with adobe creative cloud ), or Business",
    "Period of Internship": "2-3 Months, available starting June 1st",
    "Current Location(With Country)": "Los Angeles, CA, USA",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/a/usc.edu/file/d/1MadkKGpVEtefrIA4enMpetEoK1t8Q8ja/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/natasha-stamp-214943152",
    "Contact Details (Email)": "nstamp@usc.edu",
    "Anything else you'd like to share?":
      "Thank you for putting this together!",
  },
  {
    Timestamp: "04/27/2020 23:12:48",
    "Name of the student": "Ashish Pandey",
    "Institute Name(College)": "MDI Gurgaon",
    "Field of study": "Marketing, Finance, Operation, strategy",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing, operation",
    "Period of Internship": "2 month",
    "Current Location(With Country)": "Ghaziabad (India)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1zmWicwB3yqxXgVeNy3jqz3tggG2u48KQ/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/ashish-pandey1995/",
    "Contact Details (Email)": "ashishmdi104@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/28/2020 15:48:12",
    "Name of the student": "Abhimanyu Singh",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Tech, Management, Consulting, Finance",
    "Period of Internship": "1-2",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Delhi, Meerut, Noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1BNBRhB6lo7FZcker-xbXchnS8jNlMeqQ/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "abhi.prabal@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/28/2020 19:49:37",
    "Name of the student": "Mayank Khatri",
    "Institute Name(College)": "Indian Institute of Technology Delhi",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Engineering or Quantitative Analyst",
    "Period of Internship": "May-July",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "I am okay with remote Internship",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1T7d_nzTtD0ZVmUNzNF24AyrTia9eBmn0/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mayankhatriit@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/29/2020 00:23:54",
    "Name of the student": "Pranit Mehta",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Engineering Design",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Business Analytics, Marketing, Operations Research, Product Management",
    "Period of Internship": "2-2.5 months, starting anytime soon!",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?":
      "Yes. Any city is fine to relocate.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ip_h8hiXIQI8cMFw6kHL7ThSdD4B_54h/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/pranit-mehta",
    "Contact Details (Email)": "thepranitmehta@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/29/2020 04:38:06",
    "Name of the student": "Tony Boetto",
    "Institute Name(College)": "Santa Clara University",
    "Field of study": "Finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "June - September",
    "Current Location(With Country)": "Santa Clara, CA (United States)",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1N4nYSHYl1Atv4PmY1gtxCGesLhudVyhbOSj76lcPLcA/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/tony-boetto-a5484b149/",
    "Contact Details (Email)": "Aboetto@scu.edu",
    "Anything else you'd like to share?":
      "I am currently interning for a start-up company called Movius for the spring and would like to get into a position that is more finance directed. I was planning on interning at Zuora this summer, however the internship program was cancelled. I am willing to work for any company in any field.",
  },
  {
    Timestamp: "04/29/2020 06:25:04",
    "Name of the student": "Rohan Sai Raj",
    "Institute Name(College)": "SIBM Hyderabad",
    "Field of study": "MBA - Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "6-8 weeks",
    "Current Location(With Country)": "Chennai, Tamil Nadu, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11FdohrGPNLHRGJEA4hR4VujlL3gKVa75/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rohan-sai-raj-243764b8/",
    "Contact Details (Email)": "rohs91@gmail.com",
    "Anything else you'd like to share?": "Available for immediate joining",
  },
  {
    Timestamp: "04/29/2020 07:33:34",
    "Name of the student": "K Tanay",
    "Institute Name(College)":
      "Dr. D. Y. Patil Biotechnology and Bioinformatics Institute",
    "Field of study": "Biotechnology",
    Education: "M. Tech (Integrated) degree",
    "Preferred domain of internship": "Biotechnology",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "I'll prefer work from home, keeping in consideration the current situation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-PjZXRUWTONo-WCq040DhjTxJ3Ev7dAX/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/ktanay",
    "Contact Details (Email)": "ktanay98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/29/2020 22:16:28",
    "Name of the student": "Atanshu Goyal",
    "Institute Name(College)": "DIT University, Dehradun",
    "Field of study": "B.tech Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Noida, Uttar Pradesh, India",
    "Does Remote Internship work for you?": "Yes, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1p5pMJIuEug9VWLI9swL_zJxN-znooHyd/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/atanshu-goyal-48b76a160",
    "Contact Details (Email)": "goelatanshu0106@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/29/2020 22:40:48",
    "Name of the student": "Anoushka Ajwani",
    "Institute Name(College)": "DIT University",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "software/web development, content creator, digital marketing",
    "Period of Internship": "1 month (from 1st June)",
    "Current Location(With Country)": "Mussoorie, Uttarakhand(India)",
    "Does Remote Internship work for you?": "New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1znmPoh8Ijkyn5UhCGkQMTd9QIVpT2Be0",
    "LinkedIn profile link": "https://www.linkedin.com/in/anoushka-ajwani/",
    "Contact Details (Email)": "anoushka.ajwani@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/30/2020 02:37:39",
    "Name of the student": "Lara Rosales",
    "Institute Name(College)": "Universidad Iberoamericana",
    "Field of study": "Latin American Literature",
    Education:
      "I graduated in 2018 but I�m looking for possibilities to jumpstart my career.",
    "Preferred domain of internship": "Editing or proofreading.",
    "Period of Internship": "May to December",
    "Current Location(With Country)": "Winter Park, Florida, United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/scl/fi/3kz50nuqvgyi25jr2t1d0/Resume-Lara-Rosales.docx?dl=0&rlkey=xeiztyvc2ikut2wb6lq29m5b6",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/lara-rosales-681b32176",
    "Contact Details (Email)": "lari.rosales@gmail.com",
    "Anything else you'd like to share?":
      "I�ve been looking for a job in editing or proofreading since I graduated but haven�t found the right fit. I am willing to do an internship with the possibility of finding a full-time job.",
  },
  {
    Timestamp: "04/30/2020 10:11:02",
    "Name of the student": "Nikhil Jain",
    "Institute Name(College)": "Jaypee Institute Of Information Technology",
    "Field of study": "Machine Learning, Deep Learning, Python",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning, Deep Learning",
    "Period of Internship": "2 - 3 Months ( The more The better)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, Location - Delhi NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/12curJD1sDDgMyqrzTYdn7M9V9V6baR6X/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "nikjain1999@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/30/2020 11:34:38",
    "Name of the student": "Ruchi Gohil",
    "Institute Name(College)":
      "Welingkar Institute of Management Development and Research",
    "Field of study": "PGDM - Research and Business Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing or Analytics",
    "Period of Internship": "2/3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1KCku2Ogp7iipE3c-HVWRtyOYYnyR2Ny7",
    "LinkedIn profile link": "https://www.linkedin.com/in/ruchi-gohil/",
    "Contact Details (Email)": "gohilruchie@gmail.com",
    "Anything else you'd like to share?":
      "My name is Ruchi Gohil, pursuing PDGM in Research and Business Analysis at Welingkar Institute of Management Development & Research. Having said that, I have work experience of 8 months with Accenture as an Associate Software Engineer where I received hands-on training on SAP SD and GFT. Programmed automation SAP architecture for on-boarded clients. Along I have done 4 Internships before joining Accenture as a Blockchain Analyst at BuyUcoins where I shadowed the CEO to have in-depth knowledge of blockchain technology. Networked with female leaders in the cryptocurrency trading business. Assisted Bitcoin trading for clients and helped in following the marketing trends and curated shortcodes for clients. Project Manager and Business Operation Associate during 2 tenures at Shortlist Professionals and Business Development Manager at Toptal Professionals. I have also undertaken a few projects at inter-college and national level and currently pursuing an online training for Applied Data Science with Python organized by IBM. Completed certifications for Advance SQL for Data Scientists and also Financial Modeling and Forecasting Financial Statements.",
  },
  {
    Timestamp: "04/30/2020 20:35:44",
    "Name of the student": "Prerna Singh",
    "Institute Name(College)": "DIT University",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Full stack Developer,Software Developer",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Lucknow,India",
    "Does Remote Internship work for you?": "Lucknow",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1sY1d9KkVp6l6j_lPbpMe_T-y908QKEEs",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/prerna-singh-b0aa60175/",
    "Contact Details (Email)": "prerna1205may@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 05:28:36",
    "Name of the student": "Zachari OUOROU N'GOBI",
    "Institute Name(College)": "Polytechnic School of Abomey-Calavi",
    "Field of study": "Computer Science and Telecommunications",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Telecommunications",
    "Period of Internship": "6 months in early Mai",
    "Current Location(With Country)": "B�nin",
    "Does Remote Internship work for you?": "Remote internship is okay for me",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1LcTi7PPP93VR31LOInzsgWFES59wxGo-/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/boni-zachari-ouorou-n-gobi-596953123/",
    "Contact Details (Email)": "onzachari@gmail.com",
    "Anything else you'd like to share?":
      "I lost my job in the light of covid-19 outbreak then I am here to find a remote job in order to get paycheck",
  },
  {
    Timestamp: "05/01/2020 06:32:59",
    "Name of the student": "Rishabh Dutt sharma",
    "Institute Name(College)": "Jaypee Institute of Information technology",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electronics",
    "Period of Internship": "2 to 3 months",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Eys",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RAstXfVQB3XiiXb1LgNCcEI_gIpQbAJF/view?usp=drivesdk",
    "LinkedIn profile link":
      "www.linkedin.com/in/rishabh-dutt-sharma-a51b30148",
    "Contact Details (Email)": "Srishabh40@yahoo.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 08:21:25",
    "Name of the student": "Prakhar Mittal",
    "Institute Name(College)": "University of Florida",
    "Field of study": "Computer Science",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Software",
    "Period of Internship": "3moths, starting from May 2020",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1hyuMuo9s9cpeqVZuUa_XGJsItTwC_VYA/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/prakhar-mittal/",
    "Contact Details (Email)": "prakharmittal97@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 10:11:58",
    "Name of the student": "Ankush Kulkarni",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "Marketing Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing & Strategy",
    "Period of Internship": "2 months, Joining Immediate",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Looking out for a Remote Internship",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Voq8D6_f_wv0gL8lIck8O6aS3sKpkpEK/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ankush-kulkarni-b867b3101",
    "Contact Details (Email)": "ankushklkrn@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 10:44:46",
    "Name of the student": "Jajjara Pradeep",
    "Institute Name(College)":
      "Indian Institute of Information Technology, Design and Manufacturing Kancheepuram",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science,Machine Learning,Data Analyst",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ongole,India",
    "Does Remote Internship work for you?":
      "Yes,but relocation is not possible",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1b1eD4PQLEeFstm2W2f5fZzw7JIfFbT8q",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pradeep-jajjara-6380b416a/",
    "Contact Details (Email)": "jajjarapradeep99@gmail.com",
    "Anything else you'd like to share?":
      "Have an experience of doing five month intern at gavs.",
  },
  {
    Timestamp: "05/01/2020 10:52:03",
    "Name of the student": "Harsh Raj Jaiswal",
    "Institute Name(College)":
      "G L Bajaj Institute of technology and management",
    "Field of study": "B.tech in Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Design domains or CAD/CAM domains",
    "Period of Internship": "Free for any type of opportunity",
    "Current Location(With Country)": "Gorakhpur, Uttar Pradesh, India",
    "Does Remote Internship work for you?":
      "Yes, New Delhi or greater noida or anywhere near delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-7ZIfAACJQ-l6eOFmRtQx56vQCLjYZx7/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/rajharsh5511",
    "Contact Details (Email)": "rajharsh5511@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 11:06:02",
    "Name of the student": "Kuldeep Sharma",
    "Institute Name(College)": "XLRI",
    "Field of study": "Operations & Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "IT",
    "Period of Internship": "3",
    "Current Location(With Country)": "Jamshedpur, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Rj0IcTNqcSHtidaQwdgeUObPnS0PpE93/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kuldeep-sharma-4b873022/",
    "Contact Details (Email)": "g19020@astra.xlri.ac.in",
    "Anything else you'd like to share?":
      "I am open to internship in other domains such as marketing and finance also.",
  },
  {
    Timestamp: "05/01/2020 12:11:46",
    "Name of the student": "Mehak aggarwal",
    "Institute Name(College)":
      "Jaypee institute of information technology Noida",
    "Field of study": "Electronics and communication engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance,Buisness analyst",
    "Period of Internship": "1st May 2020- 1st July 2020",
    "Current Location(With Country)": "Delhi,India",
    "Does Remote Internship work for you?": "Yes,Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ciH8pPG9Wp6SjeFSEZACjwARuznW6SEP/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mehakaggarwal980@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 12:12:46",
    "Name of the student": "Suyog Ladda",
    "Institute Name(College)":
      "Welingkar Institute of Management Development & Research, Bangalore",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "2 months joining immediately",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "Yes, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1q9eRm76MvNZKJ1mg903-ZgedMxS8Vs-J/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/suyog-ladda-564479188",
    "Contact Details (Email)": "suyog.ladda.we@gmail.com",
    "Anything else you'd like to share?":
      "I have worked in any different sectors in marketing domain, so I am having good knowledge of majority of sector & i am ready to work in any of the sector.",
  },
  {
    Timestamp: "05/01/2020 13:11:20",
    "Name of the student": "Upasana Pandey",
    "Institute Name(College)": "Mumbai University",
    "Field of study": "History and sociology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Design",
    "Period of Internship": "2-4 months, Immediatly, 10th May",
    "Current Location(With Country)": "Thane, India",
    "Does Remote Internship work for you?": "no",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-Ah2Xmy8hgO5VmbzG0LbeLWiVFidsHCt",
    "LinkedIn profile link": "https://www.linkedin.com/in/upsn/",
    "Contact Details (Email)": "upsn30@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 15:28:24",
    "Name of the student": "Mayank Khatri",
    "Institute Name(College)": "Indian Institute of Technology Delhi",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Engineering or Quantitative Researcher",
    "Period of Internship": "Start asap, duration= 2-3 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1T7d_nzTtD0ZVmUNzNF24AyrTia9eBmn0/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 16:09:12",
    "Name of the student": "Vikram Singh",
    "Institute Name(College)":
      "Zakir Husain College of Engineering and Technology, Aligarh Muslim University",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning, Image Processing, and Computer Vision",
    "Period of Internship": "3-5 months staring from June",
    "Current Location(With Country)": "Aligarh, Uttar Pradesh, India",
    "Does Remote Internship work for you?":
      "Yes, remote internship is perfect for me. Yes, I can reallocate to Noida or Delhi.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1zVBHKQLZvMXtLZgZsgqIcCf4qPHC4blS",
    "LinkedIn profile link": "https://www.linkedin.com/in/vikramsingh-1/",
    "Contact Details (Email)": "vikramverma1997@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 19:44:41",
    "Name of the student": "Smayan Das",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning/ Data Analysis/Software",
    "Period of Internship": "2-3, Can start Any time",
    "Current Location(With Country)": "Nagpur, India",
    "Does Remote Internship work for you?": "Yes,  Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ybM_-GU861LLm2M9iAoSNnwlXal3Xz1s/view?usp=sharing",
    "LinkedIn profile link": "http://linkedin.com/in/smayand",
    "Contact Details (Email)": "smayanrut99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 20:46:05",
    "Name of the student": "Shivansh Srivastava",
    "Institute Name(College)": "Jaypee institute of information technology",
    "Field of study": "Computer science engineering (IT)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "IT",
    "Period of Internship": "6 months -20 May",
    "Current Location(With Country)": "Noida,  Uttar Pradesh",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1hKwuggWtRhPEtKK45V19pzwie6Rzn6Eq/view?usp=drivesdk",
    "LinkedIn profile link": "Http://LinkedIn.com/in/laughwithshivansh",
    "Contact Details (Email)": "Shivanshtech27@gmail.com",
    "Anything else you'd like to share?":
      "Working as an intern in Cadence Designs Noida for 4 months now.  Looking for paid internship or full time offer.",
  },
  {
    Timestamp: "05/01/2020 21:12:34",
    "Name of the student": "Prasang Kumar",
    "Institute Name(College)": "IIT Kharagpur",
    "Field of study": "Industrial Electronics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Analytics or Supply Chain/Operations Management",
    "Period of Internship":
      "Till 20th August(with break for july 1-15, for college exams)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "As per my college academic calender, adapted as per this situation, I can only do a remote internship",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15Eid8TI21ATBWuskriJffqHxKgZkTIvG/view",
    "LinkedIn profile link": "linkedin.com/in/prasangkr",
    "Contact Details (Email)": "mail.prasangkr@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/01/2020 23:13:16",
    "Name of the student": "HRITIK MEHTA",
    "Institute Name(College)": "Indian Institute of Technology Kharagpur",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance/ Strategy Management/ Data Science",
    "Period of Internship": "2months",
    "Current Location(With Country)": "Kharagpur, West Bengal, India",
    "Does Remote Internship work for you?": "Yes, Mumbai/ Delhi / Bangalore",
    "Link to Resume(Google Drive/Dropbox)": "https://biturl.top/j2Ejey",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "hritikmehta@iitkgp.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/02/2020 01:18:51",
    "Name of the student": "Aman Goyal",
    "Institute Name(College)":
      "Jaypee Institute of Information Technology, Noida",
    "Field of study": "Electronics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning/ Software Development/ Data Structures and Algorithms",
    "Period of Internship": "45 days, starting from 1st of June, 2020",
    "Current Location(With Country)": "Haridwar, India",
    "Does Remote Internship work for you?":
      "Yes, I'm open to relocate to Noida or Delhi",
    "Link to Resume(Google Drive/Dropbox)": "https://tinyurl.com/y9re9g6f",
    "LinkedIn profile link": "https://www.linkedin.com/in/aman-goyal-b7491319a",
    "Contact Details (Email)": "goyalaman37246@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/02/2020 02:02:03",
    "Name of the student": "Rishav Kumar",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data structures and Algorithms/Python Programmer/Data Scientist",
    "Period of Internship": "Approx 2 months/ from 4th may and after.",
    "Current Location(With Country)": "Patna, Bihar, India",
    "Does Remote Internship work for you?":
      "Yes, Delhi/Noida, But mainly I will Prefer an intership with work from home criteria.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RYHafQnB8QBiPwubx_-4uv__uMB6bw2o/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/rishav332",
    "Contact Details (Email)": "rishabhkumar332@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/02/2020 10:48:24",
    "Name of the student": "Udit Krishna Chaudhary",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "B.Tech in Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "3 months. Starting from 1st May",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1NCHbrasVqcSs7wAMURs4IC7Kr1DKVWtJ/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/udit-krishna-chaudhary-55838914b/",
    "Contact Details (Email)": "uditchaudhary799@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/02/2020 11:12:28",
    "Name of the student": "Ritik Jain",
    "Institute Name(College)": "JIIT Noida",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning(NLP)",
    "Period of Internship": "2-3 months,starting date-as early as possible",
    "Current Location(With Country)": "Delhi,India",
    "Does Remote Internship work for you?": "NO",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1JZOuE9vNXhE_OlzmGIFpTtmOFUSa1Y_h",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ritik-jain-6aa808179?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BpGBFEyK0TvCP60ehOuqDmg%3D%3D",
    "Contact Details (Email)": "jainritik1999@gmail.com",
    "Anything else you'd like to share?":
      "I would prefer work from home internship.",
  },
  {
    Timestamp: "05/02/2020 14:05:00",
    "Name of the student": "Saurav Purva",
    "Institute Name(College)":
      "Indian Institute of Information Technology Design & Manufacturing Kancheepuram",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science/ML/AI",
    "Period of Internship": "5-6 months(Can start immediately)",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "yes, remote internship will work. If situation improves and lockdown is over i would be okay working in Bangalore, Delhi, Pune.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1W9epKMHyaDQt8l_NA91PcDnJBb7VCTzR",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/saurav-purva-16b32915a/",
    "Contact Details (Email)": "spurvaiiitdmk@gmail.com",
    "Anything else you'd like to share?":
      "As of my college guidelines i have to start my internship by May'10. I love to solve real-world problems by designing end to end model and taking data-driven decisions. Good team player, skilled with logical and analytical thinking. Proficient in Machine Learning and Data Science. Have lot of experience in Data Science/ML/AI through projects and internships. My last internship stipend was 30,000/month, so am looking for stipend around that.",
  },
  {
    Timestamp: "05/02/2020 17:53:30",
    "Name of the student": "Arvind Kumar",
    "Institute Name(College)": "IIT Madras",
    "Field of study": "Development Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Economics, Finance, Development Sector, Management",
    "Period of Internship": "2",
    "Current Location(With Country)": "Chennai, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SfibDMkd6CTgxm5XlHyueT0BCyfRlPpN/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/arvind-kumar-ab7a90194/",
    "Contact Details (Email)": "arvind.iitm16@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/02/2020 17:57:22",
    "Name of the student": "Rahul Jose",
    "Institute Name(College)": "Indian Institute of Technology Madras",
    "Field of study": "English Studies",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "1 month. Start Date: Between May 10-20",
    "Current Location(With Country)": "Trivandrum, Kerala, India.",
    "Does Remote Internship work for you?":
      "Remote Internship preferred. Can relocate only to Chennai.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MYD8wVmfQawm1Nppb87kiwvarXd1nYoJ/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rahul-jose-20a1b8191/",
    "Contact Details (Email)": "rahuljoseiitm2@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/02/2020 22:29:00",
    "Name of the student": "Sahil gupta",
    "Institute Name(College)":
      "Galgotias college of engineering and technology",
    "Field of study": "Electrical and electronic engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "3, 4 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, noida",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ToF-WMepHacBuj5_TGMQewfcuqCfBDaD/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "sahil.gupta9897@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/03/2020 12:23:23",
    "Name of the student": "Siddharth Bedi",
    "Institute Name(College)": "Bharati Vidyapeeth's College of Engineering",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analysis and Machine Learning",
    "Period of Internship": "3 months - 6 months, Can start Immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Any Indian Metropolitan",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=19iZN-2bmmGHXCyCKTC_e2Npo_8F8UdMh",
    "LinkedIn profile link": "https://www.linkedin.com/in/siddharth-bedi09/",
    "Contact Details (Email)": "siddharth.bedi09@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/03/2020 20:46:50",
    "Name of the student": "Vaibhav Bagaria",
    "Institute Name(College)": "Xavier University",
    "Field of study": "BBM",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Social Media Marketing/ Digital Marketing",
    "Period of Internship": "Max 2 months, starting immediately",
    "Current Location(With Country)": "Cuttack, Odisha, India",
    "Does Remote Internship work for you?": "Yes. Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/172B-jC8iDwVApc-FtN7YdkhA8DexxTpd/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/vaibhav-bagaria-7b54b1137",
    "Contact Details (Email)": "bagaria_v@ymail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/04/2020 11:11:07",
    "Name of the student": "DHVANI MONANI",
    "Institute Name(College)":
      "SOMLALIT INSTITUTE OF BUSINESS MANAGEMENT (SLIBM)",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "5 - 6 weeks maximum 2 months",
    "Current Location(With Country)": "Porbandar, Gujarat, India",
    "Does Remote Internship work for you?": "Yes, Ahmedabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1DTLihiIF9Wi5KbYL2L7orRvX4EP8BxRC/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dhvani-monani-4553261a8",
    "Contact Details (Email)": "dhwanimonani@gmail.com",
    "Anything else you'd like to share?":
      "Being a student of MBA Finance I expect to work with organization having some finance related projects. So it will be helpful in exploring my field further by way of summer Internship.",
  },
  {
    Timestamp: "05/04/2020 12:58:11",
    "Name of the student": "Pushpneet Singh",
    "Institute Name(College)":
      "Bharati Vidhyapeeth College of Engineering (GGSIPU)",
    "Field of study": "B.tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development, Web Development",
    "Period of Internship": "2 months, immediately",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Either Remote or Office Internship (Delhi NCR)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/1Y-q_zUgP9YXa-F6JIFsPsYuQ1uNEgZN8mtd8ASgyXyw/edit?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/pushpneet-singh-155a9015a/",
    "Contact Details (Email)": "pushpneetsingh99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/04/2020 19:57:50",
    "Name of the student": "Gautam Harsolia",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Textile engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance, operations",
    "Period of Internship": "2 months (starting from 1st week of may)",
    "Current Location(With Country)": "Jaipur, Rajasthan, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11yPrr_UIOlxOxCQyg5MPJerhdQyxCnND/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gautam-harsolia-892330165",
    "Contact Details (Email)": "harsolia1999@gmail.com",
    "Anything else you'd like to share?":
      "I have some past experience in many fileds and my performance was very good at all my past work place. I have decent set of skills. I am very hard working, curious, determined and eager to learn. I'm very interested in working with you.",
  },
  {
    Timestamp: "05/05/2020 06:03:55",
    "Name of the student": "Shiv Issar",
    "Institute Name(College)": "University of Wisconsin-Milwaukee",
    "Field of study": "Sociology",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Public Policy, Qualitative Research",
    "Period of Internship": "2-3 months (June-August)",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "https://about.me/shiv.issar",
    "LinkedIn profile link": "https://www.linkedin.com/in/shivissar/",
    "Contact Details (Email)": "shiv.issar@alumni.ashoka.edu.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/05/2020 10:38:44",
    "Name of the student": "Rutuja Kawade",
    "Institute Name(College)": "Pune Institute of Computer Technology",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Python, C++programming, web development, ML, Android app development",
    "Period of Internship": "2-3 months 10th May",
    "Current Location(With Country)": "Pune",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1QWoQQ58H7gxxNvmeGKhwlLI0ZZ8_12SH/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/rutuja-kawade-6b7a8a171/",
    "Contact Details (Email)": "rutujakawade24@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/05/2020 12:57:42",
    "Name of the student": "Akshat Tomar",
    "Institute Name(College)":
      "Priyadarshini Institute of Architecture and Design Studies",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Management / Architecture / Planning",
    "Period of Internship": "A Month or less - 10/05/2020",
    "Current Location(With Country)": "Seoni, Madhya Pradesh, India",
    "Does Remote Internship work for you?": "Nagpur",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14cya8QHeb89hfIXPm-yrl3xDk4qZd0tz/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/akshat-tomar-494a141a6",
    "Contact Details (Email)": "tomarakshat40@gmail.com",
    "Anything else you'd like to share?":
      "I'm looking forward to the opportunities not matter big or small as I've taken my Pioneer step in my professional career. I am interested in internships, workshops, voluntary work or any other thing of sorts.\n\nP.S. -  I'm very grateful to you for bringing such a great chance forward to us.",
  },
  {
    Timestamp: "05/05/2020 19:37:12",
    "Name of the student": "Rashi bhat",
    "Institute Name(College)": "Lm thapar school of management",
    "Field of study": "Mba",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Human resource or marketing",
    "Period of Internship": "2 months (may to July)",
    "Current Location(With Country)": "Jammu,india",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1p_M_G8aNEV9LR4jmEdUd_zamLrQZ6gwS/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/rashi-bhat-a42a40193",
    "Contact Details (Email)": "rashibhat23@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/05/2020 22:11:16",
    "Name of the student": "Anshul Tembhare",
    "Institute Name(College)": "Indian Institute of Technology, Kharagpur",
    "Field of study": "Instrumentation engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Machine Learning, Business Analytics",
    "Period of Internship": "2-3 months, Start Immediately",
    "Current Location(With Country)": "Gondia, Maharashtra , India",
    "Does Remote Internship work for you?":
      "Yes, Remote internship is fine. Not willing to relocate after lockdown",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/my-drive?fbclid=IwAR1CDd9O501uVURoJuNCSgAY9jHxILnTZAVYxy56SMxEoKu7cli_lPJGWi0",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anshul-tembhare-35084317a/",
    "Contact Details (Email)": "atembhare2017@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/05/2020 22:55:58",
    "Name of the student": "Piyush Singh",
    "Institute Name(College)": "IIT(BHU) Varanasi",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Science",
    "Period of Internship": "start immediately for about 8 weeks",
    "Current Location(With Country)": "Cuttack, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1HEVXAmTFihmMP5KP47ajlvSIpJ2F4fxt/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/piyush-singh-049084175/",
    "Contact Details (Email)": "piyush9937588957@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/05/2020 23:50:31",
    "Name of the student": "Pranshu Sinha",
    "Institute Name(College)": "Manipal Institute Of Technology",
    "Field of study": "B.Tech Electrical and electronic engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Management",
    "Period of Internship": "6",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1xxC_TM0b-ncuZSiNJII7XELpvdrS9DHa/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/pranshu-sinha-4a8909143",
    "Contact Details (Email)": "pranshusinha55@gmail.com",
    "Anything else you'd like to share?":
      "Psychology, Philosophy, Photography, Marketing, HR.",
  },
  {
    Timestamp: "05/06/2020 04:20:18",
    "Name of the student": "Arijit Roychaudhury",
    "Institute Name(College)": "Kalyani Government Engineering College",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Machine Learning, Computer Vision, NLP, Image processing",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Kolkata, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rCJknVtitpTorUoblU2iE2_YaQtMcIPf/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/arijit-roychaudhury-a09a7a147/",
    "Contact Details (Email)": "arijitroychaudhury@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/06/2020 13:10:38",
    "Name of the student": "Sarthak Sachdeva",
    "Institute Name(College)": "Thapar Institute of Engineering and Technology",
    "Field of study": "Mechatronics Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Analytics / Consulting",
    "Period of Internship": "2 months (From June 1)",
    "Current Location(With Country)": "Chandigarh, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1knt2PwOVBnjlC82DOXEWowGnxsqOscVz/view?usp=drivesdk",
    "LinkedIn profile link": "Www.linkedin.com/in/sarcentaur",
    "Contact Details (Email)": "Sarthaksachdeva@outlook.com",
    "Anything else you'd like to share?":
      "I further assure you that with my innovative mindset coupled with a strong passion for the mentioned role, I will not only gain knowledge and accelerate my career development but in turn will immensely contribute to the firm and will certainly prove to be an asset to the co-existing team. In addition to this, my diverse educational background will bring along an adaptable and strong mindset to face all sorts of challenges.",
  },
  {
    Timestamp: "05/06/2020 23:04:17",
    "Name of the student": "Rahul Tomar",
    "Institute Name(College)": "Indian Institute of Management Bodh Gaya",
    "Field of study": "Business",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "two months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Yes, I am open to remote opportunity allover India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rsiXTfI8zQfAJmhzDWjayiUWMvjDalbW/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rahul-tomar-247738153?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BTypaxqT1TIWhwBuJF7zbLQ%3D%3D",
    "Contact Details (Email)": "rahult2021@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/07/2020 00:47:33",
    "Name of the student": "Partho Pratim Nath",
    "Institute Name(College)": "National Institute of Technology Silchar",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "CS based involving coding",
    "Period of Internship": "2 months,7th May 2020",
    "Current Location(With Country)": "Goalpara,Assam,India",
    "Does Remote Internship work for you?":
      "Yes,Bangalore,Guwahati,Kolkata,Delhi,Noida,Mumbai,Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SFe_Y3vdDdAD2ZzP1DF4a6H2RRosY1YU/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "partho9812@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "05/07/2020 01:41:28",
    "Name of the student": "Smriti Srivastava",
    "Institute Name(College)": "Lloyd Business School",
    "Field of study": "Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Digital marketing or Branding",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Kanpur, India",
    "Does Remote Internship work for you?": "Yes, I can relocate to Delhi NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1UbD6CsiNyA9oqlUY7dd3ENHcyYHOhRKG/view?usp=drivesdk",
    "LinkedIn profile link": "Linkedin.com/in/smriti-srivastava-753b4716b",
    "Contact Details (Email)": "smritis896@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/07/2020 08:33:11",
    "Name of the student": "James Sadie",
    "Institute Name(College)": "Auburn University",
    "Field of study": "Finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Investment Banking or related fields",
    "Period of Internship": "June-August",
    "Current Location(With Country)": "Montgomery, Alabama",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)": "experiences listed on linkedin",
    "LinkedIn profile link": "https://www.linkedin.com/in/james-sadie/",
    "Contact Details (Email)": "jhs0032@auburn.edu",
    "Anything else you'd like to share?":
      "I am a driven individual that is very hardworking and would love the opportunity to connect and learn about any opportunities in which I can add value to your company",
  },
  {
    Timestamp: "05/07/2020 08:41:03",
    "Name of the student": "Stephen Sadie",
    "Institute Name(College)": "Auburn University",
    "Field of study": "Finance",
    Education: "Undergraduate",
    "Preferred domain of internship": "Investment Banking or related",
    "Period of Internship": "August - December",
    "Current Location(With Country)": "United States",
    "Does Remote Internship work for you?": "Remote is preferred if possible",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/sh/v7l6qo2inhqy7wr/AACleYzLM3BbTwbhxj4ej9_qa?dl=0",
    "LinkedIn profile link": "https://www.linkedin.com/in/stephen-sadie/",
    "Contact Details (Email)": "JSS0072@auburn.edu",
    "Anything else you'd like to share?":
      "I am a very motivated, hard working individual with experience in investment banking such as M&A due diligence, valuation, modeling, excel, and more. I would love to connect and learn about any opportunities where I can bring value.",
  },
  {
    Timestamp: "05/07/2020 15:14:15",
    "Name of the student": "Shelly Jain",
    "Institute Name(College)": "Maitreyi College, DU",
    "Field of study": "BA(H) Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance and Marketing",
    "Period of Internship": "2 months (10th may)",
    "Current Location(With Country)": "Meerut UP, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.dropbox.com/sh/sme8ei9az877sqj/AACOk2Kf7ENBzXWhmjub1TVfa?dl=0",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "shellyjainsj06@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/07/2020 17:51:05",
    "Name of the student": "Anjali Sharma",
    "Institute Name(College)": "Jaypee Institute of information technology",
    "Field of study": "Computer science engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "2 to 6 months. Starting from May.",
    "Current Location(With Country)": "Delhi, Indi",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1gZFaAMU-e6ea7mL4AlH52jbxLigGu2D_/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anjali-sharma-9a028716a",
    "Contact Details (Email)": "Anjali.ss.sharma8@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/08/2020 01:21:47",
    "Name of the student": "Upasna Mattoo",
    "Institute Name(College)":
      "University School of Information Technology, GGSIPU",
    "Field of study": "Electronics and Communications engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Marketing, Business Development, Software Testing",
    "Period of Internship": "6-8 weeks",
    "Current Location(With Country)": "Noida, Uttar Pradesh, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1h5mSTyK9p_J68Thf3V6CWdgaHYXXxisZ/view?usp=drivesdk",
    "LinkedIn profile link": "http://linkedin.com/in/upasna-m-39a1a7126",
    "Contact Details (Email)": "upasnamattoo@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/08/2020 09:40:34",
    "Name of the student": "omkar sharma",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "CSE-B.Tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "software developer",
    "Period of Internship": "3",
    "Current Location(With Country)": "Agra",
    "Does Remote Internship work for you?": "yes,delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1iv0X31F32cCdGfdps7OTxGWU1DaA_3Mf",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/omkar-sharma-930781166/",
    "Contact Details (Email)": "omkarsharma211@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/08/2020 12:41:38",
    "Name of the student": "Hitanshu Vig",
    "Institute Name(College)": "IPU",
    "Field of study": "B.TECH (CSE)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Developer",
    "Period of Internship": "1-3months",
    "Current Location(With Country)": "New Delhi",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16SUIlrxNZDhPO9SbYi_1Cv1zS0iOj1GI/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "hitanshu173@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/08/2020 18:51:39",
    "Name of the student": "Saurabh Bharuka",
    "Institute Name(College)":
      "Narsee Monjee College of Commerce and Economics",
    "Field of study": "Business Administration ( Finance)",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance, Investment Banking, Equity Research.",
    "Period of Internship": "May -August",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes, Mumbai, Pune.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-jhqMQ5HvNWly9u1UUuPe62kS00ChF5R/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/saurabh-bharuka",
    "Contact Details (Email)": "saurabh.bharuka.27@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/09/2020 11:24:27",
    "Name of the student": "Harshit Bhatt",
    "Institute Name(College)": "Birla Institute of applied Sciences, Bhimtal",
    "Field of study": "Computer Science engineering.",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning, Artificial Intelligence and Chat-bot development.",
    "Period of Internship": "2 to 3 months",
    "Current Location(With Country)": "Uttarakhand, India",
    "Does Remote Internship work for you?": "Yes. And Im willing to relocate .",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1aAkn5gKvMRzEL9YMUaY9qN-FNW3oWAEe",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/harshit-bhatt-6a991a16a",
    "Contact Details (Email)": "harshitbhatt028@gmail.com",
    "Anything else you'd like to share?":
      "It will be great if the Internship has a Pre Placement Offer.",
  },
  {
    Timestamp: "05/09/2020 14:13:57",
    "Name of the student": "Anjali saini",
    "Institute Name(College)": "Lovely professional University",
    "Field of study": "Commerce, economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Management related",
    "Period of Internship": "3 months",
    "Current Location(With Country)": "Gurgaon,India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "Google drive",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "anjalisaini1591@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/09/2020 16:44:45",
    "Name of the student": "Naishi Shah",
    "Institute Name(College)":
      "School of Engineering and Applied Science, Ahmedabad University",
    "Field of study": "Information and communication technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software development",
    "Period of Internship": "2 months, starting from June 1st",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1jZUicIlBDQd207918Knx-S6QALTzLp0d",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/naishi-shah-98a610159/",
    "Contact Details (Email)": "naishilshah@gmail.com",
    "Anything else you'd like to share?":
      "Though I do not have much experience, I am an enthusiastic and quick learner and I love taking up challenges.",
  },
  {
    Timestamp: "05/09/2020 19:04:44",
    "Name of the student": "Kallam Hema Harsitha",
    "Institute Name(College)": "IIT Bhubaneswar",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine Learning, Data Science, Python development",
    "Period of Internship": "1 or 2 months(starting immediately)",
    "Current Location(With Country)": "Hyderabad,Telangana,India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1_2q1QVrCHQxwAK7S8JmaBRvXFVI2gLzW/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/hema-harshitha-00a440191",
    "Contact Details (Email)": "khh10@iitbbs.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/10/2020 16:49:49",
    "Name of the student": "Akshita Sharma",
    "Institute Name(College)": "Ambedkar University Delhi",
    "Field of study": "Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Research and Analysis",
    "Period of Internship": "1st June; 1-2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes; Delhi, Bangalore, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1L54asmMDjB8nKK1-6nULg9QjPXutwHe-/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/akshita-sharma",
    "Contact Details (Email)": "akshitas1027@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/10/2020 17:16:56",
    "Name of the student": "Akshita Sharma",
    "Institute Name(College)": "Ambedkar University Delhi",
    "Field of study": "Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Research and Analysis",
    "Period of Internship": "1 to 2 months, 1st June",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes; Delhi, Bangalore, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ceJO3Veb3KURh6rzWLZXEoMn_wRsUCY9/view?usp=drivesdk",
    "LinkedIn profile link": "linkedin.com/in/akshita-sharma",
    "Contact Details (Email)": "akshitas1027@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/11/2020 11:00:26",
    "Name of the student": "Mehul Kondapally",
    "Institute Name(College)": "San Francisco State University",
    "Field of study": "Embedded Electrical and computer systems",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Embedded systems",
    "Period of Internship": "3 months starting June 1",
    "Current Location(With Country)": "San Francisco, CA, United States",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1jPPltvMu3AUEaYb6FMz7p5w6zmhgG0Ft",
    "LinkedIn profile link": "https://www.linkedin.com/in/kmehul/",
    "Contact Details (Email)": "mkondapally@mail.sfsu.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/12/2020 14:04:46",
    "Name of the student": "Aklank Jain",
    "Institute Name(College)": "VGSoM,  IIT Kharagpur",
    "Field of study": "Business Management",
    Education: "Undergraduate",
    "Preferred domain of internship": "Program Management",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Chandigarh, India",
    "Does Remote Internship work for you?": "Yes, Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-JMgmVC0kfCh0sDiQubw3jpvgi1azmJv",
    "LinkedIn profile link": "https://www.linkedin.com/in/aklankjain95/",
    "Contact Details (Email)": "aklank.jain.iitkgp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/12/2020 20:09:17",
    "Name of the student": "siddharth sharma",
    "Institute Name(College)":
      "university of petroleum and energy studies ( UPES )",
    "Field of study": "B.tech fire and safety ( FSE )",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "fire realated or waste to energy - MSW management",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Jaipur ( Rajasthan )",
    "Does Remote Internship work for you?": "yes in jaipur or dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1-QIgE8S7skUufpo_2D-ydoTx2uMoQOKT/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/siddharth-sharma-1st-6271921a0/",
    "Contact Details (Email)": "sidsharma50282@gmail.com",
    "Anything else you'd like to share?":
      "provide me internship if possible as soon as.",
  },
  {
    Timestamp: "05/13/2020 19:27:33",
    "Name of the student": "Gautam Kumar",
    "Institute Name(College)": "BVM Engineering College",
    "Field of study": "Civil Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Writing/Manager/Any small level task",
    "Period of Internship": "1-3",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/127XMwGIAgNk2maShgWiyvVSJKGrUFydPkBTG4MxFhHw/edit?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/gautamkumar42/",
    "Contact Details (Email)": "gautamprep@gmail.com",
    "Anything else you'd like to share?":
      "I like to connect with more people and explore the world. I would love if i could get such oppournity.",
  },
  {
    Timestamp: "05/14/2020 07:08:28",
    "Name of the student": "Rachit Gupta",
    "Institute Name(College)": "Syracuse Univeristy",
    "Field of study": "Engineering Managemet",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data/Business Analytics",
    "Period of Internship": "3months-1year",
    "Current Location(With Country)": "Syracuse, NY, USA",
    "Does Remote Internship work for you?":
      "Yes, i am flexible for locations pan USA",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1JGtjPtes6_WEEr_LE9prGrSVzQiH-PI0",
    "LinkedIn profile link": "www.linkedin.com/in/rachitgupta24",
    "Contact Details (Email)": "rachitj1196@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/14/2020 08:23:31",
    "Name of the student": "Nandini Agrawal",
    "Institute Name(College)": "Jaypee institute of information technology",
    "Field of study": "Information technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analytics",
    "Period of Internship": "Starting immediately for 2-3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1kNqUTvDU0z-MlFgp_okAq4eUZ1s7A7XG/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "nandiniagrawal.can@gmail.com",
    "Anything else you'd like to share?":
      "I am a beginner in the analytics field but I am very eager to learn and committed to my responsibilities.",
  },
  {
    Timestamp: "05/14/2020 09:23:58",
    "Name of the student": "Jayesh Tada",
    "Institute Name(College)":
      "Department of business economics, University of Delhi",
    "Field of study": "MBA finance & Analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance,Data analytics",
    "Period of Internship": "From anytime",
    "Current Location(With Country)": "Gujarat,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1MTQE_bM0vfPz6JhVH4rIpJpCTtxl7jpD/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/jayesh-tada-621430117",
    "Contact Details (Email)": "jayesh-2021@dbe-du.org",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/14/2020 16:50:22",
    "Name of the student": "Aashal Kamdar",
    "Institute Name(College)": "Manipal Institute of Technology",
    "Field of study": "Computer and communication engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning, data science",
    "Period of Internship": "1 to 2 months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?":
      "Relocation is a little tough as I will enter my final year, but remote internship works",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ryPj2C8Plmq2E5tRn1LBo6N3TfSJX2Bj/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/aashal-k-54238192/",
    "Contact Details (Email)": "aashalkamdar@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/14/2020 17:23:34",
    "Name of the student": "Karmanya Sarma",
    "Institute Name(College)": "Deli Technological University",
    "Field of study": "Mathematics and Computing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Engineer,Data Science,Machine Learnin",
    "Period of Internship": "2 months,available from May itself",
    "Current Location(With Country)": "Delhi,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-5BCZpzaOosFnJubEvgxiJoASZisKTJh",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/karmanya-sharma-95269615b/",
    "Contact Details (Email)": "karmanya15@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/14/2020 18:35:25",
    "Name of the student": "Muppala Sukeerth",
    "Institute Name(College)": "sukeerthmuppala@gmail.com",
    "Field of study": "Electronics and Telecommunication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance/ Marketing",
    "Period of Internship": "2-3 months Start Date 20th May 2020",
    "Current Location(With Country)": "Bengaluru, India",
    "Does Remote Internship work for you?":
      "Yes, remote internship works for me . Preferred city to relocate to would be Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1ypezHF5g53tB7nLyQ6sDwWSItNagttpD",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/muppala-sukeerth-67a70b15a",
    "Contact Details (Email)": "sukeerthmuppala@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/14/2020 18:41:06",
    "Name of the student": "ruthwik",
    "Institute Name(College)": "IIIITDM KANCHEEPURAM",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Autonomous vehicles, space science, aeronautical , deaigning and fabrication, mechanical core subject related projects and research",
    "Period of Internship": "Any",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, remote internship helps me a lot to manage my academics with my work",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/10DMagjImaZcnND8rdrZEBnDiFGSdKPV7/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/ruthwikdasyam/",
    "Contact Details (Email)": "ruthwikdasyam@gmail.com",
    "Anything else you'd like to share?":
      "I am very passionate about my work. I do put my 100% effort and hardwork to reach to the top of any work I do. I believe in smart work.",
  },
  {
    Timestamp: "05/14/2020 19:00:51",
    "Name of the student": "Ayushi Tyagi",
    "Institute Name(College)": "Meerut institute of engineering and technology",
    "Field of study": "Biotechnology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Life science, technical skills",
    "Period of Internship": "5-6",
    "Current Location(With Country)": "Uttarpradesh, India",
    "Does Remote Internship work for you?":
      "Yes, Delhi, Noida, Bangalore, Gurgaon",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1uOXaYL2rt9_lZHlar6DggG2umEMp7yJU/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/ayushityagi",
    "Contact Details (Email)": "ayushi.tyagi768@gmail.com",
    "Anything else you'd like to share?":
      "Just a little thought: definitely this period will bring a good change to everyone's life who has support of people who can guide them properly  so that when they come out of their shell(houses) they are more powerful and skillfull \n",
  },
  {
    Timestamp: "05/14/2020 20:03:00",
    "Name of the student": "Bhawana Bisht",
    "Institute Name(College)":
      "Army institute of management and technology, IP",
    "Field of study": "Finnace",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "Upto 2 months",
    "Current Location(With Country)": "Greater Noida, India",
    "Does Remote Internship work for you?":
      "Yes, I am open to relocate anywhere in India",
    "Link to Resume(Google Drive/Dropbox)":
      "https://s.docworkspace.com/d/AB2ODeOTw9wxwZvH9cqdFA",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bhawana-bisht-11b2b91a0/",
    "Contact Details (Email)": "bhawana198bisht@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/14/2020 21:08:31",
    "Name of the student": "Nimisha Shreevastava",
    "Institute Name(College)": "Army Institute of Management and technology",
    "Field of study": "finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "6-8 weeks",
    "Current Location(With Country)": "Delhi, india",
    "Does Remote Internship work for you?": "Yes, as per the desired situation",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/16lP2G_eN569RY4Z2ZLpL_JRSkX1dN72Q/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/nimisha-shreevastava-22b87b1a7",
    "Contact Details (Email)": "nimisha.shreevastava@gmail.com",
    "Anything else you'd like to share?":
      "My diligence and ability to learn new skills and my dedication to whatever I do gives me an edge over other students.",
  },
  {
    Timestamp: "05/15/2020 16:44:20",
    "Name of the student": "Enayat",
    "Institute Name(College)": "",
    "Field of study": "BTech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analyst",
    "Period of Internship": "1- 6 months",
    "Current Location(With Country)": "Noida",
    "Does Remote Internship work for you?": "Yes, pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1koapwdCinxExraASIGoOgEtjKtEXeggz/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "enayata3@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/15/2020 22:17:08",
    "Name of the student": "Sarath Rajeev",
    "Institute Name(College)": "Symbiosis institute of operations management",
    "Field of study": "Operations",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations",
    "Period of Internship": "2",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1p72sdgByT1ir-lW8gp-4ejMpHC8SRom8/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rajeevsarath9669@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/16/2020 22:19:59",
    "Name of the student": "Kajal Chanchalani",
    "Institute Name(College)": "Netaji Subhas Institute of Technology, Delhi",
    "Field of study": "B.E. in Electronics and Communications Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software Development Internship, Teaching Internship, Any Non Tech role also works",
    "Period of Internship": "Starting immediately till August End",
    "Current Location(With Country)": "Prayagraj, India",
    "Does Remote Internship work for you?": "Prayagraj",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1as_viF-DEOavG-5HHGvkTm6Z3xjPF4YV",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "mailtokajal29@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/16/2020 22:34:42",
    "Name of the student": "Rishabh Dutt Sharma",
    "Institute Name(College)": "Jaypee Institute of Information Technology",
    "Field of study": "Electronics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electronics and AI",
    "Period of Internship": "60 days",
    "Current Location(With Country)": "Ghaziabad,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1kG2Kd9Ts66vMsaX_itBhJSW1s6rgGHfj",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rishabh-dutt-sharma-a51b30148/",
    "Contact Details (Email)": "srishabh40@yahoo.com",
    "Anything else you'd like to share?":
      "An avid learner and eager for hands on reality",
  },
  {
    Timestamp: "05/16/2020 22:55:12",
    "Name of the student": "Agrawal Shreya",
    "Institute Name(College)": "Somlalit Institute of Business Management",
    "Field of study": "Finance",
    Education: "Pursuing MBA",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ahmedabad, Gujarat, Ahmedabad",
    "Does Remote Internship work for you?": "Yes, Ahmedabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://docs.google.com/document/d/15XSz9D3B9ldj5iIOF_630jR9E20oufi-q2CISXiPrqU/edit?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/shreya-agrawal-0478171a0",
    "Contact Details (Email)": "shreyaagrawal1700@gmail.com",
    "Anything else you'd like to share?":
      "Looking for internship, where i can work with full dedication and can enhance my knowledge in field of finance.",
  },
  {
    Timestamp: "05/17/2020 18:51:30",
    "Name of the student": "Mnajul",
    "Institute Name(College)": "Indian Institute of Management Indore",
    "Field of study": "PGP",
    Education: "Post-Graduate",
    "Preferred domain of internship": "strategy & marketing",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Himachal Pradesh",
    "Does Remote Internship work for you?": "Delhi or bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1JLW81A1nDoRlCbFI6bDwPr4h8HVuuOkO/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/manjul-7a8253194/",
    "Contact Details (Email)": "p19manjul@iimidr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/17/2020 20:13:26",
    "Name of the student": "Sukriti Bhalla",
    "Institute Name(College)": "Amity University",
    "Field of study": "MBA(MARKETING & SALES)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "MARKETING",
    "Period of Internship": "1 MONTH",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1m8fCzPCIZl9tRJyKpOn9y0IHe_m9HWh5",
    "LinkedIn profile link": "www.linkedin.com/in/sukriti-bhalla-68a5b8157",
    "Contact Details (Email)": "bhallasukriti@gmail.com",
    "Anything else you'd like to share?":
      "I am Sukriti Bhalla And currently pursuing MBA from Amity, I am looking out for Internships in the domain of Marketing , I have completed a few courses in Digital marketing , content Marketing . I have good leadership and communication skills .",
  },
  {
    Timestamp: "05/17/2020 22:21:18",
    "Name of the student": "Karmanya Sharma",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Mathematics and Computing",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science,Machine Learning,Business Analytics",
    "Period of Internship": "6-8 weeks starting from May 20th",
    "Current Location(With Country)": "Delhi,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1-5BCZpzaOosFnJubEvgxiJoASZisKTJh",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/karmanya-sharma-95269615b/",
    "Contact Details (Email)": "karmanya15@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/19/2020 14:36:57",
    "Name of the student": "Ishita Batra",
    "Institute Name(College)": "Jaypee institute of Information Technology",
    "Field of study": "Information technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine learning and data science",
    "Period of Internship": "Available for 3 months starting June 2020",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ziszJkrhuXASdZ30BFg3_NOBA7gKGWkk/view?usp=sharing",
    "LinkedIn profile link": "LinkedIn.com/ishita-Batra-0809",
    "Contact Details (Email)": "ishitabatra0809@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/19/2020 19:39:35",
    "Name of the student": "Garima Chaudhary",
    "Institute Name(College)":
      "University School of Information, Communication and Technology (USICT), GGSIPU",
    "Field of study": "B.Tech ECE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Marketing, Data Analytics, Digital Marketing, Editorial",
    "Period of Internship": "1 or 2 months with starting immediately",
    "Current Location(With Country)": "Gurgaon, Haryana",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17eKqZCsqgYmZw8Wijg4NdzLImmrafHOq",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/garima-chaudhary-708a9514a/",
    "Contact Details (Email)": "garimachaudhary0527@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/19/2020 20:12:53",
    "Name of the student": "Garima Chaudhary",
    "Institute Name(College)":
      "University School of Information, Communication and Technology, GGSIPU",
    "Field of study": "B.Tech ECE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Marketing, Analytics, Editorial",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Gurugram",
    "Does Remote Internship work for you?": "no",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17eKqZCsqgYmZw8Wijg4NdzLImmrafHOq",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/garima-chaudhary-708a9514a/",
    "Contact Details (Email)": "garimachaudhary0527@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/20/2020 17:49:04",
    "Name of the student": "Yash Bhurani",
    "Institute Name(College)":
      "Delhi School of Management,Delhi Technological University",
    "Field of study": "Marketing and IT",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Product Management, Data Analysis",
    "Period of Internship": "2",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes, Delhi NCR",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1RT_HV3N13v__e4YV7yNPLJbYuH9aLdwF/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://in.linkedin.com/in/yash-bhurani-34174b128",
    "Contact Details (Email)": "yashwayne1@gmail.com",
    "Anything else you'd like to share?":
      "I am currently pursuing MBA in Marketing and IT from Delhi Technological University. I have worked with Aspiring Minds as a Management Trainee for 14 months where I was responsible for liasoning with various stakeholders for timely development of the product and creating Business Requirement Documents (BRDs) for developers. I did functionality testing  of a product based on Call Chat Simulation. I was also responsible for making the android and iOS app consistent with the web interface by identifying the key gaps. Involved in developing the Test Manuals of the assessments. I did my B.Tech in Computer Science from GGSIPU (Delhi) and I did two internship during B.Tech. One at Aspiring Minds and other at Technical University of Sofia (Bulgaria).",
  },
  {
    Timestamp: "05/21/2020 23:31:15",
    "Name of the student": "Mohit R Kulkarni",
    "Institute Name(College)": "University of Grenwich",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "MARKETING",
    "Period of Internship": "",
    "Current Location(With Country)": "",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1stu8urGkQfTvp0c2GWwvfZRkizYyqCRw",
    "LinkedIn profile link": "www.linkedin.com/in/mohit-kulkarni-2a4614197",
    "Contact Details (Email)": "kulkarnimohit61@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/22/2020 11:39:55",
    "Name of the student": "Dhruvajit Ghosh",
    "Institute Name(College)": "Manipal institute of technology",
    "Field of study": "ELectromics and Communication",
    Education: "Undergraduate",
    "Preferred domain of internship": "Semiconductor/VLSI",
    "Period of Internship": "",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1G4JmKG68I8caOsJUgvcirhYAiSWGFb-y/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "ghoshg401@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/23/2020 01:30:28",
    "Name of the student": "Abhishek Gupta",
    "Institute Name(College)": "Sir padampat Singhania University",
    "Field of study": "Cse(IoT)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analysis, python, big.data",
    "Period of Internship": "At least 50 days and max 90 days",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes, any",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/14ijzhIUEtMOxx7HyqEqg0tcH_OpHObW3/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/abhishek-gupta-1a9a4b147/",
    "Contact Details (Email)": "1502abhishekgupta@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/23/2020 18:19:51",
    "Name of the student": "Anmol Singh Sethi",
    "Institute Name(College)":
      "Indian Institute of Information Technology, Allahabad",
    "Field of study": "Information Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Development, Data Science",
    "Period of Internship": "3 months, 6th july onwards",
    "Current Location(With Country)": "Bangalore, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17ovLBrnOCuO1rM_we6xOHgtKGAQOxtMM",
    "LinkedIn profile link": "https://www.linkedin.com/in/anmolsinghsethi/",
    "Contact Details (Email)": "anmolsinghsethi99@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/24/2020 08:02:05",
    "Name of the student": "Manoj Kumar",
    "Institute Name(College)": "PSNA College of Engineering and Technology",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Software engineer/ Software developer / SDE",
    "Period of Internship": "2 to 6 months",
    "Current Location(With Country)": "Madurai, Tamil Nadu , India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15zTdxzsVIBr24t0d1CBWWvqAQwnHaAvX/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/manojkumar22/",
    "Contact Details (Email)": "manoj22.be@gmail.com",
    "Anything else you'd like to share?": "https://github.com/manoj228",
  },
  {
    Timestamp: "05/24/2020 08:55:43",
    "Name of the student": "Aparna",
    "Institute Name(College)":
      "Indian Institute of Information Technology (IIITDM)",
    "Field of study": "ECE",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Embedded systems, reconfigurable computing, electrical machines",
    "Period of Internship": "4.5 months from May 27 till Oct 12",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "I'm ok with WFH till lockdown. After that in Chennai or Bangalore will be ok with me.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Hamh8-W8quumQo-bz3MCtGVGc8UZrdki/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aparna-balamurugan-174188182/",
    "Contact Details (Email)": "edm17b009@iiitdm.ac.in",
    "Anything else you'd like to share?":
      "I want to do a solid work like a project either as a part of team or individually. I'll give my maximum.",
  },
  {
    Timestamp: "05/24/2020 11:06:12",
    "Name of the student": "Logeshwari",
    "Institute Name(College)": "Institute of insurance and risk management",
    "Field of study": "Business analytics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Analytics",
    "Period of Internship": "3",
    "Current Location(With Country)": "India ( Chennai)",
    "Does Remote Internship work for you?": "Yes ( Hyderabad, Bangalore)",
    "Link to Resume(Google Drive/Dropbox)": "Yes",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "logeshwariravi24@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/24/2020 12:11:42",
    "Name of the student": "Tushar Pimple",
    "Institute Name(College)": "IE Business School, Spain",
    "Field of study": "",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Product Management",
    "Period of Internship": "1st July",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1FwgJ7mEJ05wNLK1En7wXfBFl7AWa4pv-/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/tusharpimple/",
    "Contact Details (Email)": "tushar.p.mba@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/24/2020 13:17:39",
    "Name of the student": "Divyanshu Tiwari",
    "Institute Name(College)": "Indian Institute of Technology, Roorkee",
    "Field of study": "Architectural Design",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Game development and design, AR/VR app development and design, Front-end development and design",
    "Period of Internship": "1 month - 2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "Yes, remote internship would work.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vdIQSnZTQDQRkXZ20QkV_lV6srlYpo79/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/divyanshu-tiwari33/",
    "Contact Details (Email)": "divyanshu.tiwari33@gmail.com",
    "Anything else you'd like to share?":
      "I have a strong background in digital product design and development. Currently, I have gained interest in Game development and design, as well as AR/VR app development and design. I have been learning Unity and Blender for the same reason and would love to work as an intern for an organisation that would allow me to apply my skills in the same.",
  },
  {
    Timestamp: "05/26/2020 09:23:40",
    "Name of the student": "Roberto D. Principio Jr.",
    "Institute Name(College)": "University of the Philippines Diliman",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development",
    "Period of Internship": "3 months, start at June 2020",
    "Current Location(With Country)": "Laguna, Philippines",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ZZyI5osxg_Hr0BiHKFXJ7newUn5q8dR0/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/rdprincipiojr/",
    "Contact Details (Email)": "rdprincipio.jr@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/26/2020 20:01:40",
    "Name of the student": "Juie Shailesh Shah",
    "Institute Name(College)": "MICA, Ahmedabad",
    "Field of study": "Strategic Marketing & Communication",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing and Communications",
    "Period of Internship": "2- 3 months. Can start immediately",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Yes, Pune",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1ifAwrg0fUeOwhpQIzlDjTBQh_2krKyiV/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/juie-s-shah-934029109/",
    "Contact Details (Email)": "juieshah@gmail.com",
    "Anything else you'd like to share?":
      "Interested in fields like consumer insight mining, retail and e-commerce",
  },
  {
    Timestamp: "05/26/2020 20:59:57",
    "Name of the student": "Gautam Kumar",
    "Institute Name(College)": "Kanpur Institute of Techhhnology",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software, Graphics Design",
    "Period of Internship": "Start from Today 26th May - 30th June",
    "Current Location(With Country)": "Patna, Bihar, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1XCxvivwp3QZPgsaiTYDLBTEkFTb-ZXCZ/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gautam-kumar-605b59130/",
    "Contact Details (Email)": "gautamkumar12394@gmail.com",
    "Anything else you'd like to share?": "I can do multitask work.",
  },
  {
    Timestamp: "05/27/2020 23:20:18",
    "Name of the student": "Shrish Chandra Sharma",
    "Institute Name(College)": "Indian institute of technology Patna",
    "Field of study": "Computer science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Computer science",
    "Period of Internship": "",
    "Current Location(With Country)": "Bareilly, India",
    "Does Remote Internship work for you?":
      "Yes, I am ready for remote internship",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1iUFKV12rbjE2v1U9m63Tx9I5wR9GaxZM/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/shrish789",
    "Contact Details (Email)": "sharmashrish897@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/28/2020 17:08:15",
    "Name of the student": "Gaurav Aggarwal",
    "Institute Name(College)": "Central University of punjab",
    "Field of study": "Bioinformatics and biotechnology",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Bioinformatics Research, Teaching concepts online",
    "Period of Internship": "One month or two",
    "Current Location(With Country)": "Delhi India",
    "Does Remote Internship work for you?": "Yes, any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1e3DjZbhHEXK57kFD5wjBW77WHJIMUOIw/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gaurav-aggarwal-8397b7141/",
    "Contact Details (Email)": "bioinfo.ga@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/30/2020 06:39:16",
    "Name of the student": "Gogulamudi Dhanalakshmi",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "Textile engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Textile, Graphic design",
    "Period of Internship": "2 months",
    "Current Location(With Country)":
      "Kurichedu, Prakasam, Andhra Pradesh, 523304 India",
    "Does Remote Internship work for you?":
      "I would prefer work from home after that my college resumes. So I can not shift the location",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/13QqdvBmq65lAif9mU_aoTEmu_PRzp5fG/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gogulamudi-dhanalakshmi-874829154",
    "Contact Details (Email)": "dhanalakshmigogulamudi23@gmail.com",
    "Anything else you'd like to share?": ".",
  },
  {
    Timestamp: "06/01/2020 14:06:05",
    "Name of the student": "Sri Krishna R",
    "Institute Name(College)": "IIM Raipur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing, Operations",
    "Period of Internship": "1-2 months. From June 1st, 2020",
    "Current Location(With Country)": "Chennai",
    "Does Remote Internship work for you?": "Yes, Chennai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1pkIXoupn-AcxGBPWHfDtYlggHkEp_M5m/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sri-krishna-r-3b7667ba/",
    "Contact Details (Email)": "krishsrir@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 14:13:00",
    "Name of the student": "Divya Kelkar",
    "Institute Name(College)": "SIESCOMS(passed)",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Credit analysis",
    "Period of Internship": "any",
    "Current Location(With Country)": "Mumbai (India)",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1PYN06FFh0j43bDMmieiath3P8BvYhdx7/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "leodivya.dk@gmail.com",
    "Anything else you'd like to share?":
      "I am looking for a full time position as well",
  },
  {
    Timestamp: "06/01/2020 14:14:33",
    "Name of the student": "SANDEEP KUMAR SHARMA",
    "Institute Name(College)": "Galgotias University",
    "Field of study": "B-Tech in Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Python/C++ development, AI/ML , Arduino and IoT, Web Development",
    "Period of Internship": "2 (from 28 June onwords)",
    "Current Location(With Country)": "Lucknow, UP, India",
    "Does Remote Internship work for you?":
      "yes, If situation improves and lock-down is over my preferred city to relocate would be , Banglore, Pune, Hyderabad, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Yd4YiXxtvYr5-83MD1Ullr0FSOR_KAbQ/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/sandeeps097/",
    "Contact Details (Email)": "sandeepsharma097@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 14:52:04",
    "Name of the student": "Rachit Gupta",
    "Institute Name(College)": "JIIT, Noida 62",
    "Field of study": "Computer Science and Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Backend Development, AI",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Delhi",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1d7F_e96IjbZ4alu8aSsXQIV9czYKiDVp/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/rachiitgupta",
    "Contact Details (Email)": "mailtorachitgupta@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 15:03:47",
    "Name of the student": "Jhalak Rastogi",
    "Institute Name(College)": "IILM Academy of higher learning, Jaipur",
    "Field of study": "Finance",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "",
    "Current Location(With Country)": "Budaun (UP), India",
    "Does Remote Internship work for you?": "Yes, PAN India",
    "Link to Resume(Google Drive/Dropbox)": "n/a",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "jhalak.rastogi.pgdm20@iilm.ac.in",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "06/01/2020 15:10:11",
    "Name of the student": "Bhavesh Jain",
    "Institute Name(College)": "IIT KHARAGPUR",
    "Field of study": "Agriculture and food Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data analytics | Machine Learning",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Jaipur India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1BotN5IXK0pUZ5O9f-iVcPYiMvXtSrrR0/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/bhavesh-jain-1b8029165/",
    "Contact Details (Email)": "bhaveshjain.iitkgp@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "06/01/2020 15:26:38",
    "Name of the student": "Anis",
    "Institute Name(College)": "Bits pilank",
    "Field of study": "Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product manager",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Chennai",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/112_nmb-Jvgd6n2fslCldF-pRoAPs5UTL/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Sabeeranis@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 15:36:02",
    "Name of the student": "Ali asgar Bohra",
    "Institute Name(College)":
      "Department of financial studies, Delhi University",
    "Field of study": "FINANCE",
    Education: "MBA",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?":
      "Yes, Mumbai, Pune, Indore, Hyderabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1kxHc1Ix_VX1HhXG4rnHnT1HlDZjmPHuc",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "Aliasgarboh@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 15:37:43",
    "Name of the student": "Lakshay bahl",
    "Institute Name(College)": "DIT UNIVERSITY",
    "Field of study": "Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Moarketing",
    "Period of Internship": "2 months starting from 20th june",
    "Current Location(With Country)": "Rohtak(INDIA)",
    "Does Remote Internship work for you?": "Delhi,chandigarh,dehradun",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/0BzQzDDe-Z6uyemF6RURaT21PamFaaVJ5OTF6SXdILTZELW1F/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/lakshay-bahl-547a43168",
    "Contact Details (Email)": "Lakshaybahl.lb@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 15:46:26",
    "Name of the student": "Dhaval",
    "Institute Name(College)": "UOM, Ignou",
    "Field of study": "Finance, Accounting, Law, Research, Economics",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Finance, Research, Analytics, Management",
    "Period of Internship": "Two months",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?":
      "Yes, I would prefer Work from Home",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1yHrgIkw5cqKvUtbd_BBbwupNK0_QFSwu/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/dhaval-c-03a151160",
    "Contact Details (Email)": "dhavalcssp@gmail.com",
    "Anything else you'd like to share?":
      "Having a eight years of working experience and different forms of knowledge domains being explored, I would surely be able to provide the best possible solution and provide add in to the organisation. Very grateful to see the initiative from your end helping several interns gain such opportunities to learn more and explore.",
  },
  {
    Timestamp: "06/01/2020 15:47:59",
    "Name of the student": "Manoj Kumar",
    "Institute Name(College)": "PSNA College of Engineering and Technology",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Android,  Backend , Software engineer",
    "Period of Internship": "2",
    "Current Location(With Country)": "Madurai, Tamil Nadu, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/15zTdxzsVIBr24t0d1CBWWvqAQwnHaAvX/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/manojkumar22/",
    "Contact Details (Email)": "manoj22.be@gmail.com",
    "Anything else you'd like to share?":
      "I'm looking for intern to develop my skills and looking for job also",
  },
  {
    Timestamp: "06/01/2020 16:09:01",
    "Name of the student": "Saptarshi Saikia",
    "Institute Name(College)": "National Institute Of Technology Silchar",
    "Field of study": "MBA in Marketing",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Sales and Marketing",
    "Period of Internship": "One month starting from 15 jun, 2020.",
    "Current Location(With Country)": "North Lakhimpur, Assam, India",
    "Does Remote Internship work for you?": "Yes.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1W0FE7J1x2KwinfK3ZO_Oj80SBuVHon4z/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/saptarshisaikiadomsnits",
    "Contact Details (Email)": "saptarshisaikia@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 16:11:21",
    "Name of the student": "Avani P. Makhesana",
    "Institute Name(College)":
      "Pandit Deendayal Petroleum University, Gandhinagar",
    "Field of study": "Chemical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Nanotechnology, Energy, Sustainability, SDGs, Waste Management, R&D, Content Writing, Marketing",
    "Period of Internship": "1 or 2 months, 2nd june, 2020",
    "Current Location(With Country)": "Madhapar Chowk, Rajkot, Gujarat, India",
    "Does Remote Internship work for you?": "Yes, Gandhinagar, Ahmedabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/folders/1tXDmcK-yJzli-Pu7KTPbIBnOohlwtXza",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/avani-makhesana-b11b27159/",
    "Contact Details (Email)": "avanee14@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 16:17:00",
    "Name of the student": "Satyam Rajput",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "B.Tech- Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Oil and gas, Energy consultancy, data analytics, market research",
    "Period of Internship": "1-3 months, Start from 5 June 2020",
    "Current Location(With Country)": "Dehradun, India",
    "Does Remote Internship work for you?":
      "Yes, Delhi, Noida, Dehradun,Gurgaon,Pune,Kanpur,Barreily,",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1DZFstFaxbMvI9fPsvnDcRqzH2LZ8sebG",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/satyam-rajput-92237215b/",
    "Contact Details (Email)": "Satyamrajput15797@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 16:20:26",
    "Name of the student": "Priyanka Halder",
    "Institute Name(College)": "Symbiosis Centre for Media and Communication",
    "Field of study": "B.A in Mass Communication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Fund rising, Tele Calling, social media marketing, Social works, Ngos",
    "Period of Internship": "1-3 months",
    "Current Location(With Country)": "Kolkata, West Bengal, India",
    "Does Remote Internship work for you?": "Kolkata",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1JJtiybtvCw8naLevmJim8AffZ84Eb8od/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyanka-halder-1aaa861a0",
    "Contact Details (Email)": "Mepriyankahalder00@gmail.com",
    "Anything else you'd like to share?": "No.",
  },
  {
    Timestamp: "06/01/2020 16:22:21",
    "Name of the student": "Muppala Sukeerth",
    "Institute Name(College)":
      "Indian Institute of Engineering Science and Technology, Shibpur",
    "Field of study": "Electronics and Telecommunication",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Data Science, Machine Learning  ,FinTech",
    "Period of Internship": "3, 05-06-2020",
    "Current Location(With Country)": "Bengaluru, India",
    "Does Remote Internship work for you?":
      "Yes, Kolkata preferred city to relocate to",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1HtJL2ceqO_QxdjdE3P10Jqll9icZUNH7/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/muppala-sukeerth-67a70b15a/",
    "Contact Details (Email)": "sukeerthmuppala@gmail.com",
    "Anything else you'd like to share?": "Thank you for this Initiative",
  },
  {
    Timestamp: "06/01/2020 16:22:49",
    "Name of the student": "Ankit Jiaswal",
    "Institute Name(College)": "Indian Institute of Technology, Goa",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Machine learning, Cyber security, Internet of things",
    "Period of Internship": "1-2 months",
    "Current Location(With Country)": "Patna,Bihar,India",
    "Does Remote Internship work for you?": "no",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1qTvP8IIgRH2kNpjlIWPMqX00Hpp4Wd_-",
    "LinkedIn profile link": "linkedin.com/in/ankit-jaiswal-18001",
    "Contact Details (Email)": "ankit.jaiswal.18001@iitgoa.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 16:41:35",
    "Name of the student": "Mayuri Sawant",
    "Institute Name(College)": "Oxford Brookes University",
    "Field of study": "Accounting and Audit",
    Education: "Undergraduate",
    "Preferred domain of internship": "Auditing, Accounting, Finance",
    "Period of Internship": "3 months, start - 3rd June",
    "Current Location(With Country)": "Oman",
    "Does Remote Internship work for you?":
      "Can work remotely. Willing to relocate post lockdown",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1EFt7R21dwDqu-Mi3qPZ5Ha7NxPIsysxm/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mayuri-sawant-476489157",
    "Contact Details (Email)": "mayu15sawant@gmail.com",
    "Anything else you'd like to share?":
      "I am a graduate working towards my ACCA qualification with only 2 exams left. I am IFRS, IAS and ISA proficient.\nCan work remotely with minimal supervision. Willing to relocate as required post lockdown.",
  },
  {
    Timestamp: "06/01/2020 16:52:07",
    "Name of the student": "Sukriti Bhalla",
    "Institute Name(College)": "Amity University",
    "Field of study": "MBA (Marketing &Sales)",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Marketing",
    "Period of Internship": "1-2",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1m8fCzPCIZl9tRJyKpOn9y0IHe_m9HWh5/view?usp=sharing",
    "LinkedIn profile link": "www.linkedin.com/in/sukriti-bhalla-68a5b8157",
    "Contact Details (Email)": "bhallasukriti@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 16:59:27",
    "Name of the student": "Krish Gupta",
    "Institute Name(College)": "IIT GANDHINAGAR",
    "Field of study": "Materials Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development, Cybersecurity",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Varanasi, India",
    "Does Remote Internship work for you?": "Perfect for me",
    "Link to Resume(Google Drive/Dropbox)":
      "https://www.linkedin.com/mwlite/in/krish-gupta-367187173",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/krish-gupta-367187173",
    "Contact Details (Email)": "krish.gupta@iitgn.ac.in",
    "Anything else you'd like to share?":
      "I'm a beginner at Cybersecurity, so if given an opportunity to learn and work, I'd be very enthusiastic about it",
  },
  {
    Timestamp: "06/01/2020 17:16:15",
    "Name of the student": "Ronnie Rodrigues",
    "Institute Name(College)":
      "Prahladrai Dalmiya Lions College of Commerce & Economics",
    "Field of study": "BMM",
    Education: "Final Year Exams awaited",
    "Preferred domain of internship": "Mass Media",
    "Period of Internship": "3 months can join immediately",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?": "Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1T9tU0tMW1ZRIjaFhqEaL2TudNamp4uQY/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/ronnie-rodrigues-20bb93161/",
    "Contact Details (Email)": "7977490618",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 18:30:02",
    "Name of the student": "Navneet  Kumar",
    "Institute Name(College)": "Indian Institute Of Technology (BHU),Varanasi",
    "Field of study": "Civil Engineering and Software Developer",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Developer (C++)",
    "Period of Internship": "2-3 months from 01/06/2020",
    "Current Location(With Country)": "Bijnor,Uttarpradesh, India",
    "Does Remote Internship work for you?": "Yes,any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VhNO3IPgcAZQhh5Um4x8SsiW_ryWfHIb/view?usp=sharing",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "navneet.kumar.civ17@itbhu.ac.in",
    "Anything else you'd like to share?":
      "HackerRank profile-https://www.hackerrank.com/navneetdhankad11",
  },
  {
    Timestamp: "06/01/2020 18:52:19",
    "Name of the student": "Kaushal Tank",
    "Institute Name(College)": "Welingkar Institute of Management",
    "Field of study": "Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations ans Supply chain",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Nashik,Maharashtra,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1jPI4YGU-YyFCvqlbNBR50YqLQflc8K0X/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kaushal-tank-179419104/",
    "Contact Details (Email)": "tank.kaushal@gmail.com",
    "Anything else you'd like to share?":
      "My internship with India's Number 1 Retailing firm got revoked amidst Covid-19 and I was among top 25 students of my college who were selected.",
  },
  {
    Timestamp: "06/01/2020 19:05:34",
    "Name of the student": "Rishabh Dutt sharma",
    "Institute Name(College)": "Jaypee Institute of Information technology",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Electronics",
    "Period of Internship": "2 month",
    "Current Location(With Country)": "Ghaziabad",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1kG2Kd9Ts66vMsaX_itBhJSW1s6rgGHfj/view?usp=drivesdk",
    "LinkedIn profile link":
      "www.linkedin.com/in/rishabh-dutt-sharma-a51b30148",
    "Contact Details (Email)": "Srishabh40@yahoo.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 19:08:34",
    "Name of the student": "Rohan Jacob",
    "Institute Name(College)": "TERI School of Advanced Studies",
    "Field of study":
      "Corporate social responsibility, green energy and research",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Green energy",
    "Period of Internship": "One month, 01/07/2020",
    "Current Location(With Country)": "New Delhi, India",
    "Does Remote Internship work for you?": "Yes. Anywhere",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1SIahVjj5kweE2FfTjbFqv-vsBA2rlSlu/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "rohan.jacob@terisas.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 20:17:25",
    "Name of the student": "Parth Upadhyay",
    "Institute Name(College)": "ESC Rennes, France",
    "Field of study": "MSc in International Finance and Masters in Management",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Corporate Finance and Market Finance",
    "Period of Internship": "6 Months (starting from July/August 2020)",
    "Current Location(With Country)": "Rennes, France",
    "Does Remote Internship work for you?":
      "I need to do 6 months in office internship.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=1pvK4CvGPNtBciTJGHVJIi3HnfzXBw7lu",
    "LinkedIn profile link": "https://www.linkedin.com/in/parthupadhyay31/",
    "Contact Details (Email)": "parthupadhyay22@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 20:21:28",
    "Name of the student": "Sayani Mondal",
    "Institute Name(College)": "IIT(ISM) DHANBAD",
    "Field of study": "CHEMICAL ENGINEERING",
    Education: "Undergraduate",
    "Preferred domain of internship": "Core",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)": "sayanimondal3010@gmail.com",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sayani-mondal-9659ab190",
    "Contact Details (Email)": "sayanimondal3010@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 21:17:54",
    "Name of the student": "Pedapudi Rahul",
    "Institute Name(College)":
      "Velgapudi Ramakrishna Siddhartha Engineering College",
    "Field of study": "B.tech",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Coding,Data Entry,Content Writing,Marketing",
    "Period of Internship": "1 or 2 months starting 1/06/2020",
    "Current Location(With Country)": "VIjayawada,Andhrapradesh,India",
    "Does Remote Internship work for you?": "I like to work from home",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1t4-cLtLANxYsklrm2qk_W6YmJd2T2HCA/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/kingmaker-rahul-5915141a0/",
    "Contact Details (Email)": "kingmaker.rahul7@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/01/2020 21:27:35",
    "Name of the student": "Abhisshek Kumar Singh",
    "Institute Name(College)": "Haldia Institute Of Technology",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Java Developer, Software Developer",
    "Period of Internship": "6 month",
    "Current Location(With Country)": "Bihar (India)",
    "Does Remote Internship work for you?": "Banglore,Hyderabad,West Bengal,.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1vYRZrdRKpF4h0ByGX3WEmvIayx2JpGwa/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/abhishek-kumar-singh-450499142/",
    "Contact Details (Email)": "abhishekcsek@gmail.com",
    "Anything else you'd like to share?":
      "I am very good with programming with c++ and hands on experience to develop application on Java, I also have develop more then 3 real time application and launch it on EC2 instance of AWS.\nI am also good with DBMS and got Silver batch from IIT Kharagpur in DBMS.\nI have strong knowledge of Fundamental of C,DS,Algorithms, Computer Network, DBMS, Operating System,TOC,Digital and Maths.\nI can able to contribute from the very first day.",
  },
  {
    Timestamp: "06/02/2020 09:05:49",
    "Name of the student": "Mitali Rathod",
    "Institute Name(College)": "IIT Ropar",
    "Field of study": "B.tech in Electrical and Electronics Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "core",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Ratlam, Madhya Pradesh",
    "Does Remote Internship work for you?": "no",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/open?id=17ORaXipZY-KfeZs5I-SghgpgPL7jOvQo",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/mitali-rathod-a80036182/",
    "Contact Details (Email)": "2017ceb1014@iitrpr.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/02/2020 14:16:53",
    "Name of the student": "Anhad Taneja",
    "Institute Name(College)": "University of Petroleum and Energy Studies",
    "Field of study": "Petroleum Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data Analytics",
    "Period of Internship": "1-2",
    "Current Location(With Country)": "Agra, India",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1mtKJQgOzE5UD-wosK7hNFuxUHMl-97Hr/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anhad-taneja-b15943147",
    "Contact Details (Email)": "anhadt@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/02/2020 14:54:00",
    "Name of the student": "Mulpuri Dhatri",
    "Institute Name(College)": "CVR College Of Engineering",
    "Field of study": "Electronics and Communication Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software, Programming, VLSI",
    "Period of Internship": "6 months(Start Date: 27th June 2020)",
    "Current Location(With Country)": "Hyderabad, Telangana, India",
    "Does Remote Internship work for you?":
      "Yes, I would like to work in Hyderabad/Bangalore",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1TwmIo7adWXBfBfl4-0uMCe-AZDpmtN8J/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/dhatri-mulpuri-711529143/",
    "Contact Details (Email)": "mulpuridhatri@gmail.com",
    "Anything else you'd like to share?":
      "I have done 6 months internship in Servicenow as a Python programmer.",
  },
  {
    Timestamp: "06/02/2020 15:10:47",
    "Name of the student": "Amrita Rai",
    "Institute Name(College)": "Avadh girls PG College",
    "Field of study": "Economics",
    Education: "Undergraduate",
    "Preferred domain of internship": "Learning",
    "Period of Internship": "Depends",
    "Current Location(With Country)": "Uttar Pradesh, Lucknow",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)": "Is it compulsory",
    "LinkedIn profile link": "Don't have",
    "Contact Details (Email)": "rai.amrita2015@gmail.com",
    "Anything else you'd like to share?": "I'll try to present my best.",
  },
  {
    Timestamp: "06/02/2020 15:16:05",
    "Name of the student": "Shahrukh Alam Khan",
    "Institute Name(College)": "Purdue University",
    "Field of study": "Electrical and Computer Engineering",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data Science and Data Analysis",
    "Period of Internship": "Start date: 4-June-2020  Duration: 3-6 months",
    "Current Location(With Country)": "Hammond, IN, USA",
    "Does Remote Internship work for you?": "New York, NYC, USA",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CmxGx_4MC8r6mN-knN2TjAx_-DiIZE90/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/shahrukh-alam-2086b5157",
    "Contact Details (Email)": "shahrukhalamkhan201@gmail.com",
    "Anything else you'd like to share?":
      "Having diversified skill set and expertise in the field of IT, software, business analytics, data analytics ,data visualization, big data, machine learning, engineering and statistics, I intend to become a part of dynamic organization to acquire an efficient experience where I can work on achieving organizational goals along with the enhancement of my skills.",
  },
  {
    Timestamp: "06/02/2020 15:32:53",
    "Name of the student": "Aditya Kaushik",
    "Institute Name(College)": "Delhi Technological University",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Machine Learning, Software Development",
    "Period of Internship": "2 months available immediately",
    "Current Location(With Country)": "Delhi, India",
    "Does Remote Internship work for you?": "Yes. Open to relocate as well.",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18gSL9iHaYjFnksxwgTq8gvk0EVg046c3/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/aditya-kaushik-0674a44a/",
    "Contact Details (Email)": "adityakaushik99@gmail.com",
    "Anything else you'd like to share?":
      "I am available immediately through to July end.",
  },
  {
    Timestamp: "06/02/2020 18:47:25",
    "Name of the student": "Anusha Sasikumar",
    "Institute Name(College)": "Christ University, Bangalore",
    "Field of study": "B.Com Hons (Specialization - Finance & Accountancy)",
    Education: "Undergraduate",
    "Preferred domain of internship": "Finance",
    "Period of Internship": "2-3 months. 08/06/2020",
    "Current Location(With Country)": "Bangalore,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1rly9feZXfUnpVro_FgTwvsqx8mGrfxlq/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/anusha-sasikumar",
    "Contact Details (Email)": "anusha01us@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/02/2020 22:22:12",
    "Name of the student": "Sneha Singh",
    "Institute Name(College)": "Maitreyi college, Delhi University",
    "Field of study": "Bcom P",
    Education: "Undergraduate",
    "Preferred domain of internship": "HR, BUSINESS DEVELOPMENT Intern",
    "Period of Internship": "21 june, 1 -4 month",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?":
      "No, Preferred location is Delhi Ncr",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CeS7N4aRuGszgSRPlvq-h3fpvERmlSFa/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/sneha-singh-94859b1a7",
    "Contact Details (Email)": "snehasinghrao832@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/02/2020 22:25:38",
    "Name of the student": "Rishabh Bhanot",
    "Institute Name(College)": "Jaypee University Of Information Technology",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development",
    "Period of Internship": "1 month",
    "Current Location(With Country)": "Noida,India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1JgQPW7w3fQc_xks76Q3MKUiCyp9XxKaC/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/rishabh-bhanot-u19636794/",
    "Contact Details (Email)": "rishabhbhanot10@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "06/02/2020 22:29:58",
    "Name of the student": "Nishant Bhandari",
    "Institute Name(College)": "Jaypee University of information technology",
    "Field of study": "CSE",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data structures",
    "Period of Internship": "6 weeks(10 june)",
    "Current Location(With Country)": "Solan,Himachal Pradesh",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/18NgXhpVSO7Mp0uCZ__FLRvI0YurMJO8V/view?usp=drivesdk",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "nishantbhandari2000@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/03/2020 01:19:13",
    "Name of the student": "Priyank Chaudhary",
    "Institute Name(College)": "IIT-BHU",
    "Field of study": "Chemical Engineering & Technology",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product management Or Machine learning",
    "Period of Internship": "2 Months",
    "Current Location(With Country)": "Varanasi, U.P (INDIA)",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1S_sdR2gYgQpPImjwbIkykjcIqZ770UqF/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/priyank-chaudhary-83a4a0157/",
    "Contact Details (Email)": "priyank.chaudhary.che17@itbhu.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/03/2020 02:32:36",
    "Name of the student": "ANUJ PAHARIA",
    "Institute Name(College)": "IIT ISM Dhanbad",
    "Field of study": "Bachelor's degree in Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Product management,Finance",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1e-LUDzYxmYbyxhxySS45ibVxAr1y5Ipl/view?usp=sharing",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/anuj-paharia-8833b4172/",
    "Contact Details (Email)": "anujpaharia880@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/03/2020 07:39:27",
    "Name of the student": "Pranjali",
    "Institute Name(College)": "Gokhale institute of politics and economics",
    "Field of study": "Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Research or data analytics",
    "Period of Internship": "3 -4 months, 15th July",
    "Current Location(With Country)": "Noida, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/11q3JlaaVsCaysdPlSgbx5xyHeVFVFh_T/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/pranjali-99a3a1110",
    "Contact Details (Email)": "pranjali.mohan07@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/03/2020 10:16:54",
    "Name of the student": "Dhanalakshmi Gogulamudi",
    "Institute Name(College)": "IIT Delhi",
    "Field of study": "B.tech",
    Education: "Undergraduate",
    "Preferred domain of internship": "Graphic design",
    "Period of Internship": "2 months",
    "Current Location(With Country)":
      "West Gangavaram, Kurichedu, Prakasam (Dist), 523304, Andhra Pradesh, India",
    "Does Remote Internship work for you?": "Yes, location ok n Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/13QqdvBmq65lAif9mU_aoTEmu_PRzp5fG/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/gogulamudi-dhanalakshmi-874829154",
    "Contact Details (Email)": "dhanalakshmigogulamudi23@gmail.com",
    "Anything else you'd like to share?": ".",
  },
  {
    Timestamp: "06/03/2020 14:28:44",
    "Name of the student": "Vaibhav",
    "Institute Name(College)": "Delhi school of Economics, University of Delhi",
    "Field of study": "Economics",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Data analytics",
    "Period of Internship": "June-august",
    "Current Location(With Country)": "New Delhi",
    "Does Remote Internship work for you?": "No",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/178DBpu0WpE_ci9aqEjcOF3CPsdU1-075/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/vaibhav-yadav-5b82a3143",
    "Contact Details (Email)": "vaibhavyadav4444@gmail.com",
    "Anything else you'd like to share?": "I belong to lgbt community",
  },
  {
    Timestamp: "06/03/2020 17:45:42",
    "Name of the student": "Jimil Shah",
    "Institute Name(College)": "Sardar Patel Institute of Technology",
    "Field of study": "Computer Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Full-Stack Web Development (Angular 6 + Spring Boot/Flask), Data Science",
    "Period of Internship": "2",
    "Current Location(With Country)": "Mumbai, India",
    "Does Remote Internship work for you?":
      "Yes, I can relocate to Pune, Bangalore, Chennai, Hyderabad, Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/12JYgem1hEf3SFZ21bS9HJhUZNUZsj7Qq/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/jimilproggrammer/",
    "Contact Details (Email)": "shahjimil35@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/03/2020 18:35:17",
    "Name of the student": "Muhammad Ali",
    "Institute Name(College)": "National University of Sciences and Technology",
    "Field of study": "Electrical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "IoT, Cloud computing, Network, Telecom, Electrical Engineering, CS",
    "Period of Internship": "3months",
    "Current Location(With Country)": "Pakistan",
    "Does Remote Internship work for you?": "Islamabad",
    "Link to Resume(Google Drive/Dropbox)":
      "https://1drv.ms/w/s!AsBXn4arZme1hBHa_lNLw6MPt7Tx?e=F12ce7",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/muhammad-ali-b0077219a",
    "Contact Details (Email)": "mali.bee17seecs@seecs.edu.pk",
    "Anything else you'd like to share?":
      "I am punctual, dedicated, committed, good Teammate. Fully passionate for a remote internship.",
  },
  {
    Timestamp: "06/03/2020 18:54:49",
    "Name of the student": "Mansoor Abbas",
    "Institute Name(College)": "Abdul Wali Khan University Mardan",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Web Development",
    "Period of Internship": "More than two months",
    "Current Location(With Country)": "Pakistan",
    "Does Remote Internship work for you?": "",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1jv8EB6vkI1CFVx9XYNPBhYBS43K1hACk/view?usp=sharing",
    "LinkedIn profile link": "linkedin.com/in/mansoor-abbas-45663b187",
    "Contact Details (Email)": "mansoor.abbas651@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/04/2020 05:22:29",
    "Name of the student": "Amit Kumar Goyal",
    "Institute Name(College)": "Jawaharlal Nehru University",
    "Field of study": "Geography",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Social Research",
    "Period of Internship": "3 months, 10 June",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "New Delhi",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CZbuJ1EdTmlElQDSgO1WrjnqvaYcp3vq/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/comm/in/amit-kumar-989159184?midToken=AQH-E5aN19I99A&trk=eml-email_news_daily_rundown_01-header-10-profile&trkEmail=eml-email_news_daily_rundown_01-header-10-profile-null-c1zx2x%7Ekayqy3uv%7Eu-null-neptune%2Fprofile%7Evanity%2Eview&lipi=urn%3Ali%3Apage%3Aemail_email_news_daily_rundown_01%3BNEIjiR3kRX%2Bhp0miRirQpg%3D%3D",
    "Contact Details (Email)": "amitsks123@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/04/2020 13:13:12",
    "Name of the student": "zeel patel",
    "Institute Name(College)": "Nirma university",
    "Field of study": "Mechanical",
    Education: "Undergraduate",
    "Preferred domain of internship": "Data science",
    "Period of Internship": "2 month",
    "Current Location(With Country)": "Surat, India",
    "Does Remote Internship work for you?":
      "pune, Mumbai, Ahmadabad, pan india",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1oZs9OMhpqAeyl9wGr66UwXxCvQVot28b/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/zeel-patel-261438181",
    "Contact Details (Email)": "pzeel552@gmail.com",
    "Anything else you'd like to share?": "Na",
  },
  {
    Timestamp: "06/04/2020 21:13:07",
    "Name of the student": "Daramola Daniel",
    "Institute Name(College)": "University of ilorin",
    "Field of study": "Mechanical Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship": "Waste management",
    "Period of Internship": "6 month and above",
    "Current Location(With Country)": "Nigeria",
    "Does Remote Internship work for you?": "Lagos",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/folderview?id=1cNMyeamKsw978dFfvo4SO3M7rstM2Oxh",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "dandaramola.d@gmail.com",
    "Anything else you'd like to share?":
      "The aim of my application is for me to get a opportunity so has to develop my skills and capacity In return affect my community and the firm I will be privilege to be part of. Thank you.",
  },
  {
    Timestamp: "06/05/2020 14:49:10",
    "Name of the student": "Suyesha Magar",
    "Institute Name(College)": "Mit school of architecture",
    "Field of study": "Architecture",
    Education: "Undergraduate",
    "Preferred domain of internship": "Architecture",
    "Period of Internship": "1 to 3 months, start date- immediately",
    "Current Location(With Country)": "Pune, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://issuu.com/suyeshamagar/docs/portrait",
    "LinkedIn profile link": "",
    "Contact Details (Email)": "suyeshamagar98@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/05/2020 20:01:52",
    "Name of the student": "Majety Omesh",
    "Institute Name(College)": "Amrita Vishwa Vidyapeetham, Amritapuri",
    "Field of study": "Computer Science Engineering",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Blockchain, Web development, Machine Learning",
    "Period of Internship": "2",
    "Current Location(With Country)": "India, Andhrapradesh , Vijayawada",
    "Does Remote Internship work for you?": "Yes, any city",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1VFIH3gqARJ64sKGkVq7CoMCZunHQimxg/view?usp=drivesdk",
    "LinkedIn profile link":
      "https://www.linkedin.com/mwlite/in/omesh-majety-976aa1153",
    "Contact Details (Email)": "majetyomesh4@gmail.com",
    "Anything else you'd like to share?":
      "Have experience in web development as I have done an internship where i was a member in a team of 4,we have developed an complete web application for a government organisation with multi layer security.",
  },
  {
    Timestamp: "06/06/2020 06:59:46",
    "Name of the student": "Elizabeth Alagbe",
    "Institute Name(College)": "Federal University of Technology, Akure.",
    "Field of study": "Food Science and technology",
    Education: "Undergraduate",
    "Preferred domain of internship":
      "Food processing companies, IT companies with use of soft skills.",
    "Period of Internship": "3- 5months: June 15, 2020",
    "Current Location(With Country)":
      "52, old otta road, orile agege, Lagos State, Nigeria.",
    "Does Remote Internship work for you?": "Yes, Ibadan, Akure( Nigeria)",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1eFF_lP_jilxacjGDbpze7ummFNqfdrBj/view?usp=drivesdk",
    "LinkedIn profile link": "www.linkedin.com/in/elizabeth-alagbe-b4539815b",
    "Contact Details (Email)": "alagbeelizabeth0220@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "06/06/2020 16:56:03",
    "Name of the student": "Rohit Bhosale",
    "Institute Name(College)": "IIT Bombay",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship": "Operations and supply chain management",
    "Period of Internship": "2 months",
    "Current Location(With Country)": "Mumbai (India)",
    "Does Remote Internship work for you?": "Yes :  Mumbai",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1Ehb5Sc86tzxHsNEEhIwu1h-CI0tjjMgv/view?usp=drivesdk",
    "LinkedIn profile link": "https://www.linkedin.com/in/rohit-vilas-bhosale",
    "Contact Details (Email)": "rohit.bhosale@sjmsom.in",
    "Anything else you'd like to share?":
      "I'm a first-year MBA student at the School of Management IIT Bombay.",
  },
  {
    Timestamp: "06/07/2020 23:35:59",
    "Name of the student": "Siddharth Jain",
    "Institute Name(College)": "Indian Institute of Management Raipur",
    "Field of study": "MBA",
    Education: "Post-Graduate",
    "Preferred domain of internship":
      "Branding, Marketing & Product Management",
    "Period of Internship": "2",
    "Current Location(With Country)": "Jodhpur, India",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1GCjIl2BlJzbPEQfdeKMeJGnjb8YO99SY/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/siddharthjain18/",
    "Contact Details (Email)": "19pgp251@iimraipur.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/10/2020 11:37:48",
    "Name of the student": "iti jain",
    "Institute Name(College)":
      "Jaypee Institute of Information technology, Noida",
    "Field of study": "Computer Science",
    Education: "Undergraduate",
    "Preferred domain of internship": "Software Engineer",
    "Period of Internship": "1st aug 2020 - 6-months",
    "Current Location(With Country)": "India",
    "Does Remote Internship work for you?": "yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/file/d/1CfGXN5vy9BeFtoAES6HOYLw0TRllqITV/view?usp=sharing",
    "LinkedIn profile link": "https://www.linkedin.com/in/iti-jain-2406/",
    "Contact Details (Email)": "itijain2497@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "",
    "Name of the student": "Itika Sharma",
    "Institute Name(College)": "Chandigarh University",
    "Field of study": "B.E. in Compute Science engineering",
    Education: "Under-graduateEngineering)",
    "Preferred domain of internship": "Business development,Sales",
    "Period of Internship": "2-3 months",
    "Current Location(With Country)": "Mumbai",
    "Does Remote Internship work for you?": "Yes",
    "Link to Resume(Google Drive/Dropbox)":
      "https://drive.google.com/drive/u/0/my-drive",
    "LinkedIn profile link":
      "https://www.linkedin.com/in/itika-sharma-bhardwaj-069771185/",
    "Contact Details (Email)": "itikasharma6666@gmail.com",
    "Anything else you'd like to share?":
      "Looking for job where i could put forward my excellent communication skills and knowledge for the profitary enhancement of the organization.",
  },
];
